{
 " ao(à) paciente {nome}{cpf}": " ao(à) paciente {nome}{cpf}",
 " junto ao plano de saúde {c}": " junto do seguro de saúde {c}",
 " às {h}": " às {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiseres.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" está no {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" não é JPG nem PNG. Converte para JPG e tenta de novo.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" não é um PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" às {hora} coincide com: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" foi criada com os mesmos dados.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" já foi adicionado em {data}.",
 "% ao mês": "% ao mês",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(cópia)",
 "(sem título)": "(sem título)",
 "+ Adicionar alerta": "+ Adicionar alerta",
 "+ Adicionar outra OAB": "+ Adicionar outra OAB",
 "+ Adicionar pausa": "+ Adicionar pausa",
 "+ Adicionar subtarefa": "+ Adicionar subtarefa",
 "+ Matéria em {nome}": "+ Disciplina em {nome}",
 "+ Perfil": "+ Perfil",
 "+ Subtarefa": "+ Subtarefa",
 "+5 min": "+5 min",
 "+{n} acompanhante(s)": "+{n} acompanhante(s)",
 "+{n} páginas acima da meta": "+{n} páginas acima da meta",
 ", carteirinha nº {n},": ", cartão de beneficiário n.º {n},",
 ", pago em {d}{f}": ", pago em {d}{f}",
 "1 cápsula": "1 cápsula",
 "1 dose": "1 dose",
 "1 dose (30 g)": "1 dose (30 g)",
 "1 pessoa": "1 pessoa",
 "1 publicação nova": "1 publicação nova",
 "1 página": "1 página",
 "1 tarja no documento": "1 tarja no documento",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Instala o My Planner e cria a tua conta.  2. Abre este link de novo (ou escreve o código em Definições › Grupos e convites).",
 "1. Quais dados tratamos": "1. Que dados tratamos",
 "1. Sobre o app": "1. Sobre a app",
 "1ª dose": "1.ª dose",
 "2 por folha": "2 por folha",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 chávenas de farinha\n3 ovos\n1 colher de fermento",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 ou 9 páginas em cada folha (para imprimir).",
 "2. Para que usamos": "2. Para que os usamos",
 "2. Sua conta": "2. A sua conta",
 "2ª dose": "2.ª dose",
 "3 a 5 g": "3 a 5 g",
 "3. Bases legais (LGPD)": "3. Fundamentos jurídicos (LGPD)",
 "3. Uso correto": "3. Utilização correta",
 "3ª dose": "3.ª dose",
 "4 por folha": "4 por folha",
 "4. Com quem compartilhamos": "4. Com quem os partilhamos",
 "4. Planos e testes": "4. Planos e períodos de teste",
 "5. Limites": "5. Limites",
 "5. Segurança": "5. Segurança",
 "6 por folha": "6 por folha",
 "6. Por quanto tempo": "6. Durante quanto tempo",
 "7. Seus direitos (art. 18 da LGPD)": "7. Os seus direitos (art. 18 da LGPD)",
 "8. Crianças e adolescentes": "8. Crianças e adolescentes",
 "9 por folha": "9 por folha",
 "9. Mudanças": "9. Alterações",
 "@letra-dom": "D",
 "@letra-qua": "Q",
 "@letra-qui": "Q",
 "@letra-sab": "S",
 "@letra-seg": "S",
 "@letra-sex": "S",
 "@letra-ter": "T",
 "A IA está classificando...": "A IA está a classificar...",
 "A IA está lendo a caixa...": "A IA está a ler a caixa...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "A IA lê as páginas e o PDF passa a permitir pesquisa e cópia.",
 "A IA lê o PDF e sugere um nome claro.": "A IA lê o PDF e sugere um nome claro.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "A IA não devolveu uma resposta no formato esperado. Tente novamente.",
 "A IA não encontrou dados para esta ficha no arquivo.": "A IA não encontrou dados para esta ficha no ficheiro.",
 "A IA não encontrou tarefas nesta caixa.": "A IA não encontrou tarefas nesta caixa.",
 "A IA resume o PDF e responde perguntas.": "A IA resume o PDF e responde a perguntas.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "A SEFAZ regista que a fatura chegou ao seu conhecimento (não confirma nem recusa a compra) e liberta o XML completo na próxima pesquisa, em até 1 hora.",
 "A VENCER (7 DIAS)": "A VENCER (7 DIAS)",
 "A aba inteira": "A separador inteiro",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "O separador {aba} está perto do limite. Arquiva ou apaga itens antigos.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "O separador {aba} não está subscrito. A ligação fica guardada e volta ao subscrever.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "A pesquisa por \"{nome}\" é demasiado ampla. Use o nome completo.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "A pesquisa de GIFs ainda não foi ativada nesta app. Entretanto, usa os autocolantes animados (🎉).",
 "A cada": "A cada",
 "A cada N páginas": "A cada N páginas",
 "A cada quantos dias": "De quantos em quantos dias",
 "A cada {n} dia(s)": "A cada {n} dia(s)",
 "A cada {n} mês(es)": "A cada {n} mês(es)",
 "A cada {n} mês(es) · dia {d}": "A cada {n} mês(es) · dia {d}",
 "A cada {n} semana(s)": "A cada {n} semana(s)",
 "A cada {n} semana(s) · {dia}": "A cada {n} semana(s) · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "A caixa está em {aba}, em \"Notas recebidas\".",
 "A caixa foi para {destino}.": "A caixa foi para {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "A chave fica guardada só neste dispositivo, no cofre do sistema. Noutro dispositivo, registe-a novamente.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "A chave fica guardada só neste navegador. Use num computador pessoal.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "A ligação é encriptada. O cofre usa encriptação ponto a ponto (AES-256): nem o suporte consegue ler. A app pode ser bloqueada com palavra-passe, padrão ou biometria.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "A confirmação pelo WhatsApp ainda não foi ativada no servidor.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "A conta e todos os dados guardados na nuvem: tarefas, notas, separadores, fichas, mensagens, ficheiros enviados para a app e definições. Também são apagados os dados deste dispositivo. Não é possível desfazer.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "A cor aparece na barra, nos títulos e nas tarefas associadas a este separador.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "A cor do My Planner é a cor de destaque da app. Cada tarefa pode ter uma cor própria na ficha.",
 "A data de fim é anterior à de início.": "A data de fim é anterior à de início.",
 "A data inicial precisa ser antes da final.": "A data inicial tem de ser anterior à final.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "A equipa vai analisar o erro e corrigi-lo numa próxima atualização.",
 "A equipe vê e altera conforme o papel de cada um": "A equipa vê e altera conforme a função de cada um",
 "A fazer": "Por fazer",
 "A foto passa de 8 MB.": "A fotografia tem mais de 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "A foto é demasiado grande. Instala a nova versão da app para recortar a foto.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "A função \"nuvem\" ainda não foi publicada no servidor. Executa o 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "A função \"nuvem\" ainda não foi publicada no servidor. Execute o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "A gravação ainda está a ser preparada. Tenta novamente daqui a alguns minutos.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "A hora fica marcada neste fuso. Noutro fuso, a app mostra e avisa no horário convertido.",
 "A imagem original não está neste dispositivo.": "A imagem original não está neste dispositivo.",
 "A pagar": "A pagar",
 "A pagar: {v}": "A pagar: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "A permissão do calendário foi retirada. Volte a autorizá-la nas definições do telemóvel.",
 "A pessoa sai do grupo e deixa de receber os envios.": "A pessoa sai do grupo e deixa de receber os envios.",
 "A receber": "Por receber",
 "A receber: {v}": "A receber: {v}",
 "A reunião ainda está sendo gravada.": "A reunião ainda está a ser gravada.",
 "A senha atual não confere.": "A palavra-passe atual não está correta.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "A palavra-passe do cofre tem de ter 6 caracteres ou mais.",
 "A senha precisa ter 8 caracteres ou mais.": "A palavra-passe tem de ter 8 caracteres ou mais.",
 "A senha precisa ter pelo menos 8 caracteres.": "A palavra-passe tem de ter pelo menos 8 caracteres.",
 "A senha é a mesma no celular e no My Planner Web.": "A palavra-passe é a mesma no telemóvel e no My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "A sincronização é feita ao abrir a app e após cada alteração. As tarefas ligadas ao calendário mostram 📆.",
 "A sua equipe num lugar só": "A tua equipa num só lugar",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "A tarefa da casa não entra sozinha no My Planner. \"Enviar para o My Planner\" abre a ficha completa para escolheres o dia, a hora, a frequência, as pausas e os alertas.",
 "A validade não pode ser antes da emissão.": "A validade não pode ser anterior à emissão.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "A versão para iPhone chega em breve à App Store. Entretanto, usa o My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "A versão para iPhone chega em breve à App Store. Entretanto, utilize o My Planner Web: no Safari, toque em Partilhar > Adicionar ao ecrã principal para o transformar num ícone no telemóvel.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Carta, A5 ou Ofício, sem cortar nada.",
 "ADICIONAR AMIGO": "ADICIONAR AMIGO",
 "AGUARDANDO RESPOSTA": "A AGUARDAR RESPOSTA",
 "AMIGOS": "AMIGOS",
 "ANOTAÇÕES": "NOTAS",
 "ANOTAÇÕES RECEBIDAS · {aba}": "NOTAS RECEBIDAS · {aba}",
 "ATIVIDADE": "ATIVIDADE",
 "ATIVIDADE FÍSICA": "ATIVIDADE FÍSICA",
 "ATRASADAS": "EM ATRASO",
 "Aba": "Separador",
 "Aba bloqueada": "Separador bloqueado",
 "Aba {nome}": "Separador {nome}",
 "Abas": "Separadores",
 "Abas liberadas pelo suporte": "Separadores desbloqueados pelo suporte",
 "Abas para comprar": "Separadores para comprar",
 "Abas que você já tem": "Separadores que já tem",
 "Abastecimento": "Abastecimento",
 "Abastecimentos": "Abastecimentos",
 "Abdominal": "Abdominais",
 "Abertura do prazo da declaração do IR": "Abertura do prazo da declaração de IR",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Abra a empresa e toque em \"Pesquisar faturas\" para introduzir a palavra-passe do cofre.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Abre o My Planner Anne e entra com o teu documento e palavra-passe.",
 "Abra o My Planner no celular.": "Abra o My Planner no telemóvel.",
 "Abra o cofre": "Abra o cofre",
 "Abra um PDF para começar.": "Abre um PDF para começar.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Abra uma disciplina e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada disciplina.",
 "Abraço": "Abraço",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Abre o menu de partilha do telemóvel: WhatsApp, e-mail, Google Drive, OneDrive, guardar em Ficheiros e outros.",
 "Abre o PDF para ler aqui mesmo.": "Abre o PDF para ler aqui mesmo.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Abre o Scanner PDF (margens e sombras corrigidas).",
 "Abrir": "Abrir",
 "Abrir Ajustes": "Abrir Definições",
 "Abrir PDF": "Abrir PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Abrir PDF do telemóvel, Drive ou OneDrive",
 "Abrir a aba": "Abrir o separador",
 "Abrir a cópia guardada": "Abrir a cópia guardada",
 "Abrir a pasta no Drive": "Abrir a pasta no Drive",
 "Abrir com outro app": "Abrir com outra app",
 "Abrir configurações": "Abrir definições",
 "Abrir em outro app": "Abrir noutra app",
 "Abrir no DJEN": "Abrir no DJEN",
 "Abrir no modo seguro": "Abrir em modo seguro",
 "Abrir normalmente": "Abrir normalmente",
 "Abrir nota fiscal": "Abrir fatura",
 "Abrir o PDF": "Abrir o PDF",
 "Abrir o PDF no {nome}": "Abrir o PDF no {nome}",
 "Abrir o XML": "Abrir o XML",
 "Abrir o app": "Abrir a app",
 "Abrir o app My Planner": "Abrir a app My Planner",
 "Abrir o cartão": "Abrir o cartão",
 "Abrir o cofre": "Abrir o cofre",
 "Abrir o cofre para ver": "Abrir o cofre para ver",
 "Abrir o diário oficial": "Abrir o diário oficial",
 "Abrir ou baixar": "Abrir ou transferir",
 "Abrir página": "Abrir página",
 "Abrir site": "Abrir site",
 "Abrir {nome}": "Abrir {nome}",
 "Acabamento": "Acabamentos",
 "Acabou": "Esgotado",
 "Academia": "Ginásio",
 "Aceitar": "Aceitar",
 "Aceitar, editar ou recusar": "Aceitar, editar ou recusar",
 "Aceite os termos para continuar.": "Aceite os termos para continuar.",
 "Aceito": "Aceite",
 "Aceito com alterações": "Aceite com alterações",
 "Acerto de contas": "Acerto de contas",
 "Acerto de contas: {v}": "Acerto de contas: {v}",
 "Acessibilidade": "Acessibilidade",
 "Acesso ilimitado": "Acesso ilimitado",
 "Acesso ilimitado a todas as funções, sem prazo": "Acesso ilimitado a todas as funções, sem prazo",
 "Achatar": "Achatar",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Acompanha tudo, incluindo os gastos, e regista no diário.",
 "Acompanhamento": "Acompanhamento",
 "Acompanhantes": "Acompanhantes",
 "Acrescentar no fim da página": "Acrescentar no fim da página",
 "Adaptador de tomada": "Adaptador de tomada",
 "Adestramento": "Treino",
 "Adicionar": "Adicionar",
 "Adicionar amigo": "Adicionar amigo",
 "Adicionar amigos do app": "Adicionar amigos da app",
 "Adicionar ao Planner?": "Adicionar ao Planner?",
 "Adicionar arquivo": "Adicionar ficheiro",
 "Adicionar cômodo": "Adicionar divisão",
 "Adicionar fotos e vídeos": "Adicionar fotos e vídeos",
 "Adicionar imagem": "Adicionar imagem",
 "Adicionar item (ex.: 2 ovos mexidos)": "Adicionar item (ex.: 2 ovos mexidos)",
 "Adicionar na página": "Adicionar à página",
 "Adicionar passo": "Adicionar passo",
 "Adicionar país": "Adicionar país",
 "Adicionar página": "Adicionar página",
 "Adicionar texto": "Adicionar texto",
 "Adicionar {nome}": "Adicionar {nome}",
 "Adicionar à equipe": "Adicionar à equipa",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Adiciona um amigo pelo código dele ou envia o teu código a quem quiseres.",
 "Admin": "Admin",
 "Administração": "Gestão",
 "Adubar a cada quantos dias": "Adubar de quantos em quantos dias",
 "Adubar: {p}": "Adubar: {p}",
 "Adubei hoje": "Adubei hoje",
 "Advogado": "Advogado",
 "Advogados": "Advogados",
 "Afundo": "Afundos",
 "Agachamento": "Agachamentos",
 "Agenda do Google": "Calendário Google",
 "Agenda limpa": "Agenda limpa",
 "Agenda não liberada": "Calendário não autorizado",
 "Agenda sincronizada ✓": "Calendário sincronizado ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Agenda, notas, finanças, estudos, mensagens e muito mais numa só app.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Agenda, registo dos pacientes e pagamentos, sem o processo clínico.",
 "Agendado": "Agendado",
 "Agendado no My Planner": "Agendado no My Planner",
 "Agendamento no pet shop": "Marcação no pet shop",
 "Agendar": "Agendar",
 "Agendar no My Planner": "Agendar no My Planner",
 "Agendar no My Planner (dias e horários)": "Agendar no My Planner (dias e horários)",
 "Agora não": "Agora não",
 "Agora o verso do documento.": "Agora o verso do documento.",
 "Agora, {hora}": "Agora, {hora}",
 "Agora: {ml}": "Agora: {ml}",
 "Aguardando o celular · {s}s": "A aguardar o telemóvel · {s}s",
 "Aguarde": "Aguarda",
 "Aguarde um pouco": "Aguarde um pouco",
 "Aguarde...": "Aguarde...",
 "Ainda a pagar no mês": "Ainda por pagar este mês",
 "Ainda a receber no mês": "Ainda por receber este mês",
 "Ainda não confirmado": "Ainda não confirmado",
 "Ainda não disponível: falta configurar no servidor.": "Ainda não disponível: falta configurar no servidor.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Ainda não poupou nada este mês. Que tal pôr de lado {v} (10% do que entrou) assim que o dinheiro cair?",
 "Ainda não há feriados deste país para este ano.": "Ainda não há feriados deste país para este ano.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "Ainda não há nada neste separador para partilhar. Cria-o primeiro (ex.: a viagem) e volta aqui.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Ainda não há outras pessoas no grupo (ou não vês a lista de membros).",
 "Ainda não marcado como feito. Toque para abrir.": "Ainda não marcado como feito. Toque para abrir.",
 "Ainda não sincronizado": "Ainda não sincronizado",
 "Ainda sem chave neste dispositivo.": "Ainda sem chave neste dispositivo.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês",
 "Ajuda na organização": "Ajuda na organização",
 "Ajudante": "Ajudante",
 "Ajustar": "Ajustar",
 "Ajustar a data final": "Ajustar a data final",
 "Ajustar a folha": "Ajustar a folha",
 "Ajustar tamanho da página": "Ajustar tamanho da página",
 "Ajuste visual": "Ajuste visual",
 "Ajustes": "Definições",
 "Alarme dos remédios": "Alarme dos medicamentos",
 "Alarme que insiste até marcar como tomado": "Alarme que insiste até marcar como tomado",
 "Alemão": "Alemão",
 "Alergia": "Alergia",
 "Alergias": "Alergias",
 "Alergias e alertas": "Alergias e alertas",
 "Alertas": "Alertas",
 "Alertas das tarefas": "Alertas das tarefas",
 "Alertas dos compromissos": "Alertas dos compromissos",
 "Algo deu errado, mas o app continua aberto": "Algo correu mal, mas a app continua aberta",
 "Alguns arquivos foram guardados em outro dispositivo.": "Alguns ficheiros foram guardados noutro dispositivo.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, introduz os valores manualmente.",
 "Alguém": "Alguém",
 "Alguém indicou o app para você?": "Alguém lhe recomendou a app?",
 "Alimentação": "Alimentação",
 "Alimentação & Despensa": "Alimentação & Despensa",
 "Alimentação {semana}": "Alimentação {semana}",
 "Alimento": "Alimento",
 "Alinhamento e balanceamento": "Alinhamento e calibragem",
 "Almoço": "Almoço",
 "Alongamento": "Alongamentos",
 "Alta": "Alta",
 "Alterado por último por {nome}": "Alterado pela última vez por {nome}",
 "Alterar metadados": "Alterar metadados",
 "Alterar o valor pago": "Alterar o valor pago",
 "Alterações": "Alterações",
 "Alto-falante": "Altifalante",
 "Aluga como": "Arrenda como",
 "Alugar a casa ou um cômodo": "Arrendar a casa ou um quarto",
 "Aluguel": "Renda",
 "Aluguel & Hospedagem": "Arrendamento & Alojamento",
 "Aluguel de carro": "Aluguer de carro",
 "Aluno": "Aluno",
 "Alunos": "Alunos",
 "Alvará ou licença": "Alvará ou licença",
 "Alvenaria": "Alvenaria",
 "Alvo": "Objetivo",
 "Alíquota do ISS (%)": "Taxa do ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Taxa do ISS deste serviço (%)",
 "Amanhã": "Amanhã",
 "Ambiente": "Ambiente",
 "Ameno": "Ameno",
 "Amigos": "Amigos",
 "Amor": "Amor",
 "Amortização": "Amortização",
 "Ampliar a foto": "Ampliar a fotografia",
 "Amém": "Ámen",
 "Analisar com IA": "Analisar com IA",
 "Anamnese e histórico (no cofre)": "Anamnese e historial (no cofre)",
 "Anexar arquivos": "Anexar ficheiros",
 "Anexar comprovante": "Anexar comprovativo",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Anexar documentos, importar extratos e guardar relatórios, PDFs e cópias de segurança.",
 "Anexos": "Anexos",
 "Anexos guardados aqui no dispositivo: {n}": "Anexos guardados neste dispositivo: {n}",
 "Animais e natureza": "Animais e natureza",
 "Animação": "Animação",
 "Anime": "Anime",
 "Aniversário": "Aniversário",
 "Aniversário de Campo Grande": "Aniversário de Campo Grande",
 "Aniversário de São Paulo": "Aniversário de São Paulo",
 "Ano": "Ano",
 "Ano anterior": "Ano anterior",
 "Ano de lançamento": "Ano de lançamento",
 "Ano de {ano}": "Ano de {ano}",
 "Ano passado": "Ano passado",
 "Anotar pela foto da página": "Anotar pela fotografia da página",
 "Anotação": "Nota",
 "Anotação de {data}": "Nota de {data}",
 "Anotação do professor": "Nota do professor",
 "Anotação à mão": "Nota à mão",
 "Anotações": "Notas",
 "Anotações Rápidas": "Notas Rápidas",
 "Anotações arquivadas": "Notas arquivadas",
 "Anotações arquivadas ({n})": "Notas arquivadas ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Regista cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Registe o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Registe o que emprestou ou pediu emprestado, com foto e prazo. A app avisa no dia da devolução.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Anota os locais que queres conhecer. Pesquisa no Google Maps ou no Waze, traça a rota a passar por todos e coloca-os no roteiro do dia.",
 "Anteriores ({n})": "Anteriores ({n})",
 "Antes": "Antes",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Antes de começar, veja o que a app usa e porquê. Pode alterar tudo depois em Definições > Privacidade e termos.",
 "Antes de uma data": "Antes de uma data",
 "Antes do início": "Antes do início",
 "Antes e depois": "Antes e depois",
 "Antes: {lista}": "Antes: {lista}",
 "Antipulgas": "Antipulgas",
 "Anual": "Anual",
 "Ao ar livre": "Ao ar livre",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "Ao cancelar, o separador fica a preto e branco e as ligações desaparecem das tarefas, mas nada é apagado.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Ao criar a conta ou continuar a usar a app, concorda com estes termos e com a política de privacidade abaixo.",
 "Ao fechar, a página é salva.": "Ao fechar, a página é guardada.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "Ao guardar, cria a palavra-passe do cofre. Este campo é encriptado no dispositivo.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Ao tocar em \"Ficheiro\" ou \"Fotografia\" em Estudos e Documentos, o seletor do telemóvel mostra o Google Drive, o OneDrive e o Dropbox (quando as apps estão instaladas). Escolhe o ficheiro diretamente de lá.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Ao tocares num ficheiro anexado, abre na app do telemóvel que escolheres (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que editares lá fica guardado no próprio ficheiro.",
 "Apaga a conta e todos os vencimentos dela.": "Apaga a conta e todos os vencimentos dela.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Apaga as disciplinas e páginas deste dossier. As tarefas do planner mantêm-se.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Apaga as páginas desta disciplina. O tempo de estudo mantém-se no histórico.",
 "Apaga o cartão e as compras dele.": "Apaga o cartão e as compras dele.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não é possível anular.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Apaga todas as tarefas da agenda, passadas e futuras.",
 "Apaga todas as {n} parcelas.": "Apaga todas as {n} prestações.",
 "Apaga todos os meses desta conta.": "Apaga todos os meses desta conta.",
 "Apagar": "Apagar",
 "Apagar \"{nome}\"?": "Apagar \"{nome}\"?",
 "Apagar a caixa?": "Apagar a caixa?",
 "Apagar a chave": "Apagar a chave",
 "Apagar a chave deste dispositivo?": "Apagar a chave deste dispositivo?",
 "Apagar a conta?": "Apagar a conta?",
 "Apagar a lista de erros?": "Apagar a lista de erros?",
 "Apagar a pasta (os documentos continuam)": "Apagar a pasta (os documentos mantêm-se)",
 "Apagar as da agenda": "Apagar as do calendário",
 "Apagar caixa": "Apagar caixa",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Apagar mesmo (as páginas com tarja passam a imagem)",
 "Apagar de vez": "Apagar de vez",
 "Apagar desenho": "Apagar desenho",
 "Apagar envio": "Apagar envio",
 "Apagar lista": "Apagar lista",
 "Apagar minha conta": "Apagar a minha conta",
 "Apagar minha conta e todos os dados": "Apagar a minha conta e todos os dados",
 "Apagar o escritório": "Apagar o escritório",
 "Apagar o escritório?": "Apagar o escritório?",
 "Apagar o grupo": "Apagar o grupo",
 "Apagar o grupo?": "Apagar o grupo?",
 "Apagar o lançamento?": "Apagar o movimento?",
 "Apagar para todos": "Apagar para todos",
 "Apagar tudo": "Apagar tudo",
 "Apagar tudo antes de": "Apagar tudo antes de",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Apague de uma só vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, a app mostra o que vai sair e pede a sua palavra-passe.",
 "Aparece na barra quando estiver liberada": "Aparece na barra quando estiver desbloqueado",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Aparecem no Planner, juntamente com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpo de Deus).",
 "Aplicar": "Aplicar",
 "Aponte a câmera do celular para este QR Code.": "Aponte a câmara do telemóvel para este código QR.",
 "Aponte para o QR Code na tela do computador": "Aponte para o código QR no ecrã do computador",
 "Apostila": "Sebenta",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Sebentas, fichas, diapositivos, vídeos, links e recados. Em ⋮ › Enviar para um grupo, cada aluno recebe na app dele.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App usada no botão \"Rota\" das moradas (tarefas, consultas, roteiro da viagem, obras, escola...).",
 "Apple Saúde": "Apple Saúde",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: já grava tudo na app Saúde do iPhone. Não precisas de fazer nada.",
 "Apresentação": "Apresentação",
 "Aprovação": "Aprovação",
 "Aqui": "Aqui",
 "Ar-condicionado": "Ar condicionado",
 "Arco-íris": "Arco-íris",
 "Arenoso": "Arenoso",
 "Armazenamento": "Armazenamento",
 "Armário": "Armário",
 "Arquivadas ({n})": "Arquivadas ({n})",
 "Arquivados ({n})": "Arquivados ({n})",
 "Arquivar": "Arquivar",
 "Arquivar a caixa de anotações?": "Arquivar a caixa de notas?",
 "Arquivar conversa": "Arquivar conversa",
 "Arquivo": "Ficheiro",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "Ficheiro (Drive, OneDrive, Dropbox ou do dispositivo)",
 "Arquivo OFX ou CSV do banco": "Ficheiro OFX ou CSV do banco",
 "Arquivo adicionado": "Ficheiro adicionado",
 "Arquivo menor (para WhatsApp e e-mail)": "Ficheiro mais pequeno (para WhatsApp e e-mail)",
 "Arquivo menor para WhatsApp e e-mail.": "Ficheiro mais pequeno para WhatsApp e e-mail.",
 "Arquivo não encontrado.": "Ficheiro não encontrado.",
 "Arquivo ou PDF": "Ficheiro ou PDF",
 "Arquivo ou documento": "Ficheiro ou documento",
 "Arquivos": "Ficheiros",
 "Arquivos (frente, verso, PDF)": "Ficheiros (frente, verso, PDF)",
 "Arquivos (importar e exportar)": "Ficheiros (importar e exportar)",
 "Arquivos de {nome}": "Ficheiros de {nome}",
 "Arquivos na nuvem e cópias de segurança": "Ficheiros na nuvem e cópias de segurança",
 "Arrasou!": "Arrasaste!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Arrasta os pontos até aos 4 cantos da folha. A app recorta e endireita a página.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Arrasta o dedo sobre o que queres esconder. Toca numa tarja para a tirar.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Arrasta para a direita para eliminar, ou para a esquerda para enviar para outro separador.",
 "Arraste para a direita para excluir.": "Arrasta para a direita para eliminar.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Arrasta para mudar a ordem, roda, duplica, apaga e põe páginas em branco.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Arrasta para ver o resto do quadro. Ele cresce para baixo e para a direita.",
 "Arraste um documento para a direita para excluir.": "Arrasta um documento para a direita para eliminar.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Arraste uma caixa para a esquerda para arquivar ou para a direita para eliminar.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Arrasta uma caixa para a esquerda para arquivar ou para a direita para eliminar. Mantém premido ⋮⋮ para mudar a ordem.",
 "Arroz": "Arroz",
 "Artes": "Artes",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "As subscrições Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outras apps. Para ativar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; o Claude e o ChatGPT cobram por utilização, cêntimos por análise).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "As chamadas ainda não foram ativadas no servidor (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "As compras dele também saem das Finanças.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "As compras a prestações entram com todas as prestações: as seguintes já aparecem nos próximos extratos.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "As fotos deste documento estão no dispositivo onde foi digitalizado. Aí podes editar, partilhar e ler o texto.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "As imagens vão apenas para a IA que escolheste, com a tua chave.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "As faturas emitidas aqui, as encontradas na pesquisa e os XML importados aparecem nesta lista.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "As prestações aparecem aqui. Anexa o comprovativo (foto, PDF ou captura do PIX) em cada uma.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "As prestações dos próximos 12 meses já estão no My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "As prestações em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "As páginas deste documento estão no dispositivo onde foi digitalizado. Abre-o lá ou usa a cópia guardada no Drive ou no OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "As páginas passam a imagens mais leves: ótimo para PDFs digitalizados. O texto deixa de ser pesquisável (usa o OCR depois, se precisares).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "As páginas vão só para a IA que escolheste, com a tua chave.",
 "As receitas do cardápio já têm tudo na despensa.": "A despensa já tem tudo para as receitas da ementa.",
 "As senhas novas não conferem.": "As novas palavras-passe não coincidem.",
 "As senhas não conferem.": "As palavras-passe não coincidem.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "As tarefas continuam no My Planner. Quer apagar também as que vieram do Calendário Google?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "As tarefas da divisão continuam em A Minha Casa, sem divisão.",
 "As tarefas vinculadas continuam no My Planner.": "As tarefas associadas mantêm-se no My Planner.",
 "Aspirar e passar pano": "Aspirar e passar a esfregona",
 "Assinada": "Subscrito",
 "Assinar": "Assinar",
 "Assinar (simulação de teste)": "Subscrever (simulação de teste)",
 "Assinar o documento": "Assinar o documento",
 "Assinatura": "Assinatura",
 "Assinatura do profissional": "Assinatura do profissional",
 "Assinatura e segurança": "Assinatura e segurança",
 "Assinaturas (simulação de teste)": "Subscrições (simulação de teste)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Subscreva o separador em Definições para lhe enviar notas.",
 "Assine a aba em Ajustes para vincular.": "Subscreva o separador em Definições para associar.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Subscreva o separador em Definições › Compras para lhe enviar notas.",
 "Assine a aba em Ajustes › Compras para vincular.": "Subscreva o separador em Definições › Compras para associar.",
 "Assine a aba para abrir o vínculo.": "Subscreva o separador para abrir a ligação.",
 "Assisti mais uma aula": "Vi mais uma aula",
 "Assistido": "Visto",
 "Assistindo": "A ver",
 "Assistência técnica (nome)": "Assistência técnica (nome)",
 "Assistência: {nome}": "Assistência: {nome}",
 "Assunto": "Assunto",
 "Assunto (ex.: Reunião semanal)": "Assunto (ex.: Reunião semanal)",
 "Atender": "Atender",
 "Atendimento": "Consulta",
 "Atendimentos": "Consultas",
 "Ativar avisos": "Ativar avisos",
 "Ativar monitor": "Ativar monitor",
 "Ativas": "Ativas",
 "Atividade": "Atividade",
 "Atividade do roteiro": "Atividade do roteiro",
 "Atividade hoje": "Atividade hoje",
 "Atividade: {blocos}": "Atividade: {blocos}",
 "Atividades": "Atividades",
 "Atividades de hoje": "Atividades de hoje",
 "Atividades e materiais": "Atividades e materiais",
 "Atividades físicas e saúde": "Atividade física e saúde",
 "Atrasada": "Atrasada",
 "Atrasada há {n} dia(s)": "Atrasada há {n} dia(s)",
 "Atrasadas": "Atrasadas",
 "Atrasados": "Atrasados",
 "Atuais": "Atuais",
 "Atualidades": "Atualidades",
 "Atualizar": "Atualizar",
 "Atualizar agora": "Atualizar agora",
 "Atualizar alarmes no My Planner": "Atualizar alarmes no My Planner",
 "Atualizar rega e adubo na agenda": "Atualizar rega e adubo na agenda",
 "Atualização automática disponível no app instalado (APK).": "Atualização automática disponível na app instalada (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Atualização transferida. Entra ao reabrir a app ou ao tocar no aviso.",
 "Atualização pronta": "Atualização pronta",
 "Atualizações": "Atualizações",
 "Até": "Até",
 "Audiência": "Audiência",
 "Aula dada": "Aula dada",
 "Aula {a} de {n} ({p}%)": "Aula {a} de {n} ({p}%)",
 "Aulas assistidas": "Aulas vistas",
 "Autoajuda": "Autoajuda",
 "Autor": "Autor",
 "Avaliação": "Avaliação",
 "Avaliações e notas": "Avaliações e notas",
 "Avançado": "Avançado",
 "Aveia": "Aveia",
 "Avisar a hora de sair": "Avisar da hora de sair",
 "Avisar antes de vencer": "Avisar antes de expirar",
 "Avisar no celular quando alguém incluir algo": "Avisar no telemóvel quando alguém incluir algo",
 "Aviso": "Aviso",
 "Aviso com as tarefas do dia": "Aviso com as tarefas do dia",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Notificação de teste enviada pelo servidor. Chega dentro de alguns segundos; sai da app para a veres na barra do telemóvel.",
 "Aviso enviado": "Notificação enviada",
 "Aviso {dias} dia(s) antes e no dia": "Aviso {dias} dia(s) antes e no próprio dia",
 "Avisos no celular": "Notificações no telemóvel",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Os avisos no telemóvel passam pelos serviços da Expo, da Google e da Apple.",
 "Ação": "Ação",
 "Ações": "Ações",
 "BOLETO E DOCUMENTOS": "BOLETO E DOCUMENTOS",
 "Backup importado.": "Cópia de segurança importada.",
 "Bairro": "Bairro",
 "Baixa": "Baixa",
 "Baixando atualização...": "A transferir atualização...",
 "Baixar": "Transferir",
 "Baixar a versão {v}": "Transferir a versão {v}",
 "Baixar agora": "Transferir agora",
 "Baixar o My Planner para Android": "Transferir o My Planner para Android",
 "Baixar o My Planner para Android (versão {v})": "Transferir o My Planner para Android (versão {v})",
 "Baixar o My Planner para iPhone": "Transferir o My Planner para iPhone",
 "Baixar o PDF da nota (DANFSe)": "Transferir o PDF da fatura (DANFSe)",
 "Baixar o PDF?": "Transferir o PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Transferir o XML completo (dá ciência à SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Transfira a versão mais recente para Android: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Transfira aqui a versão mais recente: {link}",
 "Balança": "Baloiça",
 "Balanço e relatórios": "Balanço e relatórios",
 "Banana": "Banana",
 "Banco": "Banco",
 "Banco, financeira ou pessoa": "Banco, financeira ou pessoa",
 "Bandeiras": "Bandeiras",
 "Banheiro": "Casa de banho",
 "Banho": "Banho",
 "Banho e tosa": "Banho e tosquia",
 "Barra": "Barra",
 "Bateria": "Bateria",
 "Batimentos (média)": "Batimentos (média)",
 "Batizado": "Batizado",
 "Bebida": "Bebida",
 "Bebê": "Bebé",
 "Beijo": "Beijinho",
 "Bem": "Bem",
 "Bem clara": "Muito clara",
 "Bem-Estar": "Bem-Estar",
 "Bem-Estar · Cronograma alimentar": "Bem-Estar · Plano alimentar",
 "Bens": "Bens",
 "Bichos e diversão": "Animais e diversão",
 "Bicicleta": "Bicicleta",
 "Bicicleta ergométrica": "Bicicleta estática",
 "Biografia": "Biografia",
 "Biologia": "Biologia",
 "Biometria (digital ou rosto)": "Biometria (impressão digital ou rosto)",
 "Biometria ({tipos})": "Biometria ({tipos})",
 "Biometria não confirmada.": "Biometria não confirmada.",
 "Bloqueado": "Bloqueado",
 "Bloquear": "Bloquear",
 "Bloquear agora": "Bloquear agora",
 "Bloqueio": "Bloqueio",
 "Blusas de frio": "Camisolas",
 "Boa noite": "Boa noite",
 "Boa sorte!": "Boa sorte!",
 "Boas-vindas ao My Planner": "Bem-vindo ao My Planner",
 "Boas-vindas pelo WhatsApp": "Boas-vindas pelo WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto anexado",
 "Boleto do banco {b}": "Boleto do banco {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto e documentos (fotografia, PDF ou ficheiro)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto ou conta (fotografia, PDF ou ficheiro)",
 "Boleto por foto": "Boleto por fotografia",
 "Bolinha": "Bolinha",
 "Bom dia": "Bom dia",
 "Bom dia!": "Bom dia!",
 "Bom dia! Seu dia no My Planner": "Bom dia! O seu dia no My Planner",
 "Booking": "Booking",
 "Bora!": "Bora!",
 "Borboleta": "Borboleta",
 "Borracha": "Borracha",
 "Botas para neve": "Botas para a neve",
 "Brasil": "Brasil",
 "Braços acima da cabeça": "Braços acima da cabeça",
 "Brilho": "Brilho",
 "Brinquedo ou livro para a viagem": "Brinquedo ou livro para a viagem",
 "Busca de notas": "Pesquisa de faturas",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Procura o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.",
 "Buscando...": "A pesquisar...",
 "Buscar": "Pesquisar",
 "Buscar GIF (ex.: parabéns, bom dia)": "Pesquisar GIF (ex.: parabéns, bom dia)",
 "Buscar cidade, país ou GMT": "Pesquisar cidade, país ou GMT",
 "Buscar conversa": "Pesquisar conversa",
 "Buscar documento, titular ou órgão": "Procurar documento, titular ou entidade",
 "Buscar em {nome}": "Procurar em {nome}",
 "Buscar emoji (ex.: coração, risada)": "Pesquisar emoji (ex.: coração, riso)",
 "Buscar figurinha": "Pesquisar autocolante",
 "Buscar notas": "Pesquisar faturas",
 "Buscar ou digitar um alimento": "Procurar ou escrever um alimento",
 "Buscar país": "Pesquisar país",
 "Buscar pelo nome ou pelo texto": "Pesquisar pelo nome ou pelo texto",
 "Buscar produto, loja ou observação": "Pesquisar produto, loja ou observação",
 "Buscar tarefas": "Pesquisar tarefas",
 "Buscar: processo, parte, tribunal, palavra...": "Pesquisar: processo, parte, tribunal, palavra...",
 "CAIXA {n}": "CAIXA {n}",
 "CARDS DE ANOTAÇÕES": "CARTÕES DE NOTAS",
 "CARTÕES": "CARTÕES",
 "CEP": "CEP (código postal)",
 "CID (se o paciente pedir na declaração)": "CID (CID-10, se o paciente pedir na declaração)",
 "CID: {c}": "CID: {c}",
 "CNH": "Carta de condução (CNH)",
 "CNPJ (se tiver)": "CNPJ (se tiver)",
 "CNPJ ou CPF": "CNPJ ou CPF",
 "COMPROVANTE DE PAGAMENTO": "COMPROVATIVO DE PAGAMENTO",
 "COMPROVANTE DE RECEBIMENTO": "COMPROVATIVO DE RECEBIMENTO",
 "COMPROVANTES ANTERIORES": "COMPROVATIVOS ANTERIORES",
 "CONTAS DO MÊS": "CONTAS DO MÊS",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brasil)",
 "CPF de quem paga": "CPF de quem paga",
 "CPF do paciente": "CPF do paciente",
 "CPF do pagador": "CPF do pagador",
 "CPF inválido": "CPF inválido",
 "CPF ou CNPJ de quem recebeu": "CPF ou CNPJ de quem recebeu",
 "CPF ou senha incorretos.": "CPF ou palavra-passe incorretos.",
 "CRIAR CÔMODO": "CRIAR DIVISÃO",
 "CRIAR UM GRUPO": "CRIAR UM GRUPO",
 "CRONOGRAMA ALIMENTAR": "PLANO ALIMENTAR",
 "CUIDADOS PESSOAIS": "CUIDADOS PESSOAIS",
 "Cabeleireiro": "Cabeleireiro",
 "Cabelo": "Cabelo",
 "Cachorro": "Cão",
 "Cactos e suculentas": "Catos e suculentas",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Cada separador extra: {n} dias grátis; depois {preco} por ano.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Cada ficheiro pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.",
 "Cada dia da semana": "Cada dia da semana",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Cada documento novo vai para o {nome} quando sais dele. As fotos das páginas ficam só neste dispositivo.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Cada pessoa da equipa recebe a reunião em Recebidos e coloca-a no Planner com um toque, com o alerta.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Cada pessoa do grupo recebe e decide se aceita.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Cada página guarda um resumo, aula ou capítulo. Marque como revista quando terminar.",
 "Cada página vira uma imagem JPG.": "Cada página passa a uma imagem JPG.",
 "Cada refeição se repete nos dias dela": "Cada refeição repete-se nos seus dias",
 "Cadastrar": "Registar",
 "Cadastrar cartão de crédito": "Registar cartão de crédito",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Registar pela fotografia (página do curso, certificado, folheto)",
 "Cadastrar pela foto da capa": "Registar pela fotografia da capa",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Preenche \"Os meus dados\" para os recibos saírem com o teu nome, ordem e número.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Regista documentos de identificação, carta de condução, passaporte, contratos e certidões. A app avisa antes de expirarem e envia o documento com um toque.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Registe a empresa (ou a si próprio, como profissional) com CNPJ ou CPF, município e regime. Depois ative o certificado A1 para emitir NFS-e pelo Padrão Nacional e pesquisar as faturas emitidas e recebidas.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Registe a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Registe a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Registe apenas o seu próprio nome e a sua OAB.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Registe as crianças: testes, reuniões, consultas e vacinas ficam dentro de cada uma.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Registe cada animal: boletim de vacinas, desparasitantes, medicamentos e pet shop ficam dentro dele.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Registe cada planta com luz, solo e de quantos em quantos dias regar e adubar. A app monta o calendário na agenda.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Registe cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.",
 "Cadastre digital ou rosto no aparelho para usar.": "Registe a impressão digital ou o rosto no dispositivo para usar.",
 "Cadastre o cartão primeiro": "Registe o cartão primeiro",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Regista o financiamento ou empréstimo com o valor, os juros e o número de prestações. A app calcula as prestações, o capital em dívida e avisa dos vencimentos.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Regista o imóvel inteiro ou cada quarto que arrendas. Dentro de cada um ficam as reservas, a limpeza e as despesas.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Registe o livro com o total de páginas e a meta diária. Toque em ⋮ para somar as páginas lidas.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Registe o medicamento com os horários e toque em ⋮ para o pôr na cronologia com alarme.",
 "Cadastre os alunos da turma na aba Alunos.": "Registe os alunos da turma no separador Alunos.",
 "Cadastre os clientes para separar as horas.": "Registe os clientes para separar as horas.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Registe os clientes que recebem as suas faturas. A morada é opcional (se a preencher, indique CEP, código IBGE, rua, número e bairro).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Registe os serviços que mais emite, com o código de tributação nacional. Na hora de emitir, basta tocar.",
 "Cadastre primeiro em {nome}.": "Registe primeiro em {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Regista o teu nome, ordem e número de inscrição. Aparecem nos recibos e nas declarações.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Registe os seus clientes no separador \"Tomadores\" da empresa para os escolher aqui.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Regista os teus dados profissionais (nome, ordem e número) em \"Os meus dados\" para saírem no documento.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Regista os teus dados profissionais (nome, ordem e número) em \"Os meus dados\" para saírem no recibo.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Regista os teus pacientes. Dentro de cada um ficam as consultas com evolução, prescrição, pagamento, recibo e declaração para o seguro de saúde.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Registe-se a si e a cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e medicamentos. Os dados sensíveis vão para o cofre encriptado.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Registo a aguardar aprovação: desative \"Confirm email\" no Supabase (veja COMO RODAR).",
 "Cadastro recebido": "Registo recebido",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Registo: nome, CPF ou e-mail, palavra-passe (guardada apenas de forma protegida) e e-mail de contacto.",
 "Cadastros": "Registos",
 "Cadastros e comprovantes": "Registos e comprovativos",
 "Cadeira extensora": "Cadeira extensora",
 "Café": "Café",
 "Café da manhã": "Pequeno-almoço",
 "Café ou bar": "Café ou bar",
 "Café?": "Café?",
 "Cafés": "Cafés",
 "Caixa": "Caixa",
 "Caixa arquivada": "Caixa arquivada",
 "Caixa com checklist, lista ou texto livre": "Caixa com checklist, lista ou texto livre",
 "Caixa {n}": "Caixa {n}",
 "Caixas": "Caixas",
 "Caixas e cronograma da mudança.": "Caixas e calendário da mudança.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Caixas por divisão com etiqueta, mudança de água, luz e internet, vistorias e o cronograma dos dias.",
 "Calculadora": "Calculadora",
 "Calculando...": "A calcular...",
 "Calendário": "Calendário",
 "Calendário da planta": "Calendário da planta",
 "Calendário do imposto": "Calendário do imposto",
 "Calendários": "Calendários",
 "Calorias em atividade": "Calorias em atividade",
 "Calorias gastas em atividade (kcal)": "Calorias gastas em atividade (kcal)",
 "Calça térmica (segunda pele)": "Calças térmicas (primeira camada)",
 "Calças ou bermudas": "Calças ou calções",
 "Cama": "Cama",
 "Caminhada": "Caminhada",
 "Caminhão": "Camião",
 "Camisetas": "T-shirts",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Campos de formulário",
 "Cancelada": "Cancelada",
 "Canceladas": "Canceladas",
 "Cancelar": "Cancelar",
 "Cancelar a NFS-e": "Cancelar a NFS-e",
 "Cancelar a NFS-e {n}?": "Cancelar a NFS-e {n}?",
 "Cancelar a nota": "Cancelar a fatura",
 "Cancelar a reunião \"{nome}\"?": "Cancelar a reunião \"{nome}\"?",
 "Cancelar reunião": "Cancelar reunião",
 "Caneta": "Caneta",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h",
 "Captura automática: todos os dias às 08h e 12h": "Captura automática: todos os dias às 08h e 12h",
 "Card": "Cartão",
 "Cardápio": "Ementa",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Ementa da semana, receitas, lista de compras automática e validade da despensa.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Ementa só para este dia. Os outros dias mantêm a da semana.",
 "Carga (kg)": "Carga (kg)",
 "Carimbo": "Carimbo",
 "Carnaval": "Carnaval",
 "Carne magra": "Carne magra",
 "Carregando feriados...": "A carregar feriados...",
 "Carregando...": "A carregar...",
 "Carro": "Carro",
 "Carta": "Carta",
 "Carteira": "Carteira",
 "Carteira de trabalho": "Carteira profissional de trabalho",
 "Carteira profissional (OAB, CRC, CREA...)": "Cédula profissional (OAB, CRC, CREA...)",
 "Cartão": "Cartão",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Cartão de contacto das Mensagens: a fotografia, o telefone, o e-mail e a frase que tu próprio escolheres pôr. Só quem conversa contigo, os teus amigos e quem partilha um grupo da app contigo os veem.",
 "Cartão de crédito": "Cartão de crédito",
 "Cartão de débito": "Cartão de débito",
 "Cartão parcelado": "Cartão a prestações",
 "Cartões": "Cartões",
 "Cartões de visita": "Cartões de visita",
 "Cartões e dinheiro": "Cartões e dinheiro",
 "Casa": "Casa",
 "Casa e rotina": "Casa e rotina",
 "Casa, família e veículos": "Casa, família e veículos",
 "Casaco leve": "Casaco leve",
 "Casaco pesado": "Casaco grosso",
 "Casamento": "Casamento",
 "Castanhas": "Frutos secos",
 "Categoria": "Categoria",
 "Categoria de \"{d}\"": "Categoria de \"{d}\"",
 "Categorias": "Categorias",
 "Caução": "Caução",
 "Ceia": "Ceia",
 "Celular": "Telemóvel",
 "Celular confirmado": "Telemóvel confirmado",
 "Celular e carregador": "Telemóvel e carregador",
 "Certidão": "Certidão",
 "Certificado digital": "Certificado digital",
 "Certificado digital A1": "Certificado digital A1",
 "Certificado ligado": "Certificado ativado",
 "Chamada": "Chamada",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.",
 "Chamada, notas, planos de aula e materiais.": "Presenças, notas, planos de aula e materiais.",
 "Chamadas": "Chamadas",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "As chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "As chamadas de áudio e vídeo passam pelos servidores da LiveKit, apenas durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o ficheiro vai diretamente para o armazenamento da app.",
 "Chamando...": "A chamar...",
 "Chapéu ou boné": "Chapéu ou boné",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Chave da IA não registada neste dispositivo (Definições › Inteligência artificial).",
 "Chave de acesso": "Chave de acesso",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} a partir das {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} até às {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Checklist",
 "Chinelo": "Chinelos",
 "Chá de bebê": "Baby shower",
 "Cidade": "Cidade",
 "Cidade (para a data dos recibos)": "Localidade (para a data dos recibos)",
 "Cidade de {nome}": "Cidade de {nome}",
 "Cidades": "Cidades",
 "Cifrão": "Cifrão",
 "Cinza": "Cinzento",
 "Cirurgia": "Cirurgia",
 "Ciências": "Ciências",
 "Clara": "Clara",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Clareia PDFs digitalizados: fundo branco, cinzento ou preto e branco.",
 "Claro": "Claro",
 "Classificar categorias com IA": "Classificar categorias com IA",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT ou Gemini",
 "Cliente": "Cliente",
 "Clientes": "Clientes",
 "Clima esperado": "Clima previsto",
 "Co-anfitrião": "Coanfitrião",
 "Cobrança": "Cobrança",
 "Cobranças": "Cobranças",
 "Coelho": "Coelho",
 "Cofre (criptografia de ponta a ponta)": "Cofre (encriptação ponto a ponto)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Cofre aberto (fecha sozinho após 5 minutos sem uso)",
 "Cofre ainda não criado": "Cofre ainda não criado",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Cofre encriptado para cartão de cidadão, carta de condução, passaporte, contratos e certidões, com contagem até ao fim da validade e envio com um toque.",
 "Cofre fechado": "Cofre fechado",
 "Cofrinho": "Mealheiro",
 "Cole aqui a chave ({ini}...)": "Cole aqui a chave ({ini}...)",
 "Cole o link (https://...)": "Cole a ligação (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Cole ou escreva o código de barras (ou o Pix copia e cola) no campo do código: a app calcula sozinha o valor e o vencimento. Com a sua IA ligada, lê tudo pela fotografia.",
 "Coloca arquivos dentro do PDF.": "Coloca ficheiros dentro do PDF.",
 "Colocar na agenda": "Pôr na agenda",
 "Colocar na linha do tempo com alarme": "Pôr na cronologia com alarme",
 "Colocar no My Planner": "Pôr no My Planner",
 "Colocar rega e adubo na agenda": "Pôr rega e adubo na agenda",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Coloca o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.",
 "Coluna": "Coluna",
 "Colágeno": "Colagénio",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Com a biometria ativada, ela aparece primeiro. Se falhar, use o padrão ou a palavra-passe.",
 "Com convênio": "Com seguro de saúde",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Com o indicativo do país e da zona. Ex.: +55 41 99999-0000",
 "Com outras pessoas": "Com outras pessoas",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Com prazo, a app calcula quanto poupar por mês. O dinheiro poupado conta como \"Poupou\" no mês.",
 "Com quem": "Com quem",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Quem pagou, o paciente, a data e o valor de cada consulta paga. Como pessoa singular, lança cada uma na app Receita Federal › Receita Saúde; com CNPJ, emite a fatura de serviço.",
 "Com valor a receber": "Com valor a receber",
 "Com vencimento": "Com vencimento",
 "Combinado": "Combinado",
 "Combinado 👍": "Combinado 👍",
 "Combustível": "Combustível",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Comece por registar as contas fixas do mês (renda, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.",
 "Comecei em": "Comecei a",
 "Comentários": "Comentários",
 "Começa amanhã": "Começa amanhã",
 "Começa às {hora} (em {m} min)": "Começa às {hora} (daqui a {m} min)",
 "Começar": "Começar",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Começar com o modelo: pequeno-almoço, lanche, almoço, lanche e jantar",
 "Começar em": "Começar em",
 "Começar o teste grátis": "Começar o teste grátis",
 "Comi outros alimentos ou quantidades": "Comi outros alimentos ou quantidades",
 "Comida": "Comida",
 "Comidas e bebidas": "Comida e bebida",
 "Comido": "Comido",
 "Comido / alterações": "Comido / alterações",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.",
 "Comigo": "Comigo",
 "Comissão da plataforma": "Comissão da plataforma",
 "Como apagar a sua conta e os seus dados": "Como apagar a tua conta e os teus dados",
 "Como chegar": "Como chegar",
 "Como ela está": "Como está",
 "Como estou comparado ao mês passado?": "Como estou em comparação com o mês passado?",
 "Como funciona": "Como funciona",
 "Como planejado": "Como planeado",
 "Compartilhado no grupo": "Partilhado no grupo",
 "Compartilhado no grupo · só leitura": "Partilhado no grupo · só leitura",
 "Compartilhamento indisponível neste dispositivo.": "Partilha indisponível neste dispositivo.",
 "Compartilhar": "Partilhar",
 "Compartilhar PDF": "Partilhar PDF",
 "Compartilhar a limpeza": "Partilhar a limpeza",
 "Compartilhar os dados": "Partilhar os dados",
 "Compartilhar os dados com a equipe": "Partilhar os dados com a equipa",
 "Compartilhar os dados com o grupo?": "Partilhar os dados com o grupo?",
 "Compartilhar texto": "Partilhar texto",
 "Competência (mês de referência)": "Competência (mês de referência)",
 "Competência {d}": "Competência {d}",
 "Complemento": "Complemento",
 "Complete seus dados": "Completa os teus dados",
 "Compra": "Compra",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.",
 "Compra feita": "Compra feita",
 "Compra no cartão": "Compra no cartão",
 "Compras": "Compras",
 "Compras da semana": "Compras da semana",
 "Comprimir": "Comprimir",
 "Compromisso": "Compromisso",
 "Compromisso da escola": "Compromisso da escola",
 "Comprovante": "Comprovativo",
 "Comprovante guardado": "Comprovativo guardado",
 "Comprovantes": "Comprovativos",
 "Computador": "Computador",
 "Comédia": "Comédia",
 "Concedi": "Concedi",
 "Concluir": "Concluir",
 "Concluir (esquerda)": "Concluir (esquerda)",
 "Concluída": "Concluída",
 "Concluído": "Concluído",
 "Concluído (%)": "Concluído (%)",
 "Concluído!": "Concluído!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Concordo que o meu nome, CPF e e-mail sejam usados apenas para identificar a minha conta, e que as minhas tarefas e notas fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Definições › Segurança.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Concordo que o meu nome, CPF e e-mail sejam usados apenas para identificar a minha conta, e que as minhas tarefas e notas fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Definições.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Concordo que o meu nome, documento e e-mail sejam usados apenas para identificar a minha conta, e que as minhas tarefas e notas fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Definições › Segurança.",
 "Concursos": "Concursos públicos",
 "Condicionador": "Amaciador",
 "Condomínio": "Condomínio",
 "Condomínio e IPTU": "Condomínio e IMI",
 "Conectado": "Ligado",
 "Conectando...": "A ligar...",
 "Conectar": "Ligar",
 "Conectar navegador": "Ligar navegador",
 "Conectar o {nome}": "Ligar o {nome}",
 "Conectar relógio ou app de saúde": "Ligar relógio ou app de saúde",
 "Conectar {nome}": "Ligar {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Liga o {nome} em Definições › Google Drive e OneDrive.",
 "Conferindo...": "A verificar...",
 "Conferir controles, chaves e Wi-Fi": "Verificar comandos, chaves e Wi-Fi",
 "Conferir o prazo no sistema oficial": "Verificar o prazo no sistema oficial",
 "Confete": "Confettis",
 "Configuração geral": "Configuração geral",
 "Confira a senha da sua conta e tente de novo.": "Verifique a palavra-passe da sua conta e tente novamente.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Confirme as datas oficiais no site da Receita Federal e ajuste se for preciso.",
 "Confira o código. Ele tem 6 letras e números.": "Verifique o código. Tem 6 letras e números.",
 "Confira o e-mail ou deixe em branco.": "Verifique o e-mail ou deixe em branco.",
 "Confira o e-mail.": "Verifique o e-mail.",
 "Confira o prazo no sistema oficial.": "Verifique o prazo no sistema oficial.",
 "Confira os 11 números.": "Verifique os 11 números.",
 "Confira os campos antes de salvar.": "Verifique os campos antes de guardar.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Verifique se a sua conta Google está adicionada no telemóvel e se o calendário está a sincronizar.",
 "Confirmada": "Confirmada",
 "Confirmado": "Confirmado",
 "Confirmar": "Confirmar",
 "Confirme a declaração sobre a empresa.": "Confirme a declaração sobre a empresa.",
 "Confirme o seu celular": "Confirma o teu telemóvel",
 "Confirme para ativar a biometria": "Confirme para ativar a biometria",
 "Confirme para excluir": "Confirma para eliminar",
 "Confirme sua senha para sincronizar": "Confirma a tua palavra-passe para sincronizar",
 "Confraternização": "Convívio",
 "Confraternização Universal": "Dia de Ano Novo",
 "Conselho": "Ordem profissional",
 "Consignado": "Crédito consignado",
 "Consulta": "Consulta",
 "Consulta ou vacina": "Consulta ou vacina",
 "Consultas": "Consultas",
 "Consultório": "Consultório",
 "Consumo médio: {v} km/L": "Consumo médio: {v} km/L",
 "Conta": "Conta",
 "Conta a pagar": "Conta a pagar",
 "Conta a receber": "Conta a receber",
 "Conta de consumo ou tributo": "Conta de consumo ou imposto",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Conta os dias em que cada item estava previsto (pelos seus dias da semana) e os que foram marcados como feitos.",
 "Conta paga": "Conta paga",
 "Conta recebida": "Conta recebida",
 "Conta vence hoje": "Conta vence hoje",
 "Conta vencendo": "Conta a vencer",
 "Contabilidade": "Contabilidade",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Inclui os acompanhantes. Toque no estado do convidado para o alterar.",
 "Contando: {cliente}": "A contar: {cliente}",
 "Contas": "Contas",
 "Contas a pagar": "Contas a pagar",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Contas a pagar e a receber, despesas do mês, aviso de vencimento e controlo do MEI (Mestre Achado).",
 "Contas a receber": "Contas a receber",
 "Contas fixas": "Contas fixas",
 "Contato": "Contacto",
 "Contato de emergência": "Contacto de emergência",
 "Contato do encarregado de dados:": "Contacto do encarregado de proteção de dados:",
 "Conte a sua ideia para o app ficar melhor.": "Partilhe a sua ideia para a app ficar melhor.",
 "Conte o que está difícil ou não funciona como deveria.": "Diga-nos o que está difícil ou não funciona como devia.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Conte o que fez, o que esperava e o que apareceu. Se houver uma mensagem de erro, copie-a aqui.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Fale-nos de problemas, erros e ideias de melhoria. A sua mensagem vai diretamente para a equipa do My Planner.",
 "Conteúdo": "Conteúdo",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Conteúdo que cria: tarefas, notas, finanças, documentos, fotografias, anexos e dados dos separadores.",
 "Conteúdo, matéria, tarefa de casa...": "Conteúdo, matéria, trabalho de casa...",
 "Continuar": "Continuar",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Continue a usar o My Planner e as Notas por {preco} por ano. Os seus dados continuam guardados.",
 "Contratado": "Contratado",
 "Contratado: {v}": "Contratado: {v}",
 "Contrato": "Contrato",
 "Conversa": "Conversa",
 "Conversa do grupo": "Conversa do grupo",
 "Conversar": "Conversar",
 "Conversar com o Mestre (precisa da sua IA)": "Conversar com o Mestre (precisa da sua IA)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Conversa com amigos e grupos e faz chamadas de áudio e vídeo.",
 "Converter de PDF": "Converter de PDF",
 "Converter para PDF": "Converter para PDF",
 "Convidado": "Convidado",
 "Convidados": "Convidados",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.",
 "Convidados e cronograma do dia, sem os valores.": "Convidados e programa do dia, sem os valores.",
 "Convidar": "Convidar",
 "Convidar pelo WhatsApp": "Convidar pelo WhatsApp",
 "Convite": "Convite",
 "Convite copiado. Cole onde quiser enviar.": "Convite copiado. Cola onde quiseres enviar.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Convite inválido ou alterado pelo administrador. Pede um link novo.",
 "Convite para o My Planner": "Convite para o My Planner",
 "Convênio": "Seguro de saúde",
 "Copiar": "Copiar",
 "Copiar a lista para uma tarefa": "Copiar a lista para uma tarefa",
 "Copiar o código": "Copiar o código",
 "Copiar para hoje": "Copiar para hoje",
 "Copo de outro tamanho": "Copo de outro tamanho",
 "Copo {n}": "Copo {n}",
 "Cor": "Cor",
 "Cor do fichário": "Cor do dossier",
 "Cor do tema": "Cor do tema",
 "Cor do tema de cada aba": "Cor do tema de cada separador",
 "Coração": "Coração",
 "Corações": "Corações",
 "Cores das abas": "Cores dos separadores",
 "Cores das conversas": "Cores das conversas",
 "Cores e opções desta aba": "Cores e opções deste separador",
 "Corpo": "Corpo",
 "Corporativo": "Empresarial",
 "Corpus Christi": "Corpo de Deus",
 "Corredor": "Corredor",
 "Correia dentada": "Correia de distribuição",
 "Corrida": "Corrida",
 "Corta as bordas em branco ou partes da página.": "Corta as margens em branco ou partes da página.",
 "Cortesia": "Cortesia",
 "Coxa e sobrecoxa": "Perna de frango",
 "Cozinha": "Cozinha",
 "Creatina": "Creatina",
 "Criada em {data}": "Criada em {data}",
 "Criado com": "Criado com",
 "Criado em": "Criado em",
 "Criança": "Criança",
 "Crianças": "Crianças",
 "Criar": "Criar",
 "Criar animada": "Criar animado",
 "Criar conta": "Criar conta",
 "Criar do zero": "Criar de raiz",
 "Criar documento, planilha ou apresentação": "Criar documento, folha de cálculo ou apresentação",
 "Criar em outro app": "Criar noutra app",
 "Criar escritório": "Criar escritório",
 "Criar fichário": "Criar dossier",
 "Criar figurinha": "Criar autocolante",
 "Criar grupo": "Criar grupo",
 "Criar grupo e convidar pessoas": "Criar grupo e convidar pessoas",
 "Criar minha chave de API": "Criar a minha chave de API",
 "Criar o cofre": "Criar o cofre",
 "Criar o grupo e convidar": "Criar o grupo e convidar",
 "Criar os prazos do IR de {ano}": "Criar os prazos do IR de {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Criar um objetivo (viagem, reserva, carro...)",
 "Criar uma senha nova": "Criar uma palavra-passe nova",
 "Criar {n} tarefa(s)": "Criar {n} tarefa(s)",
 "Criação do Estado de MS": "Criação do Estado de MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Crie a mudança e a app monta logo a lista de mudanças de titular (luz, água, internet...). Depois registe as caixas por divisão, as vistorias e o cronograma dos dias.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Crie a pasta de cada cliente, convide o cliente pela ligação (ele só vê a pasta dele) e troquem documentos nos dois sentidos: faturas, guias, folha de vencimentos, extratos, contratos.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Cria a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Cria as tarefas da casa (limpar a casa de banho, mudar a roupa de cama...) com a frequência. A app avisa quando estão em atraso, sem encher o My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Cria cartões com checklist, lista, texto livre ou desenho para esta disciplina. Arrasta para a direita para eliminar e para a esquerda para arquivar.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Cria o escritório, chama a equipa (amigos da app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam videorreuniões. Tu, que administras, podes gravar as reuniões.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Cria o grupo e envia a ligação: quem entrar recebe data, local, avisos e tudo o que enviares, e aceita, edita ou recusa.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Cria o grupo e envia a ligação: quem entrar vê e participa conforme o papel que escolheres. Só quem administra adiciona ou remove pessoas.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Cria o grupo e envia a ligação: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra adiciona ou remove pessoas.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Crie a sua conta. Os seus dados ficam guardados na nuvem e neste dispositivo.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Crie um dossier (ex.: Doutoramento, Inglês, Concurso) e, dentro dele, as disciplinas e páginas.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Cria um grupo (turma, pacientes, equipa, convidados, clientes), envia o link de convite e envia compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Crie um perfil com nome e, se for advogado, a OAB.",
 "Criptografado no cofre, só neste dispositivo": "Encriptado no cofre, só neste dispositivo",
 "Criptomoedas": "Criptomoedas",
 "Cronograma": "Cronograma",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Plano alimentar, cuidados pessoais passo a passo e água do dia.",
 "Cronograma do dia": "Cronograma do dia",
 "Cronograma físico-financeiro": "Cronograma físico-financeiro",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.",
 "Cronômetro de horas": "Cronómetro de horas",
 "Crédito empresarial": "Crédito empresarial",
 "Créditos": "Créditos",
 "Cuida das reservas, da limpeza e das despesas.": "Trata das reservas, da limpeza e das despesas.",
 "Cuidado": "Cuidado",
 "Cuidado pessoal": "Cuidado pessoal",
 "Cuidados": "Cuidados",
 "Cupom do mercado": "Talão do supermercado",
 "Cupom do mercado (foto)": "Talão do supermercado (foto)",
 "Cupom lançado": "Talão lançado",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Curso",
 "Cursos": "Cursos",
 "Cursos livres e certificações": "Cursos livres e certificações",
 "Cuscuz": "Cuscuz de milho",
 "CÓDIGO PARA PAGAR": "CÓDIGO PARA PAGAR",
 "CÔMODOS": "DIVISÕES",
 "Câmera": "Câmara",
 "Câmera e galeria": "Câmara e galeria",
 "Câmera não liberada": "Câmara não autorizada",
 "Código IBGE do município": "Código IBGE do município",
 "Código IBGE do município (7 números)": "Código IBGE do município (7 algarismos)",
 "Código NBS (9 números, opcional)": "Código NBS (9 algarismos, opcional)",
 "Código copiado": "Código copiado",
 "Código da reserva (localizador)": "Código da reserva (localizador)",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Código de barras, linha digitável ou Pix copia e cola (opcional)",
 "Código de indicação": "Código de recomendação",
 "Código de indicação (opcional)": "Código de recomendação (opcional)",
 "Código de quem convidou você": "Código de quem o convidou",
 "Código de tributação nacional (6 números)": "Código de tributação nacional (6 algarismos)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Código de tributação nacional (6 algarismos, ex.: 171901)",
 "Código do amigo": "Código do amigo",
 "Código do convite": "Código do convite",
 "Código do procedimento (TUSS ou do plano)": "Código do procedimento (TUSS ou do seguro)",
 "Código errado. Confira e tente de novo.": "Código errado. Confirma e tenta outra vez.",
 "Código não encontrado. Confira as letras e os números.": "Código não encontrado. Verifique as letras e os números.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Código não reconhecido. Confirme os números (boleto: 47 ou 48 números).",
 "Código: {c}": "Código: {c}",
 "Cópia automática toda semana": "Cópia automática todas as semanas",
 "Cópia criada.": "Cópia criada.",
 "Cópia de segurança": "Cópia de segurança",
 "Cópia feita": "Cópia feita",
 "Cópia restaurada.": "Cópia restaurada.",
 "Cômodo": "Divisão",
 "Cômodo ou quarto": "Quarto ou divisão",
 "Cômodos da casa e as tarefas de cada um.": "Divisões da casa e as tarefas de cada uma.",
 "DAS de {mes} pago": "DAS de {mes} pago",
 "DAS de {mes}: vence dia {dia}": "DAS de {mes}: vence dia {dia}",
 "DAS do MEI": "DAS do MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "DECLARAÇÃO DE CONSULTA",
 "DICA DO MESTRE ACHADO": "DICA DO MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS n.º {n}, série {s}",
 "Da galeria ou dos arquivos": "Da galeria ou dos ficheiros",
 "Da meta de passos": "Da meta de passos",
 "Dados compartilhados": "Dados partilhados",
 "Dados compartilhados com o grupo": "Dados partilhados com o grupo",
 "Dados compartilhados · seu papel: {p}": "Dados partilhados · a sua função: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Os dados de saúde que regista são tratados apenas para si e para quem os partilhar, com o seu consentimento (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para os avisos no telemóvel.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Os dados do relógio e de saúde não são usados para publicidade nem partilhados com ninguém. Podes desligar e revogar a permissão a qualquer momento.",
 "Dança": "Dança",
 "Dar ciência": "Dar ciência",
 "Dar ciência da operação?": "Dar ciência da operação?",
 "Data": "Data",
 "Data (embarque ou check-in)": "Data (embarque ou check-in)",
 "Data agendada": "Data marcada",
 "Data da aplicação": "Data da aplicação",
 "Data da compra": "Data da compra",
 "Data da entrega": "Data da entrega",
 "Data da venda": "Data da venda",
 "Data de nascimento": "Data de nascimento",
 "Data do empréstimo": "Data do empréstimo",
 "Data do pagamento": "Data do pagamento",
 "Data em que foi feita": "Data em que foi feita",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Data sugerida com 2 dias úteis de margem. Verifique no sistema oficial.",
 "De": "De",
 "De uma foto": "De uma foto",
 "De {de} para {para} ({p}% menor).": "De {de} para {para} ({p}% menos).",
 "Declaração": "Declaração",
 "Declaração de atendimento": "Declaração de consulta",
 "Declaração para reembolso (PDF)": "Declaração para reembolso (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Declaro que esta empresa é minha ou de um cliente que autorizou o acompanhamento.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Declaro, para efeitos de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Define a meta de aulas por dia ou por semana em Editar.",
 "Defina a meta de páginas por dia em Editar.": "Define a meta de páginas por dia em Editar.",
 "Defina um horário": "Defina uma hora",
 "Defina um horário para usar pausas.": "Defina uma hora para usar pausas.",
 "Demaquilante ou água micelar": "Desmaquilhante ou água micelar",
 "Demolição": "Demolição",
 "Demonstração": "Demonstração",
 "Dentista": "Dentista",
 "Dependentes": "Dependentes",
 "Depois": "Depois",
 "Depois da aula": "Depois da aula",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Depois de apagadas, as tarefas não voltam. Introduza a palavra-passe da sua conta para confirmar.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Depois de transferir, abra o ficheiro e toque em Instalar. Se o telemóvel pedir, permita instalar apps desta fonte.",
 "Depois de criar": "Depois de criar",
 "Depois de {nome}. Toque para pular.": "Depois de {nome}. Toca para saltar.",
 "Depois é só ajustar horários e o que comer em cada um.": "Depois é só ajustar as horas e o que comer em cada refeição.",
 "Desarquivar": "Desarquivar",
 "Desbloquear": "Desbloquear",
 "Desbloquear com": "Desbloquear com",
 "Desbloquear com biometria": "Desbloquear com biometria",
 "Desbloquear o My Planner": "Desbloquear o My Planner",
 "Desbloqueio do app": "Desbloqueio da app",
 "Descanso": "Descanso",
 "Descartadas": "Descartadas",
 "Descartar": "Descartar",
 "Descartar este tempo?": "Descartar este tempo?",
 "Descobrir lugares em {d}": "Descobrir locais em {d}",
 "Desconectar": "Desligar",
 "Desconectar o {nome}?": "Desligar o {nome}?",
 "Desconto": "Desconto",
 "Desconto de {v}": "Desconto de {v}",
 "Descontos obtidos": "Descontos obtidos",
 "Descrição": "Descrição",
 "Descrição (cliente, nota fiscal...)": "Descrição (cliente, fatura...)",
 "Descrição do serviço (sai na nota)": "Descrição do serviço (sai na fatura)",
 "Descrição que sai na nota": "Descrição que sai na fatura",
 "Desenhar a assinatura": "Desenhar a assinatura",
 "Desenhar com caneta ou dedo": "Desenhar com caneta ou dedo",
 "Desenhe a assinatura e escolha a página e o lugar.": "Desenha a assinatura e escolhe a página e o sítio.",
 "Desenhe a assinatura primeiro.": "Desenha a assinatura primeiro.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Desenha com o dedo ou com a caneta. Para deslocar o quadro, toca em Mover.",
 "Desenhe de novo para confirmar.": "Desenhe novamente para confirmar.",
 "Desenhe o seu padrão": "Desenhe o seu padrão",
 "Desenhe pelo menos uma tarja.": "Desenha pelo menos uma tarja.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Desenhe um padrão ligando pelo menos 4 pontos.",
 "Desenho": "Desenho",
 "Desenho com caneta ou dedo": "Desenho com caneta ou dedo",
 "Desenho incorreto": "Padrão incorreto",
 "Desenho padrão": "Padrão de desbloqueio",
 "Desenho padrão salvo.": "Padrão guardado.",
 "Desenvolvimento": "Press de ombros",
 "Desfazer": "Anular",
 "Desfazer amizade": "Remover amizade",
 "Desligar": "Desligar",
 "Desligar a sincronização?": "Desligar a sincronização?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Desliza para os lados para ver outros dias (até 60 dias à frente). Toca numa refeição para planear a ementa só desse dia. Arrasta para a direita para eliminar.",
 "Desmarcado": "Desmarcado",
 "Desmarcar como recebida": "Desmarcar como recebida",
 "Desmarcar feita hoje": "Desmarcar feita hoje",
 "Desmarcar grupo": "Desmarcar grupo",
 "Desmarcar pagamento": "Desmarcar pagamento",
 "Desodorante": "Desodorizante",
 "Despensa": "Despensa",
 "Despesa": "Despesa",
 "Despesas": "Despesas",
 "Destino": "Destino",
 "Detalhes": "Detalhes",
 "Devolver até": "Devolver até",
 "Devolver: {i} ({p})": "Devolver: {i} ({p})",
 "Devolvido": "Devolvido",
 "Devolvidos": "Devolvidos",
 "Dia": "Dia",
 "Dia a dia": "Dia a dia",
 "Dia da mudança": "Dia da mudança",
 "Dia de vencimento do DAS": "Dia de vencimento do DAS",
 "Dia do Trabalho": "Dia do Trabalhador",
 "Dia do vencimento": "Dia de vencimento",
 "Dia em que a fatura fecha": "Dia em que o extrato fecha",
 "Dia planejado": "Dia planeado",
 "Dia {d} de {total}": "Dia {d} de {total}",
 "Diagnóstico": "Diagnóstico",
 "Dias e horários": "Dias e horários",
 "Dias específicos": "Dias específicos",
 "Dias úteis": "Dias úteis",
 "Dias: {dias}": "Dias: {dias}",
 "Dicas e observações": "Dicas e observações",
 "Diesel": "Gasóleo",
 "Diferença": "Diferença",
 "Digitado": "Manual",
 "Digitar": "Escrever",
 "Digitar à mão": "Introduzir manualmente",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Introduza a palavra-passe do cofre. Ele fecha sozinho após 5 minutos sem uso.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Escreva em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Escreva no formato HH:MM, por exemplo 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Introduza o código e ganhe 10 dias com todos os separadores desbloqueados. Se não tiver, deixe em branco.",
 "Digite o nome da tarefa.": "Introduza o nome da tarefa.",
 "Dinheiro": "Dinheiro",
 "Dinheiro e documentos": "Dinheiro e documentos",
 "Direita": "Direita",
 "Direito": "Direito",
 "Direito Administrativo": "Direito Administrativo",
 "Direito Civil": "Direito Civil",
 "Direito Constitucional": "Direito Constitucional",
 "Direito Empresarial": "Direito Comercial",
 "Direito Penal": "Direito Penal",
 "Direito Tributário": "Direito Fiscal",
 "Direito do Trabalho": "Direito do Trabalho",
 "Direto": "Direto",
 "Disciplina": "Disciplina",
 "Dispensar": "Dispensar",
 "Dispensar o aviso": "Dispensar o aviso",
 "Dispensar todas": "Dispensar todas",
 "Disponibilizada em": "Disponibilizada em",
 "Disponível no app novo": "Disponível na nova app",
 "Distância": "Distância",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Divide o curso em disciplinas ou módulos. Em cada uma, marca a aula em que paraste e cria cartões de notas.",
 "Dividir": "Dividir",
 "Dividir entre (nenhum marcado = todos)": "Dividir entre (nenhum marcado = todos)",
 "Divisão das despesas": "Divisão das despesas",
 "Diária": "Diária",
 "Diária padrão": "Diária padrão",
 "Diário": "Diário",
 "Diários municipais": "Diários municipais",
 "Do celular, do Google Drive ou do OneDrive": "Do telemóvel, do Google Drive ou do OneDrive",
 "Do cliente": "Do cliente",
 "Do escritório": "Do escritório",
 "Doações": "Donativos",
 "Docs": "Docs",
 "Documento": "Documento",
 "Documento (fundo branco)": "Documento (fundo branco)",
 "Documento do veículo (CRLV)": "Documento do veículo (CRLV)",
 "Documento pessoal": "Documento pessoal",
 "Documento vence hoje": "Documento expira hoje",
 "Documento vencendo": "Documento a expirar",
 "Documento: {o}": "Documento: {o}",
 "Documentos": "Documentos",
 "Documentos (contrato, nota, recibo...)": "Documentos (contrato, fatura, recibo...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Documentos (passaporte, cartão de cidadão, carta de condução)",
 "Documentos e autorização das crianças": "Documentos e autorização das crianças",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são encriptados aqui no dispositivo (AES-256) com a palavra-passe do cofre. Nem o suporte consegue ler. Sem a palavra-passe, estes dados não podem ser recuperados.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Documentos, recibos, cadernos e quadros, com várias páginas",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Documentos, reuniões e gravações são apagados para todos. A conversa continua nas Mensagens.",
 "Documentário": "Documentário",
 "Doenças, cirurgias e observações": "Doenças, cirurgias e observações",
 "Dois dedos ou toque duplo para ampliar": "Dois dedos ou toque duplo para ampliar",
 "Domingo": "Domingo",
 "Dono da obra": "Dono da obra",
 "Dose": "Dose",
 "Dose (ex.: 1 cápsula, 5 g)": "Dose (ex.: 1 cápsula, 5 g)",
 "Dose única": "Dose única",
 "Drama": "Drama",
 "Duplicar": "Duplicar",
 "Duplicar tarefa": "Duplicar tarefa",
 "Duração": "Duração",
 "Duração de cada sessão": "Duração de cada sessão",
 "Duração {dur}": "Duração {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Dá para comprar algo de 3 mil em 10 prestações?",
 "Débito automático": "Débito direto",
 "Débito, Pix ou dinheiro": "Débito, Pix ou numerário",
 "Dê um nome ao cartão.": "Dê um nome ao cartão.",
 "Dê um nome ao cuidado.": "Dê um nome ao cuidado.",
 "Dê um nome ao cômodo.": "Dê um nome à divisão.",
 "Dê um nome ao fichário.": "Dê um nome ao dossier.",
 "Dê um nome ao grupo.": "Dá um nome ao grupo.",
 "Dê um nome ao suplemento.": "Dá um nome ao suplemento.",
 "Dê um nome ao treino.": "Dá um nome ao treino.",
 "Dê um nome à conta.": "Dê um nome à conta.",
 "Dê um nome à matéria.": "Dê um nome à disciplina.",
 "Dê um nome à meta.": "Dê um nome ao objetivo.",
 "Dê um nome à refeição.": "Dê um nome à refeição.",
 "Dê um nome à tarefa.": "Dê um nome à tarefa.",
 "E-MAIL (OPCIONAL)": "E-MAIL (OPCIONAL)",
 "E-mail": "E-mail",
 "E-mail (recebe a nota)": "E-mail (recebe a fatura)",
 "E-mail de contato": "E-mail de contacto",
 "E-mail do responsável": "E-mail do encarregado de educação",
 "E-mail inválido": "E-mail inválido",
 "E-mail inválido.": "E-mail inválido.",
 "E-mail ou WhatsApp para resposta (opcional)": "E-mail ou WhatsApp para resposta (opcional)",
 "E-mail para contato (opcional)": "E-mail de contacto (opcional)",
 "E-mail salvo.": "E-mail guardado.",
 "EM ATRASO": "EM ATRASO",
 "ENTRAR COM UM CÓDIGO": "ENTRAR COM UM CÓDIGO",
 "ENVIADOS": "ENVIADOS",
 "ESCOLHA AS ATIVIDADES": "ESCOLHE AS ATIVIDADES",
 "ESTA SEMANA": "ESTA SEMANA",
 "EXERCÍCIO FÍSICO": "EXERCÍCIO FÍSICO",
 "Economia": "Economia",
 "Edita tudo": "Edita tudo",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Edita tudo: fases, orçamento, diário e entregas.",
 "Editar": "Editar",
 "Editar cartão": "Editar cartão",
 "Editar compra": "Editar compra",
 "Editar cômodo": "Editar divisão",
 "Editar desenho": "Editar desenho",
 "Editar documento": "Editar documento",
 "Editar fichário": "Editar dossier",
 "Editar garantia": "Editar garantia",
 "Editar matéria": "Editar disciplina",
 "Editar meta": "Editar objetivo",
 "Editar perfil": "Editar perfil",
 "Editar tarefa": "Editar tarefa",
 "Editar {nome}": "Editar {nome}",
 "Educação": "Educação",
 "Educação Física": "Educação Física",
 "Efeito de scanner": "Efeito de digitalização",
 "Ela sai da lista e dos Recebidos da equipe.": "Sai da lista e dos Recebidos da equipa.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Também fica guardado em \"Os meus autocolantes\" para enviares de novo.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Vem do separador Empréstimos & Financiamentos. Marque-a aqui como paga ou abra o separador para ver o contrato.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Vem do separador Faturas. Marque-a como recebida quando o dinheiro entrar.",
 "Eleitorais": "Eleitorais",
 "Eletrodoméstico": "Eletrodoméstico",
 "Eletrodomésticos": "Eletrodomésticos",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Eletrodomésticos, eletrónica e móveis: fatura, assistência técnica e aviso 15 dias antes de a garantia acabar.",
 "Eletrônico": "Eletrónico",
 "Elétrica": "Eletricidade",
 "Elétrico": "Elétrico",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "Em Editar, cola o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Ligar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.",
 "Em aberto": "Em aberto",
 "Em alta": "Tendências",
 "Em andamento": "Em curso",
 "Em atraso": "Em atraso",
 "Em branco": "Em branco",
 "Em casa": "Em casa",
 "Em cima": "Em cima",
 "Em construção": "Em construção",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Atualizado. As melhorias chegam sozinhas quando a app abre.",
 "Em limpeza": "Em limpeza",
 "Em quais páginas": "Em que páginas",
 "Em qual agenda criar os eventos:": "Em que calendário criar os eventos:",
 "Em qual página e onde": "Em que página e onde",
 "Em tratamento": "Em tratamento",
 "Em um horário específico": "Numa hora específica",
 "Em uso: {ia}": "Em uso: {ia}",
 "Em {n} dia(s)": "Daqui a {n} dia(s)",
 "Embaixo": "Em baixo",
 "Embaixo à esquerda": "Em baixo à esquerda",
 "Emissão": "Emissão",
 "Emissão +": "Emissão +",
 "Emissão: {data}": "Emissão: {data}",
 "Emitida": "Emitida",
 "Emitida em {data}": "Emitida em {data}",
 "Emitida ou recebida": "Emitida ou recebida",
 "Emitidas": "Emitidas",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Emitidas: {v} · Recebidas: {r} · {n} fatura(s)",
 "Emitir": "Emitir",
 "Emitir NFS-e": "Emitir NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Emita NFS-e pelo Padrão Nacional com o certificado A1, pesquise as faturas emitidas e recebidas e exporte XML, folha de cálculo e PDF.",
 "Emitir a nota de verdade?": "Emitir a fatura a sério?",
 "Emitir no ambiente de teste?": "Emitir no ambiente de teste?",
 "Emojis": "Emojis",
 "Emojis animados": "Emojis animados",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Emojis animados: Noto, da Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emojis, GIFs e autocolantes",
 "Empresa": "Empresa",
 "Empresa de mudança": "Empresa de mudanças",
 "Empresa ou pessoa": "Empresa ou pessoa",
 "Empresa, hotel ou voo": "Empresa, hotel ou voo",
 "Empresas": "Empresas",
 "Emprestei": "Emprestei",
 "Empréstimo": "Empréstimo",
 "Empréstimo entre pessoas": "Empréstimo entre pessoas",
 "Empréstimo pessoal": "Empréstimo pessoal",
 "Empréstimos": "Empréstimos",
 "Empréstimos & Financiamentos": "Empréstimos & Financiamentos",
 "Encaminhada para {nome}.": "Reencaminhada para {nome}.",
 "Encaminhar": "Reencaminhar",
 "Encaminhar para": "Reencaminhar para",
 "Encerrar e salvar": "Terminar e guardar",
 "Encontrada para {perfil}": "Encontrada para {perfil}",
 "Endereço": "Morada",
 "Endereço (opcional)": "Morada (opcional)",
 "Endereço (se for presencial)": "Morada (se for presencial)",
 "Endereço atual": "Morada atual",
 "Endereço da escola": "Morada da escola",
 "Endereço da oficina": "Morada da oficina",
 "Endereço de quem está com o item": "Morada de quem tem o item",
 "Endereço do consultório": "Morada do consultório",
 "Endereço do imóvel": "Morada do imóvel",
 "Endereço do laboratório": "Morada do laboratório",
 "Endereço do veterinário": "Morada do veterinário",
 "Endereço no trabalho e na escola": "Morada no trabalho e na escola",
 "Endereço nos Correios e entregas": "Morada nos CTT e entregas",
 "Endereço nos bancos e cartões": "Morada nos bancos e cartões",
 "Endereço novo": "Morada nova",
 "Endereço ou nome do lugar": "Morada ou nome do local",
 "Endereço ou terminal": "Morada ou terminal",
 "Energia": "Energia",
 "Enfermeiro": "Enfermeiro",
 "Engenharia": "Engenharia",
 "Engenheiro ou arquiteto": "Engenheiro ou arquiteto",
 "Enquadre o documento e toque no botão": "Enquadre o documento e toque no botão",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Enquadra o rosto e toca no botão. 🔄 vira a câmara.",
 "Ensino Fundamental": "Ensino Básico",
 "Ensino Médio e ENEM": "Ensino Secundário e ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Compreendi e aceito usar o monitor nestas condições.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Entra diretamente no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, escolhes: substituir, manter as duas ou cancelar.",
 "Entrada": "Entrada",
 "Entrada (imóvel novo)": "Entrada (casa nova)",
 "Entrada de dinheiro": "Entrada de dinheiro",
 "Entrando...": "A entrar...",
 "Entrar": "Entrar",
 "Entrar com CPF e senha": "Entrar com CPF e palavra-passe",
 "Entrar com outra conta": "Entrar com outra conta",
 "Entrar de novo": "Entrar novamente",
 "Entrar na chamada": "Entrar na chamada",
 "Entrar na reunião": "Entrar na reunião",
 "Entrar na sala online": "Entrar na sala online",
 "Entrar no grupo": "Entrar no grupo",
 "Entrar no navegador?": "Entrar no navegador?",
 "Entre com seu CPF e sua senha.": "Entre com o seu CPF e a sua palavra-passe.",
 "Entre com seu e-mail e sua senha.": "Inicie sessão com o seu e-mail e a sua palavra-passe.",
 "Entre na sua conta de novo.": "Inicia sessão novamente.",
 "Entre na sua conta para usar as notas fiscais.": "Inicie sessão na sua conta para usar as faturas.",
 "Entre no app com o seu e-mail e a senha nova.": "Entre na app com o seu e-mail e a palavra-passe nova.",
 "Entrega de material": "Entrega de material",
 "Entrega prevista": "Entrega prevista",
 "Entregas": "Entregas",
 "Entregue": "Entregue",
 "Entrou": "Entrou",
 "Entrou no total da semana.": "Entrou no total da semana.",
 "Enviada": "Enviada",
 "Enviado": "Enviado",
 "Enviado para o Planner": "Enviado para o Planner",
 "Enviado pelo cliente": "Enviado pelo cliente",
 "Enviado pelo escritório": "Enviado pelo escritório",
 "Enviado por {quem} no grupo {g}": "Enviado por {quem} no grupo {g}",
 "Enviando {f} de {n}...": "A enviar {f} de {n}...",
 "Enviando...": "A enviar...",
 "Enviar": "Enviar",
 "Enviar \"{nome}\"": "Enviar \"{nome}\"",
 "Enviar \"{nome}\" para…": "Enviar \"{nome}\" para…",
 "Enviar \"{titulo}\" para": "Enviar \"{titulo}\" para",
 "Enviar ao grupo": "Enviar ao grupo",
 "Enviar convite": "Enviar convite",
 "Enviar convite para {nome}": "Enviar convite a {nome}",
 "Enviar convite pelo WhatsApp": "Enviar convite pelo WhatsApp",
 "Enviar documento": "Enviar documento",
 "Enviar instruções ao hóspede": "Enviar instruções ao hóspede",
 "Enviar o convite": "Enviar o convite",
 "Enviar ou copiar o código": "Enviar ou copiar o código",
 "Enviar ou imprimir a etiqueta": "Enviar ou imprimir a etiqueta",
 "Enviar para Estudos": "Enviar para Estudos",
 "Enviar para My Planner": "Enviar para My Planner",
 "Enviar para a equipe": "Enviar para a equipa",
 "Enviar para o My Planner": "Enviar para o My Planner",
 "Enviar para o Planner": "Enviar para o Planner",
 "Enviar para o grupo": "Enviar para o grupo",
 "Enviar para o grupo de estudos": "Enviar para o grupo de estudo",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Enviar para o {nome} os {n} ficheiro(s) deste dispositivo",
 "Enviar para um grupo": "Enviar para um grupo",
 "Enviar para {g}": "Enviar para {g}",
 "Enviar para…": "Enviar para…",
 "Enviar por e-mail": "Enviar por e-mail",
 "Enviar relatório": "Enviar relatório",
 "Enviar relatório para a equipe": "Enviar relatório para a equipa",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Enviar também as tarefas que já existem (de hoje em diante)",
 "Enviar tarefas do My Planner para a agenda": "Enviar tarefas do My Planner para o calendário",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Envie guias, faturas e relatórios ao cliente, ou veja o que ele enviou. Cada documento aceita fotografias, PDFs e ligações.",
 "Enxaguante": "Elixir bucal",
 "Episódio": "Episódio",
 "Equipe": "Equipa",
 "Equipe ({n})": "Equipa ({n})",
 "Equipe de limpeza": "Equipa de limpeza",
 "Equipe do consultório": "Equipa do consultório",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Equipa do imóvel (limpeza e coanfitrião)",
 "Erro": "Erro",
 "Erro na emissão": "Erro na emissão",
 "Erro: {erro}": "Erro: {erro}",
 "Erros registrados neste dispositivo ({n})": "Erros registados neste dispositivo ({n})",
 "Escanear documento": "Digitalizar documento",
 "Escanear o verso": "Digitalizar o verso",
 "Escanear para PDF": "Digitalizar para PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Digitaliza documentos, recibos, cadernos e quadros: margens e sombras corrigidas, várias páginas, cartão de cidadão frente e verso, assinatura e PDF guardado no telemóvel, no Google Drive ou no OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Digitaliza, torna a imagem mais nítida, organiza em pastas e envia o PDF por WhatsApp, e-mail ou Drive. Com a tua IA ativa, a app lê o texto, resume e responde a perguntas sobre o documento.",
 "Escola": "Escola",
 "Escolha a aba:": "Escolha o separador:",
 "Escolha a data do compromisso.": "Escolhe a data do compromisso.",
 "Escolha a imagem.": "Escolhe a imagem.",
 "Escolha a matéria": "Escolha a disciplina",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Escolhe a pasta do telemóvel (ex.: Documentos). A app guarda lá automaticamente.",
 "Escolha a página": "Escolha a página",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Escolha pelo menos um tribunal ou marque \"Todos os tribunais\".",
 "Escolha ao menos uma agenda.": "Escolha pelo menos um calendário.",
 "Escolha o PDF": "Escolhe o PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Escolha o ficheiro .pfx (ou .p12) do certificado A1 da empresa e introduza a palavra-passe dele. Fica encriptado no seu cofre.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Escolha o ficheiro .xml da NFS-e, NF-e ou CT-e.",
 "Escolha o fichário": "Escolha o dossier",
 "Escolha o grupo para enviar: {t}": "Escolhe o grupo para enviar: {t}",
 "Escolha os PDFs": "Escolhe os PDFs",
 "Escolha os arquivos.": "Escolhe os ficheiros.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.",
 "Escolha para quem enviar.": "Escolhe para quem enviar.",
 "Escolha pelo menos um dia.": "Escolhe pelo menos um dia.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Escolhe pelo menos uma página que exista no PDF (ex.: 1-3, 5).",
 "Escolha quem participa:": "Escolhe quem participa:",
 "Escolher": "Escolher",
 "Escolher a imagem": "Escolher a imagem",
 "Escolher a pasta": "Escolher a pasta",
 "Escolher agendas": "Escolher calendários",
 "Escolher alimento": "Escolher alimento",
 "Escolher arquivo": "Escolher ficheiro",
 "Escolher arquivos": "Escolher ficheiros",
 "Escolher arquivos do Drive ou do OneDrive": "Escolher ficheiros do Drive ou do OneDrive",
 "Escolher as imagens e criar o PDF": "Escolher as imagens e criar o PDF",
 "Escolher da galeria": "Escolher da galeria",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Escolher da galeria ou ficheiro (fotografia ou PDF)",
 "Escolher data": "Escolher data",
 "Escolher fuso": "Escolher fuso horário",
 "Escolher hora": "Escolher hora",
 "Escolher horário": "Escolher hora",
 "Escolher o certificado": "Escolher o certificado",
 "Escolher outro": "Escolher outro",
 "Escolher pessoas": "Escolher pessoas",
 "Escolher tribunais": "Escolher tribunais",
 "Escolher ícone": "Escolher ícone",
 "Esconder da equipe (só administradores)": "Esconder da equipa (só administradores)",
 "Esconder detalhes": "Esconder detalhes",
 "Esconder o texto completo": "Ocultar o texto completo",
 "Escondido de {n} pessoa(s)": "Oculto a {n} pessoa(s)",
 "Escondido de: {n}": "Oculto a: {n}",
 "Escondidos no Planner.": "Ocultos no Planner.",
 "Escova e pasta de dente": "Escova e pasta de dentes",
 "Escovar os dentes": "Lavar os dentes",
 "Escreva aqui": "Escreva aqui",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Escreva e prima Enter (ex.: lavar a máquina)",
 "Escreva em uma ou em todas as páginas.": "Escreve numa ou em todas as páginas.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Escreva o motivo em \"Motivo do cancelamento\" na ficha da fatura (pelo menos 15 letras) e toque aqui novamente.",
 "Escreva o resumo, tópicos, dúvidas...": "Escreva o resumo, tópicos, dúvidas...",
 "Escreva o texto da marca d'água.": "Escreve o texto da marca de água.",
 "Escreva o texto.": "Escreve o texto.",
 "Escreva o título.": "Escreve o título.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Escreve ou cola o texto. Uma linha a começar por \"# \" passa a título.",
 "Escreva ou cole um texto e gere o PDF.": "Escreve ou cola um texto e gera o PDF.",
 "Escritório": "Escritório",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Escritório: documentos e reuniões da equipa. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"A gravar\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível apenas para o administrador até este a disponibilizar à equipa.",
 "Escuro": "Escuro",
 "Espanhol": "Espanhol",
 "Espaço": "Espaço",
 "Espaço livre, dados de cada aba e anexos": "Espaço livre, dados de cada separador e anexos",
 "Especialidade": "Especialidade",
 "Espécie": "Espécie",
 "Esquadro": "Esquadro",
 "Esqueci a senha": "Esqueci-me da palavra-passe",
 "Esquerda": "Esquerda",
 "Esse código é o seu.": "Esse código é o teu.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Esse código é o seu. Use o código de quem lhe recomendou a app.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Esse endereço não respondeu como servidor de faturas. Verifique e tente novamente.",
 "Esta aba ainda não está no seu plano.": "Este separador ainda não está no seu plano.",
 "Esta e todas as futuras": "Esta e todas as futuras",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Esta ferramenta precisa de ver as páginas do PDF, o que chega com a app nova (versão 0.50). Usa o navegador ou instala o APK novo.",
 "Esta imagem foi guardada em outro dispositivo.": "Esta imagem foi guardada noutro dispositivo.",
 "Esta janela pode ser fechada.": "Podes fechar esta janela.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Esta pessoa ainda não preencheu o cartão de contacto.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Esta semana: {a} de {m} aulas ({p}%)",
 "Esta senha é de outra conta.": "Esta palavra-passe é de outra conta.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Esta tarefa não tem hora: \"No início\" e \"Antes do início\" não se aplicam. Use \"Numa hora específica\".",
 "Esta tarefa se repete. O que excluir?": "Esta tarefa repete-se. O que eliminar?",
 "Esta tela teve um problema": "Este ecrã teve um problema",
 "Estado (UF) do registro": "Estado (UF) da inscrição",
 "Estado de Mato Grosso do Sul": "Estado de Mato Grosso do Sul",
 "Estado de São Paulo": "Estado de São Paulo",
 "Estado do Paraná": "Estado do Paraná",
 "Estados": "Estados",
 "Estaduais": "Estaduais",
 "Estadual": "Estadual",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Estes separadores aparecem na barra de baixo, por esta ordem. My Planner, Separadores e Definições ficam sempre. Os outros continuam aqui no ecrã Separadores.",
 "Estatística": "Estatística",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Este CPF já está registado. Use \"Entrar\".",
 "Este PDF está no dispositivo onde foi aberto.": "Este PDF está no dispositivo onde foi aberto.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Este PDF está no dispositivo onde foi aberto. Abre-o lá, ou abre de novo a cópia guardada no Drive ou no OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Este PDF está protegido com palavra-passe. Tira a palavra-passe no programa onde foi criado e tenta de novo.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "Este PDF não tem campos de formulário. Usa \"Adicionar texto\" para escrever nele.",
 "Este ano": "Este ano",
 "Este dispositivo": "Este dispositivo",
 "Este dispositivo não consegue abrir o arquivo.": "Este dispositivo não consegue abrir o ficheiro.",
 "Este dispositivo não consegue compartilhar arquivos.": "Este dispositivo não consegue partilhar ficheiros.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Este dispositivo não tem dados de saúde. Podes introduzi-los manualmente.",
 "Este arquivo foi guardado em outro dispositivo.": "Este ficheiro foi guardado noutro dispositivo.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Este ficheiro foi guardado no telemóvel. Abra-o na app do telemóvel.",
 "Este arquivo não é um backup do My Planner.": "Este ficheiro não é uma cópia de segurança do My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Este telemóvel ainda não recebe notificações com a app fechada. Instala a app {v} ou mais recente (APK com as notificações do servidor). Com a app aberta, as notificações já funcionam.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).",
 "Este fichário ainda não tem matérias.": "Este dossier ainda não tem disciplinas.",
 "Este grupo já está cheio.": "Este grupo já está cheio.",
 "Este mês": "Este mês",
 "Este mês: emitidas {e} · recebidas {r}": "Este mês: emitidas {e} · recebidas {r}",
 "Este mês: {h}": "Este mês: {h}",
 "Este navegador": "Este navegador",
 "Este país só tem feriados nacionais.": "Este país só tem feriados nacionais.",
 "Esteira": "Passadeira",
 "Esteticista": "Esteticista",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Estou a usar o My Planner para organizar a agenda, as finanças e muito mais. Descarrega a app e, ao criares a tua conta, usa o meu código {codigo} para ganhares 10 dias com todos os separadores desbloqueados.",
 "Estratégia": "Estratégia",
 "Estrela": "Estrela",
 "Estudando": "A estudar",
 "Estudar agora": "Estudar agora",
 "Estudar {nome}": "Estudar {nome}",
 "Estudar: {c}": "Estudar: {c}",
 "Estudo": "Estudo",
 "Estudos": "Estudos",
 "Estudos e exatas": "Estudos e ciências",
 "Estudos, lazer e viagens": "Estudos, lazer e viagens",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Está em Património & IRS › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Está na página \"{titulo}\" e em \"Ver ficheiros\".",
 "Etanol": "Etanol",
 "Etapa": "Etapa",
 "Etapa do cronograma": "Etapa do cronograma",
 "Etapas": "Etapas",
 "Evento": "Evento",
 "Eventos": "Eventos",
 "Eventos & Celebrações": "Eventos & Celebrações",
 "Evolução (no cofre)": "Evolução (no cofre)",
 "Ex.: 08:00 e 20:00": "Ex.: 08:00 e 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Ex.: 08:00, 14:00 e 20:00",
 "Ex.: 09/2026": "Ex.: 09/2026",
 "Ex.: 1 comprimido": "Ex.: 1 comprimido",
 "Ex.: 1-3, 4-10, 11-": "Ex.: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Ex.: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Ex.: 171901 (consultoria), 010101 (programação)",
 "Ex.: 40 sacos de cimento": "Ex.: 40 sacos de cimento",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Ex.: 8.º ano B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Ex.: Alongamento lombar, Dieta 1.800 kcal",
 "Ex.: Aniversário de 30 anos da Ana": "Ex.: 30.º aniversário da Ana",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Ex.: Apartamento da praia, Suíte 1, Anexo",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Ex.: Apartamento na Rua X, 100 ações PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Ex.: Aula de revisão, Consulta de seguimento",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Ex.: Catering, DJ, decoração, fotógrafo",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO",
 "Ex.: Cardiologista": "Ex.: Cardiologista",
 "Ex.: Consultoria mensal": "Ex.: Consultoria mensal",
 "Ex.: Costela-de-adão da sala": "Ex.: Costela-de-adão da sala",
 "Ex.: DAS de setembro, Extrato do Itaú": "Ex.: DAS de setembro, Extrato do Itaú",
 "Ex.: Desmontar os móveis do quarto": "Ex.: Desmontar os móveis do quarto",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Ex.: Disponível · Em aula até às 18h · Vamos viajar!",
 "Ex.: Eletricista, loja de material": "Ex.: Eletricista, loja de materiais",
 "Ex.: Entrada dos noivos": "Ex.: Entrada dos noivos",
 "Ex.: Financiamento do carro": "Ex.: Crédito automóvel",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Ex.: Fisioterapeuta, Nutricionista, Cardiologista",
 "Ex.: Furadeira, livro, R$ 200": "Ex.: Berbequim, livro, 200 €",
 "Ex.: Hemograma": "Ex.: Hemograma",
 "Ex.: IPVA 2027, parcela 1": "Ex.: IPVA 2027, prestação 1",
 "Ex.: Lisboa, Portugal": "Ex.: Lisboa, Portugal",
 "Ex.: Mala da Ana": "Ex.: Mala da Ana",
 "Ex.: Mensalidade de outubro, material": "Ex.: Mensalidade de outubro, material",
 "Ex.: Netflix, cinema": "Ex.: Netflix, cinema",
 "Ex.: Notas de compra de setembro": "Ex.: Faturas de compra de setembro",
 "Ex.: Onix 2022": "Ex.: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Ex.: Teste 1, Trabalho de grupo",
 "Ex.: Prova de matemática": "Ex.: Teste de matemática",
 "Ex.: Pôr do sol no Tejo": "Ex.: Pôr do sol no Tejo",
 "Ex.: Reforma da cozinha": "Ex.: Remodelação da cozinha",
 "Ex.: TAP TP 108": "Ex.: TAP TP 108",
 "Ex.: Torre de Belém": "Ex.: Torre de Belém",
 "Ex.: Troca da fiação da sala": "Ex.: Substituição da cablagem da sala",
 "Ex.: V10, antirrábica": "Ex.: Polivalente, antirrábica",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Ex.: Visita ao Mosteiro dos Jerónimos",
 "Ex.: cerâmica 30 cm": "Ex.: cerâmica 30 cm",
 "Ex.: kg, pacotes, latas": "Ex.: kg, pacotes, latas",
 "Ex.: seg e qua, 07:30": "Ex.: seg e qua, 07:30",
 "Ex.: troquei o arroz por batata doce": "Ex.: troquei o arroz por batata-doce",
 "Ex.: varanda, sala": "Ex.: varanda, sala",
 "Exame": "Exame",
 "Exame da OAB": "Exame da OAB",
 "Exames": "Exames",
 "Excel": "Excel",
 "Excluir": "Eliminar",
 "Excluir \"{nome}\"?": "Eliminar \"{nome}\"?",
 "Excluir \"{titulo}\"?": "Eliminar \"{titulo}\"?",
 "Excluir a caixa?": "Eliminar a caixa?",
 "Excluir a compra": "Eliminar a compra",
 "Excluir a compra?": "Eliminar a compra?",
 "Excluir a meta \"{m}\"?": "Eliminar o objetivo \"{m}\"?",
 "Excluir cartão": "Eliminar cartão",
 "Excluir conta": "Eliminar conta",
 "Excluir cuidado": "Eliminar cuidado",
 "Excluir cômodo": "Eliminar divisão",
 "Excluir esta página?": "Eliminar esta página?",
 "Excluir fichário": "Eliminar dossier",
 "Excluir matéria": "Eliminar disciplina",
 "Excluir o cartão \"{c}\"?": "Eliminar o cartão \"{c}\"?",
 "Excluir o documento": "Eliminar o documento",
 "Excluir o fichário {nome}": "Eliminar o dossier {nome}",
 "Excluir página": "Eliminar página",
 "Excluir refeição": "Eliminar refeição",
 "Excluir suplemento": "Eliminar suplemento",
 "Excluir tarefa": "Eliminar tarefa",
 "Excluir tarefa repetida": "Eliminar tarefa repetida",
 "Excluir tarefa?": "Eliminar tarefa?",
 "Excluir treino": "Eliminar treino",
 "Excluir {nome}?": "Eliminar {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Eliminadas definitivamente 30 dias após serem descartadas.",
 "Executivo e profissional": "Executivo e profissional",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Execução do contrato (art. 7.º, V), para prestar o serviço; consentimento (art. 7.º, I), para câmara, galeria, microfone e localização; cumprimento de obrigação legal (art. 7.º, II); e interesse legítimo (art. 7.º, IX), para segurança e prevenção de fraudes.",
 "Exemplos: 13:30, 1330, 9:05": "Exemplos: 13:30, 1330, 9:05",
 "Exercício": "Exercício",
 "Exercício físico": "Exercício físico",
 "Experimente grátis por {n} dias": "Experimente grátis durante {n} dias",
 "Explique o motivo (para cancelar)": "Explique o motivo (para cancelar)",
 "Exportar arquivo": "Exportar ficheiro",
 "Exportar para o contador": "Exportar para o contabilista",
 "Extrair páginas": "Extrair páginas",
 "Extras (pet, check-in tardio...)": "Extras (animal, check-in tardio...)",
 "Extrato": "Extrato bancário",
 "Extrato bancário": "Extrato bancário",
 "Extrato do banco (foto ou PDF)": "Extrato bancário (foto ou PDF)",
 "Extrato importado": "Extrato importado",
 "Extrato por foto": "Extrato por foto",
 "FRASE": "FRASE",
 "FRÁGIL": "FRÁGIL",
 "Fabricante ou estendida: {n} meses": "Fabricante ou estendida: {n} meses",
 "Facultativo": "Facultativo",
 "Falar com a limpeza": "Falar com a limpeza",
 "Fale conosco": "Fale connosco",
 "Falta": "Falta",
 "Falta XML": "Falta XML",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Falta ativar o servidor de faturas: no computador, faça duplo clique em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Falta o Health Connect, a app da Google que reúne os dados dos relógios e das apps de saúde.",
 "Faltam": "Por visitar",
 "Faltam {ml} ({n} copo(s))": "Faltam {ml} ({n} copo(s))",
 "Faltam {n} dia(s) do seu período grátis": "Faltam {n} dia(s) do seu período grátis",
 "Faltam {n} dias": "Faltam {n} dias",
 "Faltou": "Faltou",
 "Família": "Família",
 "Fantasia": "Fantasia",
 "Fatura": "Extrato",
 "Fatura com vencimento em {d}.": "Extrato com vencimento em {d}.",
 "Fatura de {mes}": "Extrato de {mes}",
 "Fatura de {mes}: vence {data}": "Extrato de {mes}: vence a {data}",
 "Fatura do cartão (foto ou PDF)": "Extrato do cartão (foto ou PDF)",
 "Fatura importada": "Extrato importado",
 "Fatura paga (toque para desfazer)": "Extrato pago (toque para anular)",
 "Fatura {c}": "Extrato {c}",
 "Faturamento em {ano}: {v} de {lim}": "Faturação em {ano}: {v} de {lim}",
 "Faturas dos cartões": "Extratos dos cartões",
 "Fazer agora, passo a passo": "Fazer agora, passo a passo",
 "Fazer com este PDF": "Fazer com este PDF",
 "Fazer cópia agora": "Fazer cópia agora",
 "Fecha dia {f} · vence dia {v}": "Fecha no dia {f} · vence no dia {v}",
 "Fecha {f} · vence {v}": "Fecha {f} · vence {v}",
 "Fechar": "Fechar",
 "Fechar o cofre": "Fechar o cofre",
 "Feche e abra o app de novo": "Fecha e abre a app de novo",
 "Federais": "Federais",
 "Feijão": "Feijão",
 "Feita em {data}": "Feita em {data}",
 "Feita hoje": "Feita hoje",
 "Feitas": "Feitas",
 "Feitas (não se repetem) · {n}": "Feitas (não se repetem) · {n}",
 "Feito": "Feito",
 "Feito!": "Feito!",
 "Feliz aniversário": "Feliz aniversário",
 "Feminino": "Feminino",
 "Feminino e suave": "Feminino e suave",
 "Feriado escolar": "Feriado escolar",
 "Feriado estadual": "Feriado estadual",
 "Feriado estadual: {nome}": "Feriado estadual: {nome}",
 "Feriado municipal": "Feriado municipal",
 "Feriado municipal: {nome}": "Feriado municipal: {nome}",
 "Feriado nacional": "Feriado nacional",
 "Feriado nacional: {nome}": "Feriado nacional: {nome}",
 "Feriado regional": "Feriado regional",
 "Feriado regional: {nome}": "Feriado regional: {nome}",
 "Feriados": "Feriados",
 "Feriados nacionais": "Feriados nacionais",
 "Feriados no planner": "Feriados no planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e faturas podem ter erros. Verifique antes de usar.",
 "Ferramenta": "Ferramenta",
 "Ferramentas": "Ferramentas",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Ficha de cada planta, transplantes e calendário de rega e adubo na agenda.",
 "Ficha preenchida": "Ficha preenchida",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Dossiers, disciplinas e páginas, cronómetro de estudo e metas semanais.",
 "Ficção": "Ficção",
 "Figurinha": "Autocolante",
 "Figurinhas": "Autocolantes",
 "Filme": "Filme",
 "Filme ou série": "Filme ou série",
 "Filmes e séries": "Filmes e séries",
 "Filosofia": "Filosofia",
 "Filtros": "Filtros",
 "Fim": "Fim",
 "Fim (vazio = uso contínuo)": "Fim (vazio = uso contínuo)",
 "Fim da garantia": "Fim da garantia",
 "Fim da garantia:": "Fim da garantia:",
 "Fim da pausa. Continue: {tarefa}": "Fim da pausa. Continue: {tarefa}",
 "Fim de semana": "Fim de semana",
 "Fim previsto": "Fim previsto",
 "Fina": "Fina",
 "Finados": "Dia de Finados",
 "Finalizador": "Finalizador",
 "Financeiro": "Financeiro",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Financeiro: {gasto} de {orcado} ({p}%)",
 "Financiamento": "Financiamento",
 "Financiamento de veículo": "Crédito automóvel",
 "Financiamento imobiliário": "Crédito habitação",
 "Financiamentos": "Financiamentos",
 "Financiamentos e empréstimos": "Financiamentos e empréstimos",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Financiamentos e empréstimos com prestações, juros, capital em dívida e comprovativos; objetos emprestados com foto e aviso da devolução.",
 "Finanças": "Finanças",
 "Finanças {p}": "Finanças {p}",
 "Finanças · {p}": "Finanças · {p}",
 "Fins de semana": "Fins de semana",
 "Fio dental": "Fio dental",
 "Flex": "Flex",
 "Flexão de braço": "Flexões",
 "Flor": "Flor",
 "Flutua": "Flutua",
 "Foguete": "Foguetão",
 "Fogão": "Fogão",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Foi no cartão de crédito? Lançar como compra no cartão",
 "Foi para {destino}.": "Foi para {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Foi para {destino}. Queres tirar daqui?",
 "Folha de pagamento": "Folha de vencimentos",
 "Fone": "Auricular",
 "Fone de ouvido": "Auscultadores",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Fontes: Brasil, calculado na app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), transferida pela internet e guardada no dispositivo.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Fontes: Brasil, calculado na app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), transferida pela internet e guardada no dispositivo.",
 "Forma": "Forma",
 "Forma das parcelas": "Tipo de prestações",
 "Forma de pagamento": "Forma de pagamento",
 "Forma de pagamento: {f}.": "Forma de pagamento: {f}.",
 "Formas": "Formas",
 "Formato": "Formato",
 "Formatos": "Formas",
 "Formatura": "Formatura",
 "Fornecedor": "Fornecedor",
 "Fornecedores": "Fornecedores",
 "Forte": "Forte",
 "Foto": "Fotografia",
 "Foto da galeria": "Foto da galeria",
 "Foto do contato": "Fotografia do contacto",
 "Foto inteira": "Foto inteira",
 "Foto ou PDF (lido pela sua IA)": "Foto ou PDF (lido pela sua IA)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Fotografe cada divisão na vistoria de saída e na de entrada. As fotos protegem-no na altura de devolver o imóvel.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Fotografe cada recibo de médico, dentista, escola e PPR assim que pagar. No fim do ano está tudo pronto.",
 "Fotos": "Fotos",
 "Fotos JPG, PNG e outras viram um PDF.": "Fotos JPG, PNG e outras passam a um PDF.",
 "Fotos de {d}": "Fotos de {d}",
 "Fotos do espaço pronto": "Fotos do espaço pronto",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "As fotos e ficheiros desta ficha também vão para a pasta do grupo, para os participantes os abrirem.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "As fotografias e os ficheiros ficam guardados só neste dispositivo. Os dados do documento vão para a tua conta, protegidos.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "As fotos e os ficheiros ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Definições).",
 "Fotos e notas": "Fotos e notas",
 "Fotos e vídeos": "Fotos e vídeos",
 "Fotos, arquivos e links": "Fotos, ficheiros e ligações",
 "Fraldas e lenços": "Fraldas e toalhitas",
 "Francês": "Francês",
 "Frango com osso": "Frango com osso",
 "Frango sem osso": "Frango sem osso",
 "Frase (opcional, ex.: Bom dia!)": "Frase (opcional, ex.: Bom dia!)",
 "Freelancer & Projetos": "Freelancer & Projetos",
 "Freezer": "Congelador",
 "Freios": "Travões",
 "Frente": "Frente",
 "Frente do documento": "Frente do documento",
 "Frente e verso na mesma folha": "Frente e verso na mesma folha",
 "Frente pronta": "Frente pronta",
 "Frequência": "Frequência",
 "Frio": "Frio",
 "Fruta": "Fruta",
 "Frágil": "Frágil",
 "Fundação e estrutura": "Fundações e estrutura",
 "Fundo": "Fundo",
 "Fundos e renda fixa": "Fundos e rendimento fixo",
 "Fuso": "Fuso",
 "Fuso horário": "Fuso horário",
 "Fuso horário do destino": "Fuso horário do destino",
 "Futebol": "Futebol",
 "Física": "Física",
 "Físico (obra pronta): {p}%": "Físico (obra pronta): {p}%",
 "GASTOS POR CATEGORIA": "GASTOS POR CATEGORIA",
 "GIF guardado nos seus GIFs.": "GIF guardado nos teus GIFs.",
 "Garagem": "Garagem",
 "Garantia": "Garantia",
 "Garantia até {data}.": "Garantia até {data}.",
 "Garantia legal": "Garantia legal",
 "Garantia vencendo": "Garantia a terminar",
 "Garantias": "Garantias",
 "Garrafa de água": "Garrafa de água",
 "Gasolina": "Gasolina",
 "Gasto": "Despesa",
 "Gasto até agora": "Gasto até agora",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Despesa de {v} lançada. {n} preço(s) guardado(s) para a sua lista de compras.",
 "Gasto neste mês: {v}": "Gasto neste mês: {v}",
 "Gasto: {v}": "Gasto: {v}",
 "Gastos": "Despesas",
 "Gastos por categoria": "Despesas por categoria",
 "Gato": "Gato",
 "Geladeira": "Frigorífico",
 "Geografia": "Geografia",
 "Gerado por": "Gerado por",
 "Gerando QR Code...": "A gerar código QR...",
 "Gerar PDF": "Gerar PDF",
 "Gerar as cobranças do mês": "Gerar as cobranças do mês",
 "Gerar as parcelas": "Gerar as prestações",
 "Gerar lista da mala": "Gerar lista da mala",
 "Gerar pelo cardápio e pela despensa": "Gerar a partir da ementa e da despensa",
 "Gesso e forro": "Pladur e teto falso",
 "Gira todas as páginas ou só as escolhidas.": "Roda todas as páginas ou só as escolhidas.",
 "Girar": "Rodar",
 "Google Drive e OneDrive": "Google Drive e OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive e Calendário Google: só se os ligar, e apenas para guardar os seus ficheiros e eventos.",
 "Gorro, cachecol e luvas": "Gorro, cachecol e luvas",
 "Gota": "Gota",
 "Graduação e Pós": "Licenciatura e Pós-graduação",
 "Grande": "Grande",
 "Gravando": "A gravar",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Gravar lembretes e notas por voz quando pedir. O microfone só liga quando toca.",
 "Gravar reunião": "Gravar reunião",
 "Gravação de áudio": "Gravação de áudio",
 "Gravações das reuniões": "Gravações das reuniões",
 "Grossa": "Grossa",
 "Grupo": "Grupo",
 "Grupo com convite (turma, equipe, convidados)": "Grupo com convite (turma, equipa, convidados)",
 "Grupo criado": "Grupo criado",
 "Grupo da família": "Grupo da família",
 "Grupo da mudança (família e ajudantes)": "Grupo da mudança (família e ajudantes)",
 "Grupo da obra (equipe)": "Grupo da obra (equipa)",
 "Grupo da turma (convidar alunos)": "Grupo da turma (convidar alunos)",
 "Grupo da viagem (convidar quem vai)": "Grupo da viagem (convidar quem vai)",
 "Grupo de cuidado (família ou profissional)": "Grupo de cuidados (família ou profissional)",
 "Grupo de estudos (convidar colegas)": "Grupo de estudo (convidar colegas)",
 "Grupo de leitura (convidar)": "Grupo de leitura (convidar)",
 "Grupo do cliente": "Grupo do cliente",
 "Grupo do evento (convidar)": "Grupo do evento (convidar)",
 "Grupos": "Grupos",
 "Grupos de estudo": "Grupos de estudo",
 "Grupos de {aba}": "Grupos de {aba}",
 "Grupos desta aba: {n}": "Grupos deste separador: {n}",
 "Grupos e convites": "Grupos e convites",
 "Grátis no lançamento": "Grátis no lançamento",
 "Guarda-chuva": "Guarda-chuva",
 "Guardada nas suas figurinhas.": "Guardado nos teus autocolantes.",
 "Guardado": "Poupado",
 "Guardado até agora: {v}": "Poupado até agora: {v}",
 "Guardado em outro dispositivo": "Guardado noutro dispositivo",
 "Guardado na pasta \"{pasta}\" do celular.": "Guardado na pasta \"{pasta}\" do telemóvel.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Guardado no cofre, com encriptação ponto a ponto.",
 "Guardado no {nome}.": "Guardado no {nome}.",
 "Guardado {onde} em {quando}": "Guardado {onde} a {quando}",
 "Guardando...": "A guardar...",
 "Guardar": "Guardar",
 "Guardar como recibo do IR": "Guardar como recibo do IRS",
 "Guardar dinheiro": "Poupar dinheiro",
 "Guardar e enviar": "Guardar e enviar",
 "Guardar na meta": "Poupar no objetivo",
 "Guardar nas minhas figurinhas": "Guardar nos meus autocolantes",
 "Guardar nos meus GIFs": "Guardar nos meus GIFs",
 "Guardar o PDF {onde}": "Guardar o PDF {onde}",
 "Guardar os PDFs em": "Guardar os PDF em",
 "Guardar os arquivos prontos em": "Guardar os ficheiros prontos em",
 "Guardar sozinho cada arquivo pronto": "Guardar automaticamente cada ficheiro pronto",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Guarda as prescrições e orientações que usas sempre. Na consulta, toca em ⋮ › Usar modelo.",
 "Guarde seus documentos num lugar só": "Guarda os teus documentos num só lugar",
 "Guarde {v} por mês até {d}": "Poupe {v} por mês até {d}",
 "Guardou": "Poupou",
 "Guia de imposto": "Guia de imposto",
 "Gás": "Gás",
 "Gênero ou categoria": "Género ou categoria",
 "HISTÓRICO DOS DADOS": "HISTÓRICO DOS DADOS",
 "HOJE": "HOJE",
 "Hall de entrada": "Hall de entrada",
 "Halteres": "Halteres",
 "Hexágono": "Hexágono",
 "Hidratante": "Hidratante",
 "Hidratante labial": "Batom do cieiro",
 "Hidráulica": "Canalização",
 "Higiene bucal": "Higiene oral",
 "Higienizar": "Higienizar",
 "História": "História",
 "Histórico": "Histórico",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Histórico da família, exames protegidos, vacinas, consultas e alarme dos medicamentos na cronologia.",
 "Hmm...": "Hmm...",
 "Hoje": "Hoje",
 "Hoje: {a} de {m} aulas ({p}%)": "Hoje: {a} de {m} aulas ({p}%)",
 "Hoje: {n} página(s)": "Hoje: {n} página(s)",
 "Hora": "Hora",
 "Hora da pausa": "Hora da pausa",
 "Hora de voltar": "Hora de voltar",
 "Hora de voltar!": "Hora de voltar!",
 "Hora do check-in": "Hora do check-in",
 "Hora do check-out": "Hora do check-out",
 "Horas": "Horas",
 "Horas de sono": "Horas de sono",
 "Horário": "Hora",
 "Horário de check-in": "Horário de check-in",
 "Horário de check-out": "Horário de check-out",
 "Horário do lembrete": "Hora do lembrete",
 "Horário inválido": "Hora inválida",
 "Horário ocupado": "Horário ocupado",
 "Horários": "Horários",
 "Horários (remédio diário)": "Horários (medicamento diário)",
 "Hospedados agora": "Alojados agora",
 "Hospedagem": "Alojamento",
 "Hospital ou pronto-socorro de referência": "Hospital ou urgência de referência",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Há uma versão nova do My Planner Web. Recarrega para usar.",
 "Híbrido": "Híbrido",
 "Hóspede": "Hóspede",
 "Hóspede ({c})": "Hóspede ({c})",
 "Hóspedes (máximo)": "Hóspedes (máximo)",
 "IA ligada": "IA ativada",
 "IA não ligada": "IA não ativada",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "IA não ativada. Ative em Definições › Inteligência artificial.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS retido pelo tomador",
 "Ida": "Ida",
 "Identidade": "Identificação",
 "Idioma": "Idioma",
 "Idiomas": "Línguas",
 "Ilimitados": "Ilimitados",
 "Imagem": "Imagem",
 "Imagem escolhida (trocar)": "Imagem escolhida (trocar)",
 "Imagem guardada no {nome}. Toque para abrir.": "Imagem guardada no {nome}. Toca para abrir.",
 "Imagens para PDF": "Imagens para PDF",
 "Imagens {data}": "Imagens {data}",
 "Imperdíveis": "Imperdíveis",
 "Imperdível": "Imperdível",
 "Importar": "Importar",
 "Importar XML de nota": "Importar XML de fatura",
 "Importar arquivo": "Importar ficheiro",
 "Importar backup?": "Importar cópia de segurança?",
 "Importar extrato": "Importar extrato",
 "Importar extrato do banco (OFX ou CSV)": "Importar extrato do banco (OFX ou CSV)",
 "Importar fatura": "Importar extrato",
 "Importar fotos": "Importar fotos",
 "Importar reservas do Airbnb, Booking...": "Importar reservas do Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Importar {n} movimento(s)",
 "Imóveis e espaços": "Imóveis e espaços",
 "Imóvel": "Imóvel",
 "Imóvel inteiro": "Imóvel inteiro",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Imóvel inteiro ou por quarto: reservas do Airbnb, Booking ou diretas, limpeza no check-out, despesas, ocupação e lucro do mês.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Inclui {v} das faturas emitidas no separador Faturas.",
 "Independência do Brasil": "Independência do Brasil",
 "Indicação": "Recomendação",
 "Indique e ganhe": "Recomende e ganhe",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Recomende o My Planner a amigos e família. Quem criar a conta com o seu código ganha 10 dias com todos os separadores desbloqueados.",
 "Infantil": "Infantil",
 "Informações do PDF": "Informações do PDF",
 "Informe a descrição e o valor.": "Indique a descrição e o valor.",
 "Informe de quantos em quantos dias regar ou adubar.": "Indique de quantos em quantos dias regar ou adubar.",
 "Informe o nome do produto.": "Indique o nome do produto.",
 "Informe o rótulo e o nome.": "Indique o rótulo e o nome.",
 "Informe o total de aulas da matéria em Editar.": "Indica o total de aulas da disciplina em Editar.",
 "Informe o valor.": "Indique o valor.",
 "Informe os horários": "Indique os horários",
 "Informe quanto quer juntar.": "Indique quanto quer juntar.",
 "Informe seu nome.": "Indique o seu nome.",
 "Informática": "Informática",
 "Inglês": "Inglês",
 "Ingredientes (um por linha)": "Ingredientes (um por linha)",
 "Inscrição municipal (se tiver)": "Inscrição municipal (se tiver)",
 "Inspeção": "Inspeção",
 "Instalar ou atualizar o Health Connect": "Instalar ou atualizar o Health Connect",
 "Instruções, receita, observações...": "Instruções, receita, observações...",
 "Insumos (papel, sabonete, café)": "Consumíveis (papel, sabonete, café)",
 "Inteligência artificial": "Inteligência artificial",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Inteligência artificial (Claude, ChatGPT ou Gemini): só se a ativar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai diretamente para o serviço escolhido.",
 "Intensidade": "Intensidade",
 "Internação": "Internamento",
 "Internet": "Internet",
 "Intimação": "Notificação",
 "Intimação com prazo": "Notificação com prazo",
 "Investimento": "Investimento",
 "Investimentos": "Investimentos",
 "Início": "Início",
 "Início {ini} · Fim {fim} · Duração {dur}": "Início {ini} · Fim {fim} · Duração {dur}",
 "Iogurte": "Iogurte",
 "Ir para Ajustes (exportar meus dados)": "Ir para Definições (exportar os meus dados)",
 "Ir para hoje": "Ir para hoje",
 "Ir para o My Planner Web": "Ir para o My Planner Web",
 "Italiano": "Italiano",
 "Item": "Item",
 "Item da despensa": "Artigo da despensa",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Item protegido: fotos e ficheiros ficam encriptados no cofre, só neste dispositivo (não vão para o Drive nem para o OneDrive).",
 "Itens": "Artigos",
 "Itens de higiene (xampu, sabonete)": "Artigos de higiene (champô, sabonete)",
 "Jantar": "Jantar",
 "Japonês": "Japonês",
 "Jaqueta impermeável": "Casaco impermeável",
 "Jogo": "Jogo",
 "Jovem e divertido": "Jovem e divertido",
 "Juntar PDFs": "Juntar PDFs",
 "Juros": "Juros",
 "Juros ainda por vir: {v}": "Juros ainda por vir: {v}",
 "Juros ao mês": "Juros ao mês",
 "JÁ RESPONDIDOS": "JÁ RESPONDIDOS",
 "Já aberta na casa nova": "Já aberta na casa nova",
 "Já enviado para a turma": "Já enviado para a turma",
 "Já está compacto": "Já está compacto",
 "Já está no Planner": "Já está no Planner",
 "Já está pago": "Já está pago",
 "Já há horários deste item no My Planner": "Já existem horários deste item no My Planner",
 "Já pago: {v}": "Já pago: {v}",
 "Já tenho o app: abrir nele": "Já tenho a app: abrir nela",
 "Já tenho o app: abrir o convite nele": "Já tenho a app: abrir o convite nela",
 "Já visitei": "Já visitei",
 "Kit de primeiros socorros": "Kit de primeiros socorros",
 "Kkkk": "Ahah",
 "Kkkkk": "Ahahah",
 "Km de hoje no painel": "Km de hoje no conta-quilómetros",
 "Km no dia": "Km no dia",
 "Km no painel": "Km no conta-quilómetros",
 "LANÇAMENTOS": "MOVIMENTOS",
 "LINHA DO TEMPO": "CRONOLOGIA",
 "Laboratório": "Laboratório",
 "Lanche": "Lanche",
 "Lanche da manhã": "Lanche da manhã",
 "Lanche da tarde": "Lanche da tarde",
 "Lanches e água": "Snacks e água",
 "Lançamentos": "Movimentos",
 "Lavanderia": "Lavandaria",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Lavandaria, consumíveis, manutenção, contas e taxas. Entram no lucro do mês.",
 "Lavar o rosto com sabonete facial": "Lavar o rosto com sabonete facial",
 "Lazer": "Lazer",
 "Leg press": "Leg press",
 "Legenda": "Legenda",
 "Legislação Específica": "Legislação Específica",
 "Legumes": "Legumes",
 "Leia hoje para começar uma sequência": "Lê hoje para começar uma sequência",
 "Leite": "Leite",
 "Leitura": "Leitura",
 "Leitura automática do texto": "Leitura automática do texto",
 "Leitura da IA": "Leitura da IA",
 "Leitura, Cursos & Mídia": "Leitura, Cursos & Media",
 "Lembrete": "Lembrete",
 "Lembrete de hoje": "Lembrete de hoje",
 "Lembrete de renovação no Planner": "Lembrete de renovação no Planner",
 "Lembrete no Planner": "Lembrete no Planner",
 "Lembrete no planner": "Lembrete no planner",
 "Lembrete pelo WhatsApp": "Lembrete pelo WhatsApp",
 "Lembrete: começa às {hora}": "Lembrete: começa às {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Lemos todas as mensagens. Se for preciso, respondemos para o seu e-mail.",
 "Lendo": "A ler",
 "Lendo a fatura...": "A ler o extrato...",
 "Lendo a página": "A ler a página",
 "Lendo o boleto...": "A ler o boleto...",
 "Lendo o cupom...": "A ler o talão...",
 "Lendo o documento...": "A ler o documento...",
 "Lendo o extrato...": "A ler o extrato bancário...",
 "Lendo o relógio...": "A ler o relógio...",
 "Lendo o texto": "A ler o texto",
 "Ler a fatura": "Ler o extrato",
 "Ler a publicação inteira": "Ler a publicação completa",
 "Ler com a minha IA": "Ler com a minha IA",
 "Ler de novo": "Ler novamente",
 "Ler de novo agora": "Ler novamente agora",
 "Ler o texto": "Ler o texto",
 "Ler o texto completo": "Ler o texto completo",
 "Ler publicação inteira": "Ler publicação completa",
 "Ler sozinho as publicações novas": "Ler automaticamente as publicações novas",
 "Leve": "Leve",
 "Leve (sem perder qualidade)": "Leve (sem perder qualidade)",
 "Li e aceito os termos e a política de privacidade": "Li e aceito os termos e a política de privacidade",
 "Li mais {n} páginas": "Li mais {n} páginas",
 "Liberada pelo suporte": "Desbloqueado pelo suporte",
 "Liberar para a equipe": "Disponibilizar à equipa",
 "Liberar para a turma em": "Libertar para a turma em",
 "Liberar para o grupo": "Libertar para o grupo",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Desbloqueios e créditos estão associados ao seu CPF. Atualiza ao sincronizar.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Autorize a câmara para o My Planner nas definições do telemóvel para ler o código QR.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Permita o acesso à câmara para o My Planner nas definições do telemóvel.",
 "Libere outras abas em Ajustes › Compras.": "Desbloqueia outros separadores em Definições › Compras.",
 "Licenciamento": "Licenciamento",
 "Lidas hoje": "Lidas hoje",
 "Lido": "Lido",
 "Ligando. Toque para atender.": "A ligar. Toque para atender.",
 "Ligar": "Ligar",
 "Ligar certificado": "Ativar certificado",
 "Ligar para a assistência": "Ligar para a assistência",
 "Ligar para {nome}": "Ligar para {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Liga a tua IA em Definições › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Ativa a tua IA em Definições › Inteligência artificial para ler o texto, resumir e fazer perguntas sobre o documento.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Ative a sua IA em Definições › Inteligência artificial.",
 "Ligue o certificado A1 da empresa primeiro.": "Ative primeiro o certificado A1 da empresa.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Liga o teu Google Drive ou OneDrive para guardar fotografias e ficheiros (que passam a abrir em qualquer dispositivo) e para teres cópias de segurança completas.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Ative para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com a sua função.",
 "Ligue pelo menos 4 pontos.": "Ligue pelo menos 4 pontos.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Limite anual editável em Definições › Separadores › Separador Finanças. Confirme sempre com o seu contabilista.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Limite de consultas atingido. Tente novamente dentro de 1 minuto.",
 "Limite de energia por dia": "Limite de energia por dia",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Limite de faturação anual do MEI (confirme o valor em vigor com o seu contabilista).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Limite de mensagens de hoje atingido. Tente amanhã.",
 "Limite diário": "Limite diário",
 "Limite livre: {v} de {l}": "Limite disponível: {v} de {l}",
 "Limite total (opcional)": "Limite total (opcional)",
 "Limpar": "Limpar",
 "Limpar a agenda": "Limpar a agenda",
 "Limpar banheiro": "Limpar a casa de banho",
 "Limpar cozinha e louça": "Limpar cozinha e loiça",
 "Limpar feitos": "Limpar concluídos",
 "Limpeza": "Limpeza",
 "Limpeza após {h}": "Limpeza após {h}",
 "Limpeza final": "Limpeza final",
 "Limpeza · {e}": "Limpeza · {e}",
 "Limpeza: {e}": "Limpeza: {e}",
 "Limpezas": "Limpezas",
 "Linha do tempo, tarefas, energia e alertas.": "Cronologia, tarefas, energia e alertas.",
 "Link": "Ligação",
 "Link (Drive, OneDrive, Dropbox)": "Ligação (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Ligação copiada. Cola onde quiseres enviar.",
 "Link da aula ou reunião online (opcional)": "Link da aula ou reunião online (opcional)",
 "Link da nota fiscal (Drive ou OneDrive)": "Link da fatura (Drive ou OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Ligação da pasta no Drive ou OneDrive (opcional)",
 "Link da reserva": "Ligação da reserva",
 "Link da sala online (Meet, Zoom...)": "Link da sala online (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Link de outro calendário (iCal)",
 "Link do calendário do Airbnb (iCal)": "Link do calendário do Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Link do calendário do Booking (iCal)",
 "Link inválido": "Link inválido",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Links de materiais (Drive, vídeos, PDFs), um por linha",
 "Links: {n}": "Links: {n}",
 "Lista": "Lista",
 "Lista da mala": "Lista da mala",
 "Lista de compras": "Lista de compras",
 "Lista de exercícios": "Ficha de exercícios",
 "Lista rápida": "Lista rápida",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Listas rápidas e caixas que passam a tarefa ou vão para outro separador.",
 "Literatura": "Literatura",
 "Litros": "Litros",
 "Livre": "Livre",
 "Livro": "Livro",
 "Livros": "Livros",
 "Local": "Local",
 "Local ou endereço": "Local ou morada",
 "Local: {l}": "Local: {l}",
 "Localização (país e fuso horário)": "Localização (país e fuso horário)",
 "Logo, foto ou rubrica nas páginas.": "Logótipo, foto ou rubrica nas páginas.",
 "Loja (opcional)": "Loja (opcional)",
 "Lote": "Lote",
 "Lua": "Lua",
 "Lugar": "Local",
 "Lugar para visitar": "Local a visitar",
 "Lugares": "Locais",
 "Luz": "Luz",
 "Luz indireta": "Luz indireta",
 "Luz, água, gás e internet": "Luz, água, gás e internet",
 "Lápis": "Lápis",
 "Língua Portuguesa": "Língua Portuguesa",
 "MAIS ADIANTE": "MAIS TARDE",
 "MAIS USADOS": "MAIS USADOS",
 "ME ou EPP do Simples": "ME ou EPP do Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: faturação em {ano} de {v} (limite {l}).",
 "MEMBROS ({n})": "MEMBROS ({n})",
 "METAS": "OBJETIVOS",
 "MS": "MS",
 "Mais": "Mais",
 "Mais abas": "Mais separadores",
 "Mais cidades entram nas próximas versões.": "Mais cidades chegam nas próximas versões.",
 "Mais emojis": "Mais emojis",
 "Mais ferramentas": "Mais ferramentas",
 "Mais figurinhas animadas (KLIPY)": "Mais autocolantes animados (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Mais opções deste separador chegam nas próximas versões.",
 "Mais uma": "Mais uma",
 "Mala": "Mala",
 "Mala ({clima}, {n} dias)": "Mala ({clima}, {n} dias)",
 "Mamadeiras e leite": "Biberões e leite",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Enviámos um código de 6 algarismos para o WhatsApp do número {tel}.",
 "Mandar as orientações pelo WhatsApp": "Enviar as orientações pelo WhatsApp",
 "Mandar de novo": "Enviar de novo",
 "Mandar e-mail": "Enviar e-mail",
 "Mandar lembrete": "Enviar lembrete",
 "Mandar meu código": "Enviar o meu código",
 "Mandar o acerto para o grupo": "Enviar o acerto para o grupo",
 "Mandar para quem limpa (WhatsApp)": "Enviar a quem limpa (WhatsApp)",
 "Mandarim": "Mandarim",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Envia um e-mail a pedir a eliminação, com o documento da conta. Respondemos em até 15 dias.",
 "Manter": "Manter",
 "Manter ambas": "Manter ambas",
 "Manter ambos": "Manter ambos",
 "Manter aqui também": "Manter aqui também",
 "Manter tarefas": "Manter tarefas",
 "Manutenção": "Manutenção",
 "Manutenções": "Manutenções",
 "Mapas (Apple)": "Mapas (Apple)",
 "Marca d'água": "Marca de água",
 "Marca-texto": "Marcador",
 "Marcado": "Marcado",
 "Marcado como feito hoje.": "Marcado como feito hoje.",
 "Marcar como concluída ({dia})": "Marcar como concluída ({dia})",
 "Marcar como devolvido": "Marcar como devolvido",
 "Marcar como feita hoje": "Marcar como feita hoje",
 "Marcar como lido": "Marcar como lida",
 "Marcar como paga": "Marcar como paga",
 "Marcar como pago": "Marcar como pago",
 "Marcar como quitado": "Marcar como liquidado",
 "Marcar como recebida": "Marcar como recebida",
 "Marcar como recebida?": "Marcar como recebida?",
 "Marcar como recebido": "Marcar como recebido",
 "Marcar como visto": "Marcar como visto",
 "Marcar e avisar a equipe": "Marcar e avisar a equipa",
 "Marcar esta conta como paga?": "Marcar esta conta como paga?",
 "Marcar fatura como paga": "Marcar extrato como pago",
 "Marcar grupo": "Marcar grupo",
 "Marcar reunião": "Marcar reunião",
 "Marcenaria": "Carpintaria",
 "Margem": "Margem",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Marque as fotos do diário como Antes ou Depois para montar a galeria.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Marca os dias em que estudas e o horário de cada dia. Cada dia passa a ser uma tarefa que se repete todas as semanas, associada a este item.",
 "Marque um ou mais estados.": "Marque um ou mais estados.",
 "Martelo": "Martelo",
 "Masculino": "Masculino",
 "Masculino e minimalista": "Masculino e minimalista",
 "Matemática": "Matemática",
 "Materiais": "Materiais",
 "Material": "Material",
 "Matrícula, placa, código ou CNPJ": "Registo predial, matrícula, código ou CNPJ",
 "Matéria ou material": "Matéria ou material",
 "Matéria ou módulo": "Disciplina ou módulo",
 "Matérias": "Disciplinas",
 "Meia-sombra": "Meia-sombra",
 "Melhorando a imagem...": "A melhorar a imagem...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "As novas melhorias já foram transferidas. Demora só alguns segundos e os teus dados mantêm-se.",
 "Membros": "Membros",
 "Menos de 1 minuto": "Menos de 1 minuto",
 "Mensagem": "Mensagem",
 "Mensagem apagada": "Mensagem apagada",
 "Mensagem enviada. Obrigado!": "Mensagem enviada. Obrigado!",
 "Mensagem ou observações": "Mensagem ou observações",
 "Mensagens": "Mensagens",
 "Mensagens que você envia em Fale conosco.": "Mensagens que envia em Fale connosco.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Mensagens: a tua lista de amigos, as conversas e as fotos e ficheiros enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.",
 "Mensalidade de {m}": "Mensalidade de {m}",
 "Mensalidade ou valor por aluno": "Mensalidade ou valor por aluno",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.",
 "Mercado": "Supermercado",
 "Mesa flexora": "Mesa flexora",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Encarregado de obra",
 "Meta": "Objetivo",
 "Meta 100% batida": "Meta 100% cumprida",
 "Meta atingida": "Objetivo atingido",
 "Meta atingida!": "Objetivo atingido!",
 "Meta da semana: {dur}": "Objetivo da semana: {dur}",
 "Meta de aulas": "Meta de aulas",
 "Meta de aulas batida": "Meta de aulas cumprida",
 "Meta de copos por dia": "Meta de copos por dia",
 "Meta de páginas por dia": "Meta de páginas por dia",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.",
 "Meta diária": "Meta diária",
 "Meta por dia": "Meta diária",
 "Meta por semana:": "Meta semanal:",
 "Meta {meta} · copo de {copo} · {n} copos": "Meta {meta} · copo de {copo} · {n} copos",
 "Metas": "Objetivos",
 "Metodologia Científica": "Metodologia Científica",
 "Meu caderno": "O meu caderno",
 "Meu cartão de contato": "O meu cartão de contacto",
 "Meu plano": "O meu plano",
 "Meus GIFs ({n})": "Os meus GIFs ({n})",
 "Meus PDFs": "Os meus PDFs",
 "Meus dados": "Os meus dados",
 "Meus dados profissionais": "Os meus dados profissionais",
 "Microchip": "Microchip",
 "Microfone": "Microfone",
 "Microscópio": "Microscópio",
 "Militares estaduais": "Militares estaduais",
 "Minha Casa": "A Minha Casa",
 "Minha conta": "A minha conta",
 "Minhas anotações do livro": "As minhas notas do livro",
 "Minhas figurinhas": "Os meus autocolantes",
 "Minutos": "Minutos",
 "Minutos de exercício": "Minutos de exercício",
 "Mirante": "Miradouro",
 "Mirantes": "Miradouros",
 "Modelo": "Modelo",
 "Modelo de prescrição": "Modelo de prescrição",
 "Modelos": "Modelos",
 "Modificado em": "Modificado em",
 "Modo": "Modo",
 "Modo de preparo": "Modo de preparação",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Modo seguro: tarefas automáticas desligadas até abrires a app de novo",
 "Moeda": "Moeda",
 "Moeda: {m}": "Moeda: {m}",
 "Moedas": "Moedas",
 "Momento do evento": "Momento do evento",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitor do Diário da Justiça Eletrónico (DJEN) por nome e OAB.",
 "Monitor ou co-professor": "Monitor ou coprofessor",
 "Montando o PDF: página {n} de {total}...": "A criar o PDF: página {n} de {total}...",
 "Montar a mala pelo clima ({n} dias)": "Fazer a mala pelo clima ({n} dias)",
 "Monte o cronograma alimentar para ver o relatório.": "Monta o plano alimentar para ver o relatório.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Monte o roteiro dia a dia. Durante a viagem, ele aparece na cronologia do My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Monte o seu plano alimentar e os seus cuidados abaixo. O que for de hoje aparece aqui para marcar.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Monta abaixo o teu plano alimentar, cuidados, treinos e suplementos. O que for de hoje aparece aqui para marcares.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Monta os teus treinos com atividades prontas: máquinas do ginásio, exercícios em casa, caminhada, corrida, ioga, pilates...",
 "Mostrando as 120 mais recentes.": "A mostrar as 120 mais recentes.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "A mostrar só o roteiro. {n} tarefa(s) do dia escondida(s).",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Mostrar datas, horas, moeda e feriados certos para onde está. Não usamos o GPS.",
 "Mostrar menos": "Mostrar menos",
 "Mostrar só o roteiro durante a viagem": "Mostrar só o roteiro durante a viagem",
 "Motivo do cancelamento": "Motivo do cancelamento",
 "Moto": "Mota",
 "Mover": "Mover",
 "Mover para hoje": "Mover para hoje",
 "Mudança": "Mudança",
 "Mudança: {para}": "Mudança: {para}",
 "Mudanças": "Mudanças",
 "Mudar e-mail": "Alterar e-mail",
 "Mudar o nome": "Mudar o nome",
 "Mudar senha": "Alterar palavra-passe",
 "Mudo": "Silenciar",
 "Muitas tentativas": "Demasiadas tentativas",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Demasiadas tentativas erradas. Tente de novo dentro de {s} segundos.",
 "Muitas tentativas. Aguarde alguns minutos.": "Demasiadas tentativas. Aguarde alguns minutos.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Muito bem: já poupou {v} este mês. A constância vale mais do que um valor alto.",
 "Multa": "Multa",
 "Multa e juros": "Multa e juros",
 "Multa e juros de {v}": "Multa e juros de {v}",
 "Multa e juros estimados: {v}": "Coima e juros estimados: {v}",
 "Multas e juros pagos": "Multas e juros pagos",
 "Mundo": "Mundo",
 "Municipal": "Municipal",
 "Município da prestação (IBGE), se for outro": "Município da prestação (IBGE), se for outro",
 "Município da prestação (código IBGE, 7 números)": "Município da prestação (código IBGE, 7 algarismos)",
 "Mural": "Mural",
 "Museu": "Museu",
 "Museus": "Museus",
 "My Planner (vira tarefa)": "My Planner (passa a tarefa)",
 "My Planner bloqueado": "My Planner bloqueado",
 "Máxima": "Máxima",
 "Média": "Média",
 "Média para aprovação": "Média para aprovação",
 "Média · repouso {n}": "Média · repouso {n}",
 "Médico": "Médico",
 "Médico ou clínica": "Médico ou clínica",
 "Médio": "Médio",
 "Mês": "Mês",
 "Mês a mês": "Mês a mês",
 "Mês atual": "Mês atual",
 "Mês passado": "Mês passado",
 "Móveis e enxoval": "Móveis e enxoval",
 "Móvel": "Móvel",
 "Música": "Música",
 "NAS ABAS": "NOS SEPARADORES",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: a SEFAZ exige 1 hora entre pesquisas. Próxima a partir das {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: indique a UF da empresa para pesquisar as faturas de produtos.",
 "NFS-e emitida": "NFS-e emitida",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "À (opcional):",
 "Na agenda": "Na agenda",
 "Na agenda em {data}": "Na agenda a {data}",
 "Na barra": "Na barra",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "Na demonstração não há servidor de faturas. Use a app com a sua conta.",
 "Na hora": "De imediato",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "À hora da pausa surge um aviso grande no ecrã, com contagem decrescente.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "Na cronologia, tocar no temporizador também abre esta página.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "Na pasta \"{pasta}\" do telemóvel. Cada ficheiro pronto vai para lá.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "Na pasta \"{pasta}\" do telemóvel. Cada documento novo vai para lá quando sais dele.",
 "Na prévia de demonstração não há chamadas de verdade.": "Na pré-visualização de demonstração não há chamadas reais.",
 "Na prévia de demonstração não há gravação de verdade.": "Na pré-visualização de demonstração não há gravação real.",
 "Na prévia de demonstração os arquivos não abrem.": "Na pré-visualização de demonstração os ficheiros não abrem.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "Na versão das lojas, a compra será feita pela Google Play ou pela App Store. Por enquanto, o interruptor simula a subscrição para testes.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.",
 "Nacional": "Nacional",
 "Nada a gerar": "Nada a gerar",
 "Nada encontrado.": "Nada encontrado.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.",
 "Nada foi registrado.": "Nada foi registado.",
 "Nada lançado neste mês.": "Nada registado este mês.",
 "Nada no mês": "Nada no mês",
 "Nada no roteiro deste dia.": "Nada no roteiro deste dia.",
 "Nada para apagar com esse filtro.": "Nada para apagar com este filtro.",
 "Nada para comprar": "Nada para comprar",
 "Nada para enviar.": "Nada para enviar.",
 "Nada planejado para este dia": "Nada planeado para este dia",
 "Nada planejado para hoje. Bom dia!": "Nada planeado para hoje. Bom dia!",
 "Nada por aqui.": "Nada por aqui.",
 "Nada recebido ainda.": "Nada recebido ainda.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "Nas conversas, cada pessoa vê o teu nome e o que envias aí. Podes apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.",
 "Nascimento": "Nascimento",
 "Natal": "Natal",
 "Natação": "Natação",
 "Navegador conectado": "Navegador ligado",
 "Negrito": "Negrito",
 "Negócios": "Negócios",
 "Nenhum": "Nenhum",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Nenhum XML neste período (ou foram guardados noutro dispositivo).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Nenhum amigo para adicionar. Convida pelo WhatsApp ou adiciona amigos nas Mensagens (código de amigo).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "Nenhum ficheiro, imagem ou ligação nas páginas desta disciplina.",
 "Nenhum arquivo.": "Nenhum ficheiro.",
 "Nenhum atendimento pago neste mês.": "Nenhuma consulta paga neste mês.",
 "Nenhum cartão": "Nenhum cartão",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Ainda não há comprovativos guardados. Ao pagar uma conta, toque nela e anexe a fotografia, o PDF ou a captura de ecrã do comprovativo.",
 "Nenhum cômodo ainda": "Ainda sem divisões",
 "Nenhum dia": "Nenhum dia",
 "Nenhum documento ainda.": "Ainda não há documentos.",
 "Nenhum documento neste filtro.": "Nenhum documento neste filtro.",
 "Nenhum e-mail cadastrado": "Nenhum e-mail registado",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Nenhum erro registado. Se a app fechar sozinha ou um ecrã der problema, o erro aparece aqui para o enviares à equipa.",
 "Nenhum feriado neste ano.": "Nenhum feriado neste ano.",
 "Nenhum fichário ainda": "Ainda sem dossiers",
 "Nenhum grupo ainda.": "Ainda não há grupos.",
 "Nenhum item em {nome}": "Nenhum item em {nome}",
 "Nenhum lançamento encontrado": "Nenhum movimento encontrado",
 "Nenhum país encontrado.": "Nenhum país encontrado.",
 "Nenhum selecionado": "Nenhum selecionado",
 "Nenhuma (plano gratuito)": "Nenhuma (plano gratuito)",
 "Nenhuma aba encontrada.": "Nenhum separador encontrado.",
 "Nenhuma aba fixada além do My Planner.": "Nenhum separador fixado além do My Planner.",
 "Nenhuma aba liberada para receber": "Nenhum separador desbloqueado pode receber",
 "Nenhuma agenda encontrada": "Nenhum calendário encontrado",
 "Nenhuma agenda para trazer": "Nenhum calendário para importar",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "Nenhuma audiência ou prazo encontrado nesta publicação.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.",
 "Nenhuma compra encontrada": "Nenhuma compra encontrada",
 "Nenhuma compra nesta fatura.": "Nenhuma compra neste extrato.",
 "Nenhuma conta a pagar cadastrada.": "Nenhuma conta a pagar registada.",
 "Nenhuma conta a receber cadastrada.": "Nenhuma conta a receber registada.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Nenhuma conta neste mês. Toque em + para registar (renda, luz, cartão...).",
 "Nenhuma cópia de segurança ainda.": "Ainda não há cópias de segurança.",
 "Nenhuma cópia encontrada.": "Nenhuma cópia encontrada.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Nenhuma garantia ativa. Registe com o +.",
 "Nenhuma garantia vencida.": "Nenhuma garantia expirada.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Ainda não há mensagens. Diz olá! 👋",
 "Nenhuma nota neste período.": "Nenhuma fatura neste período.",
 "Nenhuma opção ainda.": "Ainda sem opções.",
 "Nenhuma publicação nova.": "Nenhuma publicação nova.",
 "Nenhuma refeição neste dia.": "Nenhuma refeição neste dia.",
 "Nenhuma reunião marcada.": "Nenhuma reunião marcada.",
 "Nesse ritmo, termina em {d}": "A este ritmo, terminas a {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "Nesta fase de lançamento, todos os separadores estão desbloqueados e grátis.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "Nesta fase de testes, a palavra-passe é redefinida pelo suporte. Escreva para {email} indicando o seu CPF ou e-mail.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "Nesta fase de testes, a palavra-passe é redefinida pelo suporte. Escreva para {email} indicando o seu CPF.",
 "Neve": "Neve",
 "Ninguém deve nada a ninguém.": "Ninguém deve nada a ninguém.",
 "Ninguém entrou ainda. Envie o convite.": "Ainda ninguém entrou. Envia o convite.",
 "Ninguém usou o seu código ainda.": "Ainda ninguém usou o seu código.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "No Android, a app guarda só o atalho do ficheiro escolhido: ele continua onde está (Drive, OneDrive, Transferências) e abre na app do telemóvel. Nada é copiado. Esta opção vale para as fotos tiradas com a câmara.",
 "No Google Drive ou OneDrive: {n}": "No Google Drive ou OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "No Google Drive, a app só vê os ficheiros que ela própria criou na pasta My Planner. A utilização das informações recebidas das APIs do Google segue a Política de Dados do Utilizador dos Serviços de API Google, incluindo os requisitos de Utilização Limitada: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "Na app do teu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ativa a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "Na nova app (versão 0.49), o telemóvel deteta sozinho as margens da folha. Nesta versão, ajusta os 4 cantos com o dedo.",
 "No centro": "Ao centro",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "No computador, abra {url}, toque no botão acima e aponte a câmara para o código QR do ecrã.",
 "No dia (opcional):": "No dia (opcional):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "No iPhone, a app abre \"Guardar em Ficheiros\" para escolheres a pasta (pode ser o iCloud Drive).",
 "No início": "No início",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "No modo seguro a app abre sem as tarefas automáticas (avisos, Google Calendar, publicações, mensagens e relógio). Os teus dados não mudam e tudo volta ao normal da próxima vez que abrires.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "No navegador, as páginas só ficam enquanto esta página estiver aberta.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "No navegador, cola a ligação do ficheiro do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Ligação). No telemóvel, o botão de ficheiro já mostra o Drive e o OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "No navegador, o PDF é transferido para o computador.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "No navegador, só é possível guardar imagens pequenas (até 200 KB). Para outros ficheiros, adicione uma ligação do Drive, OneDrive ou Dropbox, ou use a app no telemóvel.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "Na outra app, copie a ligação do ficheiro (Partilhar › Copiar ligação) e cole-a no bloco de ligação que ficou nesta página.",
 "No ritmo atual, o ano fecha em {v}.": "Ao ritmo atual, o ano fecha em {v}.",
 "No seu fuso: {hora}{dia}": "No seu fuso: {hora}{dia}",
 "Nome": "Nome",
 "Nome (cliente ou fornecedor)": "Nome (cliente ou fornecedor)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Nome (ex.: 8.º ano B, Pacientes da clínica, Aniversário da Ana)",
 "Nome (ex.: Almoço)": "Nome (ex.: Almoço)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Nome (ex.: Renda recebida, Cliente X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Nome (ex.: Renda, Luz, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Nome (ex.: Doutoramento UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Nome (ex.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Nome (ex.: Skincare da noite)",
 "Nome (ex.: Treino A)": "Nome (ex.: Treino A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Nome (ex.: Viagem de férias, Fundo de emergência)",
 "Nome (ex.: Vitamina C)": "Nome (ex.: Vitamina C)",
 "Nome (opcional)": "Nome (opcional)",
 "Nome (opcional, ex.: CNH do Walter)": "Nome (opcional, ex.: Carta do Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Nome (podes editar, ex.: \"Sumo de uva\")",
 "Nome completo": "Nome completo",
 "Nome curto": "Nome curto",
 "Nome da lista": "Nome da lista",
 "Nome da matéria": "Nome da disciplina",
 "Nome da obra": "Nome da obra",
 "Nome da pasta (ex.: Recibos, Contratos)": "Nome da pasta (ex.: Recibos, Contratos)",
 "Nome da tarefa": "Nome da tarefa",
 "Nome da tarefa (ex.: Academia)": "Nome da tarefa (ex.: Ginásio)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Nome da tarefa (ex.: Limpar a casa de banho)",
 "Nome do PDF (opcional)": "Nome do PDF (opcional)",
 "Nome do conselho": "Nome da ordem",
 "Nome do cômodo": "Nome da divisão",
 "Nome do documento": "Nome do documento",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Nome do escritório (ex.: Ravasco Contabilidade)",
 "Nome do evento": "Nome do evento",
 "Nome do grupo (ex.: Família)": "Nome do grupo (ex.: Família)",
 "Nome do modelo": "Nome do modelo",
 "Nome ou modelo": "Nome ou modelo",
 "Nome ou razão social": "Nome ou denominação social",
 "Nome, subtarefa ou anotação": "Nome, subtarefa ou nota",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.",
 "Nossa Senhora Aparecida": "Nossa Senhora Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "Fatura cancelada",
 "Nota fiscal": "Fatura",
 "Nota fiscal emitida": "Fatura emitida",
 "Nota fiscal, certificado de garantia e fotos": "Fatura, certificado de garantia e fotos",
 "Nota importada": "Fatura importada",
 "Notas": "Faturas",
 "Notas Fiscais": "Faturas",
 "Notebook e carregador": "Portátil e carregador",
 "Nova avaliação": "Nova avaliação",
 "Nova caixa (ex.: Compras, Ideias)": "Nova caixa (ex.: Compras, Ideias)",
 "Nova conversa": "Nova conversa",
 "Nova garantia": "Nova garantia",
 "Nova matéria": "Nova disciplina",
 "Nova meta": "Novo objetivo",
 "Nova pasta": "Nova pasta",
 "Nova página": "Nova página",
 "Nova página com esta caixa": "Nova página com esta caixa",
 "Nova refeição": "Nova refeição",
 "Nova tarefa": "Nova tarefa",
 "Nova tarefa da casa": "Nova tarefa da casa",
 "Nova tarefa neste cômodo": "Nova tarefa nesta divisão",
 "Novas": "Novas",
 "Novo": "Novo",
 "Novo alerta:": "Novo alerta:",
 "Novo cartão": "Novo cartão",
 "Novo cartão de crédito": "Novo cartão de crédito",
 "Novo cuidado": "Novo cuidado",
 "Novo documento": "Novo documento",
 "Novo e-mail": "Novo e-mail",
 "Novo fichário": "Novo dossier",
 "Novo grupo": "Novo grupo",
 "Novo item": "Novo item",
 "Novo perfil": "Novo perfil",
 "Novo suplemento": "Novo suplemento",
 "Novo treino": "Novo treino",
 "Novo: {nome}": "Novo: {nome}",
 "Novos": "Novos",
 "Num período": "Num período",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Numere cada caixa e indique a divisão e o conteúdo. Use a pesquisa para encontrar onde está cada coisa.",
 "Nº": "N.º",
 "Não": "Não",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Não encontrei o total no talão. Tente uma foto mais nítida.",
 "Não consegue entrar?": "Não consegues entrar?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Não consegui abrir \"{nome}\". Experimenta a ferramenta Reparar PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Não consegui ligar a chamada. Verifica a internet e tenta novamente.",
 "Não deu certo: {msg}": "Não resultou: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Não deu para reduzir mais este PDF ({tam}).",
 "Não dá para tirar todas as páginas.": "Não dá para tirar todas as páginas.",
 "Não encontrei texto neste PDF.": "Não encontrei texto neste PDF.",
 "Não encontrei texto neste documento.": "Não encontrei texto neste documento.",
 "Não foi possível": "Não foi possível",
 "Não foi possível abrir": "Não foi possível abrir",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Não foi possível abrir o certificado guardado. Ative o certificado novamente.",
 "Não foi possível abrir.": "Não foi possível abrir.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Não foi possível transferir os feriados deste país. Verifique a ligação à internet.",
 "Não foi possível conectar": "Não foi possível ligar",
 "Não foi possível conectar o {nome}": "Não foi possível ligar o {nome}",
 "Não foi possível consultar o DJEN agora.": "Não foi possível consultar o DJEN agora.",
 "Não foi possível continuar": "Não foi possível continuar",
 "Não foi possível criar um evento na agenda: {msg}": "Não foi possível criar um evento no calendário: {msg}",
 "Não foi possível entrar.": "Não foi possível entrar.",
 "Não foi possível enviar": "Não foi possível enviar",
 "Não foi possível enviar.": "Não foi possível enviar.",
 "Não foi possível guardar: {erro}": "Não foi possível guardar: {erro}",
 "Não foi possível ler o arquivo.": "Não foi possível ler o ficheiro.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Não foi possível ler o calendário. Verifica o link em Editar.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Não foi possível pesquisar agora. A app volta a tentar sozinha mais tarde.",
 "Não foi possível reiniciar sozinho.": "Não foi possível reiniciar automaticamente.",
 "Não foi possível sincronizar com a agenda: {msg}": "Não foi possível sincronizar com o calendário: {msg}",
 "Não foi possível trocar a foto": "Não foi possível alterar a fotografia",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Não há garantia de aviso com a app fechada. A verificação ocorre ao abrir a app (a cada 6 horas) ou em \"Verificar agora\".",
 "Não identificado": "Não identificado",
 "Não marcada como feita": "Não marcada como feita",
 "Não optante pelo Simples": "Não aderente ao Simples",
 "Não se repete": "Não se repete",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Não use a app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar aceder a dados de outras pessoas.",
 "Não vai": "Não vai",
 "Não vence": "Não expira",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Não vendemos os seus dados e não usamos o seu conteúdo para publicidade.",
 "Não é possível adicionar esta pessoa.": "Não é possível adicionar esta pessoa.",
 "Não é um XML de nota fiscal": "Não é um XML de fatura",
 "Número": "Número",
 "Número (opcional)": "Número (opcional)",
 "Número da OAB": "Número da OAB",
 "Número da caixa": "Número da caixa",
 "Número da carteirinha": "Número do cartão",
 "Número da guia do convênio": "Número da guia do seguro",
 "Número da parcela": "Número da prestação",
 "Número de hóspedes": "Número de hóspedes",
 "Número de parcelas": "Número de prestações",
 "Número do contrato": "Número do contrato",
 "Número do registro": "Número de inscrição",
 "Número na chamada": "Número na chamada",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Número {n}. O XML ficou guardado na fatura. Toque nela para ver o PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "O número, a entidade emissora e as observações são encriptados (AES-256) no dispositivo antes de irem para a nuvem.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Número, entidade emissora, observações, fotos e PDFs ficam encriptados (AES-256) no dispositivo. Os ficheiros protegidos ficam só neste dispositivo.",
 "Número: {n}": "Número: {n}",
 "Números de página": "Números de página",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "O ChatGPT não lê PDF por aqui. Tire uma foto ou uma captura de ecrã da página, ou use o Claude ou o Gemini em Definições › Inteligência artificial.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "O DAS vence no dia {dia}. Marque como pago em Finanças.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "O Escritório ainda não foi ativado no servidor. No computador, executa o 29-SERVIDOR-0.45.bat (só uma vez).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "O Mestre Achado cuida do seu dinheiro: contas, cartões e extratos, orçamento por categoria, objetivos, extrato bancário e talão pela foto, relatório e MEI.",
 "O Mestre está pensando...": "O Mestre está a pensar...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "O My Planner cria a pasta \"My Planner\" no teu Drive e só vê o que ele próprio lá guardou.",
 "O My Planner já abriu no computador, com os seus dados.": "O My Planner já abriu no computador, com os seus dados.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "O My Planner lê os dados do relógio através de {fonte}, onde o relógio e as apps de saúde e exercício guardam tudo.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É disponibilizado por Walter Ravasco da Costa, que é o responsável pelo tratamento dos dados pessoais tratados na app.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "O My Planner usa só a pasta Aplicações › My Planner do teu OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "O PDF e as imagens serão removidos deste dispositivo e da nuvem.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "O PDF ultrapassou 15 MB. Se o WhatsApp ou o e-mail o recusar, ativa \"Ficheiro mais pequeno\".",
 "O QUE COMER": "O QUE COMER",
 "O QUE OS MEMBROS PODEM": "O QUE OS MEMBROS PODEM",
 "O QUE VOCÊ MANDA": "O QUE ENVIAS",
 "O QUE VOCÊ RECEBE": "O QUE RECEBES",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "O acesso continua a ser feito pelo CPF. O e-mail serve para o suporte o contactar.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na tua agenda sem tu aceitares.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "O alarme volta a tocar a cada 2 minutos (até 4 vezes) enquanto o medicamento não for marcado como tomado.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "A app ajuda a organizar, mas não substitui a orientação de médicos, advogados, contabilistas ou outros profissionais. Verifique prazos, valores e datas importantes.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "A app avisa 3 dias antes e no dia do vencimento, às 9h.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "A app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que registar. Estes dados são enviados a esse serviço em cada verificação.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "A app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OAB que registar e, se marcar, o Querido Diário (diários oficiais municipais). Estes dados são enviados a esses serviços em cada verificação.",
 "O app fechou sozinho {n} vezes seguidas": "A app fechou sozinha {n} vezes seguidas",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "A app instalada neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, instale a app 0.35 ou mais recente (APK novo). As mensagens já funcionam.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "A app não fechou e os teus dados continuam guardados. Tenta de novo ou envia o relatório para a equipa corrigir.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "A app pede o desbloqueio ao abrir e ao voltar do segundo plano.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "A app pede o desbloqueio ao abrir. Mudar de app ou de ecrã rapidamente não volta a pedir; se o telemóvel for bloqueado ou a app ficar fora do ecrã durante mais tempo do que o prazo abaixo, pede.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "A app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os teus dados de saúde. Os totais de cada dia ficam na tua conta para aparecerem também no site e no outro telemóvel.",
 "O app volta a pedir a senha para desbloquear.": "A app volta a pedir a palavra-passe para desbloquear.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "A app destina-se a maiores de 18 anos. Os dados de crianças só podem ser registados pelos pais ou responsáveis.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "O ficheiro ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "O ficheiro já não está nesse lugar (foi apagado ou movido).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "O ficheiro já não está nesse lugar (foi apagado, movido ou a app dele retirou a permissão). Anexa de novo.",
 "O arquivo passa de 15 MB.": "O ficheiro ultrapassa 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "O ficheiro ultrapassa 15 MB. Ativa \"Ficheiro mais pequeno\" e tenta de novo.",
 "O arquivo passa de 25 MB.": "O ficheiro ultrapassa 25 MB.",
 "O arquivo passa de 50 MB.": "O ficheiro tem mais de 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "O ficheiro sai deste telemóvel. As cópias que guardaste no Drive, OneDrive ou enviaste a alguém continuam lá.",
 "O arquivo sai do escritório para todos.": "O ficheiro sai do escritório para todos.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "O aviso chega às 9h, e de novo no dia em que expira.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "A base de dados ainda não foi preparada. Execute o ficheiro supabase/schema.sql no Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "O cartão {c} tem {p}% do limite usado. Evite novas compras a prestações nele por agora.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "O telemóvel não avisa a app quando o ecrã é bloqueado, por isso a app conta o tempo fora. Com 1 minuto, bloquear o telemóvel e voltar depois pede a biometria; responder a uma mensagem rápida, não.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "O telemóvel serve só para confirmar que a conta é tua (código pelo WhatsApp no registo e ao mudar de número). Um número por conta.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "A partilha ainda não foi ativada no servidor. No computador, abra a pasta C:\\MyPlanner e faça duplo clique em 12-LIGAR-COMPARTILHAMENTO.bat (só uma vez).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "O computador vai abrir o My Planner com a sua conta. Faça isto apenas em computadores de confiança.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "O convite leva o link da app e do APK mais recente. Quem entra pelo link vai diretamente para o escritório.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "O código de recomendação só é válido nos primeiros 30 dias da conta.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "O padrão fica guardado só neste dispositivo, protegido. A palavra-passe continua válida se se esquecer do padrão.",
 "O dinheiro gasto está à frente do andamento da obra.": "O dinheiro gasto está à frente do andamento da obra.",
 "O documento não tem páginas.": "O documento não tem páginas.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima são liquidadas automaticamente.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "O extrato é lido aqui no dispositivo. As contas a pagar com o mesmo valor e data próxima são liquidadas automaticamente. O pagamento do extrato do cartão não conta duas vezes.",
 "O governo recusou a nota": "O governo recusou a fatura",
 "O governo recusou a nota.": "O governo recusou a fatura.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "O idioma aplica-se a este dispositivo. Os dados que escreveu não são traduzidos.",
 "O item vinculado foi apagado ou movido.": "O item associado foi apagado ou movido.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "O item associado foi apagado ou movido. Edite a tarefa para escolher outro.",
 "O link antigo deixa de funcionar.": "O link antigo deixa de funcionar.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "O link antigo deixa de funcionar. Quem já está no grupo continua.",
 "O link deve começar com https://": "A ligação deve começar por https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "O navegador não deixa ler o calendário das plataformas. Importa pela app no telemóvel.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "O plano básico e os períodos de teste dos separadores seguem as regras indicadas em Definições > Compras. Os benefícios de recomendação valem uma vez por conta.",
 "O que acontece": "O que acontece",
 "O que apagar": "O que apagar",
 "O que comprou": "O que comprou",
 "O que fazer": "O que fazer",
 "O que foi comido:": "O que foi comido:",
 "O que foi feito": "O que foi feito",
 "O que foi visto": "O que foi dado",
 "O que funcionou, o que ajustar, metodologias, resumos...": "O que funcionou, o que ajustar, metodologias, resumos...",
 "O que já foi guardado continua nos lançamentos como investimento.": "O que já foi poupado continua nos movimentos como investimento.",
 "O que levar ou estudar": "O que levar ou estudar",
 "O que o app pode usar": "O que a app pode usar",
 "O que o médico disse": "O que o médico disse",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "O que os teus grupos enviaram. Os compromissos aceites vão para o My Planner; materiais e avisos vão para as Notas.",
 "O que precisa": "O que é preciso",
 "O que tem dentro": "O que tem dentro",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "O que emprestou ou pediu emprestado: foto, com quem está e aviso da devolução.",
 "O que é apagado": "O que é apagado",
 "O quê": "O quê",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando essas apps estão instaladas no telemóvel. A app guarda só o atalho: o ficheiro continua onde está e abre na app do telemóvel.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando essas apps estão instaladas no telemóvel. O ficheiro escolhido fica guardado neste dispositivo.",
 "O servidor ainda não buscou para os seus perfis.": "O servidor ainda não pesquisou para os teus perfis.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "O servidor ainda não está preparado para as mensagens. Executa o 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "O servidor ainda não está preparado para recomendações. Tente novamente mais tarde.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "O servidor ainda não está preparado para o cartão de contacto. Executa o 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "O servidor ainda não foi preparado para dados partilhados. No computador, abre a pasta C:\\MyPlanner e faz duplo clique em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (só uma vez).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "O servidor ainda não foi preparado para o Drive e o OneDrive (vê COMO RODAR, versão 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "O servidor ainda não foi preparado para o acesso pela web (execute supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, executa o 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "O servidor de faturas respondeu algo inesperado (HTTP {s}). Verifique o endereço.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (hora de Brasília), mesmo com a app fechada. As publicações capturadas aparecem quando abres a app. Também podes usar \"Verificar agora\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "O servidor faz a captura automática todos os dias às 08h e 12h (hora de Brasília), mesmo com a app fechada. As publicações capturadas aparecem quando abre a app. Também pode usar \"Verificar agora\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desliga \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desative \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já o faz).",
 "O seu papel no grupo não permite incluir aqui.": "A sua função no grupo não permite adicionar aqui.",
 "O site deve começar com https://": "O site deve começar por https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "O tamanho predefinido do copo ({copo}) muda-se em Ajustar, no quadro da água.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "O tema muda as cores dos separadores (os ícones continuam os mesmos) e aplica-se nos modos claro e escuro. Depois ainda pode mudar a cor de um separador em Definições > Separadores.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "O temporizador enche-se de cor à medida que o tempo da tarefa passa. Tocar nele abre a ligação da tarefa.",
 "O teste grátis terminou": "O teste grátis terminou",
 "O texto": "O texto",
 "O texto do PDF num arquivo .docx para editar.": "O texto do PDF num ficheiro .docx para editar.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "O texto também vai escondido dentro do PDF: podes pesquisá-lo e copiá-lo no leitor de PDF.",
 "O tom escolhido fica para os próximos emojis.": "O tom escolhido fica para os próximos emojis.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.",
 "OAB (opcional, para advogados)": "OAB (opcional, para advogados)",
 "OBS": "OBS.",
 "OCR: texto pesquisável": "OCR: texto pesquisável",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "OU ESCOLHER DIVISÃO…",
 "Objetivos": "Objetivos",
 "Objeto": "Objeto",
 "Objetos": "Objetos",
 "Objetos e valores": "Objetos e valores",
 "Obra": "Obra",
 "Obras": "Obras",
 "Obras & Reformas": "Obras & Remodelações",
 "Obrigado": "Obrigado",
 "Obrigado!": "Obrigado!",
 "Observações": "Observações",
 "Observações (alergias, ração...)": "Observações (alergias, ração...)",
 "Observações (chave Pix, conta para depósito...)": "Observações (chave Pix, conta para depósito...)",
 "Observações (código de barras, chave Pix...)": "Observações (código de barras, chave Pix...)",
 "Observações (dados bancários, PIX...)": "Observações (dados bancários, PIX...)",
 "Observações (estado do item...)": "Observações (estado do artigo...)",
 "Observações (garantia, seguro, CET...)": "Observações (garantia, seguro, TAEG...)",
 "Observações (nº de série, modelo...)": "Observações (n.º de série, modelo...)",
 "Observações (onde está o original, categoria da CNH...)": "Observações (onde está o original, categoria da carta...)",
 "Observações (recibo de entrega, número...)": "Observações (guia de entrega, número...)",
 "Observações (restrição alimentar...)": "Observações (restrição alimentar...)",
 "Ocultar texto (tarja)": "Ocultar texto (tarja)",
 "Ocupado": "Ocupado",
 "Oficina": "Oficina",
 "Ofício": "Ofício",
 "Oi!": "Olá!",
 "Oi! Tudo certo para sábado?": "Olá! Está tudo combinado para sábado?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Olá, {pessoa}! Ainda tenho o(a) {coisa} que me emprestaste. Quando dá jeito para eu devolver?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Olá, {pessoa}! Tudo bem? Só para lembrar o(a) {coisa} que te emprestei a {data}. Consegues devolver {quando}?",
 "Oi?!": "Hã?!",
 "Olá!": "Olá!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Olá! Eu sou o Mestre Achado. Pergunte sobre as suas despesas, contas, cartões e objetivos: eu respondo com os seus números.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Olá! Só para lembrar o pagamento de {ref} ({v}), com vencimento a {d}. Obrigado(a)!",
 "Olá! Preciso de assistência técnica para: {item}": "Olá! Preciso de assistência técnica para: {item}",
 "Olá, {nome}!": "Olá, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Olá, {nome}! Sê bem-vindo(a).",
 "Ombros: girar para trás": "Ombros: rodar para trás",
 "Omelete": "Omelete",
 "Onde": "Onde",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela fotografia) e Notas (transformar uma caixa em tarefas).",
 "Onde assistir": "Onde ver",
 "Onde eu mais gastei este mês?": "Onde gastei mais este mês?",
 "Onde fica": "Onde fica",
 "Onde guardar fotos e arquivos novos": "Onde guardar fotografias e ficheiros novos",
 "Onde na página": "Onde na página",
 "Ontem": "Ontem",
 "Organizar": "Organizar",
 "Organizar barra": "Organizar barra",
 "Organizar com IA": "Organizar com IA",
 "Organizar com IA (vira tarefas)": "Organizar com IA (passa a tarefas)",
 "Organizar páginas": "Organizar páginas",
 "Orgulho e vibrante": "Orgulho e vibrante",
 "Origem": "Origem",
 "Origem da reserva": "Origem da reserva",
 "Original": "Original",
 "Orquídeas": "Orquídeas",
 "Orçado": "Orçamentado",
 "Orçamento": "Orçamento",
 "Orçamento do mês": "Orçamento do mês",
 "Orçamento por categoria": "Orçamento por categoria",
 "Orçamento total": "Orçamento total",
 "Orçamento: {v}": "Orçamento: {v}",
 "Os alertas precisam de um horário.": "Os alertas precisam de uma hora.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Os anexos que ficam só no dispositivo não aparecem nos outros e perdem-se se trocares de telemóvel. Liga o Google Drive ou o OneDrive em Definições para guardar uma cópia.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Os ficheiros e cópias que já lá estão continuam lá. O My Planner apenas deixa de guardar coisas novas.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Os ficheiros guardados neste dispositivo também serão apagados.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Os ficheiros que estão no teu Google Drive, OneDrive ou no telemóvel continuam contigo. Registos que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Os avisos do grupo ainda não foram ativados no servidor. No computador, faz duplo clique em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (só uma vez).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "As notificações estão desligadas para o My Planner. Toca em Abrir definições e ativa as notificações.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "As notificações no telemóvel funcionam na app instalada (Android ou iPhone).",
 "Os campos do formulário viram parte da página.": "Os campos do formulário passam a fazer parte da página.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Os dados atuais serão substituídos pelos do ficheiro, aqui e na nuvem.",
 "Os dados continuam salvos na nuvem.": "Os dados continuam guardados na nuvem.",
 "Os dados da aba ainda são só seus": "Os dados do separador ainda são só seus",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Os dados do separador {aba} passam a ser vistos pela equipa, cada pessoa conforme a função que escolher.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Os dados deste grupo ainda não foram libertados. Pede a quem criou o grupo para abrir o My Planner atualizado: a app liberta-os sozinha.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Os dados deste grupo ainda não foram libertados. Pede a quem criou o grupo para atualizar o My Planner e abrir o grupo: aí aparece o botão para libertar.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Os dados do cofre são encriptados aqui no dispositivo (AES-256) antes de irem para a nuvem. Nem o suporte consegue ler. Se esquecer a palavra-passe do cofre, estes dados não podem ser recuperados.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, exceto o que a lei obrigar a manter.",
 "Os desenhos não conferem. Comece de novo.": "Os padrões não coincidem. Comece de novo.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Os dias estão na app ou no extrato do banco. As compras feitas depois do fecho caem no extrato seguinte.",
 "Os emojis que você usar aparecem aqui.": "Os emojis que usares aparecem aqui.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Os grupos ainda não foram ativados no servidor. No computador, abre a pasta C:\\MyPlanner e faz duplo clique em 11-LIGAR-GRUPOS.bat (só uma vez).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Os grupos ainda não foram ativados no servidor. Executa o supabase\\migracao-0.21.sql no Supabase (vê o COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Os locais abrem no Google Maps, no Waze ou no Mapas, conforme escolhido em Definições.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Os membros veem sempre os administradores e só recebem o que lhes foi enviado.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Os outros membros deixam de ver os dados (a cópia desaparece dos dispositivos deles). Tudo continua consigo.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Os perfis e os resultados ficam na sua conta do My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Os perfis, as OAB e os tribunais ficam dentro do separador Publicações. A pesquisa automática corre no servidor às 08h e às 12h (hora de Brasília).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Os preços ficam guardados e aparecem na lista de Compras do separador Alimentação & Despensa como o preço da última compra.",
 "Os resultados deste perfil também serão apagados.": "Os resultados deste perfil também serão apagados.",
 "Os termos foram atualizados": "Os termos foram atualizados",
 "Ou digite (ex.: 2 ovos mexidos)": "Ou escreve (ex.: 2 ovos mexidos)",
 "Ou escreva o prato": "Ou escreva o prato",
 "Ou escreva o seu": "Ou escreve o teu",
 "Outra": "Outra",
 "Outra aba…": "Outro separador…",
 "Outra atividade (digite e dê Enter)": "Outra atividade (escreve e prime Enter)",
 "Outro": "Outro",
 "Outro (ml)": "Outro (ml)",
 "Outro valor": "Outro valor",
 "Outros": "Outros",
 "Outros países": "Outros países",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): na app do relógio, ativa a opção de enviar os dados para a app Saúde (Apple Saúde).",
 "Ovo": "Ovo",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o teu texto, com a data.",
 "PARA ACERTAR": "PARA ACERTAR",
 "PARA QUEM": "PARA QUEM",
 "PARA {refeicao}": "PARA {refeicao}",
 "PASSO A PASSO": "PASSO A PASSO",
 "PASSO {n}": "PASSO {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF com texto digital: sai logo no navegador. PDF digitalizado (foto): a tua IA lê cada página.",
 "PDF grande": "PDF grande",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF guardado na pasta \"{pasta}\" do telemóvel.",
 "PDF guardado no {nome}.": "PDF guardado no {nome}.",
 "PDF numa página só": "PDF numa só página",
 "PDF para Word": "PDF para Word",
 "PDF para imagens": "PDF para imagens",
 "PDF para texto": "PDF para texto",
 "PDFs arquivados ({n})": "PDFs arquivados ({n})",
 "PDFs juntados {data}": "PDFs juntos {data}",
 "PEDIDOS RECEBIDOS": "PEDIDOS RECEBIDOS",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPIA E COLA",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "PRÓXIMOS EXTRATOS (JÁ COMPROMETIDO)",
 "Paciente": "Paciente",
 "Paciente ou aluno": "Paciente ou aluno",
 "Pacientes": "Pacientes",
 "Padrão": "Predefinido",
 "Padrão da aba": "Predefinição do separador",
 "Paga": "Paga",
 "Paga (toque para desfazer)": "Paga (toque para anular)",
 "Pagador": "Pagador",
 "Pagamento já contado": "Pagamento já contado",
 "Pagar": "Pagar",
 "Pagar parcela {n}/{t} · {c}": "Pagar prestação {n}/{t} · {c}",
 "Pagas": "Pagas",
 "Pago": "Pago",
 "Pago com": "Pago com",
 "Pago: {p} · Falta pagar: {f}": "Pago: {p} · Falta pagar: {f}",
 "Pagos": "Pagos",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Pagaste {v}? Se tiveste desconto, multa ou juros, indica o valor pago. Queres guardar o comprovativo agora?",
 "Paguei outro valor (desconto, multa ou juros)": "Paguei outro valor (desconto, multa ou juros)",
 "Paixão de Cristo": "Sexta-feira Santa",
 "Palavras-chave (separe com vírgula)": "Palavras-chave (separa com vírgulas)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Para o objetivo \"{m}\" chegar no prazo, seriam {v} por mês. Vale a pena alargar o prazo ou começar com um valor menor.",
 "Para clareza, firmo o presente.": "Por ser verdade, assino a presente.",
 "Para comprar": "Para comprar",
 "Para continuar, digite a senha do app.": "Para continuar, introduz a palavra-passe da app.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Para conversar, ligue a sua IA em Definições › Inteligência artificial (Claude, ChatGPT ou Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Para dividir as despesas, escreve em \"Quem vai\" os nomes separados por vírgula (edita a viagem).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Para emitir e pesquisar faturas, ative uma vez o servidor de faturas: no computador, faça duplo clique em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Para exercer os seus direitos, use Fale connosco na app ou escreva para o e-mail abaixo. Respondemos no prazo de 15 dias.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Para fazer chamadas de áudio e vídeo, instala a nova versão da app (0.35). As mensagens já funcionam.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Para a app funcionar: guardar e sincronizar os seus dados entre dispositivos, enviar alertas, partilhar com os grupos que escolheu e prestar suporte.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Para guardar os PDF no {nome}, liga a tua conta em Definições › Google Drive e OneDrive.",
 "Para hoje": "Para hoje",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Para ler foto ou PDF, ligue a sua IA em Definições › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Para ler o relógio automaticamente, instala a nova versão da app (0.33). Entretanto, podes introduzir os valores manualmente.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Para ler o relógio, liga-o através da app no telemóvel. Os números aparecem aqui também.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Para ler o relógio, autoriza o acesso do My Planner aos dados de atividade.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Para ler o texto, resumir e fazer perguntas, ativa a tua IA em Definições › Inteligência artificial (Claude, ChatGPT ou Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Para ligar, use a app no telemóvel (Definições > Calendário Google). Depois, tudo aparece aqui também.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Para ligar, use a app no telemóvel (Definições › Configuração geral › Calendário Google). Depois, tudo aparece aqui também.",
 "Para monitorar a OAB, informe o número e a UF.": "Para monitorizar a OAB, indique o número e a UF.",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Para não perguntar mais, escolhe a app em Definições › Configuração geral.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com seguro de saúde, recibo e declaração para reembolso.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Para proteger a tua conta, confirmamos o teu telemóvel uma vez, com um código pelo WhatsApp. Só é pedido outra vez se mudares de número.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Para quem arrenda o imóvel ou um quarto por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Para receberes a agenda, o local e os avisos do evento no telemóvel, entra no grupo: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Para sincronizar, autorize o acesso do My Planner ao calendário nas definições do telemóvel.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Para retirar uma permissão que já deu ao sistema (câmara, fotografias, microfone), use também as definições do telemóvel.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Para uma leitura mais completa, ative a sua IA em Definições › Inteligência artificial.",
 "Parabéns": "Parabéns",
 "Parabéns!": "Parabéns!",
 "Parada": "Parado",
 "Parar": "Parar",
 "Parar de compartilhar?": "Parar de partilhar?",
 "Parar e salvar": "Parar e guardar",
 "Parar gravação": "Parar gravação",
 "Parcela": "Prestação",
 "Parcela de financiamento": "Prestação de financiamento",
 "Parcela {n}/{t}": "Prestação {n}/{t}",
 "Parcela {n}/{t} · {c}": "Prestação {n}/{t} · {c}",
 "Parcelas": "Prestações",
 "Parcelas a pagar nos próximos meses": "Prestações a pagar nos próximos meses",
 "Parcelas recalculadas": "Prestações recalculadas",
 "Parece que foi impresso e escaneado.": "Parece que foi impresso e digitalizado.",
 "Parei": "Parei",
 "Parei na aula": "Parei na aula",
 "Parei na aula...": "Parei na aula...",
 "Pares de meia": "Pares de meias",
 "Parque ou natureza": "Parque ou natureza",
 "Parques": "Parques",
 "Parte": "Parte",
 "Partes": "Partes",
 "Participa": "Participa",
 "Participantes": "Participantes",
 "Participação em empresa": "Participação em empresa",
 "Passa do limite do MEI: fale com seu contador.": "Ultrapassa o limite do MEI: fale com o seu contabilista.",
 "Passaporte": "Passaporte",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Passa o dedo sobre o desenho para apagar só essa parte.",
 "Passeio": "Passeio",
 "Passeios": "Passeios",
 "Passo a passo": "Passo a passo",
 "Passos": "Passos",
 "Passos, exercício, calorias, batimentos e sono": "Passos, exercício, calorias, batimentos e sono",
 "Passou do orçamento": "Acima do orçamento",
 "Passou do orçamento em {v}": "Ultrapassou o orçamento em {v}",
 "Pasta": "Pasta",
 "Patrimônio": "Património",
 "Patrimônio & Imposto de Renda": "Património & IRS",
 "Patrimônio pelo valor de compra: {v}": "Património pelo valor de compra: {v}",
 "Pausa (s)": "Pausa (s)",
 "Pausa de {m} min": "Pausa de {m} min",
 "Pausado": "Em pausa",
 "Pausar": "Pausar",
 "Pausas": "Pausas",
 "Pausas de estudo": "Pausas de estudo",
 "Pauta (opcional)": "Ordem de trabalhos (opcional)",
 "Paz": "Paz",
 "Pediatra": "Pediatra",
 "Pedido": "Pedido",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Pedido enviado a {nome}. Quando aceitar, já podem conversar.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Pedido enviado. Quando a pessoa aceitar, já podem conversar.",
 "Pedidos de documentos": "Pedidos de documentos",
 "Pedir de novo depois de": "Pedir novamente após",
 "Peguei emprestado": "Pedi emprestado",
 "Peito de frango": "Peito de frango",
 "Peixe": "Peixe",
 "Pela última compra: cerca de {v}": "Pela última compra: cerca de {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir uma despesa nova.",
 "Pendente": "Pendente",
 "Pensão alimentícia": "Pensão de alimentos",
 "Pequena": "Pequena",
 "Pequeno": "Pequeno",
 "Percentual de tributos do Simples (para sair na nota)": "Percentagem de tributos do Simples (para sair na fatura)",
 "Perguntar ao Mestre": "Perguntar ao Mestre",
 "Perguntar sempre": "Perguntar sempre",
 "Pergunte ao Mestre...": "Pergunte ao Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Pergunta sobre o documento (ex.: qual é o prazo?)",
 "Permissões": "Permissões",
 "Personalizado": "Personalizado",
 "Perto do limite do orçamento": "Perto do limite do orçamento",
 "Período": "Período",
 "Período da meta": "Período da meta",
 "Pescoço: inclinar para os lados": "Pescoço: inclinar para os lados",
 "Peso": "Peso",
 "Peso na média": "Peso na média",
 "Pesquisar no mapa": "Pesquisar no mapa",
 "Pessoa": "Pessoa",
 "Pessoa de contato": "Pessoa de contacto",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "As pessoas dos seus grupos só veem o que for partilhado no grupo.",
 "Pet": "Animal",
 "Pet & Família": "Animais & Família",
 "Pet shop": "Pet shop",
 "Pet shop ou clínica": "Pet shop ou clínica",
 "Pets": "Animais",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.",
 "Pijamas": "Pijamas",
 "Pilates": "Pilates",
 "Pintura": "Pintura",
 "Pix copia e cola": "Pix copia e cola",
 "Placa": "Matrícula",
 "Planejado": "Planeado",
 "Planejado e comido": "Planeado e comido",
 "Planilha": "Folha de cálculo",
 "Planilha (Excel)": "Folha de cálculo (Excel)",
 "Planilha do mês para o Receita Saúde": "Folha de cálculo do mês para o Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Plano básico: My Planner + Notas",
 "Plano de aula": "Plano de aula",
 "Plano de saúde": "Seguro de saúde",
 "Planos de aula": "Planos de aula",
 "Planta": "Planta",
 "Plantas": "Plantas",
 "Plantas & Jardim": "Plantas & Jardim",
 "Plataforma ou escola": "Plataforma ou escola",
 "Pneus novos": "Pneus novos",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Pode confirmar a sua presença respondendo a esta mensagem?",
 "Polichinelo": "Polichinelos",
 "Polo ativo": "Parte ativa",
 "Polo passivo": "Parte passiva",
 "Política de privacidade (LGPD)": "Política de privacidade (LGPD)",
 "Política de privacidade, LGPD e permissões": "Política de privacidade, LGPD e permissões",
 "Política de privacidade, LGPD e termos": "Política de privacidade, LGPD e termos",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Põe aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.",
 "Ponte de glúteos": "Ponte de glúteos",
 "Ponto facultativo": "Tolerância de ponto",
 "Ponto facultativo: {nome}": "Tolerância de ponto: {nome}",
 "Ponto turístico": "Ponto turístico",
 "Pontos turísticos": "Pontos turísticos",
 "Por dia": "Por dia",
 "Por faixas": "Por intervalos",
 "Por mês": "Por mês",
 "Por nome": "Por nome",
 "Por semana": "Por semana",
 "Portal": "Portal",
 "Portal do Cliente": "Portal do Cliente",
 "Portal do cliente (convidar o cliente)": "Portal do cliente (convidar o cliente)",
 "Português": "Português",
 "Porão": "Cave",
 "Porções": "Doses",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Pouco espaço livre: fotos e anexos novos podem não ser guardados. Liberta espaço ou guarda os anexos no Google Drive ou OneDrive.",
 "Praia": "Praia",
 "Prancha": "Prancha",
 "Prato do cardápio": "Prato da ementa",
 "Prato principal": "Prato principal",
 "Prazo": "Prazo",
 "Prazo (pagamento ou entrega)": "Prazo (pagamento ou entrega)",
 "Prazo até {fim} · fazer em {dia}": "Prazo até {fim} · fazer a {dia}",
 "Prazo final: {fim}": "Prazo final: {fim}",
 "Prazo: {d}": "Prazo: {d}",
 "Prazo: {t}": "Prazo: {t}",
 "Prazos criados": "Prazos criados",
 "Precisa da sua IA": "Precisa da sua IA",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Preencha a descrição, o código de tributação nacional (6 algarismos) e o valor.",
 "Preenche os campos do PDF e, se quiser, trava.": "Preenche os campos do PDF e, se quiseres, bloqueia-os.",
 "Preencher formulário": "Preencher formulário",
 "Preencher pela foto com a minha IA": "Preencher pela fotografia com a minha IA",
 "Preencher pela nota fiscal com a minha IA": "Preencher pela fatura com a minha IA",
 "Preparando a conversa da equipe...": "A preparar a conversa da equipa...",
 "Preparando a página {n} de {total}...": "A preparar a página {n} de {total}...",
 "Preparando o arquivo": "A preparar o ficheiro",
 "Prescrição, conduta e orientações": "Prescrição, conduta e orientações",
 "Presente": "Presente",
 "Presença": "Presença",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Prima sem soltar o código para o copiar, ou toque em Enviar e escolha \"Copiar\".",
 "Pressione e segure o código para copiar.": "Mantenha premido o código para o copiar.",
 "Pressione e segure um lançamento para apagar.": "Mantenha premido um movimento para o apagar.",
 "Pressione e segure um perfil para removê-lo.": "Mantenha premido um perfil para o remover.",
 "Preto e branco": "Preto e branco",
 "Previdência privada": "PPR (reforma privada)",
 "Preço ou ingresso": "Preço ou bilhete",
 "Price": "Prestação constante (Price)",
 "Primeira": "Primeira",
 "Primeira cota ou cota única do IR": "Primeira prestação ou prestação única do IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Primeira prestação no extrato de {mes}, que vence a {data}.",
 "Prioridade": "Prioridade",
 "Privacidade": "Privacidade",
 "Privacidade e termos": "Privacidade e termos",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Privacidade: o texto ou a imagem analisada vai diretamente deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.",
 "Problema": "Problema",
 "Problemas, erros e sugestões": "Problemas, erros e sugestões",
 "Procedimento": "Procedimento",
 "Procedimento: {c}": "Procedimento: {c}",
 "Processo": "Processo",
 "Processo Civil": "Processo Civil",
 "Processo Penal": "Processo Penal",
 "Processo do Trabalho": "Processo do Trabalho",
 "Processo não informado": "Processo não indicado",
 "Proclamação da República": "Proclamação da República",
 "Procurando a folha...": "A procurar a folha...",
 "Procurando atualização...": "A procurar atualização...",
 "Procurar aba": "Procurar separador",
 "Procurar atualização agora": "Procurar atualização agora",
 "Procurar documento": "Procurar documento",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Procurar ferramenta (ex.: juntar, assinar, comprimir)",
 "Produto": "Produto",
 "Produto (ex.: Geladeira)": "Produto (ex.: Frigorífico)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Produtos, faturas, assistência técnica e aviso antes de expirar.",
 "Produção (vale de verdade)": "Produção (vale a sério)",
 "Produção restrita (teste)": "Produção restrita (teste)",
 "Produção restrita (teste, não vale)": "Produção restrita (teste, não vale)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Produção restrita: ambiente de teste do governo. As faturas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Produção: as faturas emitidas valem a sério e vão para a prefeitura e a Receita Federal.",
 "Produção: vale de verdade": "Produção: vale a sério",
 "Professor": "Professor",
 "Professor & Mentoria": "Professor & Mentoria",
 "Professor(a)": "Professor(a)",
 "Profissionais": "Profissionais",
 "Profissional": "Profissional",
 "Profissional assistente": "Profissional assistente",
 "Profissional ou fornecedor": "Profissional ou fornecedor",
 "Profissional ou local": "Profissional ou local",
 "Profissão ou especialidade": "Profissão ou especialidade",
 "Profissões": "Profissões",
 "Programação": "Programação",
 "Progresso geral": "Progresso geral",
 "Projeto e licenças": "Projeto e licenças",
 "Projetos": "Projetos",
 "Prontas": "Prontos",
 "Pronto": "Pronto",
 "Pronto! Todas as abas estão liberadas até {data}.": "Pronto! Todos os separadores estão desbloqueados até {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Pronto. Bloqueia o ecrã e espera 1 minuto: o aviso deve aparecer com som.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Processo clínico, evolução e prescrições, sem a parte financeira.",
 "Protegendo a chave...": "A proteger a chave...",
 "Proteger no cofre": "Proteger no cofre",
 "Protegido": "Protegido",
 "Protegido no cofre": "Protegido no cofre",
 "Protegidos pelo cofre: {n}": "Protegidos pelo cofre: {n}",
 "Protetor solar": "Protetor solar",
 "Protocolo": "N.º de pedido",
 "Prova": "Teste",
 "Próxima": "Próxima",
 "Próxima até a data": "Próxima até à data",
 "Próxima com quantos km": "Próxima aos quantos km",
 "Próxima dose": "Próxima dose",
 "Próxima: {data}": "Próxima: {data}",
 "Próxima: {d} · {v}": "Próxima: {d} · {v}",
 "Próximas": "Próximas",
 "Próximo": "Seguinte",
 "Próximo ano": "Próximo ano",
 "Próximo número da DPS": "Próximo número da DPS",
 "Próximos 7 dias": "Próximos 7 dias",
 "Próximos vencimentos ({n})": "Próximos vencimentos ({n})",
 "Publicação": "Publicação",
 "Publicações": "Publicações",
 "Pula": "Salta",
 "Pulsa": "Pulsa",
 "Punho": "Punho",
 "Puxada frontal": "Puxada à frente",
 "PÁGINAS": "PÁGINAS",
 "PÔR NA BARRA": "PÔR NA BARRA",
 "Pág. {n}": "Pág. {n}",
 "Página": "Página",
 "Página 1": "Página 1",
 "Página 1 de 10": "Página 1 de 10",
 "Página em branco no fim": "Página em branco no fim",
 "Página em que estou": "Página em que estou",
 "Página escaneada": "Página digitalizada",
 "Página inteira": "Página inteira",
 "Página {a} de {n}": "Página {a} de {n}",
 "Página {n}": "Página {n}",
 "Página {n} de {total}": "Página {n} de {total}",
 "Página: {titulo}": "Página: {titulo}",
 "Páginas": "Páginas",
 "Páginas, tamanho, autor, datas e campos.": "Páginas, tamanho, autor, datas e campos.",
 "Pássaro": "Pássaro",
 "Pão francês": "Papo-seco",
 "Pão integral": "Pão integral",
 "Pôr a data de hoje": "Pôr a data de hoje",
 "Pôr as parcelas no My Planner": "Pôr as prestações no My Planner",
 "Pôr na barra": "Pôr na barra",
 "Pôr no roteiro da viagem": "Pôr no roteiro da viagem",
 "Pôr uma foto": "Pôr uma fotografia",
 "Quadro": "Quadro",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Quadro Kanban, cronómetro de horas por cliente e prazos no My Planner.",
 "Quais contas vencem nos próximos dias?": "Que contas vencem nos próximos dias?",
 "Quais páginas ficam no PDF novo": "Que páginas ficam no PDF novo",
 "Quais páginas sair": "Que páginas tirar",
 "Qual IA": "Qual IA",
 "Qualidade alta": "Qualidade alta",
 "Qualidade boa (menor)": "Qualidade boa (mais pequeno)",
 "Quantidade": "Quantidade",
 "Quanto cortar de cada lado (% da página)": "Quanto cortar de cada lado (% da página)",
 "Quanto já tem guardado (opcional)": "Quanto já tem poupado (opcional)",
 "Quanto paga por limpeza": "Quanto paga por limpeza",
 "Quanto preciso guardar por mês para as minhas metas?": "Quanto preciso de poupar por mês para os meus objetivos?",
 "Quanto quer juntar": "Quanto quer juntar",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Quanto quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.",
 "Quarta": "Quarta",
 "Quarta-feira de Cinzas (até 14h)": "Quarta-feira de Cinzas (até às 14h)",
 "Quarto": "Quarto",
 "Quarto das crianças": "Quarto das crianças",
 "Quarto de casal": "Quarto de casal",
 "Quarto de hóspedes": "Quarto de hóspedes",
 "Quarto infantil": "Quarto das crianças",
 "Queijo": "Queijo",
 "Queixa principal": "Queixa principal",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Quem abrir o link transfere o My Planner (ou usa-o no navegador), inicia sessão e passa a fazer parte do grupo.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Quem criar a conta com o teu código passa logo a ser teu amigo aqui, sem precisar de pedido.",
 "Quem enviou": "Quem enviou",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Quem está num grupo da app contigo (turma, família, viagem...) já pode conversar sem ser amigo. Mantém premido um amigo para remover a amizade ou bloquear.",
 "Quem faz a limpeza": "Quem faz a limpeza",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Quem paga, se não for o paciente (mãe, pai, encarregado)",
 "Quem pagou": "Quem pagou",
 "Quem recebeu (médico, escola...)": "Quem recebeu (médico, escola...)",
 "Quem vai": "Quem vai",
 "Quem vai limpar": "Quem vai limpar",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Quem vê: só quem conversa contigo, os teus amigos e quem está num grupo da app contigo. Deixa em branco o que não quiseres mostrar.",
 "Quente": "Quente",
 "Quer escanear mais uma página?": "Queres digitalizar mais uma página?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Quer guardar o comprovativo agora? Fotografia, PDF ou captura de ecrã do Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Quer enviar uma captura de ecrã? Envie por e-mail e anexe a imagem.",
 "Quer trocar pelos novos ou manter os dois?": "Queres substituir pelos novos ou manter os dois?",
 "Quero assistir": "Quero ver",
 "Quero ir": "Quero ir",
 "Quero ler": "Quero ler",
 "Quero ver": "Quero ver",
 "Quilometragem atual": "Quilometragem atual",
 "Quilometragem: {km}": "Quilometragem: {km}",
 "Quinta": "Quinta",
 "Quintal": "Quintal",
 "Quitado": "Liquidado",
 "Quitados": "Liquidados",
 "Química": "Química",
 "RECIBO": "RECIBO",
 "RG / Carteira de identidade": "Cartão de identificação (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Identificação, carta de condução, passaporte, contratos e certidões, com aviso antes de expirar e envio com um toque.",
 "Raciocínio Lógico": "Raciocínio Lógico",
 "Razão social ou nome": "Denominação social ou nome",
 "Razão social ou nome do consultório": "Denominação social ou nome do consultório",
 "Razão social ou nome fantasia": "Denominação social ou nome comercial",
 "Raça": "Raça",
 "Realizado": "Realizada",
 "Recado": "Recado",
 "Recalcular": "Recalcular",
 "Recalcular as parcelas em aberto": "Recalcular as prestações em aberto",
 "Recalcular as parcelas?": "Recalcular as prestações?",
 "Receber": "Receber",
 "Receber de volta: {i} ({p})": "Receber de volta: {i} ({p})",
 "Receber o código no WhatsApp": "Receber o código no WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Receber prestação {n}/{t} · {c}",
 "Recebeu um convite?": "Recebeste um convite?",
 "Recebeu um código?": "Recebeu um código?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Recebi de {pagador}{doc} a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.",
 "Recebi outro valor": "Recebi outro valor",
 "Recebida": "Recebida",
 "Recebida (toque para desfazer)": "Recebida (toque para anular)",
 "Recebidas": "Recebidas",
 "Recebido": "Recebido",
 "Recebido: {v}": "Recebido: {v}",
 "Recebidos": "Recebidos",
 "Recebidos dos grupos": "Recebidos dos grupos",
 "Recebimento": "Recebimento",
 "Receita": "Receita",
 "Receitas": "Receitas",
 "Recibo": "Recibo",
 "Recibo em PDF": "Recibo em PDF",
 "Recibo emitido": "Recibo emitido",
 "Recibo guardado": "Recibo guardado",
 "Recibos dedutíveis": "Recibos dedutíveis",
 "Recomendada": "Recomendada",
 "Recomeçar": "Recomeçar",
 "Recortar": "Recortar",
 "Recortar margens": "Recortar margens",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Recortar, rodar e os filtros chegam com a nova app (versão 0.49).",
 "Recusada": "Recusada",
 "Recusado": "Recusado",
 "Recusar": "Recusar",
 "Redação": "Redação",
 "Refazer": "Refazer",
 "Refeição": "Refeição",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Refeições, exercícios, cuidados e suplementos marcados para hoje",
 "Referente a": "Referente a",
 "Referência": "Referência",
 "Reforço": "Reforço",
 "Regar a cada quantos dias": "Regar de quantos em quantos dias",
 "Regar hoje": "Regar hoje",
 "Regar: {p}": "Regar: {p}",
 "Regional": "Regional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Regista o diário, as fases e as entregas, sem ver os valores.",
 "Registrar venda/serviço do MEI": "Registar venda/serviço do MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Regista cada consulta: a evolução fica no cofre, com encriptação. A prescrição pode vir de um modelo.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Registe compras e vendas de imóveis, veículos e investimentos com os comprovativos. Ajuda muito na altura do imposto.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Regista o que foi diferente do plano (trocaste um alimento, mudaste a refeição). Entra no relatório da semana.",
 "Registro": "Registo",
 "Registro clínico": "Registo clínico",
 "Registro de horas": "Registo de horas",
 "Registro do diário": "Registo do diário",
 "Regiões com feriado próprio (marque as suas):": "Regiões com feriado próprio (marque as suas):",
 "Regras da casa": "Regras da casa",
 "Regras da casa:": "Regras da casa:",
 "Reguei": "Reguei",
 "Reguei hoje": "Reguei hoje",
 "Reiniciar": "Reiniciar",
 "Reiniciar o app": "Reiniciar a app",
 "Relatório": "Relatório",
 "Relatório da semana": "Relatório da semana",
 "Relatório em PDF ou Excel": "Relatório em PDF ou Excel",
 "Relatório enviado. Obrigado!": "Relatório enviado. Obrigado!",
 "Relatórios": "Relatórios",
 "Relatórios do Bem-Estar": "Relatórios do Bem-Estar",
 "Relatórios gerados ({n})": "Relatórios gerados ({n})",
 "Relaxar": "Relaxar",
 "Religião": "Religião",
 "Relógio": "Relógio",
 "Relógio e apps de saúde": "Relógio e apps de saúde",
 "Remada baixa": "Remada baixa",
 "Remover": "Remover",
 "Remover \"{nome}\"?": "Remover \"{nome}\"?",
 "Remover anotações": "Remover anotações",
 "Remover este bloco?": "Remover este bloco?",
 "Remover páginas": "Remover páginas",
 "Remover vínculo": "Remover ligação",
 "Remover {nome}?": "Remover {nome}?",
 "Remédio": "Medicamento",
 "Remédio contínuo": "Medicamento contínuo",
 "Remédio na linha do tempo": "Medicamento na cronologia",
 "Remédios": "Medicamentos",
 "Remédios de uso contínuo": "Medicamentos de uso contínuo",
 "Renavam ou chassi": "Renavam ou n.º de quadro",
 "Renegociado": "Renegociado",
 "Renomear": "Mudar o nome",
 "Renomear com IA": "Mudar o nome com IA",
 "Renomear ou trocar ícone": "Mudar o nome ou o ícone",
 "Renomear pasta": "Mudar o nome da pasta",
 "Renomear, ícone ou cor": "Nome, ícone ou cor",
 "Renovar: {nome}": "Renovar: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Reorganiza o ficheiro por dentro. Ajuda pouco em PDFs com fotos.",
 "Reparar PDF": "Reparar PDF",
 "Repelente": "Repelente",
 "Repete": "Repete",
 "Repetir a cada quantos dias": "Repetir de quantos em quantos dias",
 "Repetições": "Repetições",
 "Repita a senha": "Repita a palavra-passe",
 "Repita a senha do cofre": "Repita a palavra-passe do cofre",
 "Repita a senha nova": "Repita a nova palavra-passe",
 "Replantio": "Transplante",
 "Replantios": "Transplantes",
 "Repor papel higiênico, sabonete e café": "Repor papel higiénico, sabonete e café",
 "Representatividade": "Representatividade",
 "Reserva": "Reserva",
 "Reservas": "Reservas",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Reservas, limpeza, receitas e despesas no separador Arrendamento & Alojamento",
 "Respirar fundo 5 vezes": "Respirar fundo 5 vezes",
 "Respondendo a {nome}": "A responder a {nome}",
 "Responder": "Responder",
 "Responsável": "Responsável",
 "Responsável (imobiliária, vistoriador)": "Responsável (imobiliária, vistoriador)",
 "Resposta da SEFAZ": "Resposta da SEFAZ",
 "Resta {tempo}": "Falta {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Faltam {ml} = {n} copo(s) de {copo}",
 "Restaurante": "Restaurante",
 "Restaurantes": "Restaurantes",
 "Restaurar": "Restaurar",
 "Restaurar esta cópia?": "Restaurar esta cópia?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Restaurar substitui TODOS os dados atuais pelos da cópia, aqui e na tua conta.",
 "Restaurar uma cópia": "Restaurar uma cópia",
 "Resultado": "Resultado",
 "Resultado nas vendas: {v}": "Resultado nas vendas: {v}",
 "Resumir": "Resumir",
 "Resumir e perguntar": "Resumir e perguntar",
 "Resumo": "Resumo",
 "Resumo (falta o XML completo)": "Resumo (falta o XML completo)",
 "Resumo da manhã": "Resumo da manhã",
 "Resumo da pasta": "Resumo da pasta",
 "Resumo e opinião": "Resumo e opinião",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Resumo, despesas por categoria, contas, extratos, objetivos e todos os movimentos. Bom para enviar ao contabilista ou guardar para o IRS.",
 "Retirar": "Retirar",
 "Retirar da meta": "Retirar do objetivo",
 "Retorno": "Consulta de controlo",
 "Reunião": "Reunião",
 "Reunião agora": "Reunião agora",
 "Reunião de equipe": "Reunião de equipa",
 "Reuniões": "Reuniões",
 "Revestimento e pisos": "Revestimentos e pavimentos",
 "Revisão": "Revisão",
 "Revolução Constitucionalista": "Revolução Constitucionalista",
 "Rico em matéria orgânica": "Rico em matéria orgânica",
 "Rodízio de pneus": "Rotação de pneus",
 "Roedor": "Roedor",
 "Romance": "Romance",
 "Rosca direta": "Curl de bíceps",
 "Rota": "Rota",
 "Rota passando pelos {n} lugares que faltam": "Rota a passar pelos {n} locais que faltam",
 "Rotas e mapas": "Rotas e mapas",
 "Roteiro": "Roteiro",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Roteiro diário que entra na cronologia durante a viagem, mala pelo clima, reservas e fusos horários.",
 "Rotina": "Rotina",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Rotinas passo a passo: skincare, alongamentos, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.",
 "Roupa": "Roupa",
 "Roupa social": "Roupa formal",
 "Roupas de banho": "Fatos de banho",
 "Roupas extras das crianças": "Roupa extra das crianças",
 "Roupas íntimas": "Roupa interior",
 "Rua": "Rua",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Rua, número, localidade (ou o nome do local)",
 "Régua": "Régua",
 "Réptil": "Réptil",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Rótulo (ex.: O meu nome, Empresa do cliente)",
 "SAC": "Amortização constante (SAC)",
 "SEM HORÁRIO": "SEM HORA",
 "SEU MÊS EM NÚMEROS": "O SEU MÊS EM NÚMEROS",
 "SEU TREINO": "O TEU TREINO",
 "SEUS GRUPOS DO APP": "OS TEUS GRUPOS DA APP",
 "SP": "SP",
 "SUBTAREFA": "SUBTAREFA",
 "SUBTAREFAS": "SUBTAREFAS",
 "SUPLEMENTAÇÃO": "SUPLEMENTAÇÃO",
 "Sabonete facial": "Sabonete facial",
 "Sabão para lavar roupa": "Detergente para a roupa",
 "Sacada": "Varanda",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Sai só da lista desta app. A cópia guardada no Drive, no OneDrive ou na pasta do telemóvel continua lá.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Sai só da lista. O ficheiro continua onde foi guardado.",
 "Sair": "Sair",
 "Sair da conta?": "Terminar sessão?",
 "Sair do escritório": "Sair do escritório",
 "Sair do escritório?": "Sair do escritório?",
 "Sair do grupo": "Sair do grupo",
 "Sair do grupo?": "Sair do grupo?",
 "Sair sem baixar": "Sair sem transferir",
 "Saiu": "Saiu",
 "Sala": "Sala",
 "Sala de estar": "Sala de estar",
 "Sala de jantar": "Sala de jantar",
 "Sala virtual": "Sala virtual",
 "Salada": "Salada",
 "Saldo": "Saldo",
 "Saldo depois desta parcela": "Capital em dívida após esta prestação",
 "Saldo devedor: {v}": "Capital em dívida: {v}",
 "Saldo do mês": "Saldo do mês",
 "Salvar": "Guardar",
 "Salvar backup do My Planner": "Guardar cópia de segurança do My Planner",
 "Salvar cuidado": "Guardar cuidado",
 "Salvar cômodo": "Guardar divisão",
 "Salvar e colocar no My Planner": "Guardar e pôr no My Planner",
 "Salvar e sincronizar": "Guardar e sincronizar",
 "Salvar e testar": "Guardar e testar",
 "Salvar endereço": "Guardar morada",
 "Salvar no My Planner": "Guardar no My Planner",
 "Salvar refeição": "Guardar refeição",
 "Salvar suplemento": "Guardar suplemento",
 "Salvar tarefa": "Guardar tarefa",
 "Salvar treino": "Guardar treino",
 "Sanduíche natural": "Sanduíche natural",
 "Santo Antônio": "Santo António",
 "Sapato confortável": "Calçado confortável",
 "Saudade": "Saudades",
 "Saída (imóvel antigo)": "Saída (casa antiga)",
 "Saída de praia": "Saída de praia",
 "Saúde": "Saúde",
 "Saúde & Prontuário": "Saúde & Processo Clínico",
 "Saúde (médicos, dentistas, exames, plano)": "Saúde (médicos, dentistas, exames, seguro de saúde)",
 "Saúde e bem-estar": "Saúde e bem-estar",
 "Scanner": "Scanner",
 "Scanner PDF": "Scanner PDF",
 "Sci-Fi": "Ficção científica",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Se alguma coisa não responder, reinicia a app. Os teus dados estão guardados.",
 "Se der tempo": "Se houver tempo",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Se esta política mudar de forma importante, a app avisa e volta a pedir a sua aceitação.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Se este aviso apareceu, os alertas dos compromissos estão a funcionar.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Se existir uma conta com {email}, enviámos uma ligação para criar uma palavra-passe nova. Verifique também o spam.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Se o alerta se atrasar ou não aparecer: nas definições da app, deixa as notificações ativadas, a bateria \"Sem restrições\" e permite \"Alarmes e lembretes\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Se o relógio estiver ligado, os números dele substituem os introduzidos manualmente quando tiver o dado.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Se ligares o relógio: totais diários de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou da app Saúde (iPhone). A app só lê e nunca altera estes dados.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Se já usou este separador, nada foi apagado: tudo volta a ficar como estava ao subscrever.",
 "Secretária ou recepção": "Secretária ou receção",
 "Seg a sex": "Seg a sex",
 "Seguir": "Seguinte",
 "Segunda": "Segunda",
 "Segurança": "Segurança",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Mantém premido e arrasta para mudar a ordem. ↻ roda, ⧉ duplica e ✕ tira a página.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Mantém premido um GIF numa conversa e toca em \"Guardar\" para ele aparecer aqui.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Mantém premida uma divisão para a mudar de lugar. Com a divisão aberta, mantém premida uma tarefa e larga-a noutra divisão para a levar para lá.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Mantém premido um dossier, uma disciplina ou uma página para mudar a ordem. Larga uma disciplina noutro dossier para a levar para lá.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Mantém premida uma conversa para silenciar ou arquivar. Arquivada continua a receber e enviar, mas sem aviso.",
 "Seguro": "Seguro",
 "Seguro da casa": "Seguro da casa",
 "Seguro viagem": "Seguro de viagem",
 "Selecionar": "Selecionar",
 "Sem": "Sem",
 "Sem alerta": "Sem alerta",
 "Sem categoria": "Sem categoria",
 "Sem comprovante": "Sem comprovativo",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Sem ligação ao servidor de faturas. Verifique a internet e o endereço do servidor.",
 "Sem conexão com o servidor. Confira a internet.": "Sem ligação ao servidor. Verifique a internet.",
 "Sem conexão com os GIFs agora.": "Sem ligação aos GIFs neste momento.",
 "Sem cômodo": "Sem divisão",
 "Sem data de fim": "Sem data de fim",
 "Sem exercícios": "Sem exercícios",
 "Sem fatura em {mes}": "Sem extrato em {mes}",
 "Sem fim": "Sem fim",
 "Sem horário": "Sem hora",
 "Sem internet ou servidor ainda não preparado.": "Sem internet ou servidor ainda não preparado.",
 "Sem internet. Envia quando voltar.": "Sem internet. Envia quando voltar.",
 "Sem internet. Tente de novo.": "Sem internet. Tente novamente.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Sem isto, a tarja só tapa: o texto por baixo continua no ficheiro e dá para copiar.",
 "Sem itens": "Sem itens",
 "Sem juros": "Sem juros",
 "Sem limite": "Sem limite",
 "Sem link de calendário": "Sem link de calendário",
 "Sem margem": "Sem margem",
 "Sem nome": "Sem nome",
 "Sem número na primeira página (capa)": "Sem número na primeira página (capa)",
 "Sem pasta": "Sem pasta",
 "Sem pausas": "Sem pausas",
 "Sem permissão": "Sem permissão",
 "Sem prazo": "Sem prazo",
 "Sem recibo": "Sem recibo",
 "Sem tarefas": "Sem tarefas",
 "Sem texto.": "Sem texto.",
 "Sem tomador identificado": "Sem tomador identificado",
 "Sem título": "Sem título",
 "Sem validade": "Sem validade",
 "Semana": "Semana",
 "Semana completa": "Semana completa",
 "Semana de {de} a {ate}": "Semana de {de} a {ate}",
 "Semanal": "Semanal",
 "Semanal · dias úteis": "Semanal · dias úteis",
 "Semanal · todos os dias": "Semanal · todos os dias",
 "Semanal · {dias}": "Semanal · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Aparecem sempre, juntamente com as tolerâncias de ponto (Carnaval, Quarta-feira de Cinzas e Corpo de Deus).",
 "Senha": "Palavra-passe",
 "Senha (8 caracteres ou mais)": "Palavra-passe (8 caracteres ou mais)",
 "Senha alterada.": "Palavra-passe alterada.",
 "Senha atual": "Palavra-passe atual",
 "Senha atual do cofre": "Palavra-passe atual do cofre",
 "Senha da conta": "Palavra-passe da conta",
 "Senha do certificado": "Palavra-passe do certificado",
 "Senha do cofre": "Palavra-passe do cofre",
 "Senha do cofre alterada.": "Palavra-passe do cofre alterada.",
 "Senha do cofre incorreta.": "Palavra-passe do cofre incorreta.",
 "Senha incorreta": "Palavra-passe incorreta",
 "Senha incorreta.": "Palavra-passe incorreta.",
 "Senha nova (8 caracteres ou mais)": "Nova palavra-passe (8 caracteres ou mais)",
 "Senha nova do cofre (6 caracteres ou mais)": "Nova palavra-passe do cofre (6 caracteres ou mais)",
 "Senha, biometria, bloqueio e privacidade": "Palavra-passe, biometria, bloqueio e privacidade",
 "Senha, e-mail e formas de desbloquear": "Palavra-passe, e-mail e formas de desbloquear",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Juntar as declarações de rendimentos (bancos, entidade patronal, corretoras)",
 "Servidor de notas": "Servidor de faturas",
 "Servidor não configurado (lib/config.ts).": "Servidor não configurado (lib/config.ts).",
 "Servidor não configurado.": "Servidor não configurado.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.",
 "Serviço": "Serviço",
 "Serviço não prestado": "Serviço não prestado",
 "Serviços": "Serviços",
 "Será excluída em 1 dia": "Será eliminada dentro de 1 dia",
 "Será excluída em {n} dias": "Será eliminada dentro de {n} dias",
 "Será excluída hoje": "Será eliminada hoje",
 "Sessão": "Sessão",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "O seu acesso ainda tem de ser aprovado. Tente entrar dentro de alguns instantes.",
 "Seu código": "O seu código",
 "Seu código de amigo": "O teu código de amigo",
 "Seu código para amigos ganharem 10 dias com todas as abas": "O seu código para os amigos ganharem 10 dias com todos os separadores",
 "Seu nome": "O seu nome",
 "Seu papel: {p}": "A sua função: {p}",
 "Seu papel: {p}. {d}": "A sua função: {p}. {d}",
 "Seu scanner de bolso": "O teu scanner de bolso",
 "Seus dados continuam salvos na nuvem.": "Os seus dados continuam guardados na nuvem.",
 "Seus dados na nuvem do My Planner": "Os teus dados na nuvem do My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Os seus dados são seus: não os vendemos nem os usamos para publicidade. Pode exportar ou apagar tudo quando quiser.",
 "Seus {n} meses grátis terminaram": "Os seus {n} meses grátis terminaram",
 "Sexta": "Sexta",
 "Sextou": "Sexta-feira",
 "Sextou!": "Já é sexta!",
 "Shampoo": "Champô",
 "Show ou passeio": "Espetáculo ou passeio",
 "Silenciar avisos": "Silenciar avisos",
 "Sim": "Sim",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Sincronizado em {data}",
 "Sincronizando pelo dispositivo {nome}": "A sincronizar pelo dispositivo {nome}",
 "Sincronizando...": "A sincronizar...",
 "Sincronizar agora": "Sincronizar agora",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Sincronização parada: confirma a tua palavra-passe. Nada se perde.",
 "Site da assistência": "Site da assistência",
 "Site da assistência (https://...)": "Site da assistência (https://...)",
 "Site ou ingresso online": "Site ou bilhete online",
 "Situação": "Estado",
 "Situação agora": "Situação atual",
 "Skincare da manhã": "Skincare da manhã",
 "Skincare da noite": "Skincare da noite",
 "Slides": "Diapositivos",
 "Smileys e pessoas": "Smileys e pessoas",
 "Sobremesa": "Sobremesa",
 "Sobrou no mês": "Sobrou no mês",
 "Sociologia": "Sociologia",
 "Sofá": "Sofá",
 "Sol": "Sol",
 "Sol pleno": "Sol pleno",
 "Solo ou substrato": "Solo ou substrato",
 "Solte numa matéria para mover a página para lá:": "Larga numa disciplina para mover a página para lá:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Soma a garantia legal e a do fabricante. Confirme no certificado de garantia. Avisa 15 e 3 dias antes.",
 "Sombra": "Sombra",
 "Somente esta tarefa": "Apenas esta tarefa",
 "Sono": "Sono",
 "Sono da noite": "Sono da noite",
 "Sopa": "Sopa",
 "Sou MEI": "Sou MEI",
 "Status": "Estado",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "A tua ligação à nuvem expirou (acontece quando a app fica muito tempo sem ser aberta ou a palavra-passe foi alterada noutro dispositivo). Nada se perde: o que está aqui é enviado assim que confirmares.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "A tua equipa num só lugar: conversa, documentos, videorreuniões com gravação e convite pelo link.",
 "Sua rotina em um só lugar": "A tua rotina num só lugar",
 "Sua senha": "A sua palavra-passe",
 "Suas abas": "Os seus separadores",
 "Substituir": "Substituir",
 "Substrato usado": "Substrato usado",
 "Subtarefa {n}": "Subtarefa {n}",
 "Suco": "Sumo",
 "Sugerir nome": "Sugerir nome",
 "Sugestão": "Sugestão",
 "Sugestões de {categoria}": "Sugestões de {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: guarda a conta e os dados sincronizados, como subcontratante. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.",
 "Superiores": "Superiores",
 "Supino reto": "Supino plano",
 "Suplemento": "Suplemento",
 "Suspense": "Suspense",
 "Suíte": "Suite",
 "Sábado": "Sábado",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "São mais de 60 ficheiros. Usa \"A cada N páginas\".",
 "Série": "Série",
 "Série da DPS": "Série da DPS",
 "Série e turma": "Ano e turma",
 "Séries": "Séries",
 "Sérum": "Sérum",
 "Símbolos": "Símbolos",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Só a equipa do escritório vê. Até 50 MB por ficheiro.",
 "Só acompanha": "Só acompanha",
 "Só acompanha, sem valores": "Só acompanha, sem valores",
 "Só administradores": "Só administradores",
 "Só em {data}": "Só em {data}",
 "Só leitura": "Só leitura",
 "Só mandar para a aba Estudos (sem escolher página)": "Só enviar para o separador Estudos (sem escolher página)",
 "Só neste dispositivo": "Só neste dispositivo",
 "Só neste dispositivo: {n}": "Só neste dispositivo: {n}",
 "Só o código": "Só o código",
 "Só o dia {data}": "Só o dia {data}",
 "Só os dados (texto)": "Só os dados (texto)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Só teu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Só um telemóvel sincroniza com o calendário. Para passar para este, toque abaixo.",
 "Só uma vez": "Só uma vez",
 "Só uma vez (abrir a ficha da tarefa)": "Só uma vez (abrir a ficha da tarefa)",
 "Só áudio": "Só áudio",
 "Sótão": "Sótão",
 "TAREFAS DA CASA": "TAREFAS DA CASA",
 "TELEFONE (OPCIONAL)": "TELEFONE (OPCIONAL)",
 "TRAZER PARA O MY PLANNER": "TRAZER PARA O MY PLANNER",
 "TV por assinatura": "TV por subscrição",
 "Tabela": "Tabela",
 "Talvez": "Talvez",
 "Tamanho": "Tamanho",
 "Tamanho da foto": "Tamanho da foto",
 "Tamanho da página": "Tamanho da página",
 "Tamanho das páginas": "Tamanho das páginas",
 "Tamanho do arquivo": "Tamanho do ficheiro",
 "Tamanho do copo": "Tamanho do copo",
 "Também procurar nos Diários Oficiais dos municípios": "Procurar também nos Diários Oficiais dos municípios",
 "Também serão excluídos {n} item(ns) dentro dele.": "Também serão eliminados {n} item(ns) dentro dele.",
 "Tapioca": "Tapioca",
 "Tarefa": "Tarefa",
 "Tarefa da casa": "Tarefa da casa",
 "Tarefa de casa": "Trabalho de casa",
 "Tarefa duplicada": "Tarefa duplicada",
 "Tarefa ou entrega": "Tarefa ou entrega",
 "Tarefa para {nome}": "Tarefa para {nome}",
 "Tarefas da casa": "Tarefas da casa",
 "Tarefas e itens de todas as abas": "Tarefas e itens de todos os separadores",
 "Tarefas novas do My Planner vão para: {agenda}": "As novas tarefas do My Planner vão para: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "As tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Tarjas pretas sobre CPF, valores e nomes. Apaga mesmo.",
 "Tartaruga": "Tartaruga",
 "Taxa de limpeza": "Taxa de limpeza",
 "Taxa de limpeza cobrada do hóspede": "Taxa de limpeza cobrada ao hóspede",
 "Taxas e anúncios": "Taxas e anúncios",
 "Te amo": "Amo-te",
 "Tecnologia": "Tecnologia",
 "Tela cheia": "Ecrã inteiro",
 "Teleconsulta": "Teleconsulta",
 "Telefone": "Telefone",
 "Telefone da assistência": "Telefone da assistência",
 "Telefone da empresa": "Telefone da empresa",
 "Telefone da escola": "Telefone da escola",
 "Telefone da limpeza": "Telefone da limpeza",
 "Telefone de emergência": "Telefone de emergência",
 "Telefone do veterinário": "Telefone do veterinário",
 "Telhado": "Telhado",
 "Tem anexos": "Tem anexos",
 "Tem certeza?": "Tem a certeza?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Tem {n} conta(s) em atraso no total de {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o descoberto bancário.",
 "Tema": "Tema",
 "Tempo de preparo": "Tempo de preparação",
 "Temporada": "Temporada",
 "Temporizador (direita)": "Temporizador (direita)",
 "Tenta consertar um PDF que não abre direito.": "Tenta reparar um PDF que não abre bem.",
 "Tentar de novo": "Tentar novamente",
 "Tente uma foto mais nítida, com a página inteira.": "Tente uma foto mais nítida, com a página inteira.",
 "Termina às {hora}": "Termina às {hora}",
 "Terminar até": "Terminar até",
 "Terminei em": "Terminei a",
 "Terminou": "Terminou",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Terminou a {data}. Nada foi apagado: tudo volta como estava ao subscrever.",
 "Termos de uso": "Termos de utilização",
 "Termos de uso e privacidade": "Termos de utilização e privacidade",
 "Terror": "Terror",
 "Terça": "Terça",
 "Testando...": "A testar...",
 "Testar alerta (1 minuto)": "Testar alerta (1 minuto)",
 "Testar aviso": "Testar notificação",
 "Teste de alerta do Planner": "Teste de alerta do Planner",
 "Teste grátis até {data} ({n} dia(s))": "Teste grátis até {data} ({n} dia(s))",
 "Teste grátis: {n} dia(s)": "Teste grátis: {n} dia(s)",
 "Teste terminado": "Teste terminado",
 "Teste terminou em {data}": "Teste terminou a {data}",
 "Teste: aviso feito pelo próprio celular.": "Teste: notificação criada pelo próprio telemóvel.",
 "Texto": "Texto",
 "Texto completo": "Texto completo",
 "Texto copiado. Cole onde quiser enviar.": "Texto copiado. Cola onde quiseres enviar.",
 "Texto do documento": "Texto do documento",
 "Texto extra do convite (traje, presentes...)": "Texto extra do convite (dress code, presentes...)",
 "Texto livre": "Texto livre",
 "Texto ou recado": "Texto ou recado",
 "Texto para PDF": "Texto para PDF",
 "Texto {data}": "Texto {data}",
 "Tipo": "Tipo",
 "Tipo sanguíneo": "Grupo sanguíneo",
 "Tira as páginas que você não quer.": "Tira as páginas que não queres.",
 "Tira autor, programas, comandos escondidos e anexos.": "Tira autor, programas, comandos escondidos e anexos.",
 "Tira comentários, destaques e desenhos de outros programas.": "Tira comentários, destaques e desenhos de outros programas.",
 "Tira o texto do PDF (arquivo .txt).": "Tira o texto do PDF (ficheiro .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Remover",
 "Tirar a assinatura": "Remover a assinatura",
 "Tirar a foto": "Remover a fotografia",
 "Tirar a foto agora": "Tirar a fotografia agora",
 "Tirar admin": "Retirar admin",
 "Tirar alarmes do My Planner": "Tirar alarmes do My Planner",
 "Tirar arquivos anexados": "Tirar ficheiros anexados",
 "Tirar comentários, destaques e links": "Tirar comentários, destaques e ligações",
 "Tirar da agenda": "Tirar da agenda",
 "Tirar da barra": "Tirar da barra",
 "Tirar daqui": "Tirar daqui",
 "Tirar das minhas figurinhas?": "Tirar dos meus autocolantes?",
 "Tirar de administrador": "Retirar de administrador",
 "Tirar do escritório": "Retirar do escritório",
 "Tirar dos meus GIFs?": "Tirar dos meus GIFs?",
 "Tirar este copo": "Remover este copo",
 "Tirar foto": "Tirar fotografia",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Tirar fotografias de boletos, talões e documentos e escolher fotografias e vídeos da galeria.",
 "Tirar o desenho padrão?": "Remover o padrão?",
 "Tirar o lixo": "Levar o lixo",
 "Tire a foto e a sua IA preenche a ficha": "Tire a fotografia e a sua IA preenche a ficha",
 "Titular (de quem é o documento)": "Titular (a quem pertence o documento)",
 "Titular: {nome}": "Titular: {nome}",
 "Toalha de praia": "Toalha de praia",
 "Tocar os pés": "Tocar nos pés",
 "Toda a agenda": "Toda a agenda",
 "Toda semana": "Todas as semanas",
 "Todas": "Todas",
 "Todas (passadas, esta e futuras)": "Todas (passadas, esta e futuras)",
 "Todas ({n})": "Todas ({n})",
 "Todas as abas liberadas até {data}.": "Todos os separadores desbloqueados até {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Todas as capitais. Marque uma ou mais cidades.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no telemóvel, no Google Drive ou no OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Todas as ferramentas estão no ecrã do separador.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Todas as fotos da viagem ficam aqui: as que puseres no álbum e as do roteiro, dos locais e das reservas.",
 "Todas as plantas estão regadas.": "Todas as plantas estão regadas.",
 "Todas as páginas, uma embaixo da outra.": "Todas as páginas, uma por baixo da outra.",
 "Todo ano": "Todos os anos",
 "Todo dia": "Todos os dias",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Todos os dias à hora escolhida: quantas tarefas tem o dia, a primeira e a energia total.",
 "Todo mês": "Todos os meses",
 "Todo mês · dia {d}": "Todos os meses · dia {d}",
 "Todo o histórico": "Todo o histórico",
 "Todos": "Todos",
 "Todos ({n})": "Todos ({n})",
 "Todos do grupo": "Todos do grupo",
 "Todos do grupo veem": "Todos do grupo veem",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Todos na reunião veem o aviso \"A gravar\". O ficheiro vai para os Documentos do escritório, visível só para ti até o disponibilizares à equipa.",
 "Todos os cuidados": "Todos os cuidados",
 "Todos os dias": "Todos os dias",
 "Todos os suplementos": "Todos os suplementos",
 "Todos os treinos": "Todos os treinos",
 "Todos os tribunais": "Todos os tribunais",
 "Todos presentes": "Todos presentes",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Todos saem do grupo. O que cada pessoa já aceitou continua na sua agenda.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Todos trabalham nos mesmos dados, cada um conforme a sua função. Toque na função de cada pessoa em Membros para a trocar.",
 "Tomador": "Tomador",
 "Tomador (quem contratou)": "Tomador (quem contratou)",
 "Tomadores": "Tomadores",
 "Tomei": "Pedi emprestado",
 "Toque aqui ou no + para criar uma tarefa": "Toque aqui ou no + para criar uma tarefa",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Toca em \"Apagar a minha conta e todos os dados\" e confirma.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Toque em + › Novo cartão de crédito e indique os dias de fecho e de vencimento.",
 "Toque em Ajustes e depois em Segurança.": "Toca em Definições e depois em Segurança.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Toca em Ligar e, no ecrã da Apple, ativa os itens que o My Planner pode ler.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Toca em Ligar e, no ecrã do Health Connect, permite que o My Planner leia os dados.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Toca em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Toque num separador para abrir. Os bloqueados mostram como subscrever.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Toque num separador para o abrir. Cada separador extra pode ser experimentado grátis durante 10 dias.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Toque num separador para o abrir. Toque em 📌 para pôr ou tirar o separador da barra de baixo. Cada separador extra pode ser experimentado grátis durante 10 dias.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Toque numa área para abrir. As bloqueadas mostram como subscrever.",
 "Toque no desenho para continuar desenhando.": "Toque no desenho para continuar a desenhar.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Toca no que este grupo vai partilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.",
 "Toque nos PDFs na ordem em que devem ficar.": "Toca nos PDFs pela ordem em que devem ficar.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Toca num copo para mudar o volume; mantém premido o + para um copo de outro tamanho.",
 "Toque num feriado para adicioná-lo ao Planner.": "Toque num feriado para o adicionar ao Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Toque num movimento para mudar a categoria, guardar o recibo no IRS ou apagar.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Toque num movimento para mudar a categoria. Mantenha premido para apagar.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Toque num perfil para editar. Mantenha premido para o remover.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Toca num texto, desenho ou checklist e arrasta para qualquer lugar da folha.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Toca numa página para recortar, rodar ou mudar o filtro. Mantém premido e arrasta para mudar a ordem.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Toca numa tarefa para a copiar ou mover para hoje.",
 "Toque onde quer a checklist.": "Toca onde queres a checklist.",
 "Toque onde quer escrever.": "Toca onde queres escrever.",
 "Toque para abrir": "Toque para abrir",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Toca para abrir na app do telemóvel. Arrasta para a direita para tirar da lista.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Toca para abrir, mantém premido para mudar o nome. Arrasta para a esquerda para arquivar ou para a direita para eliminar.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Toca para abrir. Arrasta para a direita para tirar da lista.",
 "Toque para aceitar ou recusar.": "Toca para aceitar ou recusar.",
 "Toque para aceitar, editar ou recusar.": "Toca para aceitar, editar ou recusar.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Toque para aplicar agora. Ou entra sozinha ao reabrir a app.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Toque para transferir e instalar por cima. Os seus dados mantêm-se.",
 "Toque para conversar": "Toca para conversar",
 "Toque para enviar o emoji animado": "Toca para enviar o emoji animado",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Toca para enviar. Mantém premido para guardar ou tirar dos teus.",
 "Toque para escolher": "Toque para escolher",
 "Toque para fechar": "Toca para fechar",
 "Toque para gerar um novo QR Code": "Toque para gerar um novo código QR",
 "Tornar admin": "Tornar admin",
 "Tornar administrador": "Tornar administrador",
 "Tosa": "Tosquia",
 "Totais por alimento": "Totais por alimento",
 "Total": "Total",
 "Total bruto": "Total bruto",
 "Total das reservas: {v}": "Total das reservas: {v}",
 "Total de aulas": "Total de aulas",
 "Total de capítulos": "Total de capítulos",
 "Total de módulos": "Total de módulos",
 "Total de páginas": "Total de páginas",
 "Total de recibos: {v}": "Total de recibos: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Total: {n}. Cada separador pode ter até {lim} de texto (fotos e ficheiros não contam: ficam no dispositivo ou no teu Drive).",
 "Total: {v}": "Total: {v}",
 "Trabalhando...": "A trabalhar...",
 "Trabalho": "Trabalho",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Traga os compromissos do seu Calendário Google para o My Planner e edite-os aqui: as alterações voltam para o calendário.",
 "Trans": "Trans",
 "Transferir: {s}": "Transferir: {s}",
 "Transferência": "Mudança de titular",
 "Transferências": "Mudanças de titular",
 "Transporte": "Transportes",
 "Tratamento": "Tratamento",
 "Travar depois de preencher": "Bloquear depois de preencher",
 "Trazer todas para hoje": "Trazer todas para hoje",
 "Trazer tudo para hoje?": "Trazer tudo para hoje?",
 "Trecho ou ideia": "Excerto ou ideia",
 "Treino": "Treino",
 "Trem ou ônibus": "Comboio ou autocarro",
 "Treme": "Treme",
 "Tribunais": "Tribunais",
 "Trilha": "Trilho",
 "Triste": "Triste",
 "Triângulo": "Triângulo",
 "Troca de óleo": "Mudança de óleo",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Mudança de óleo, rotação de pneus, revisões por km, IPVA, licenciamento e seguro.",
 "Trocador portátil": "Muda-fraldas portátil",
 "Trocar": "Alterar",
 "Trocar a categoria": "Mudar a categoria",
 "Trocar a foto": "Alterar a fotografia",
 "Trocar a pasta": "Mudar de pasta",
 "Trocar a senha do cofre": "Alterar a palavra-passe do cofre",
 "Trocar número": "Mudar número",
 "Trocar o certificado": "Trocar o certificado",
 "Trocar o código": "Alterar o código",
 "Trocar o código?": "Alterar o código?",
 "Trocar o desenho": "Mudar o padrão",
 "Trocar o emoji": "Trocar o emoji",
 "Trocar o modelo": "Trocar o modelo",
 "Trocar o número": "Mudar o número",
 "Trocar o número do celular": "Mudar o número de telemóvel",
 "Trocar por:": "Trocar por:",
 "Trocar roupa de cama e toalhas": "Mudar roupa de cama e toalhas",
 "Tríceps na polia": "Tríceps na polia",
 "Tubo de ensaio": "Tubo de ensaio",
 "Tudo": "Tudo",
 "Tudo certo": "Tudo certo",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Tudo em dia por aqui. Lance as despesas do dia a dia para eu ver para onde vai o dinheiro.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Tudo fica guardado na sua conta. O ficheiro é uma cópia extra que guarda onde quiser.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme a função que escolher (quem entra começa com a função mais limitada).",
 "Tudo! Já comprei os ingressos.": "Está! Já comprei os bilhetes.",
 "Turma": "Turma",
 "Turma (opcional)": "Turma (opcional)",
 "Turmas": "Turmas",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o teu caderno.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Turmas, alunos, chamada, notas e planos de aula.",
 "Turmas, pacientes, equipes e convidados": "Turmas, pacientes, equipas e convidados",
 "Técnico": "Técnico",
 "Título": "Título",
 "Título (ex.: Capítulo 3)": "Título (ex.: Capítulo 3)",
 "Título (opcional)": "Título (opcional)",
 "Título da caixa": "Título da caixa",
 "Título de eleitor": "Cartão de eleitor",
 "Título, autor, assunto e palavras-chave.": "Título, autor, assunto e palavras-chave.",
 "Tô chegando": "Estou a chegar",
 "Tônico": "Tónico",
 "UF": "UF",
 "Uau": "Uau",
 "Uhuul!": "Iupi!",
 "Um PDF novo só com as páginas escolhidas.": "Um PDF novo só com as páginas escolhidas.",
 "Um texto clarinho na diagonal de todas as páginas.": "Um texto clarinho na diagonal de todas as páginas.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Uma pasta para cada cliente: trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.",
 "Uma página por arquivo": "Uma página por ficheiro",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Uma página por ficheiro, a cada N páginas ou por intervalos.",
 "Unicórnio": "Unicórnio",
 "Unidade": "Unidade",
 "Universal": "Universal",
 "União": "União",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Usa a conta Google que já está no telemóvel. O My Planner não pede nenhuma palavra-passe do Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Usado: {u} · disponível: {v} · limite {l}",
 "Usar": "Usar",
 "Usar \"{nome}\"": "Usar \"{nome}\"",
 "Usar biometria": "Usar biometria",
 "Usar desenho padrão": "Usar padrão",
 "Usar este celular": "Usar este telemóvel",
 "Usar este nome": "Usar este nome",
 "Usar modelo: {m}": "Usar modelo: {m}",
 "Usar no navegador (My Planner Web)": "Usar no navegador (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Usar o ficheiro já anexado ({nome})",
 "Usar o código": "Usar o código",
 "Usar senha": "Usar palavra-passe",
 "Usar {ia}": "Usar {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Use a nova palavra-passe da próxima vez que entrar, aqui e no My Planner Web.",
 "Use a senha para desbloquear.": "Use a palavra-passe para desbloquear.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Use a sua própria IA para ler publicações, documentos e notas e sugerir marcações. Confirma sempre antes de qualquer coisa entrar no Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Utilize este código ao criar a sua conta e ganhe 10 dias com todos os separadores desbloqueados.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Use o extrato em OFX (o mais indicado) ou CSV, transferido na app ou no site do seu banco.",
 "Use o seu planner no computador, sincronizado com o celular.": "Use o seu planner no computador, sincronizado com o telemóvel.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.",
 "Uso": "Utilização",
 "Uso próprio": "Uso próprio",
 "VRBO": "VRBO",
 "Vacina": "Vacina",
 "Vacina {nome}: {pet}": "Vacina {nome}: {pet}",
 "Vacina: {nome}": "Vacina: {nome}",
 "Vacinas": "Vacinas",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Vacinas e medicamentos dos animais, pet shop e a rotina da escola e da saúde das crianças.",
 "Vai na viagem": "Vai na viagem",
 "Vale até {d}": "Válido até {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Aplica-se a Estudos e Documentos. Na nuvem, o ficheiro abre em qualquer dispositivo e no My Planner Web (até 15 MB por ficheiro).",
 "Vale quantos pontos": "Vale quantos pontos",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Aplica-se só a ti. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Vale uma vez, nos primeiros 30 dias da sua conta.",
 "Validade": "Validade",
 "Validade do certificado A1": "Validade do certificado A1",
 "Validade: {data}": "Validade: {data}",
 "Valor": "Valor",
 "Valor ({m})": "Valor ({m})",
 "Valor a pagar": "Valor a pagar",
 "Valor combinado": "Valor combinado",
 "Valor combinado por atendimento": "Valor combinado por consulta",
 "Valor da hora": "Valor por hora",
 "Valor da parcela (1ª)": "Valor da prestação (1.ª)",
 "Valor da venda": "Valor da venda",
 "Valor de costume": "Valor habitual",
 "Valor do atendimento: {v}{pago}.": "Valor da consulta: {v}{pago}.",
 "Valor emprestado ou financiado": "Valor emprestado ou financiado",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Valor final definido pelo Google Play ou pela App Store, já na moeda do seu país.",
 "Valor maior que o guardado nesta meta.": "Valor superior ao poupado neste objetivo.",
 "Valor padrão da consulta ou sessão": "Valor padrão da consulta ou sessão",
 "Valor pago": "Valor pago",
 "Valor pago (com multa ou desconto)": "Valor pago (com multa ou desconto)",
 "Valor pago (opcional)": "Valor pago (opcional)",
 "Valor pago: {v}": "Valor pago: {v}",
 "Valor que este aluno paga (se for diferente)": "Valor que este aluno paga (se for diferente)",
 "Valor recebido": "Valor recebido",
 "Valor recebido: {v}": "Valor recebido: {v}",
 "Valor total da compra": "Valor total da compra",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Valores e dados clínicos só aparecem para quem a função permitir. Pode desativar quando quiser: os dados continuam consigo.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Valores a confirmar com o seu contabilista. As regras de dedução mudam todos os anos.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Vamos conversar no My Planner? Adiciona-me como amigo com o código {codigo} (separador Mensagens > Amigos).",
 "Vaso": "Vaso",
 "Veja os planos em Ajustes › Compras.": "Veja os planos em Definições › Compras.",
 "Vem da aba Empréstimos & Financiamentos": "Vem do separador Empréstimos & Financiamentos",
 "Vence em {data}.": "Expira a {data}.",
 "Vence em {fim} (data informada na publicação).": "Vence a {fim} (data indicada na publicação).",
 "Vence em {n} dia(s)": "Expira dentro de {n} dia(s)",
 "Vence hoje": "Expira hoje",
 "Vence {data}": "Vence {data}",
 "Vencendo": "A expirar",
 "Venceu há {n} dia(s)": "Expirou há {n} dia(s)",
 "Vencidas": "Expiradas",
 "Vencidos": "Expirados",
 "Vencimento": "Vencimento",
 "Vencimento (guias e boletos)": "Vencimento (guias e boletos)",
 "Vencimento da 1ª parcela": "Vencimento da 1.ª prestação",
 "Vencimentos": "Vencimentos",
 "Venda": "Venda",
 "Venda/serviço do MEI": "Venda/serviço do MEI",
 "Vendidos": "Vendidos",
 "Ver": "Ver",
 "Ver a lista de membros": "Ver a lista de membros",
 "Ver a rota": "Ver a rota",
 "Ver arquivos": "Ver ficheiros",
 "Ver detalhes do erro": "Ver detalhes do erro",
 "Ver e editar": "Ver e editar",
 "Ver em Compras": "Ver em Compras",
 "Ver mais": "Ver mais",
 "Ver mais páginas": "Ver mais páginas",
 "Ver no My Planner": "Ver no My Planner",
 "Ver o dia": "Ver o dia",
 "Ver os feriados do ano": "Ver os feriados do ano",
 "Ver participantes": "Ver participantes",
 "Ver páginas": "Ver páginas",
 "Ver todos": "Ver todos",
 "Ver todos ({n})": "Ver todos ({n})",
 "Ver {nome}": "Ver {nome}",
 "Verificar agora": "Verificar agora",
 "Vermífugo": "Desparasitante",
 "Vermífugo ou remédio": "Desparasitante ou medicamento",
 "Vermífugos e remédios": "Desparasitantes e medicamentos",
 "Verso": "Verso",
 "Verso do documento": "Verso do documento",
 "Versão do PDF": "Versão do PDF",
 "Versão instalada": "Versão instalada",
 "Versão {versao} disponível": "Versão {versao} disponível",
 "Versão {v}": "Versão {v}",
 "Veterinário": "Veterinário",
 "Veterinário ou clínica": "Veterinário ou clínica",
 "Veículo": "Veículo",
 "Veículo e acessórios": "Veículo e acessórios",
 "Veículos": "Veículos",
 "Veículos & Manutenção": "Veículos & Manutenção",
 "Vi mais um episódio": "Vi mais um episódio",
 "Viagem": "Viagem",
 "Viagens": "Viagens",
 "Viagens & Lazer": "Viagens & Lazer",
 "Viagens e lugares": "Viagens e locais",
 "Vida noturna": "Vida noturna",
 "Vidros e esquadrias": "Vidros e caixilharia",
 "Vigente": "Em vigor",
 "Vigentes": "Em vigor",
 "Virar": "Virar",
 "Virar a câmera": "Virar a câmara",
 "Virar tarefa (levar à assistência)": "Passar a tarefa (levar à assistência)",
 "Visita domiciliar": "Visita domiciliária",
 "Visitados": "Visitados",
 "Visto": "Visto",
 "Vistoria": "Vistoria",
 "Vistoria: {i}": "Vistoria: {i}",
 "Vistorias": "Vistorias",
 "Visualizar feriados": "Ver feriados",
 "Vitamina": "Vitamina",
 "Vitamina D": "Vitamina D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcares.",
 "Você": "Tu",
 "Você aceitou os termos em {data}.": "Aceitou os termos em {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Ainda não tens amigos na app. Adiciona-os pelo código.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Ainda não tem dossiers. Crie um no separador Estudos.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Deixas de ver a conversa, os documentos e as reuniões.",
 "Você deve: {v}": "Deves: {v}",
 "Você entrou no grupo": "Entraste no grupo",
 "Você entrou no grupo \"{nome}\".": "Entraste no grupo \"{nome}\".",
 "Você está convidado(a) para: {evento}": "Está convidado(a) para: {evento}",
 "Você foi convidado para o My Planner": "Foi convidado para o My Planner",
 "Você foi convidado para o grupo": "Foste convidado para o grupo",
 "Você juntou {v} para \"{m}\".": "Juntou {v} para \"{m}\".",
 "Você já tem todas as abas.": "Já tem todos os separadores.",
 "Você já usou um código de indicação nesta conta.": "Já usou um código de recomendação nesta conta.",
 "Você ligou": "Ligaste",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Podes apagar a conta a qualquer momento, na app do telemóvel ou no site:",
 "Você não tem permissão para isso neste grupo.": "Não tens permissão para isso neste grupo.",
 "Você não vê os outros membros deste grupo.": "Não vês os outros membros deste grupo.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Pode apagar a conta a qualquer momento em Definições > Segurança. Isto apaga para sempre os dados na nuvem e no dispositivo.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Pode: confirmar se tratamos os seus dados, aceder, corrigir, pedir a portabilidade (exportar o ficheiro em Definições > Configuração geral), pedir o apagamento, saber com quem os partilhamos, revogar o consentimento e apresentar reclamação à ANPD.",
 "Você recebe (líquido)": "Recebes (líquido)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "É responsável pela sua palavra-passe e pelo que é feito na sua conta. Use dados verdadeiros no registo.",
 "Volta": "Regresso",
 "Volta ou check-out": "Regresso ou check-out",
 "Volta às {hora}": "Volta às {hora}",
 "Voltar": "Voltar",
 "Voltar ao cardápio da semana neste dia": "Voltar à ementa da semana neste dia",
 "Voltar ao cálculo": "Voltar ao cálculo",
 "Voltar ao foco": "Voltar ao foco",
 "Voltar ao padrão": "Repor o padrão",
 "Voltar ao planejado": "Voltar ao planeado",
 "Voltar para Anotações": "Voltar às Notas",
 "Voltar para as cores do My Planner": "Voltar às cores do My Planner",
 "Voltar para novas": "Voltar às novas",
 "Voltar para o QR Code": "Voltar ao código QR",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Volta à app My Planner no telemóvel. O ecrã de Definições atualiza-se sozinho.",
 "Voo": "Voo",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Voos, hotéis, carro e passeios num só lugar, com o código e o comprovativo.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Vá a Definições e toque em \"Ligar navegador\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Vá a Definições › Configuração geral e toque em \"Ligar navegador\".",
 "Várias páginas por folha": "Várias páginas por folha",
 "Vários PDFs num só, na ordem que você escolher.": "Vários PDFs num só, pela ordem que escolheres.",
 "Vê as aulas e os materiais liberados.": "Vê as aulas e os materiais disponibilizados.",
 "Vê as etapas e registra o diário.": "Vê as fases e regista o diário.",
 "Vê e altera tudo, inclusive os valores.": "Vê e altera tudo, incluindo os valores.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Vê e envia os documentos da própria pasta e responde aos pedidos.",
 "Vê o andamento, sem os valores e sem alterar.": "Vê o andamento, sem os valores e sem alterar.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Vê tudo e regista gastos, locais, roteiro e mala.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Vê tudo, inclui, edita, comenta e põe fotos. Só não adiciona nem remove pessoas do grupo.",
 "Vê tudo, inclusive os valores, sem alterar.": "Vê tudo, incluindo os valores, sem alterar.",
 "Vídeo": "Vídeo",
 "Vínculo": "Ligação",
 "Vínculo perdido": "Ligação perdida",
 "WhatsApp da assistência": "WhatsApp da assistência",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (rede e palavra-passe)",
 "Yoga": "Ioga",
 "Zumbi e Consciência Negra": "Dia de Zumbi e da Consciência Negra",
 "Zzz": "Zzz",
 "a cada {n} dias": "a cada {n} dias",
 "a pagar": "a pagar",
 "a receber": "a receber",
 "a receber {v}": "por receber {v}",
 "a reserva": "a reserva",
 "a última execução falhou; avise o suporte": "a última execução falhou; avisa o suporte",
 "abr": "abr",
 "abril": "abril",
 "acabou": "esgotado",
 "achatado": "achatado",
 "administra": "administrador",
 "ago": "ago",
 "agosto": "agosto",
 "ajustado": "ajustado",
 "algo novo": "algo novo",
 "alterou": "alterou",
 "amanhã": "amanhã",
 "anual": "anual",
 "apagou": "apagou",
 "aplicada em {d}": "aplicada a {d}",
 "app {v} · atualização {p} de {data}": "app {v} · atualização {p} de {data}",
 "assinado": "assinado",
 "atrasada": "atrasada",
 "atrasada há {n} dia(s)": "atrasada há {n} dia(s)",
 "até": "até",
 "até {data}": "até {data}",
 "até {d}": "até {d}",
 "aula {a} de {n}": "aula {a} de {n}",
 "avisos silenciados": "avisos silenciados",
 "caixa": "caixa",
 "colher(es)": "colher(es)",
 "coluna": "coluna",
 "com anexos": "com anexos",
 "com imagem": "com imagem",
 "com tarjas": "com tarjas",
 "com texto": "com texto",
 "com {p}": "com {p}",
 "como planejado": "como planeado",
 "comprado em {data}": "comprado a {data}",
 "comprado em {d} por {v}": "comprado a {d} por {v}",
 "comprimido": "comprimido",
 "comprovante": "comprovativo",
 "concha(s)": "concha(s)",
 "confirmados": "confirmados",
 "consulta recusada": "consulta recusada",
 "contratado": "contratado",
 "contínuo": "contínuo",
 "copo(s)": "copo(s)",
 "corridos": "seguidos",
 "criou o grupo": "criou o grupo",
 "de": "de",
 "de Anotações": "de Notas",
 "de {meta} passos": "de {meta} passos",
 "de {n}": "de {n}",
 "de {p}": "de {p}",
 "dentro / fora do planejado": "dentro / fora do planeado",
 "desconto {v}": "desconto {v}",
 "desfazer": "anular",
 "destino": "destino",
 "deve {v}": "deve {v}",
 "devolvido em {d}": "devolvido a {d}",
 "dez": "dez",
 "dezembro": "dezembro",
 "dia": "dia",
 "dias": "dias",
 "dias com a meta batida": "dias com a meta atingida",
 "dias com a meta de passos": "dias com a meta de passos",
 "digital": "impressão digital",
 "diária média": "diária média",
 "do cliente": "do cliente",
 "do escritório": "do escritório",
 "dom": "dom",
 "domingo": "domingo",
 "e mais {n}": "e mais {n}",
 "em aberto": "em aberto",
 "em atraso": "em atraso",
 "em {n} dias": "daqui a {n} dias",
 "emitida": "emitida",
 "entregue": "entregue",
 "entrou no escritório": "entrou no escritório",
 "enviado": "enviado",
 "escaneado": "digitalizado",
 "escolha": "escolha",
 "este": "este",
 "este dispositivo": "este dispositivo",
 "este item": "este item",
 "exercícios concluídos": "exercícios concluídos",
 "falta {v}": "faltam {v}",
 "faltam {km}": "faltam {km}",
 "fatia(s)": "fatia(s)",
 "faturamento": "faturação",
 "feita em {d}": "feita a {d}",
 "feito {dur}": "feito {dur}",
 "fev": "fev",
 "fevereiro": "fevereiro",
 "frequência {p}%": "assiduidade {p}%",
 "gasto {v}": "gasto {v}",
 "girado": "rodado",
 "guardado": "guardado",
 "higienizado": "higienizado",
 "hoje": "hoje",
 "hora fixa no dia": "hora fixa no dia",
 "há {n} dias": "há {n} dias",
 "iPhone ou computador: {link}": "iPhone ou computador: {link}",
 "incluiu": "adicionou",
 "jan": "jan",
 "janeiro": "janeiro",
 "jul": "jul",
 "julho": "julho",
 "jun": "jun",
 "junho": "junho",
 "já importado": "já importado",
 "liberar em {d}": "libertar em {d}",
 "ligou o compartilhamento": "ativou a partilha",
 "linha": "linha",
 "lucro líquido": "lucro líquido",
 "mai": "mai",
 "maio": "maio",
 "mar": "mar",
 "marca d'água": "marca de água",
 "marcada por {nome}": "marcada por {nome}",
 "março": "março",
 "menos de 1 ano": "menos de 1 ano",
 "mensalidade": "mensalidade",
 "meta batida!": "meta cumprida!",
 "metadados": "metadados",
 "min": "min",
 "min antes": "min antes",
 "min antes do início": "min antes do início",
 "min · {de} às {ate}": "min · {de} às {ate}",
 "multa e juros {v}": "multa e juros {v}",
 "média {m}": "média {m}",
 "mês(es)": "mês(es)",
 "na nuvem": "na nuvem",
 "na pasta \"{pasta}\"": "na pasta \"{pasta}\"",
 "na pasta escolhida": "na pasta escolhida",
 "neste dispositivo": "neste dispositivo",
 "neste celular": "neste telemóvel",
 "no Planner": "no Planner",
 "no {nome}": "no {nome}",
 "nos próximos dias": "nos próximos dias",
 "nov": "nov",
 "novembro": "novembro",
 "numerado": "numerado",
 "nunca verificado": "nunca verificado",
 "não vão": "não vão",
 "o documento mudou depois disso: guarde de novo": "o documento mudou desde então: guarda de novo",
 "ocupação": "ocupação",
 "ontem": "ontem",
 "organizado": "organizado",
 "orçando": "a orçamentar",
 "out": "out",
 "outubro": "outubro",
 "paga": "paga",
 "paga em {d}": "paga em {d}",
 "pago": "pago",
 "pago em {d}": "pago em {d}",
 "pago por {p}": "pago por {p}",
 "pagou {v}": "pagou {v}",
 "parcela {a} de {n}": "prestação {a} de {n}",
 "parece já lançado": "parece já lançado",
 "parte {n}": "parte {n}",
 "passos por dia (média)": "passos por dia (média)",
 "passou {km}": "passou {km}",
 "pausa {p}": "pausa {p}",
 "pausado": "em pausa",
 "peso {n}": "peso {n}",
 "pesquisável": "pesquisável",
 "por dia": "por dia",
 "por dia (média)": "por dia (média)",
 "por dia disponível": "por dia disponível",
 "por semana": "por semana",
 "por {p}": "por {p}",
 "porção(ões)": "porção(ões)",
 "preenchido": "preenchido",
 "primeira às {hora}: {tarefa}": "primeira às {hora}: {tarefa}",
 "produção": "produção",
 "próxima em {data}": "próxima a {data}",
 "próxima rega {d}": "próxima rega {d}",
 "publicação": "publicação",
 "página de estudo": "página de estudo",
 "página única": "página única",
 "páginas": "páginas",
 "páginas {p}": "páginas {p}",
 "qua": "qua",
 "quarta": "quarta",
 "quarta-feira": "quarta-feira",
 "qui": "qui",
 "quinta": "quinta",
 "quinta-feira": "quinta-feira",
 "quitada": "liquidada",
 "recebe {v}": "recebe {v}",
 "recebida": "recebida",
 "reconhecimento facial": "reconhecimento facial",
 "recortado": "recortado",
 "refeições feitas": "refeições feitas",
 "rega a cada {n} dias": "rega a cada {n} dias",
 "regar hoje": "regar hoje",
 "reparado": "reparado",
 "retorno {d}": "controlo {d}",
 "saldo {v}": "saldo {v}",
 "seg": "seg",
 "segunda": "segunda",
 "segunda-feira": "segunda-feira",
 "sem anotações": "sem anotações",
 "sem as páginas {p}": "sem as páginas {p}",
 "sem cliente": "sem cliente",
 "sem dias previstos": "sem dias previstos",
 "sem horário": "sem hora",
 "sem meta": "sem meta",
 "sem resposta": "sem resposta",
 "sem tempo": "sem tempo",
 "semana(s)": "semana(s)",
 "set": "set",
 "setembro": "setembro",
 "seu@email.com": "teu@email.com",
 "sex": "sex",
 "sexta": "sexta",
 "sexta-feira": "sexta-feira",
 "sáb": "sáb",
 "sábado": "sábado",
 "talvez": "talvez",
 "tarefa da casa": "tarefa da casa",
 "tarefa: {t}": "tarefa: {t}",
 "taxas e despesas": "taxas e despesas",
 "ter": "ter",
 "termina em {d}": "termina a {d}",
 "terça": "terça",
 "terça-feira": "terça-feira",
 "teste": "teste",
 "todas": "todas",
 "todo ano em {d}": "todos os anos a {d}",
 "todo dia {d}": "todos os meses no dia {d}",
 "todos": "todos",
 "toque para abrir": "toque para abrir",
 "toque para pausar": "toque para pausar",
 "toque para ver o contato": "toca para ver o contacto",
 "toque para voltar a hoje": "toca para voltar a hoje",
 "treinos concluídos": "treinos concluídos",
 "uma vez em {d}": "uma vez a {d}",
 "unidade(s)": "unidade(s)",
 "vale {n}": "vale {n}",
 "vence em {n} dias": "vence em {n} dias",
 "vence {d}": "vence {d}",
 "venceu em {data}": "expirou a {data}",
 "vencido": "vencido",
 "vendido com ganho de {v}": "vendido com ganho de {v}",
 "vendido com perda de {v}": "vendido com perda de {v}",
 "verificado {quando}": "verificado {quando}",
 "você": "tu",
 "você administra": "és administrador",
 "xícara(s)": "chávena(s)",
 "{aba} bloqueada": "{aba} bloqueado",
 "{aba} está bloqueada": "{aba} está bloqueado",
 "{aba}, em \"Anotações recebidas\"": "{aba}, em \"Notas recebidas\"",
 "{a} aula(s) feita(s)": "{a} aula(s) feita(s)",
 "{a} de {n} aulas": "{a} de {n} aulas",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} chegou a {p}% do orçamento ({g} de {l}).",
 "{c} confirmados de {n} convidados": "{c} confirmados de {n} convidados",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} já está {v} acima do mês passado inteiro. Confirme se foi algo fora do comum.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} já passou o orçamento: {g} de {l}. Segure essa despesa até o mês virar.",
 "{c} passou do orçamento: {g} de {l}.": "{c} passou o orçamento: {g} de {l}.",
 "{de} paga {v} para {para}": "{de} paga {v} a {para}",
 "{de} às {ate}": "{de} às {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} de {mes} de {a}",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}/{m}",
 "{dur} na semana": "{dur} na semana",
 "{dur} registrados": "{dur} registados",
 "{d}/{n} notas": "{d}/{n} notas",
 "{feito} de {meta}": "{feito} de {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} de {n} feitas",
 "{f}/{n} transferências feitas": "{f}/{n} mudanças de titular feitas",
 "{hora} em {fuso}": "{hora} em {fuso}",
 "{h} este mês": "{h} este mês",
 "{h} h": "{h} h",
 "{h} h {m} min": "{h} h {m} min",
 "{h} no seu relógio": "{h} no seu relógio",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} ligado. {n} modelo(s) disponível(is) na sua conta.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: chave de API inválida ou sem permissão.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: limite de utilização atingido. Verifique o saldo ou o limite da sua conta de API.",
 "{item}: em {n} dias ({data}).": "{item}: daqui a {n} dias ({data}).",
 "{item}: hoje ({data}).": "{item}: hoje ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: termina daqui a {n} dias ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: expira dentro de {n} dias ({data}).",
 "{item}: vence hoje ({data}).": "{item}: expira hoje ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: venceu a {data} e ainda não foi marcado como feito.",
 "{livre} livres de {total}": "{livre} livres de {total}",
 "{m} min": "{m} min",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} é agora teu amigo. Já podem conversar.",
 "{nome} conectado!": "{nome} ligado!",
 "{nome} ligou": "{nome} ligou",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)",
 "{n} ITEM(NS)": "{n} ARTIGO(S)",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} separador(es) no seu plano · cores e opções de cada um",
 "{n} aba(s) para comprar": "{n} separador(es) para comprar",
 "{n} adicionada(s)": "{n} adicionada(s)",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} alerta(s) agendado(s) neste telemóvel para os próximos dias.",
 "{n} aluno(s)": "{n} aluno(s)",
 "{n} anexo(s)": "{n} anexo(s)",
 "{n} ano(s)": "{n} ano(s)",
 "{n} arquivo(s)": "{n} ficheiro(s)",
 "{n} atendimento(s)": "{n} consulta(s)",
 "{n} atrasada(s)": "{n} em atraso",
 "{n} atrasado(s)": "{n} atrasado(s)",
 "{n} caixa(s)": "{n} caixa(s)",
 "{n} caixa(s) frágil(eis)": "{n} caixa(s) frágil(eis)",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} caixa(s) · {a} já aberta(s) na casa nova",
 "{n} cancelada(s).": "{n} cancelada(s).",
 "{n} cartão(ões) abertos": "{n} cartão(ões) abertos",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} cobrança(s) criada(s) com vencimento a {d}.",
 "{n} com vencimento": "{n} com vencimento",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} compra(s) no cartão {c}. As prestações futuras já aparecem nos próximos extratos.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} conta(s) marcada(s) como paga(s) automaticamente.",
 "{n} copo(s), {ml} de {meta}": "{n} copo(s), {ml} de {meta}",
 "{n} de {meta} copos": "{n} de {meta} copos",
 "{n} de {total}": "{n} de {total}",
 "{n} de {total} dias": "{n} de {total} dias",
 "{n} de {total} hoje": "{n} de {total} hoje",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} de {t} artigo(s) com preço, dos talões lidos em Finanças.",
 "{n} dia(s)": "{n} dia(s)",
 "{n} dia(s) seguido(s) lendo": "{n} dia(s) seguido(s) a ler",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} dia(s) retirado(s) de tarefas que se repetem",
 "{n} dias": "{n} dias",
 "{n} dias grátis": "{n} dias grátis",
 "{n} dias grátis para testar": "{n} dias grátis para experimentar",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} dias {tipo}: publicada a {pub}, contagem a partir de {ini}, vence a {fim}.",
 "{n} documento(s)": "{n} documento(s)",
 "{n} em atraso": "{n} em atraso",
 "{n} etapa(s) atrasada(s)": "{n} etapa(s) atrasada(s)",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} eliminação(ões) à espera de que o telemóvel sincronize.",
 "{n} falta(s)": "{n} falta(s)",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} ficha(s) no grupo. Escolha a função de cada pessoa em Membros.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos locais e das reservas também aparecem aqui.",
 "{n} item(ns) adicionado(s).": "{n} item(ns) adicionado(s).",
 "{n} item(ns) com outras pessoas": "{n} item(ns) com outras pessoas",
 "{n} item(ns) no Planner.": "{n} item(ns) no Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} movimento(s) encontrado(s)",
 "{n} lançamento(s) novo(s).": "{n} movimento(s) novo(s).",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} lembrete(s) colocado(s) no My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} livro(s) lido(s) este ano",
 "{n} marcado(s)": "{n} selecionado(s)",
 "{n} matéria(s)": "{n} disciplina(s)",
 "{n} membro(s) · abrir a conversa do grupo": "{n} membro(s) · abrir a conversa do grupo",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} meses grátis a partir da criação da conta; depois {preco} por ano.",
 "{n} min": "{n} min",
 "{n} min antes": "{n} min antes",
 "{n} módulo(s)": "{n} módulo(s)",
 "{n} noite(s)": "{n} noite(s)",
 "{n} nota(s) nova(s).": "{n} fatura(s) nova(s).",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} fatura(s) sem XML neste dispositivo ficaram de fora.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} fatura(s) · emitidas {e} · recebidas {r}",
 "{n} nova(s)": "{n} nova(s)",
 "{n} novo(s) do cliente": "{n} novo(s) do cliente",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} novo(s) para aceitar, editar ou recusar.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} prestação(ões) colocada(s) no My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} prestação(ões) em aberto refeitas. As pagas ficaram como estavam.",
 "{n} parcela(s) em atraso": "{n} prestação(ões) em atraso",
 "{n} parcela(s) em atraso: {v}": "{n} prestação(ões) em atraso: {v}",
 "{n} participantes · toque para ver": "{n} participantes · toca para ver",
 "{n} passo(s)": "{n} passo(s)",
 "{n} pausa(s)": "{n} pausa(s)",
 "{n} pedido(s) de amizade": "{n} pedido(s) de amizade",
 "{n} pedido(s) em aberto": "{n} pedido(s) em aberto",
 "{n} pessoa(s)": "{n} pessoa(s)",
 "{n} pessoa(s) já entraram com o seu código.": "{n} pessoa(s) já entraram com o seu código.",
 "{n} pessoas": "{n} pessoas",
 "{n} por folha": "{n} por folha",
 "{n} porções": "{n} doses",
 "{n} publicação(ões) nova(s).": "{n} publicação(ões) nova(s).",
 "{n} publicações novas": "{n} publicações novas",
 "{n} página(s)": "{n} página(s)",
 "{n} página(s) · {r} revisada(s)": "{n} página(s) · {r} revista(s)",
 "{n} páginas": "{n} páginas",
 "{n} recebido(s) dos seus grupos": "{n} recebido(s) dos teus grupos",
 "{n} recebido(s) para responder": "{n} recebido(s) para responder",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} refeição(ões), com a ementa desse dia",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} reserva(s) nova(s) ou alterada(s).",
 "{n} resultado(s) em todas as publicações": "{n} resultado(s) em todas as publicações",
 "{n} selecionado(s): {lista}": "{n} selecionado(s): {lista}",
 "{n} tarefa(s)": "{n} tarefa(s)",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} tarefa(s) apagada(s) por inteiro",
 "{n} tarefa(s) criada(s)": "{n} tarefa(s) criada(s)",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em A Minha Casa. Para levares uma delas para o Planner, abre a tarefa e toca em \"Enviar para o My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} tarefa(s) de ontem por concluir",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} tarefa(s) dos últimos dias por concluir",
 "{n} tarefa(s) hoje": "{n} tarefa(s) hoje",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} tarefa(s) pendente(s) passam para a lista de hoje.",
 "{n} tarjas no documento": "{n} tarjas no documento",
 "{n} treino(s), cada um nos dias dele": "{n} treino(s), cada um nos seus dias",
 "{n} tribunais": "{n} tribunais",
 "{n}x de {v}": "{n}x de {v}",
 "{n}º alerta": "{n}.º alerta",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} enviado(s), {falhas} com erro. Tenta de novo mais tarde.",
 "{ok} enviado(s).": "{ok} enviado(s).",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.",
 "{preco} por ano": "{preco} por ano",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} de {t} prestações pagas ({pct}%)",
 "{p} presentes · {f} faltas": "{p} presentes · {f} faltas",
 "{p}% da meta de {m} páginas": "{p}% da meta de {m} páginas",
 "{p}% feito": "{p}% feito",
 "{p}% ocupado no mês": "{p}% ocupado no mês",
 "{p}% pronta": "{p}% pronta",
 "{p}/{t} pagas": "{p}/{t} pagas",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} convidou-te para o grupo \"{grupo}\" no My Planner. Toca no link para entrar (a app é gratuita para começar): {link}\nCódigo do convite: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} e outros incluíram {n} itens no grupo.",
 "{quem} incluiu {item} no grupo.": "{quem} incluiu {item} no grupo.",
 "{servico} do veículo": "{servico} do veículo",
 "{s} de {a}": "{s} de {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: volte às {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (cópia)",
 "{uso} usados de {total} reservados para o site": "{uso} usados de {total} reservados para o site",
 "{v} · atualização de {data}": "{v} · atualização de {data}",
 "{v}/hora": "{v}/hora",
 "À direita": "À direita",
 "À vista": "A pronto",
 "Às": "Às",
 "Às {hora}": "Às {hora}",
 "ÁGUA": "ÁGUA",
 "Ácido": "Ácido",
 "Água": "Água",
 "Água hoje": "Água hoje",
 "Área externa": "Área exterior",
 "Áreas": "Áreas",
 "Áudio": "Áudio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "É um auxílio e não substitui o acompanhamento das notificações nos canais oficiais. Os prazos devem ser verificados no sistema oficial.",
 "Ética Profissional": "Ética Profissional",
 "Ícone e aba": "Ícone e separador",
 "Óculos de sol": "Óculos de sol",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Entidade emissora (ex.: DETRAN-MS, Polícia Federal)",
 "Órgão emissor: {nome}": "Entidade emissora: {nome}",
 "Ômega 3": "Ómega 3",
 "Última": "Última",
 "Última adubação": "Última adubação",
 "Última aplicação": "Última aplicação",
 "Última busca do servidor para você: {quando}": "Última pesquisa do servidor para ti: {quando}",
 "Última cópia de segurança: {data}": "Última cópia de segurança: {data}",
 "Última rega": "Última rega",
 "Última sincronização: {quando}": "Última sincronização: {quando}",
 "Última: {data}": "Última: {data}",
 "Último dia para entregar a declaração do IR": "Último dia para entregar a declaração de IR",
 "Último erro: {m}": "Último erro: {m}",
 "Últimos 30 dias": "Últimos 30 dias",
 "Últimos 7 dias": "Últimos 7 dias",
 "íris": "íris",
 "última vez em {data}": "última vez a {data}",
 "último em {d}": "última a {d}",
 "úteis": "úteis",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ é a cor do My Planner. A escolha aplica-se a todas as conversas deste dispositivo e da tua conta.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} está a ligar (vídeo)",
 "📆 Conectar a agenda deste celular": "📆 Ligar o calendário deste telemóvel",
 "📞 {nome} está ligando (áudio)": "📞 {nome} está a ligar (áudio)",
 "Link bloqueado por segurança.": "Ligação bloqueada por segurança.",
 "Este arquivo não é uma imagem válida.": "Este ficheiro não é uma imagem válida.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "A pesquisa automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando toca em \"Verificar agora\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Este ecrã mostra a linha temporal da viagem, com as atividades e os locais que têm dia marcado. Para adicionar ou editar as informações completas de um local, use o separador Locais.",
 "Para a viagem {d}": "Para a viagem {d}",
 "sem nome": "sem nome",
 "Foi para a viagem {d}.": "Passou para a viagem {d}.",
 "Orçamento total (se não for detalhar)": "Orçamento total (se não for detalhar)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Monte o roteiro dia a dia. Os locais com dia marcado entram aqui automaticamente. Durante a viagem, o roteiro aparece na linha temporal do My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Marque o dia e a hora no local para ele aparecer automaticamente no Roteiro.",
 "No roteiro": "No roteiro",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou a hora, edite o local.",
 "Para o roteiro desta viagem": "Para o roteiro desta viagem",
 "Orçamento e gastos": "Orçamento e despesas",
 "Parada (cidade)": "Paragem (cidade)",
 "Item da categoria": "Item da categoria",
 "Orçamento da viagem inteira": "Orçamento da viagem inteira",
 "Orçamento geral da viagem": "Orçamento geral da viagem",
 "Previsto {p} · gasto {g}": "Previsto {p} · gasto {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Aqui ficam os custos da viagem que não são de uma paragem (ex.: bilhetes, seguro). Cada paragem tem o seu orçamento.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Indique quanto pretende gastar em cada categoria. Ao registar as despesas, a app mostra quanto já foi usado.",
 "Orçamento por parada": "Orçamento por paragem",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Vai passar por mais de uma cidade? Registe as paragens (separador Paragens): cada uma tem o seu orçamento e as despesas dessas datas entram nela automaticamente.",
 "Coloque o valor do gasto.": "Indique o valor da despesa.",
 "Orçamento de {c}": "Orçamento de {c}",
 "Lançar um gasto nesta parada": "Registar uma despesa nesta paragem",
 "Lançar gasto": "Registar despesa",
 "Orçamento e gastos da parada": "Orçamento e despesas da paragem",
 "Gastos lançados ({n})": "Despesas registadas ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Para corrigir ou apagar uma despesa, use o separador Orçamento e despesas da viagem.",
 "Paradas": "Paragens",
 "Cidade ou lugar": "Cidade ou local",
 "Ex.: Porto": "Ex.: Porto",
 "Chegada": "Chegada",
 "Saída": "Partida",
 "Onde vai ficar": "Onde vai ficar",
 "gasto {g} de {p}": "gasto {g} de {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Vai passar por mais de uma cidade? Registe cada paragem com as datas. Cada uma tem o seu orçamento (alojamento, refeições, transportes...) e as despesas dessas datas entram nela automaticamente.",
 "Café da tarde": "Lanche da tarde",
 "Outros / Lanches": "Outros / Lanches",
 "Gasto {v}": "Gasto {v}",
 "Gasto {g} de {p} · {a} acima": "Gasto {g} de {p} · {a} acima",
 "Gasto {g} de {p}": "Gasto {g} de {p}",
 "Tirar \"{nome}\" do orçamento?": "Retirar \"{nome}\" do orçamento?",
 "Os gastos já lançados nela continuam na lista de gastos.": "As despesas já registadas nela continuam na lista de despesas.",
 "Previsto para {nome}": "Previsto para {nome}",
 "Tirar {nome}": "Retirar {nome}",
 "Nome do item (ex.: Jantar especial)": "Nome do item (ex.: Jantar especial)",
 "Adicionar item": "Adicionar item",
 "Detalhar em itens": "Detalhar em itens",
 "Nova categoria (ex.: Seguro, Presentes)": "Nova categoria (ex.: Seguro, Prendas)",
 "Voltar às categorias sugeridas?": "Voltar às categorias sugeridas?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Os valores previstos desta lista serão apagados. As despesas registadas mantêm-se.",
 "Voltar às categorias sugeridas": "Voltar às categorias sugeridas",
 "Previsto": "Previsto",
 "Ainda pode gastar": "Ainda pode gastar",
 "Passou do previsto": "Acima do previsto",
 "Não foi possível buscar o câmbio": "Não foi possível obter o câmbio",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e indique o câmbio manualmente.",
 "Câmbio de {m} ainda não definido": "Câmbio de {m} ainda não definido",
 "Câmbio de hoje": "Câmbio de hoje",
 "Atualizado em {d}": "Atualizado em {d}",
 "Valor em {m}": "Valor em {m}",
 "Moeda do destino": "Moeda do destino",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Câmbio: quanto vale 1 da moeda do destino na sua moeda",
 "Sem dia marcado": "Sem dia marcado",
 "Valor na moeda do destino": "Valor na moeda do destino",
 "Tirar só desta lista ou excluir de vez?": "Retirar só desta lista ou eliminar de vez?",
 "Excluir de vez": "Eliminar de vez",
 "Relatório da viagem (PDF)": "Relatório da viagem (PDF)",
 "Planilha da viagem (Excel)": "Folha de cálculo da viagem (Excel)",
 "Geral da viagem": "Geral da viagem",
 "Viagem {d}": "Viagem {d}",
 "Quem vai: {p}": "Quem vai: {p}",
 "Outros gastos": "Outras despesas",
 "Orçamento · {n}": "Orçamento · {n}",
 "Código": "Código",
 "Pagou": "Pagou",
 "Permissão internacional para dirigir": "Licença internacional de condução",
 "Vacina (certificado)": "Vacina (certificado)",
 "Autorização de viagem de menor": "Autorização de viagem de menor",
 "Vence antes da volta": "Caduca antes do regresso",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Caduca menos de 6 meses depois do regresso (muitos países não aceitam)",
 "A lista básica já está aqui.": "A lista básica já está aqui.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} documento(s) com validade que pode prejudicar a viagem",
 "Lista básica: passaporte de cada um e seguro viagem": "Lista básica: passaporte de cada um e seguro de viagem",
 "Lista básica: identidade de cada um": "Lista básica: cartão de cidadão de cada um",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Indique a validade de cada documento: a app avisa antes de caducar e verifica se o passaporte é válido por 6 meses depois do regresso. As fotos dos documentos ficam protegidas no cofre.",
 "De quem": "De quem",
 "Número (protegido no cofre)": "Número (protegido no cofre)",
 "Está em mãos": "Já está comigo",
 "Válido até {d}": "Válido até {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Passaporte, visto, seguro de viagem, vacina, autorização de menor... com a validade e a foto. Marque quando já o tiver consigo.",
 "acerto entre os viajantes (não entra no orçamento)": "acerto entre os viajantes (não entra no orçamento)",
 "Só gastos": "Só despesas",
 "Acertos": "Acertos",
 "Marcar como pago?": "Marcar como pago?",
 "{de} já pagou {v} para {para}?": "{de} já pagou {v} a {para}?",
 "Já pagou": "Já pagou",
 "Acerto: {de} pagou {para}": "Acerto: {de} pagou a {para}",
 "Conferir minhas assinaturas": "Verificar as minhas assinaturas",
 "Gerenciar ou cancelar assinaturas na loja": "Gerir ou cancelar assinaturas na loja",
 "Restaurar compras": "Restaurar compras",
 "Procurando...": "A procurar...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} assinatura(s) encontrada(s) e desbloqueada(s).",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Assinatura anual, renova automaticamente. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.",
 "Assinaturas da loja": "Assinaturas da loja",
 "Gerenciar assinaturas (App Store)": "Gerir assinaturas (App Store)",
 "Gerenciar assinaturas (Google Play)": "Gerir assinaturas (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "A assinatura é feita na app do telemóvel (Google Play ou App Store) e vale também aqui no site.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Esta assinatura ainda não está disponível na loja. Tente mais tarde.",
 "Assinatura feita": "Assinatura feita",
 "Já assinei no celular: conferir": "Já assinei no telemóvel: verificar",
 "Nenhuma assinatura encontrada nesta conta da loja.": "Nenhuma assinatura encontrada nesta conta da loja.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Verifique a internet e tente de novo. Nada foi cobrado.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} desbloqueada. Vale também nos seus outros dispositivos e no site.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Para assinar, atualize o My Planner pela Google Play ou pela App Store.",
 "Assinada, renova em {data}": "Assinada, renova a {data}",
 "Não deu para assinar agora": "Não foi possível assinar agora",
 "Assinar por {preco} por ano": "Assinar por {preco} por ano",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" foi para o Mural, em Conquistas.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" voltou ao lugar.",
 "1 ano": "1 ano",
 "1 mês": "1 mês",
 "A IA não achou o valor no comprovante.": "A IA não encontrou o valor no comprovativo.",
 "A cada {n} dias": "A cada {n} dias",
 "A carta está vazia": "A carta está vazia",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "A carta fica trancada até {d}. Até lá não é possível reler nem editar. Para mudar algo, escreva outra carta.",
 "A lixeira está vazia.": "O lixo está vazio.",
 "A mesma do app e do celular": "A mesma da app e do telemóvel",
 "A mesma forma de desbloqueio do app e do celular": "A mesma forma de desbloqueio da app e do telemóvel",
 "A senha do diário precisa ter 6 caracteres ou mais.": "A palavra-passe do diário tem de ter 6 caracteres ou mais.",
 "A senha precisa ter 6 caracteres ou mais.": "A palavra-passe tem de ter 6 caracteres ou mais.",
 "A turma ainda não tem grupo": "A turma ainda não tem grupo",
 "AS 4 BOLINHAS DE COR": "AS 4 BOLINHAS DE COR",
 "Aberta em {d}": "Aberta em {d}",
 "Abra a aba para poder restaurar": "Abra o separador para poder restaurar",
 "Abra o diário primeiro": "Abra o diário primeiro",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Abre com a biometria, o reconhecimento facial ou a palavra-passe da app. A palavra-passe do diário só é pedida na primeira vez em cada dispositivo.",
 "Abre em {d}": "Abre em {d}",
 "Abrir carta para o futuro": "Abrir carta para o futuro",
 "Abrir em {aba}": "Abrir em {aba}",
 "Abrir o Diário": "Abrir o Diário",
 "Abrir o diário": "Abrir o diário",
 "Abrir {aba}": "Abrir {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.",
 "Adicionar foto": "Adicionar fotografia",
 "Apaga tudo o que está no quadro desta página.": "Apaga tudo o que está no quadro desta página.",
 "Apagar o desenho?": "Apagar o desenho?",
 "Apagar o diário": "Apagar o diário",
 "Apagar para todos?": "Apagar para todos?",
 "Aplicar a todas as páginas desta matéria": "Aplicar a todas as páginas desta disciplina",
 "Aplicar a todas as páginas desta pasta": "Aplicar a todas as páginas desta pasta",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Sebentas, fichas, slides, vídeos, ligações e recados. Em ⋮ › Enviar para a turma, cada aluno recebe na sua app.",
 "Aquarela": "Aguarela",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Aqui aparece, sem custo, o que os grupos partilharam consigo. Para usar o separador com os seus próprios dados, subscreva o separador.",
 "Arquivados": "Arquivados",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Arraste para a direita para eliminar, ou para a esquerda para arquivar.",
 "As cobranças desta aula extra já existem.": "As cobranças desta aula extra já existem.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo tem de ser igual ao nome do aluno ou do encarregado de educação no registo.",
 "Atestado": "Atestado",
 "Atestados": "Atestados",
 "Até quando (opcional)": "Até quando (opcional)",
 "Até {d}": "Até {d}",
 "Aula extra": "Aula extra",
 "Aula extra (fora dos dias de aula)": "Aula extra (fora dos dias de aula)",
 "Aula extra de {d}": "Aula extra de {d}",
 "Avaliação de {d}": "Avaliação de {d}",
 "Avaliação salva": "Avaliação guardada",
 "Avançar": "Avançar",
 "Aviso da revisão do mês": "Aviso da revisão do mês",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Aviso no último dia do mês: \"Que tal rever o seu mês? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"",
 "Avulsa": "Avulsa",
 "Avulsas": "Avulsas",
 "Azul": "Azul",
 "Baixar na App Store": "Descarregar na App Store",
 "Baixar na Google Play": "Descarregar no Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Transfira o My Planner na loja: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometria, reconhecimento facial ou a palavra-passe da app. A palavra-passe do diário fica guardada para a primeira vez em cada dispositivo.",
 "Branco": "Branco",
 "Buscando o clima…": "A obter o tempo…",
 "Básicas": "Básicas",
 "COMO ESTOU": "COMO ESTOU",
 "COMO O DIÁRIO ABRE": "COMO O DIÁRIO ABRE",
 "COR DA FOLHA": "COR DA FOLHA",
 "Caixinha no My Planner": "Mealheiro no My Planner",
 "Caixinha {m}": "Mealheiro {m}",
 "Carta de {d}": "Carta de {d}",
 "Carta guardada": "Carta guardada",
 "Carta para o futuro": "Carta para o futuro",
 "Carta trancada": "Carta trancada",
 "Cartas abertas podem ser lidas, mas não editadas.": "As cartas abertas podem ser lidas, mas não editadas.",
 "Cartas para o Futuro": "Cartas para o Futuro",
 "Cartões arquivados": "Cartões arquivados",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Chegou uma carta da {nome} de há {tempo} 💌",
 "Chegou! Toque para abrir 💌": "Chegou! Toque para abrir 💌",
 "Cinza-escuro": "Cinzento-escuro",
 "Clara (segue o tema)": "Clara (segue o tema)",
 "Claras e pastel (boas para folha escura)": "Claras e pastel (boas para folha escura)",
 "Clima (toque para preencher)": "Tempo (toque para preencher)",
 "Clima automático": "Tempo automático",
 "Clima do dia": "Tempo do dia",
 "Cobrar a aula extra": "Cobrar a aula extra",
 "Cobrar a aula extra dos presentes": "Cobrar a aula extra aos presentes",
 "Cobrar a turma toda": "Cobrar à turma toda",
 "Cole um link que comece com https://": "Cole uma ligação que comece por https://",
 "Coloque o valor da aula extra na turma (Editar).": "Indique o valor da aula extra na turma (Editar).",
 "Coloque o valor.": "Indique o valor.",
 "Colunas": "Colunas",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Com a sua IA ativada (Definições › Inteligência artificial), a app lê o valor, a data e a descrição a partir da fotografia.",
 "Como cuidei de mim hoje?": "Como cuidei de mim hoje?",
 "Como foi o seu dia? ✍️": "Como foi o seu dia? ✍️",
 "Compartilhar este projeto (convidar)": "Partilhar este projeto (convidar)",
 "Compartilhar o texto": "Partilhar o texto",
 "Completa": "Completa",
 "Comprovante (foto, PDF ou print)": "Comprovativo (fotografia, PDF ou captura de ecrã)",
 "Comprovante anexado": "Comprovativo anexado",
 "Comprovante de pagamento (foto ou PDF)": "Comprovativo de pagamento (fotografia ou PDF)",
 "Concluído: hábito formado": "Concluído: hábito formado",
 "Concluídos": "Concluídos",
 "Configurar o Diário": "Configurar o Diário",
 "Confirmar pagamento": "Confirmar pagamento",
 "Confirmar recebimento": "Confirmar receção",
 "Conquistas": "Conquistas",
 "Contas arquivadas": "Contas arquivadas",
 "Continuar escrevendo": "Continuar a escrever",
 "Copiado ✓": "Copiado ✓",
 "Copiar código": "Copiar código",
 "Copiar link": "Copiar ligação",
 "Cor atual": "Cor atual",
 "Cor {n}": "Cor {n}",
 "Creme": "Creme",
 "Criada em {d}": "Criada em {d}",
 "Criar as cobranças": "Criar as cobranças",
 "Criar o grupo da turma": "Criar o grupo da turma",
 "Criar o meu diário": "Criar o meu diário",
 "Crie a senha do diário (6 ou mais)": "Crie a palavra-passe do diário (6 ou mais)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Crie o grupo da turma e envie o convite aos alunos. Depois, o envio vai diretamente para eles.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Crie a sua primeira meta, objetivo ou sonho com o botão + abaixo.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.",
 "Crie uma senha nova para começar.": "Crie uma palavra-passe nova para começar.",
 "Cuidados arquivados": "Cuidados arquivados",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Cuidados pessoais do dia feitos (Bem-Estar)",
 "Curto prazo": "Curto prazo",
 "Custos": "Custos",
 "Céu estrelado": "Céu estrelado",
 "Círculo": "Círculo",
 "Cômodos arquivados": "Divisões arquivadas",
 "DIAS CUMPRIDOS": "DIAS CUMPRIDOS",
 "Data (opcional)": "Data (opcional)",
 "De {d}": "De {d}",
 "Desafixar do topo": "Desafixar do topo",
 "Desenho mais fraco ou mais forte": "Desenho mais fraco ou mais forte",
 "Desfazer \"Concluído\" ({d})": "Anular \"Concluído\" ({d})",
 "Desligado": "Desligado",
 "Desmarcar": "Desmarcar",
 "Desmarcar como paga?": "Desmarcar como paga?",
 "Desmarcar como recebida?": "Desmarcar como recebida?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Desmarque o que não usa: desaparece do ecrã e deixa o separador mais simples. Pode alterar depois em Definições › Separadores › {aba} › Partes deste separador.",
 "Dias da semana": "Dias da semana",
 "Dias de aula": "Dias de aula",
 "Dias de aula: {d}": "Dias de aula: {d}",
 "Dias escritos": "Dias escritos",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Dica: desenhe a forma à mão e mantenha o dedo no fim do traço para ela ficar perfeita.",
 "Ditado": "Ditado",
 "Ditar (falar para escrever)": "Ditar (falar para escrever)",
 "Diário apagado": "Diário apagado",
 "Diário protegido": "Diário protegido",
 "Dom": "Dom",
 "Dê um nome a ele na pasta Hábitos.": "Dê-lhe um nome na pasta Hábitos.",
 "EVOLUÇÃO": "EVOLUÇÃO",
 "Editada em {d}": "Editada em {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Abre em {d} ({n} dias). Até lá não é possível reler nem editar.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Abre em {d}. Vai receber um aviso nesse dia.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Fica guardada com a data de hoje para comparar depois.",
 "Enorme": "Enorme",
 "Enviado ao paciente": "Enviado ao paciente",
 "Enviado em": "Enviado em",
 "Enviar \"{t}\" para todos do grupo {g}?": "Enviar \"{t}\" a todos do grupo {g}?",
 "Enviar a nota para cada aluno": "Enviar a nota a cada aluno",
 "Enviar as notas": "Enviar as notas",
 "Enviar o arquivo: {nome}": "Enviar o ficheiro: {nome}",
 "Enviar o recado para a turma": "Enviar o recado para a turma",
 "Enviar o título para outra aba": "Enviar o título para outro separador",
 "Enviar para a turma": "Enviar para a turma",
 "Enviar para outra aba": "Enviar para outro separador",
 "Escolha a cor desta bolinha": "Escolha a cor desta bolinha",
 "Escolha uma data no futuro": "Escolha uma data no futuro",
 "Escolher qualquer cor": "Escolher qualquer cor",
 "Esconder a barra": "Esconder a barra",
 "Escreva a frase": "Escreva a frase",
 "Escreva a que se refere a cobrança.": "Escreva a que se refere a cobrança.",
 "Escreva alguma coisa antes de guardar.": "Escreva alguma coisa antes de guardar.",
 "Escreva alguma coisa antes de salvar.": "Escreva alguma coisa antes de guardar.",
 "Escreva hoje, abra no futuro": "Escreva hoje, abra no futuro",
 "Escreva o que você quer mudar a partir de hoje": "Escreva o que quer mudar a partir de hoje",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Escreva para o seu eu do futuro. A carta fica trancada até ao dia de abrir.",
 "Escrever uma carta": "Escrever uma carta",
 "Escrita em {e} · abre em {a}": "Escrita em {e} · abre em {a}",
 "Escuras (boas para folha clara)": "Escuras (boas para folha clara)",
 "Esperado": "Previsto",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Previsto: {e} · Feito: {f} · Em falta: {fa}",
 "Esqueceu a senha do diário?": "Esqueceu-se da palavra-passe do diário?",
 "Esqueci a senha do diário": "Esqueci-me da palavra-passe do diário",
 "Esta semana": "Esta semana",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Este movimento vem de outra parte da app e não se apaga aqui.",
 "Estudo: {h}": "Estudo: {h}",
 "Esvaziar": "Esvaziar",
 "Esvaziar a lixeira": "Esvaziar o lixo",
 "Esvaziar a lixeira?": "Esvaziar o lixo?",
 "Ex.: Comer uma fruta por dia": "Ex.: Comer uma peça de fruta por dia",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Ex.: Trabalhos de casa, Atestado de 2 dias",
 "Ex.: Reservar a pousada": "Ex.: Reservar a pousada",
 "Ex.: Viagem em família, juntar para a festa": "Ex.: Viagem em família, juntar para a festa",
 "Excluir de vez?": "Eliminar definitivamente?",
 "Excluir esta avaliação?": "Eliminar esta avaliação?",
 "Excluir este bloco?": "Eliminar este bloco?",
 "Excluir este desenho?": "Eliminar este desenho?",
 "Excluir este item?": "Eliminar este item?",
 "Excluir {n} item(ns)?": "Eliminar {n} item(ns)?",
 "Exportar como imagem": "Exportar como imagem",
 "Exportar em PDF": "Exportar em PDF",
 "FOTOS": "FOTOGRAFIAS",
 "FRASE DO DIA": "FRASE DO DIA",
 "FREQUÊNCIA": "FREQUÊNCIA",
 "Falta o valor": "Falta o valor",
 "Feriado": "Feriado",
 "Feriado: {f}": "Feriado: {f}",
 "Fica 30 dias na lixeira.": "Fica 30 dias no lixo.",
 "Ficam 30 dias na lixeira.": "Ficam 30 dias no lixo.",
 "Fichários arquivados": "Dossiers arquivados",
 "Fixar no topo": "Fixar no topo",
 "Floral": "Floral",
 "Folha": "Folha",
 "Folha, tema e cores das páginas com escrita": "Folha, tema e cores das páginas com escrita",
 "Folhas e plantas": "Folhas e plantas",
 "Foto adicionada": "Fotografia adicionada",
 "Foto do sonho": "Fotografia do sonho",
 "Fotos do dia": "Fotografias do dia",
 "Frase": "Frase",
 "Frase do dia (aparece no topo do Meu Dia)": "Frase do dia (aparece no topo do Meu Dia)",
 "Frases, textos, vídeos e fotos que motivam": "Frases, textos, vídeos e fotografias que motivam",
 "Geométrico": "Geométrico",
 "Gerar": "Gerar",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Gravar lembretes e notas por voz e ditar textos (🎤) quando pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.",
 "Guardar e trancar": "Guardar e trancar",
 "Guardar e trancar?": "Guardar e trancar?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Guarde aqui o que o motiva: frases, textos seus, vídeos e fotografias.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Guarde bem esta palavra-passe: sem ela o diário não pode ser recuperado.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Hoje é feriado: {f}. Registar mesmo assim?",
 "Humor do mês": "Humor do mês",
 "Humor do período": "Humor do período",
 "HÁBITOS LIGADOS": "HÁBITOS ASSOCIADOS",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "Há itens grandes na seleção. Só podem ser eliminados um a um, com confirmação e palavra-passe.",
 "Há um ano": "Há um ano",
 "Há um mês": "Há um mês",
 "Hábito": "Hábito",
 "Hábito criado": "Hábito criado",
 "Hábitos": "Hábitos",
 "Hábitos cumpridos": "Hábitos cumpridos",
 "Hábitos cumpridos: {f} de {n}": "Hábitos cumpridos: {f} de {n}",
 "Hábitos formados": "Hábitos formados",
 "INSPIRAÇÃO": "INSPIRAÇÃO",
 "Imagem adicionada": "Imagem adicionada",
 "Imagem não encontrada": "Imagem não encontrada",
 "Incrível": "Incrível",
 "Informação nutricional": "Informação nutricional",
 "Inserir": "Inserir",
 "Inspiração": "Inspiração",
 "Item para o paciente": "Item para o paciente",
 "Itens grandes só se excluem um por um.": "Os itens grandes só se eliminam um a um.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Junte fotografias do que quer viver. Mantenha premido e arraste para organizar.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "ASSOCIAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)",
 "LIGAR A UMA META (OPCIONAL)": "ASSOCIAR A UMA META (OPCIONAL)",
 "LINKS DE VÍDEO": "LIGAÇÕES DE VÍDEO",
 "Lance as notas antes de enviar.": "Lance as notas antes de enviar.",
 "Lançamentos arquivados": "Movimentos arquivados",
 "Legenda (opcional)": "Legenda (opcional)",
 "Lembrete diário": "Lembrete diário",
 "Lendo o comprovante...": "A ler o comprovativo...",
 "Ler o comprovante com a minha IA": "Ler o comprovativo com a minha IA",
 "Ligado": "Ligado",
 "Ligar um texto de motivação (Inspiração)": "Associar um texto de motivação (Inspiração)",
 "Lilás": "Lilás",
 "Limpar a folha inteira?": "Limpar a folha inteira?",
 "Linha reta": "Linha reta",
 "Linhas": "Linhas",
 "Link do vídeo (YouTube, Instagram...)": "Ligação do vídeo (YouTube, Instagram...)",
 "Lisa": "Lisa",
 "Liste os passos do projeto e diga quem faz cada um.": "Liste os passos do projeto e indique quem faz cada um.",
 "Lixeira": "Lixo",
 "Longo prazo": "Longo prazo",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "MARCAR AUTOMATICAMENTE PELO BEM-ESTAR (OPCIONAL)",
 "META OU SONHO LIGADO (OPCIONAL)": "META OU SONHO ASSOCIADO (OPCIONAL)",
 "Mais opções": "Mais opções",
 "Mal": "Mal",
 "Mandar ao paciente pelo WhatsApp": "Enviar ao paciente pelo WhatsApp",
 "Marque o que fez em cada dia": "Marque o que fez em cada dia",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.",
 "Matérias arquivadas": "Disciplinas arquivadas",
 "Mensalidade": "Mensalidade",
 "Meta de água do Bem-Estar": "Meta de água do Bem-Estar",
 "Metas arquivadas": "Metas arquivadas",
 "Metas e sonhos concluídos": "Metas e sonhos concluídos",
 "Metas em andamento": "Metas em curso",
 "Metas que avançaram": "Metas que avançaram",
 "Metas, objetivos e sonhos, com passos e prazos": "Metas, objetivos e sonhos, com passos e prazos",
 "Meu Dia": "Meu Dia",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com palavra-passe.",
 "Minimalista": "Minimalista",
 "Mostrar as contas antes do vencimento": "Mostrar as contas antes do vencimento",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Mostrar datas, horários, moeda e feriados corretos para onde está. A localização aproximada do telemóvel só é usada quando pede o tempo do dia no Diário, e não fica guardada.",
 "Muito bem": "Muito bem",
 "Muito mal": "Muito mal",
 "Mural de fotos dos seus sonhos": "Mural de fotografias dos seus sonhos",
 "Mural, relatório e revisão do mês": "Mural, relatório e revisão do mês",
 "Médio prazo": "Médio prazo",
 "N dias cumpridos no mês": "N dias cumpridos no mês",
 "N dias seguidos": "N dias seguidos",
 "NESTE DIA": "NESTE DIA",
 "Nada a enviar": "Nada a enviar",
 "Nenhum estudo registrado nesta semana.": "Nenhum estudo registado esta semana.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Ainda nenhum hábito. Ex.: \"Comer uma peça de fruta por dia\", \"Beber 2 L de água\", \"Não saltar o pequeno-almoço\".",
 "Nenhum no período.": "Nenhum no período.",
 "Nenhuma": "Nenhuma",
 "Nenhuma carta ainda.": "Ainda nenhuma carta.",
 "Nenhuma foto ainda.": "Ainda nenhuma fotografia.",
 "Neutras e opacas": "Neutras e opacas",
 "Ninguém encontrado no grupo": "Ninguém encontrado no grupo",
 "No computador: {link}": "No computador: {link}",
 "No navegador, a senha do diário é pedida sempre.": "No navegador, a palavra-passe do diário é sempre pedida.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "No último dia do mês: \"Que tal rever o seu mês? ✨\"",
 "Nome da página (opcional)": "Nome da página (opcional)",
 "Nome de quem faz este passo": "Nome de quem faz este passo",
 "Nome do vídeo (opcional)": "Nome do vídeo (opcional)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Nota de 0 a 10 para cada área da vida",
 "Nota: {a}": "Nota: {a}",
 "Nova caixa": "Nova caixa",
 "Nova carta": "Nova carta",
 "Nova meta, objetivo ou sonho": "Nova meta, objetivo ou sonho",
 "Nova senha (6 caracteres ou mais)": "Nova palavra-passe (6 caracteres ou mais)",
 "Nova área (ex.: Espiritualidade)": "Nova área (ex.: Espiritualidade)",
 "Novo cômodo": "Nova divisão",
 "Novo hábito": "Novo hábito",
 "Não dá para excluir em grupo": "Não é possível eliminar em grupo",
 "Não enviados": "Não enviados",
 "Não estão no grupo (ou com outro nome): {l}": "Não estão no grupo (ou têm outro nome): {l}",
 "Não foi possível exportar": "Não foi possível exportar",
 "Não foi possível ouvir agora ({erro}).": "Não foi possível ouvir agora ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Não pede a palavra-passe do diário. É a única parte que pode ser partilhada.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "A app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Pode alterar em Definições › Separadores › Finanças.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "O tempo automático usa a localização do telemóvel. Sem permissão, fica para preencher aqui.",
 "O conteúdo desta carta não foi encontrado.": "O conteúdo desta carta não foi encontrado.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "O ditado chega com a nova versão da app. Atualize o My Planner na loja (ou instale o APK novo) para usar o microfone.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "O diário pede a palavra-passe sempre que entra nele, mesmo com a app desbloqueada.",
 "O diário só abre com essa senha, sempre.": "O diário só abre com essa palavra-passe, sempre.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "O diário é encriptado: sem a palavra-passe, ninguém o consegue abrir, nem o suporte. Se quiser, pode apagar o diário e começar um novo (os Projetos em Grupo mantêm-se).",
 "O que aprendi hoje?": "O que aprendi hoje?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "O que é que este mês lhe ensinou? O que quer levar para o próximo?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "O que fica desmarcado desaparece do ecrã. Os dados continuam guardados.",
 "O que foi bom hoje?": "O que foi bom hoje?",
 "O que foi excluído nos últimos 30 dias": "O que foi eliminado nos últimos 30 dias",
 "O que quero melhorar amanhã?": "O que quero melhorar amanhã?",
 "O que quero mudar agora": "O que quero mudar agora",
 "O que você escreveu nesta carta vai se perder.": "O que escreveu nesta carta vai perder-se.",
 "O que você quer fazer com o arquivo?": "O que quer fazer com o ficheiro?",
 "Objetivo": "Objetivo",
 "Oculta": "Oculta",
 "Orientação": "Orientação",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Orientações, receitas, atestados e materiais para entregar ao paciente, com ficheiros. Só o que está aqui é enviado: o processo clínico nunca sai por esta pasta.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Os dias com página escrita ficam marcados. Toque num dia para abrir.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Os itens são eliminados definitivamente e já não podem ser restaurados.",
 "Outra data": "Outra data",
 "Outras moedas": "Outras moedas",
 "Ouvindo…": "A ouvir…",
 "PASSOS": "PASSOS",
 "PDF com seus dados e assinatura": "PDF com os seus dados e assinatura",
 "POR DIA": "POR DIA",
 "POR MATÉRIA": "POR DISCIPLINA",
 "PROGRESSO": "PROGRESSO",
 "Paciente: {nome}": "Paciente: {nome}",
 "Para o paciente": "Para o paciente",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Para mudar a forma de abrir, entre no Diário com a respetiva palavra-passe e volte aqui.",
 "Para {nome} de {tempo} depois": "Para {nome} de daqui a {tempo}",
 "Parar o ditado": "Parar o ditado",
 "Parcelado": "Em prestações",
 "Partes desta aba": "Partes deste separador",
 "Passo": "Passo",
 "Pastas arquivadas": "Pastas arquivadas",
 "Pastas arquivadas ({n})": "Pastas arquivadas ({n})",
 "Pautada": "Pautada",
 "Pautada com margem": "Pautada com margem",
 "Pedido de exame": "Pedido de exame",
 "Pelo que sou grata hoje?": "Pelo que sou grata hoje?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Permita o microfone e o reconhecimento de voz para o My Planner nas definições do telemóvel.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para este separador",
 "Pontilhada": "Pontilhada",
 "Posto": "Posto",
 "Preenche o clima do Meu Dia pela localização do celular.": "Preenche o tempo do Meu Dia pela localização do telemóvel.",
 "Preencher pela foto do comprovante": "Preencher pela fotografia do comprovativo",
 "Primeira vez neste aparelho: digite a senha do diário.": "Primeira vez neste dispositivo: introduza a palavra-passe do diário.",
 "Projeto": "Projeto",
 "Projeto de Vida": "Projeto de Vida",
 "Projetos com amigos e família (compartilhados)": "Projetos com amigos e família (partilhados)",
 "Projetos em Grupo": "Projetos em Grupo",
 "Proprietário / Locador": "Proprietário / Senhorio",
 "Páginas arquivadas": "Páginas arquivadas",
 "Páginas desta aba": "Páginas deste separador",
 "QUANDO ELA ABRE": "QUANDO ABRE",
 "Qua": "Qua",
 "Quadriculada": "Quadriculada",
 "Quadro dos Sonhos": "Quadro dos Sonhos",
 "Quais partes você vai usar?": "Que partes vai usar?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Quando concluir uma meta ou formar um hábito, aparece aqui para celebrar. 🎉",
 "Quanto você pagou?": "Quanto pagou?",
 "Quanto você recebeu?": "Quanto recebeu?",
 "Que tal revisar o seu mês? ✨": "Que tal rever o seu mês? ✨",
 "Quem faz": "Quem faz",
 "Quem fez o meu dia melhor?": "Quem tornou o meu dia melhor?",
 "Quer guardar o comprovante agora?": "Quer guardar o comprovativo agora?",
 "Qui": "Qui",
 "REFLEXÃO DO MÊS": "REFLEXÃO DO MÊS",
 "Recebeu {v} a mais": "Recebeu {v} a mais",
 "Recebeu {v} a menos": "Recebeu {v} a menos",
 "Receita médica": "Receita médica",
 "Receitas médicas": "Receitas médicas",
 "Recolher": "Recolher",
 "Refeições arquivadas": "Refeições arquivadas",
 "Refeições do cronograma feitas (Bem-Estar)": "Refeições do plano feitas (Bem-Estar)",
 "Referente a (ex.: material, passeio, inscrição)": "Referente a (ex.: material, passeio, inscrição)",
 "Registrar": "Registar",
 "Relacionamentos": "Relações",
 "Relatório de estudos": "Relatório de estudos",
 "Relatório de realizações": "Relatório de conquistas",
 "Relatório em PDF": "Relatório em PDF",
 "Renomear, adicionar ou tirar áreas": "Mudar o nome, adicionar ou remover áreas",
 "Reposição": "Reposição",
 "Restaurado": "Restaurado",
 "Resumida": "Resumida",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada deste separador se torna tarefa automaticamente.",
 "Resumo de {nome}": "Resumo de {nome}",
 "Resumo do dia": "Resumo do dia",
 "Retângulo": "Retângulo",
 "Revisar antes": "Rever antes",
 "Revisão do mês": "Revisão do mês",
 "Roda da Vida": "Roda da Vida",
 "Rosa": "Rosa",
 "Sair sem guardar?": "Sair sem guardar?",
 "Salvar avaliação de hoje": "Guardar avaliação de hoje",
 "Salvar ou enviar": "Guardar ou enviar",
 "Seg": "Seg",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Mantenha premidas e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.",
 "Sem chamada neste dia: cobra todos os alunos.": "Sem chamada neste dia: cobra a todos os alunos.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Sem ideias para escrever? Toque numa pergunta:",
 "Sem registros de humor.": "Sem registos de humor.",
 "Sem tema": "Sem tema",
 "Semana de {d}": "Semana de {d}",
 "Senha atual do diário": "Palavra-passe atual do diário",
 "Senha do diário": "Palavra-passe do diário",
 "Senha do diário incorreta.": "Palavra-passe do diário incorreta.",
 "Senha do diário trocada": "Palavra-passe do diário alterada",
 "Senha própria só do diário": "Palavra-passe própria só do diário",
 "Sequência dos hábitos": "Sequência dos hábitos",
 "Seta": "Seta",
 "Seu diário, só seu": "O seu diário, só seu",
 "Seu texto de motivação": "O seu texto de motivação",
 "Sex": "Sex",
 "Sonho": "Sonho",
 "Suplementos arquivados": "Suplementos arquivados",
 "Sáb": "Sáb",
 "Só abre com a senha do diário.": "Só abre com a palavra-passe do diário.",
 "TEMA DECORATIVO": "TEMA DECORATIVO",
 "TIPO DE FOLHA": "TIPO DE FOLHA",
 "Tarefas arquivadas": "Tarefas arquivadas",
 "Ter": "Ter",
 "Texto para o paciente": "Texto para o paciente",
 "Tipo, cor e tema da folha": "Tipo, cor e tema da folha",
 "Tirar a área \"{a}\"?": "Remover a área \"{a}\"?",
 "Tirar da frase do dia": "Remover da frase do dia",
 "Tirar do arquivo": "Retirar do arquivo",
 "Tirar esta foto do quadro?": "Remover esta fotografia do quadro?",
 "Tirar esta pergunta?": "Remover esta pergunta?",
 "Tirar este vídeo?": "Remover este vídeo?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Todos os dias às {h}: \"Como foi o seu dia? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Todos os alunos já têm uma cobrança com esta referência.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Toque novamente para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner automaticamente: use Enviar, no menu ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Toque num dia para marcar ou desmarcar.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Toque numa bolinha para mudar a cor. Na página, manter premida a bolinha faz o mesmo.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para eliminar.",
 "Treino do dia feito (Bem-Estar)": "Treino do dia feito (Bem-Estar)",
 "Treinos arquivados": "Treinos arquivados",
 "Trocar a senha do diário": "Alterar a palavra-passe do diário",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Tudo o que escrever no diário fica encriptado neste dispositivo antes de ir para a sua conta. Mais ninguém consegue ler, nem o suporte.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Tudo o que eliminar fica aqui durante 30 dias. Depois disso é eliminado definitivamente.",
 "Título (ex.: Ter uma boa alimentação)": "Título (ex.: Ter uma boa alimentação)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só a um aluno, toque em +.",
 "Uma senha própria, só do diário": "Uma palavra-passe própria, só do diário",
 "Usar a senha do diário": "Usar a palavra-passe do diário",
 "Usar como frase do dia": "Usar como frase do dia",
 "Usar este valor": "Usar este valor",
 "Usar o padrão do app": "Usar o padrão da app",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Aplica-se aos valores de todos os separadores (Finanças, renda, mensalidades...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Aplica-se a todas as páginas com escrita (Estudos, Notas, Diário, Documentos...). Cada separador pode ter o seu próprio padrão em Definições › Separadores, e cada página pode mudar a folha em ⋮ › Folha.",
 "Valor da aula extra (por aluno)": "Valor da aula extra (por aluno)",
 "Valor por aluno": "Valor por aluno",
 "Valor previsto: {v}": "Valor previsto: {v}",
 "Vencimento: {d}": "Vencimento: {d}",
 "Ver o comprovante": "Ver o comprovativo",
 "Verde": "Verde",
 "Visualizar": "Pré-visualizar",
 "Você está como convidado": "Está como convidado",
 "Voltar a acompanhar este hábito": "Voltar a acompanhar este hábito",
 "Voltar ao início da folha": "Voltar ao início da folha",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Repor o padrão inicial (folha pautada; preto, azul, vermelho e verde)",
 "Voltar para a nova avaliação": "Voltar à nova avaliação",
 "Vídeos": "Vídeos",
 "X vezes por semana": "X vezes por semana",
 "abre em {n} dias": "abre dentro de {n} dias",
 "agradável": "agradável",
 "arquivo": "ficheiro",
 "aula extra": "aula extra",
 "calor": "calor",
 "chuva": "chuva",
 "concluído": "concluído",
 "céu limpo": "céu limpo",
 "de {n} planejados": "de {n} planeados",
 "dentro de {p}": "dentro de {p}",
 "enviado em {d}": "enviado em {d}",
 "estudados na semana": "estudados na semana",
 "excluído em {d}": "eliminado em {d}",
 "falta 1 dia": "falta 1 dia",
 "faltam {n} dias": "faltam {n} dias",
 "feito {dur} na semana": "feito {dur} na semana",
 "fresco": "fresco",
 "frio": "frio",
 "garoa": "chuvisco",
 "hoje não está planejado": "hoje não está planeado",
 "hábito formado ✨": "hábito formado ✨",
 "incorreta": "incorreta",
 "neblina": "nevoeiro",
 "neve": "neve",
 "nublado": "nublado",
 "não enviado": "não enviado",
 "parcela {k}/{n}": "prestação {k}/{n}",
 "passou há {n} dias": "passou há {n} dias",
 "pelo Bem-Estar": "pelo Bem-Estar",
 "poucas nuvens": "poucas nuvens",
 "reposição": "reposição",
 "sai de vez em {n} dia(s)": "é eliminado definitivamente dentro de {n} dia(s)",
 "sem registros": "sem registos",
 "tempestade": "trovoada",
 "tracejado: {d}": "tracejado: {d}",
 "ver mais": "ver mais",
 "ver menos": "ver menos",
 "{aluno}: {n} de {max}": "{aluno}: {n} de {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} é feriado: {f}. Registar mesmo assim?",
 "{f} de {n} passos feitos": "{f} de {n} passos feitos",
 "{f}/{n} passos": "{f}/{n} passos",
 "{nome} daqui a 1 ano": "{nome} daqui a 1 ano",
 "{nome} daqui a 10 anos": "{nome} daqui a 10 anos",
 "{nome} daqui a 6 meses": "{nome} daqui a 6 meses",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} aluno(s) recebem só a própria nota de \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} aluno(s) receberam a nota.",
 "{n} aluno(s) · {v} cada": "{n} aluno(s) · {v} cada",
 "{n} anos": "{n} anos",
 "{n} dia(s) antes": "{n} dia(s) antes",
 "{n} dia(s) cumprido(s) no mês": "{n} dia(s) cumprido(s) no mês",
 "{n} dia(s) registrado(s) · média {e}": "{n} dia(s) registado(s) · média {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} dia(s) registado(s), média {m} de 6",
 "{n} dia(s) seguido(s)": "{n} dia(s) seguido(s)",
 "{n} dispensada(s) hoje": "{n} dispensada(s) hoje",
 "{n} meses": "{n} meses",
 "{n} outro(s)": "{n} outro(s)",
 "{n} selecionado(s)": "{n} selecionado(s)",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} tarefa(s) concluída(s) no My Planner",
 "{n} vez(es) por semana": "{n} vez(es) por semana",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Água: {a} de {m} ml",
 "ÚLTIMAS 8 SEMANAS": "ÚLTIMAS 8 SEMANAS",
 "Última parcela em {d}": "Última prestação em {d}",
 "é hoje!": "é hoje!",
 "A mesma do app": "A mesma da app",
 "Abrir com o código": "Abrir com o código",
 "Ainda não criado": "Ainda não criado",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "Ao criar, a app mostra um código de recuperação para guardar.",
 "Apagar o diário e começar de novo": "Apagar o diário e começar de novo",
 "Biometria ou código do dispositivo": "Biometria ou código do dispositivo",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometria, PIN do dispositivo ou a palavra-passe da app. Não é preciso criar outra palavra-passe.",
 "Bloquear o app": "Bloquear a app",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Registe a impressão digital, o rosto ou um código de bloqueio no dispositivo para usar.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Com a biometria ativada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a palavra-passe da app continua válida.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Com ele recupera o diário se se esquecer da palavra-passe ou mudar de dispositivo.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Com este código recupera o diário se se esquecer da palavra-passe ou mudar de dispositivo. Guarde-o num local seguro e não o mostre a ninguém.",
 "Como funciona a Roda da Vida": "Como funciona a Roda da Vida",
 "Como o diário abre": "Como o diário abre",
 "Crie a senha que vai abrir o diário.": "Crie a palavra-passe que vai abrir o diário.",
 "Crie o PIN do diário (4 a 6 números)": "Crie o PIN do diário (4 a 6 números)",
 "Crie o diário de novo para começar.": "Crie o diário de novo para começar.",
 "Código aceito. Crie uma senha nova para o diário.": "Código aceite. Crie uma nova palavra-passe para o diário.",
 "Código de recuperação": "Código de recuperação",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Código de recuperação (ex.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Código de recuperação incorreto.",
 "Cômodos": "Divisões",
 "Depois de 1 minuto": "Após 1 minuto",
 "Depois de {n} minutos": "Após {n} minutos",
 "Desenhe o padrão do diário": "Desenhe o padrão do diário",
 "Dias no mês": "Dias no mês",
 "Dias seguidos": "Dias seguidos",
 "Digite o seu PIN": "Introduza o seu PIN",
 "Diário ainda não criado": "Diário ainda não criado",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Dê uma nota de 0 a 10 a como se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Guarde a avaliação e repita-a de tempos a tempos (por exemplo, todos os meses) para comparar e ver a sua evolução. Pode mudar o nome, adicionar ou retirar áreas.",
 "Entre na aba Diário para criar o seu diário.": "Vá ao separador Diário para criar o seu diário.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Entre no Diário (com a palavra-passe dele ou o desbloqueio da app) e volte aqui.",
 "Esconder a senha": "Ocultar a palavra-passe",
 "Gerar novo código": "Gerar novo código",
 "Gerar um código de recuperação novo?": "Gerar um novo código de recuperação?",
 "Guarde este código": "Guarde este código",
 "Já guardei": "Já guardei",
 "Ligar um hábito que já existe": "Associar um hábito que já existe",
 "Mostrar a senha": "Mostrar a palavra-passe",
 "Mudar como o diário abre": "Mudar como o diário abre",
 "My Planner · Código de recuperação do Diário": "My Planner · Código de recuperação do Diário",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Não foi possível abrir com a chave deste dispositivo. Use a palavra-passe do diário ou o código de recuperação.",
 "O Caps Lock parece estar ligado.": "O Caps Lock parece estar ativado.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "O PIN fica guardado só neste dispositivo, protegido. A palavra-passe continua válida se se esquecer do PIN.",
 "O PIN precisa ter de 4 a 6 números.": "O PIN tem de ter de 4 a 6 números.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "O código anterior deixa de ser válido. Por segurança, o código não fica guardado na app: só é possível vê-lo no momento em que é gerado.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "O código não fica guardado em nenhum local que o suporte possa ver. Sem a palavra-passe e sem o código, o diário não pode ser recuperado.",
 "O diário agora abre só com a senha dele.": "O diário agora abre só com a palavra-passe dele.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "O reconhecimento facial deste dispositivo não pode ser usado por apps. Use a impressão digital ou o código/PIN do dispositivo.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "O tempo conta a partir do momento em que a app sai do ecrã (outra app, ecrã inicial ou ecrã desligado). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou ficheiro não contam.",
 "Os PINs não conferem.": "Os PINs não coincidem.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 a 6 números)",
 "PIN (só números, 4 a 6)": "PIN (só números, 4 a 6)",
 "PIN do diário": "PIN do diário",
 "PIN incorreto": "PIN incorreto",
 "PIN salvo.": "PIN guardado.",
 "Padrão do app": "Predefinição da app",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Para apagar, confirme com a palavra-passe da app, a biometria ou o PIN do dispositivo. Isto apaga o Meu Dia, objetivos, hábitos, cartas e fotos do diário. Os Projetos em Grupo mantêm-se.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Para continuar, introduza a palavra-passe da app ou use a biometria/o código do dispositivo.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Para recuperar o diário se se esquecer da palavra-passe ou mudar de dispositivo.",
 "Pastas": "Pastas",
 "Pedir a senha de novo": "Pedir a palavra-passe de novo",
 "Personalizada": "Personalizada",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Primeira vez neste dispositivo: introduza a palavra-passe do diário ou use o código de recuperação.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Primeira vez neste dispositivo: introduza o código de recuperação do diário.",
 "Reconhecimento de rosto": "Reconhecimento facial",
 "Repita o PIN": "Repita o PIN",
 "Salvar a senha nova": "Guardar a nova palavra-passe",
 "Salvar em arquivo / no Drive": "Guardar em ficheiro / no Drive",
 "Salvar o código de recuperação": "Guardar o código de recuperação",
 "Senha (letras e números)": "Palavra-passe (letras e números)",
 "Senha do app": "Palavra-passe da app",
 "Senha nova do diário": "Nova palavra-passe do diário",
 "Senha própria": "Palavra-passe própria",
 "Senha própria do diário": "Palavra-passe própria do diário",
 "Tarefas": "Tarefas",
 "Trocar o PIN": "Mudar o PIN",
 "Usar a senha": "Usar a palavra-passe",
 "Usar o PIN": "Usar o PIN",
 "Usar o código de recuperação": "Usar o código de recuperação",
 "Usar o desbloqueio do app": "Usar o desbloqueio da app",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Use a biometria ou o código/PIN/padrão do dispositivo.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Use o código de recuperação que apareceu quando o diário foi criado. Sem a palavra-passe e sem o código, ninguém consegue abrir o diário, nem o suporte.",
 "Voltar a usar só a senha?": "Voltar a usar só a palavra-passe?",
 "incorreto": "incorreto",
 "1 h": "1 h",
 "12 horas (2:30 PM)": "12 horas (2:30 PM)",
 "15 min": "15 min",
 "24 horas (14:30)": "24 horas (14:30)",
 "30 min": "30 min",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "O lixo tem itens grandes. Confirme com a palavra-passe da app, a biometria ou o código do dispositivo.",
 "A semana começa na": "A semana começa à",
 "Abra o Diário primeiro": "Abra o Diário primeiro",
 "Abrir configurações do celular": "Abrir definições do telemóvel",
 "Agenda e mapas": "Agenda e mapas",
 "Agora: {m}": "Agora: {m}",
 "Ajuda e sobre": "Ajuda e sobre",
 "Alarme (som)": "Alarme (som)",
 "Alarme ou vibração das pausas": "Alarme ou vibração das pausas",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua palavra-passe antes.",
 "Apagar todas ({n})": "Apagar todas ({n})",
 "Apagar {n} selecionada(s)": "Apagar {n} selecionada(s)",
 "Aparência": "Aspeto",
 "App das rotas": "App de navegação",
 "Ardósia": "Ardósia",
 "Arrastar para a direita": "Deslizar para a direita",
 "Arrastar para a esquerda": "Deslizar para a esquerda",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "As contas de Finanças aparecem no My Planner com esta antecedência.",
 "Atualizações e sobre": "Atualizações e sobre",
 "Avisar antes do vencimento": "Avisar antes do vencimento",
 "Aviso marcado": "Aviso marcado",
 "Aviso no começo e no fim de cada pausa": "Aviso no início e no fim de cada pausa",
 "Avisos desta aba": "Avisos deste separador",
 "Avisos e alarmes": "Avisos e alarmes",
 "Avisos silenciosos": "Avisos silenciosos",
 "Avisos: som e vibração": "Avisos: som e vibração",
 "Avisos: só som": "Avisos: só som",
 "Avisos: só vibração": "Avisos: só vibração",
 "Azul elétrico": "Azul elétrico",
 "Azul-aço": "Azul-aço",
 "Azul-bebê": "Azul-bebé",
 "Azul-marinho": "Azul-marinho",
 "Baixar meus dados": "Transferir os meus dados",
 "Baixar todos os meus dados": "Transferir todos os meus dados",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Transferir todos os meus dados e eliminar a conta (LGPD)",
 "Biometria": "Biometria",
 "Bissexual": "Bissexual",
 "Brilhante": "Brilhante",
 "Buscar abas": "Procurar separadores",
 "Buscar nos ajustes": "Procurar nas definições",
 "Cancelar aviso": "Cancelar aviso",
 "Cinza-chumbo": "Cinzento-chumbo",
 "Cofre": "Cofre",
 "Coloque pelo menos uma matéria.": "Adicione pelo menos uma disciplina.",
 "Como usar": "Como usar",
 "Conexões": "Ligações",
 "Cor da aba": "Cor do separador",
 "Cor de destaque": "Cor de destaque",
 "Crie uma matéria primeiro": "Crie primeiro uma disciplina",
 "Cítrico": "Cítrico",
 "Cópia de segurança em arquivo": "Cópia de segurança em ficheiro",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Dados de pacientes e processos clínicos. Confirme com a palavra-passe da app, a biometria ou o código do dispositivo.",
 "Desligadas": "Desligadas",
 "Digite a senha da sua conta para confirmar.": "Introduza a palavra-passe da sua conta para confirmar.",
 "Duração padrão de uma tarefa nova": "Duração predefinida de uma tarefa nova",
 "Editar sessão": "Editar sessão",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Repete-se sem data de fim: aparecem as ocorrências até {data}. Com todas marcadas, sai a tarefa inteira.",
 "Em atividade": "Em atividade",
 "Em pausa": "Em pausa",
 "Emoji da pausa": "Emoji da pausa",
 "Encerrar": "Terminar",
 "Encerrar a sessão?": "Terminar a sessão?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Entra no modo de seleção, para escolher vários itens de uma vez.",
 "Escolha um horário no futuro.": "Escolha uma hora no futuro.",
 "Escolher a matéria": "Escolher a disciplina",
 "Esconde os valores em dinheiro (R$ •••)": "Esconde os valores em dinheiro (R$ •••)",
 "Esconder o CPF": "Esconder o CPF",
 "Esconder os valores": "Esconder os valores",
 "Esta e as próximas": "Esta e as seguintes",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Esta tarefa repete-se. Onde aplicar a alteração?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Este item tem muito conteúdo. Confirme com a palavra-passe da app, a biometria ou o código do dispositivo.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Elimina o item (pede confirmação). Depois pode anular ou restaurar a partir do Lixo.",
 "Excluir minha conta": "Eliminar a minha conta",
 "Ficha protegida": "Ficha protegida",
 "Formato da hora": "Formato da hora",
 "Foto do Quadro dos Sonhos": "Foto do Quadro dos Sonhos",
 "Geral": "Geral",
 "Gestos": "Gestos",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive e ficheiro de cópia",
 "Grafite": "Grafite",
 "Guardar em": "Guardar em",
 "Hábito do Diário": "Hábito do Diário",
 "Idioma e moeda": "Idioma e moeda",
 "Inspiração do Diário": "Inspiração do Diário",
 "Intenso": "Intenso",
 "Item arquivado": "Item arquivado",
 "Item excluído": "Item eliminado",
 "Lavanda": "Lavanda",
 "Ligadas": "Ligadas",
 "Limite de energia": "Limite de energia",
 "Lésbica": "Lésbica",
 "Marque as vezes que vão ser apagadas.": "Marque as ocorrências que vão ser apagadas.",
 "Matéria": "Disciplina",
 "Me avise em…": "Avise-me daqui a…",
 "Menta": "Menta",
 "Menu ⋮": "Menu ⋮",
 "Meta do Diário": "Meta do Diário",
 "Modo discreto": "Modo discreto",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Monte a sessão uma vez (disciplinas, tempo de cada uma e pausas) e repita-a noutros dias tocando em Começar. O tempo de estudo entra automaticamente na meta.",
 "Mostra Arquivar e Duplicar.": "Mostra Arquivar e Duplicar.",
 "Mostrar feriados no topo": "Mostrar feriados no topo",
 "Mostrar os valores": "Mostrar os valores",
 "Muda a ordem dos itens.": "Muda a ordem dos itens.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Muda só a cor do My Planner. A cor de destaque da app está em Definições > Aspeto. Cada tarefa pode ter uma cor própria na ficha.",
 "Nada encontrado nos ajustes.": "Nada encontrado nas definições.",
 "Nenhuma sessão salva ainda.": "Ainda não há sessões guardadas.",
 "Neon": "Néon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "Neste horário a app não toca nem vibra. Os avisos continuam a chegar, em silêncio.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "No menu ⋮ de qualquer item: o telemóvel avisa à hora escolhida, sem criar tarefa no My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Nome (ex.: Sessão do mestrado)",
 "Nova sessão": "Nova sessão",
 "Nuvem e cópias de segurança": "Nuvem e cópias de segurança",
 "Não perturbe": "Não incomodar",
 "Não perturbe {de}–{ate}": "Não incomodar {de}–{ate}",
 "Não-binário": "Não-binário",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados estão em Definições > Feriados.",
 "O celular avisa às {h}.": "O telemóvel avisa às {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "O que sai do Diário fica cifrado no lixo. Entre no Diário e depois volte aqui para restaurar.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "O que sair fica no Lixo durante 30 dias. Introduza a palavra-passe da sua conta para confirmar.",
 "O que saiu fica na Lixeira por 30 dias.": "O que saiu fica no Lixo durante 30 dias.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "O tema muda as cores dos separadores, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para mudar a cor de um só separador, vá a Definições > Separadores.",
 "O tempo estudado até agora entra na meta.": "O tempo de estudo até agora entra na meta.",
 "Oliva": "Oliva",
 "Orgulho": "Orgulho",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Os avisos funcionam na app instalada, com as notificações ligadas.",
 "Os gestos do app": "Os gestos da app",
 "Outro (escolher a hora)": "Outro (escolher a hora)",
 "Pansexual": "Pansexual",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Para ligar, use a app no telemóvel (Definições › Agenda e mapas › Calendário Google). Depois, tudo aparece aqui também.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Para não perguntar mais, escolha a app em Definições › Agenda e mapas.",
 "Pausa": "Pausa",
 "Petróleo": "Azul-petróleo",
 "Pink elétrico": "Rosa elétrico",
 "Preto total": "Preto total",
 "Progresso": "Progresso",
 "Pêssego": "Pêssego",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Quantos dias antes as contas aparecem define-se em Definições > Avisos e alarmes.",
 "Rosa-chá": "Rosa-chá",
 "Roxo-profundo": "Roxo-profundo",
 "Segurança e dados": "Segurança e dados",
 "Segurar e arrastar": "Manter premido e arrastar",
 "Segurar e soltar": "Manter premido e largar",
 "Selecionar todas": "Selecionar todas",
 "Semana começa na {dia}": "Semana começa à {dia}",
 "Sessão de estudo": "Sessão de estudo",
 "Sessão encerrada": "Sessão terminada",
 "Sessão pausada": "Sessão em pausa",
 "Som e vibração": "Som e vibração",
 "Suave": "Suave",
 "Só esta semana": "Só esta semana",
 "Só hoje": "Só hoje",
 "Só neste dia ({data})": "Só neste dia ({data})",
 "Tamanho das caixas": "Tamanho das caixas",
 "Tamanho do texto": "Tamanho do texto",
 "Tarefa nova": "Tarefa nova",
 "Tela inicial": "Ecrã inicial",
 "Tema e cor de destaque": "Tema e cor de destaque",
 "Testar alerta": "Testar alerta",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Testar alerta, \"Não incomodar\" e as definições do telemóvel estão em Definições > Avisos e alarmes.",
 "Testar e conferir": "Testar e verificar",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Todas as opções do item: editar, mover, partilhar, arquivar, eliminar...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.",
 "Total: {dur}": "Total: {dur}",
 "Tropical": "Tropical",
 "Turquesa": "Turquesa",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Um ficheiro com todos os seus dados do My Planner, para guardar ou levar para outro lado (portabilidade, LGPD).",
 "Usar no computador, pelo navegador": "Usar no computador, pelo navegador",
 "Usar o padrão": "Usar a predefinição",
 "Usar o padrão ({emoji})": "Usar a predefinição ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Use a app no telemóvel para transferir o ficheiro.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Aplica-se a todos os separadores. Cada separador pode ter o seu em Definições > Separadores.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Aplicam-se às tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.",
 "Ver lista": "Ver lista",
 "Ver o CPF inteiro": "Ver o CPF completo",
 "Verde-floresta": "Verde-floresta",
 "Verde-água": "Verde-água",
 "Vibração": "Vibração",
 "Vinho": "Vinho",
 "Você pediu para ser avisado agora.": "Pediu para ser avisado agora.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Pode: confirmar se tratamos os seus dados, aceder, corrigir, pedir a portabilidade (transferir os seus dados em Definições > Os meus dados), pedir a eliminação, saber com quem partilhamos, revogar o consentimento e apresentar reclamação à ANPD.",
 "Voltar ao filtro": "Voltar ao filtro",
 "Voltar à lista": "Voltar à lista",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Vá a Definições › My Planner Web e toque em \"Ligar navegador\".",
 "atividade {n} de {total}": "atividade {n} de {total}",
 "matéria {n} de {t}": "disciplina {n} de {t}",
 "padrão": "predefinição",
 "pausa em {n} min": "pausa daqui a {n} min",
 "pausa {n} de {total}": "pausa {n} de {total}",
 "termina em {n} min": "termina daqui a {n} min",
 "todas as vezes": "todas as ocorrências",
 "troca em {n} min": "troca daqui a {n} min",
 "volta em {n} min": "volta daqui a {n} min",
 "{nome} · {n} dia(s)": "{nome} · {n} dia(s)",
 "{n} de {total} vezes": "{n} de {total} ocorrências",
 "{n} itens arquivados": "{n} itens arquivados",
 "{n} itens excluídos": "{n} itens eliminados",
 "{n} marcada(s)": "{n} marcada(s)",
 "{n} vezes": "{n} vezes",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} min / {total}",
 "📔 Diário": "📔 Diário",
 "Agendados": "Agendados",
 "Atrasado": "Em atraso",
 "Atrasado: {v}": "Em atraso: {v}",
 "Atualizar o a receber": "Atualizar o valor a receber",
 "Até (fim do contrato, se houver)": "Até (fim do contrato, se existir)",
 "Clínica": "Clínica",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".",
 "Data do recebimento": "Data do recebimento",
 "Data prevista do pagamento": "Data prevista do pagamento",
 "Desmarcar como recebido": "Desmarcar como recebido",
 "Dia do pagamento": "Dia do pagamento",
 "Diferença: {v} (juros/multa)": "Diferença: {v} (juros/multa)",
 "Diferença: {v} (taxas/descontos)": "Diferença: {v} (taxas/descontos)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Escolas, universidades e cursos que lhe pagam. Com salário fixo, a app gera o valor a receber de todos os meses; por hora letiva, soma as aulas dadas nas turmas ligadas à instituição.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Escolha o tipo de pagamento (Editar) para a app calcular o que tem a receber.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Este valor vem da secção \"Onde trabalho\" do separador {aba}. Marque aqui como recebido ou abra o separador para ver a instituição.",
 "Ex.: Colégio Estadual, Universidade Federal": "Ex.: Escola Secundária, Universidade de Lisboa",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Ex.: Hospital de Santa Maria, Clínica Vida",
 "Ex.: Salário de outubro, 13º, férias": "Ex.: Salário de outubro, subsídio de Natal, férias",
 "Feitos": "Feitos",
 "Horas-aula de cada aula": "Horas letivas de cada aula",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Hospitais e clínicas que lhe pagam. Com salário fixo, a app gera o valor a receber de todos os meses; por turno ou consulta, marque os realizados e a app calcula.",
 "Hospital": "Hospital",
 "Instituição": "Instituição",
 "Instituição (Onde trabalho)": "Instituição (Onde trabalho)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Associe as turmas a esta instituição (na turma, Editar › Instituição) para a app somar as aulas dadas.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Marque cada turno ou consulta como feito: a app soma e calcula o valor do mês.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Marque cada turno ou consulta feito nesta instituição. A app soma e calcula o valor a receber do mês.",
 "Nome da instituição": "Nome da instituição",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "O que a instituição tem a pagar-lhe, mês a mês. Marque como recebido quando o dinheiro entrar: passa também para o separador Finanças.",
 "Onde trabalho": "Onde trabalho",
 "Plantão": "Turno",
 "Plantão ou atendimento": "Turno ou consulta",
 "Plantões e atendimentos": "Turnos e consultas",
 "Por atendimento ou procedimento": "Por consulta ou procedimento",
 "Por hora-aula": "Por hora letiva",
 "Por plantão": "Por turno",
 "Previsto: {v}": "Previsto: {v}",
 "Previsão do mês: {v}": "Previsão do mês: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Quantidade (aulas, turnos ou consultas)",
 "Recebe no mês seguinte ao trabalhado": "Recebe no mês seguinte ao trabalhado",
 "Receber: {t}": "Receber: {t}",
 "Recebimentos": "Recebimentos",
 "Salário": "Salário",
 "Salário (valor do mês)": "Salário (valor do mês)",
 "Salário fixo": "Salário fixo",
 "Telefone (RH ou financeiro)": "Telefone (RH ou financeiro)",
 "Tipo de pagamento": "Tipo de pagamento",
 "Universidade": "Universidade",
 "Valor da hora-aula": "Valor da hora letiva",
 "Valor de cada um (se for diferente)": "Valor de cada um (se for diferente)",
 "Valor do plantão": "Valor do turno",
 "Valor por atendimento ou procedimento": "Valor por consulta ou procedimento",
 "Valor previsto": "Valor previsto",
 "feito": "feito",
 "recebido em {d}": "recebido em {d}",
 "{n} aula(s) dada(s)": "{n} aula(s) dada(s)",
 "{n} hora(s)-aula": "{n} hora(s) letiva(s)",
 "{n} plantão(ões)": "{n} turno(s)",
 "Abas do My Planner Anne": "Separadores do My Planner Anne",
 "Acesso ao Não perturbe": "Acesso ao Não incomodar",
 "Alarme dos remédios (mesmo no silencioso)": "Alarme dos medicamentos (mesmo em silêncio)",
 "Algodão-doce": "Algodão-doce",
 "Aplicar tema": "Aplicar tema",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...",
 "Assim ficam as letras no app.": "É assim que ficam as letras na app.",
 "Automática": "Automática",
 "Baht tailandês": "Baht tailandês",
 "Boliviano": "Boliviano",
 "Bolívar venezuelano": "Bolívar venezuelano",
 "Botão": "Botão",
 "Buscar moeda": "Procurar moeda",
 "Cor do desenho": "Cor do desenho",
 "Coroa dinamarquesa": "Coroa dinamarquesa",
 "Coroa norueguesa": "Coroa norueguesa",
 "Coroa sueca": "Coroa sueca",
 "Coroa tcheca": "Coroa checa",
 "Crepúsculo": "Crepúsculo",
 "Crescente": "Crescente",
 "Curta": "Curta",
 "Despesas em outra moeda (fora do lucro): {v}": "Despesas noutra moeda (fora do lucro): {v}",
 "Dirham dos Emirados Árabes Unidos": "Dirham dos Emirados Árabes Unidos",
 "Dirham marroquino": "Dirham marroquino",
 "Do seu país": "Do seu país",
 "Dong vietnamita": "Dong vietnamita",
 "Dupla": "Dupla",
 "Dólar americano": "Dólar americano",
 "Dólar australiano": "Dólar australiano",
 "Dólar canadense": "Dólar canadiano",
 "Dólar de Hong Kong": "Dólar de Hong Kong",
 "Dólar de Singapura": "Dólar de Singapura",
 "Dólar neozelandês": "Dólar neozelandês",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Envia todos os itens desta lista, incluindo os novos que forem criados depois.",
 "Enviar todos para a equipe": "Enviar todos para a equipa",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Escolha se o alarme deste medicamento deve tocar mesmo com o telemóvel em silêncio.",
 "Euro": "Euro",
 "Exemplo": "Exemplo",
 "Falta uma resposta": "Falta uma resposta",
 "Folha, tema e cores da caneta e das letras": "Folha, tema e cores da caneta e das letras",
 "Franco suíço": "Franco suíço",
 "Guarani paraguaio": "Guarani paraguaio",
 "Hryvnia ucraniana": "Hryvnia ucraniana",
 "Iene japonês": "Iene japonês",
 "Kwanza angolano": "Kwanza angolano",
 "Libra egípcia": "Libra egípcia",
 "Libra esterlina": "Libra esterlina",
 "Lira turca": "Lira turca",
 "Longa": "Longa",
 "Mais usadas": "Mais usadas",
 "Metical moçambicano": "Metical moçambicano",
 "Na página, segurar a bolinha faz o mesmo.": "Na página, manter premida a bolinha faz o mesmo.",
 "Naira nigeriana": "Naira nigeriana",
 "Nenhuma moeda encontrada": "Nenhuma moeda encontrada",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "No Android, para o alarme do medicamento tocar com o \"Não incomodar\" ativado, o telemóvel tem de permitir o acesso ao \"Não incomodar\" para o My Planner. Toque em \"Abrir definições\", procure o My Planner na lista e ative a permissão.",
 "No My Planner": "No My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "No iPhone, o modo silencioso do telemóvel pode impedir o alarme. Deixe o telemóvel no modo normal.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos reais usam a vibração padrão do iPhone.",
 "Novo dólar taiwanês": "Novo dólar taiwanês",
 "Novo shekel israelense": "Novo shekel israelita",
 "Ouvir/Sentir": "Ouvir/Sentir",
 "Peso argentino": "Peso argentino",
 "Peso chileno": "Peso chileno",
 "Peso colombiano": "Peso colombiano",
 "Peso filipino": "Peso filipino",
 "Peso mexicano": "Peso mexicano",
 "Peso uruguaio": "Peso uruguaio",
 "Política de privacidade": "Política de privacidade",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Pronto. Bloqueie o ecrã e aguarde 1 minuto: o aviso deve aparecer em silêncio.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Pronto. Bloqueie o ecrã e aguarde 1 minuto: o aviso deve aparecer a vibrar, sem som.",
 "Páginas e canetas": "Páginas e canetas",
 "Pôr do sol": "Pôr do sol",
 "Rand sul-africano": "Rand sul-africano",
 "Real brasileiro": "Real brasileiro",
 "Ringgit malaio": "Ringgit malaio",
 "Riyal saudita": "Rial saudita",
 "Rublo russo": "Rublo russo",
 "Rupia indiana": "Rupia indiana",
 "Rupia indonésia": "Rupia indonésia",
 "Rupia paquistanesa": "Rupia paquistanesa",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Se o My Planner não aparecer na lista, esta permissão chega na próxima versão da app (atualize através da loja).",
 "Sentir": "Sentir",
 "Sol peruano": "Sol peruano",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor predefinida ao abrir uma página. Toque numa bolinha para mudar a cor dela.",
 "Taka bengali": "Taka do Bangladesh",
 "Teste grátis por {n} dias": "Teste gratuito durante {n} dias",
 "Tipo de vibração": "Tipo de vibração",
 "Tirar do My Planner": "Retirar do My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Tocar mesmo em silêncio e no Não incomodar",
 "Tocar só se o celular estiver no normal": "Tocar só se o telemóvel estiver no modo normal",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Todos os itens desta lista aparecem no My Planner, incluindo os novos.",
 "Vaga-lume": "Pirilampo",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Aplica-se a todos os avisos que vibram (Vibração e Som e vibração).",
 "Won sul-coreano": "Won sul-coreano",
 "Xelim queniano": "Xelim queniano",
 "Yuan chinês": "Yuan chinês",
 "Zloty polonês": "Zlóti polaco",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 O alarme deste medicamento deve tocar mesmo com o telemóvel em silêncio?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "A galeria de fotos chega na próxima versão da app. Por agora, use Ficheiros ou Tirar fotografia.",
 "Abrir o fichário do grupo": "Abrir o dossier do grupo",
 "Arrastar a barra": "Arrastar a barra",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Assim que o dossier for partilhado, aparece aqui.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Procurar ícone pelo nome (ex.: livro, casa, café)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Com o separador Estudos cria os seus dossiers, usa o cronómetro, acompanha o seu relatório e muito mais. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Com o separador {aba} cria o que é seu e usa todos os recursos. ✨",
 "Conhecer a aba": "Conhecer o separador",
 "Crie um fichário em Estudos e volte aqui.": "Crie um dossier em Estudos e volte aqui.",
 "Em sessão": "Em sessão",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Terminar e guardar o cronómetro e começar a sessão?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Terminar e guardar o cronómetro e continuar a sessão?",
 "Enquadre e toque no botão": "Enquadre e toque no botão",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Escolha o dossier que os colegas vão ver no ecrã (só para leitura).",
 "Esconder": "Esconder",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Este ficheiro está guardado apenas no dispositivo ou no Drive de quem o partilhou, por isso não aparece aqui.",
 "Fichário do grupo": "Dossier do grupo",
 "Guia passo a passo do app e de cada aba": "Guia passo a passo da app e de cada separador",
 "Há um cronômetro em andamento.": "Há um cronómetro em curso.",
 "Há uma sessão em andamento.": "Há uma sessão em curso.",
 "Inserir imagem": "Inserir imagem",
 "Mais ícones": "Mais ícones",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Nenhum ícone com esse nome. Experimente outra palavra ou escolha numa categoria.",
 "Nenhuma matéria neste fichário ainda.": "Ainda não há disciplinas neste dossier.",
 "Nenhuma página nesta matéria ainda.": "Ainda não há páginas nesta disciplina.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "No grupo de estudo, as imagens e os PDFs abrem aqui no ecrã. Este tipo de ficheiro não tem pré-visualização dentro da app.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Não foi possível mostrar agora. Verifique a ligação à internet e tente novamente.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "A partilha de dossiers ainda está a ser preparada. Volte daqui a pouco.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "O dossier deste grupo está noutro dispositivo seu. Continua a ser partilhado a partir daí.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Conhecer o separador · Cancelar = Agora não",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Os colegas deixam de ver o dossier. Tudo continua consigo.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Os colegas veem este dossier no ecrã, apenas para leitura: não editam, não transferem, não imprimem e não partilham. As suas metas, o cronómetro e as páginas revistas continuam a ser só seus.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Para ver PDFs aqui no ecrã, instale a versão mais recente da app a partir da loja.",
 "Parar de compartilhar": "Deixar de partilhar",
 "Pausar a sessão": "Pausar a sessão",
 "Pausar a sessão e estudar só esta?": "Pausar a sessão e estudar só esta?",
 "Página em branco.": "Página em branco.",
 "Quer estudar com tudo isso?": "Quer estudar com tudo isto?",
 "Quer usar tudo isso?": "Quer usar tudo isto?",
 "Selecionar todos": "Selecionar todos",
 "Trocar fichário": "Trocar de dossier",
 "Você está participando do grupo de {nome}": "Está a participar no grupo de {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Vê no ecrã o que foi partilhado neste grupo, para ler e acompanhar.",
 "abacate, fruta": "abacate, fruta",
 "academia, musculação, treino, peso": "ginásio, musculação, treino, peso",
 "acampamento, camping": "acampamento, campismo",
 "alfinete, fixar, importante": "alfinete, fixar, importante",
 "almoço, arroz, prato": "almoço, arroz, prato",
 "alvo, meta, objetivo, foco": "alvo, meta, objetivo, foco",
 "aniversário, bolo": "aniversário, bolo",
 "anotação, nota, lista, escrever": "anotação, nota, lista, escrever",
 "arco-íris": "arco-íris",
 "avião, viagem, voo": "avião, viagem, voo",
 "balança, direito, justiça, lei, processo": "balança, direito, justiça, lei, processo",
 "balde, limpeza": "balde, limpeza",
 "banana, fruta": "banana, fruta",
 "banheira, banho, banheiro": "banheira, banho, casa de banho",
 "barbear, barba, lâmina": "barbear, barba, lâmina",
 "bicicleta, pedalar, bike": "bicicleta, pedalar, bike",
 "bolo, doce, sobremesa": "bolo, doce, sobremesa",
 "brilho, mágica": "brilho, magia",
 "cabelo, cabeleireiro, corte": "cabelo, cabeleireiro, corte",
 "cachorro, cão, pet": "cão, cachorro, animal de estimação",
 "caderno": "caderno",
 "caderno, fichário, amarelo": "caderno, dossier, amarelo",
 "café, xícara, pausa": "café, chávena, pausa",
 "caixa, pacote, mudança, entrega": "caixa, pacote, mudança, entrega",
 "calendário, agenda, data": "calendário, agenda, data",
 "cama, quarto": "cama, quarto",
 "caminhada, caminhar, andar": "caminhada, caminhar, andar",
 "camisa, gravata, roupa, trabalho": "camisa, gravata, roupa, trabalho",
 "carne, churrasco": "carne, churrasco",
 "carrinho, mercado, compras, supermercado": "carrinho, supermercado, compras, mercearia",
 "carro, dirigir, veículo": "carro, conduzir, veículo",
 "certo, feito, visto": "certo, feito, visto",
 "cesto, roupa, lavanderia, lavar roupa": "cesto, roupa, lavandaria, lavar roupa",
 "chave de fenda, ferramenta, conserto": "chave de fendas, ferramenta, reparação",
 "chave, senha": "chave, palavra-passe",
 "chocolate, doce": "chocolate, doce",
 "chuveiro, banho": "chuveiro, duche, banho",
 "chá, xícara": "chá, chávena",
 "compras, sacolas, shopping": "compras, sacos, centro comercial",
 "computador, monitor, tela": "computador, monitor, ecrã",
 "computador, notebook, informática": "computador, portátil, informática",
 "coração amarelo": "coração amarelo",
 "coração azul": "coração azul",
 "coração branco": "coração branco",
 "coração laranja": "coração laranja",
 "coração roxo": "coração roxo",
 "coração verde": "coração verde",
 "coração, amor, saúde, vermelho": "coração, amor, saúde, vermelho",
 "corrida, correr": "corrida, correr",
 "creme, hidratante, pele, skincare": "creme, hidratante, pele, cuidados de pele",
 "croissant, pão, café da manhã": "croissant, pão, pequeno-almoço",
 "câmera, foto, fotografia": "câmara, foto, fotografia",
 "cérebro, mente, memória, pensar": "cérebro, mente, memória, pensar",
 "dado, jogo de tabuleiro": "dado, jogo de tabuleiro",
 "dente, dentista": "dente, dentista",
 "despertador, relógio, alarme, acordar": "despertador, relógio, alarme, acordar",
 "diamante, joia": "diamante, joia",
 "dinheiro, pagar, conta, pagamento": "dinheiro, pagar, conta, pagamento",
 "dormir, sono, descanso": "dormir, sono, descanso",
 "e-mail, mensagem, carta": "e-mail, mensagem, carta",
 "escada": "escada",
 "escova de dentes, dentes": "escova de dentes, dentes",
 "escrever, redação, caneta": "escrever, redação, caneta",
 "esponja, lavar louça": "esponja, lavar a loiça",
 "esquadro, régua, geometria, desenho técnico": "esquadro, régua, geometria, desenho técnico",
 "estrela brilhante, destaque": "estrela brilhante, destaque",
 "estrela, favorito": "estrela, favorito",
 "etiqueta, marcador": "etiqueta, marcador",
 "extintor, segurança, incêndio": "extintor, segurança, incêndio",
 "falar, idioma, inglês, conversa": "falar, idioma, inglês, conversa",
 "feito, concluído, certo": "feito, concluído, certo",
 "ferramenta, conserto, manutenção": "ferramenta, reparação, manutenção",
 "festa, comemoração": "festa, celebração",
 "filme, cinema, série": "filme, cinema, série",
 "fogo, urgente, sequência": "fogo, urgente, sequência",
 "folha, natureza, erva, chá": "folha, natureza, erva, chá",
 "fone de ouvido, áudio, música, podcast": "auscultadores, áudio, música, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "formatura, capelo, faculdade, diploma, universidade",
 "força, braço, músculo": "força, braço, músculo",
 "frango, coxa": "frango, coxa",
 "frigideira, cozinhar, ovo, cozinha": "frigideira, cozinhar, ovo, cozinha",
 "futebol, bola, esporte": "futebol, bola, desporto",
 "gato, pet": "gato, animal de estimação",
 "gelo, geladeira, congelador": "gelo, frigorífico, congelador",
 "gráfico, planilha, finanças, relatório": "gráfico, folha de cálculo, finanças, relatório",
 "ingresso, show, evento": "bilhete, concerto, evento",
 "jogo, videogame, game": "jogo, videojogo, consola",
 "lancha, barco": "lancha, barco",
 "leite, copo": "leite, copo",
 "letras, alfabeto, português": "letras, alfabeto, português",
 "link, corrente": "link, ligação, corrente",
 "livro aberto, leitura, ler": "livro aberto, leitura, ler",
 "livro azul, caderno": "livro azul, caderno",
 "livro laranja, caderno": "livro laranja, caderno",
 "livro verde, caderno": "livro verde, caderno",
 "livro vermelho, caderno": "livro vermelho, caderno",
 "livros, estudo, estudar, biblioteca": "livros, estudo, estudar, biblioteca",
 "lixo, lixeira": "lixo, caixote do lixo",
 "lua, noite": "lua, noite",
 "lâmpada, ideia, luz": "lâmpada, ideia, luz",
 "macarrão, massa": "massa, esparguete",
 "maleta, trabalho, escritório, negócios": "pasta, trabalho, escritório, negócios",
 "massagem, relaxar": "massagem, relaxar",
 "maçã, fruta": "maçã, fruta",
 "microfone, cantar, karaokê, palestra": "microfone, cantar, karaoke, palestra",
 "microscópio, ciência, biologia": "microscópio, ciência, biologia",
 "mochila, escola, filhos": "mochila, escola, filhos",
 "montanha, trilha": "montanha, trilho",
 "mundo, planeta, geografia": "mundo, planeta, geografia",
 "médico, consulta, exame, saúde": "médico, consulta, exame, saúde",
 "música, nota musical": "música, nota musical",
 "natação, nadar, piscina": "natação, nadar, piscina",
 "olho, visão, oftalmologista": "olho, visão, oftalmologista",
 "oração, orar, gratidão, igreja": "oração, rezar, gratidão, igreja",
 "ovo": "ovo",
 "pastas, arquivo, fichário, divisórias": "pastas, arquivo, dossier, separadores",
 "peixe": "peixe",
 "pescaria, pescar": "pesca, pescar",
 "pessoas, reunião, equipe, grupo": "pessoas, reunião, equipa, grupo",
 "piano, teclado musical": "piano, teclado musical",
 "pintura, arte, desenho": "pintura, arte, desenho",
 "pipa": "papagaio de papel",
 "pipoca, cinema": "pipocas, cinema",
 "pizza": "pizza",
 "planta, vaso, regar": "planta, vaso, regar",
 "porta, entrada": "porta, entrada",
 "praia, férias": "praia, férias",
 "prato, refeição, louça, jantar": "prato, refeição, loiça, jantar",
 "prédio, história, governo, tribunal": "edifício, história, governo, tribunal",
 "pão, padaria": "pão, padaria",
 "pé, podólogo": "pé, podologista",
 "pôr do sol, amanhecer": "pôr do sol, amanhecer",
 "quebra-cabeça, peça": "quebra-cabeças, puzzle, peça",
 "queijo": "queijo",
 "raio, energia, rápido": "raio, energia, rápido",
 "refrigerante, suco, bebida": "refrigerante, sumo, bebida",
 "remédio, medicamento, vitamina, farmácia": "medicamento, remédio, vitamina, farmácia",
 "sabão, sabonete, lavar": "sabão, sabonete, lavar",
 "salada, dieta, verdura": "salada, dieta, legumes",
 "sanduíche, lanche": "sandes, sanduíche, lanche",
 "sino, aviso, lembrete": "sino, aviso, lembrete",
 "skate": "skate",
 "sofá, sala": "sofá, sala",
 "sol, manhã, dia": "sol, manhã, dia",
 "spa, sauna, autocuidado": "spa, sauna, autocuidado",
 "teatro, máscaras": "teatro, máscaras",
 "telefone, ligação, ligar": "telefone, chamada, ligar",
 "tigela, cereal, sopa, mingau": "taça, cereais, sopa, papas",
 "trevo, sorte": "trevo, sorte",
 "troféu, conquista, prêmio": "troféu, conquista, prémio",
 "tubo de ensaio, química, laboratório": "tubo de ensaio, química, laboratório",
 "tênis, esporte": "ténis, desporto",
 "unha, manicure": "unha, manicure",
 "vassoura, limpeza, faxina, varrer": "vassoura, limpeza, limpezas, varrer",
 "violão, guitarra": "guitarra, viola",
 "yoga, meditação, alongamento": "ioga, meditação, alongamento",
 "{n} selecionada": "{n} selecionada",
 "{n} selecionadas": "{n} selecionadas",
 "{n} selecionado": "{n} selecionado",
 "{n} selecionados": "{n} selecionados",
 "ábaco, matemática, contas, cálculo, contabilidade": "ábaco, matemática, contas, cálculo, contabilidade",
 "água, gota, hidratar": "água, gota, hidratar",
 "árvore, jardim, quintal": "árvore, jardim, quintal",
 "ônibus, transporte": "autocarro, transporte",
 "1 dia antes": "1 dia antes",
 "1 dia depois": "1 dia depois",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "A subscrição é feita na app do telemóvel, pela loja de apps, e também é válida aqui no site.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "A chave está incompleta (demasiado curta). Copie-a novamente com o botão de copiar da página da chave.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "A chave tem caracteres que não fazem parte de uma chave. Copie novamente só a chave, sem texto à volta.",
 "A galeria chega na próxima atualização do app.": "A galeria chega na próxima atualização da app.",
 "ALERTAS": "ALERTAS",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Abra um separador pago e comece o teste gratuito. Depois volte aqui.",
 "Abrir a barra do editor": "Abrir a barra do editor",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Agora é hora do Não incomodar da app: o aviso chega em até 5 segundos, sem som nem vibração.",
 "Aguardando confirmação": "A aguardar confirmação",
 "Aguardando envio ao My Planner": "A aguardar envio para o My Planner",
 "Alertas de cada fatura": "Alertas de cada fatura",
 "Alertas do fim da garantia": "Alertas do fim da garantia",
 "Alertas do vencimento": "Alertas do vencimento",
 "Alertas: {campo}": "Alertas: {campo}",
 "Alvorada": "Alvorada",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "Ao abrir este separador, a app pede o mesmo desbloqueio da app (palavra-passe, biometria ou PIN). Pode alterar em Definições > Separadores.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Ao tocar num ficheiro anexado, ele abre na app do telemóvel que escolher (se o telemóvel perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que editar lá fica guardado no próprio ficheiro.",
 "App instalado": "App instalada",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: já grava tudo na app Saúde do telemóvel. Não precisa de fazer nada.",
 "Arquivados e fixados": "Arquivados e fixados",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "Ficheiro para ler e guardar, organizado por separador. Gerado em {data}.",
 "As notificações do My Planner estão desligadas no celular.": "As notificações do My Planner estão desligadas no telemóvel.",
 "Atualização automática disponível no app instalado.": "Atualização automática disponível na app instalada.",
 "Aurora": "Aurora",
 "Avisos: alarme (som)": "Avisos: alarme (som)",
 "Baixar o app": "Transferir a app",
 "Baixar o arquivo técnico": "Transferir o ficheiro técnico",
 "Baixar para ler (PDF)": "Transferir para ler (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Barra do editor (caneta, marcador, texto)",
 "Brisa": "Brisa",
 "Campainha": "Campainha",
 "Canal": "Canal",
 "Cole a chave antes de testar.": "Cole a chave antes de testar.",
 "Começa em": "Começa em",
 "Como avisar": "Como avisar",
 "Confira a chave": "Verifique a chave",
 "Conta de teste de compras": "Conta de teste de compras",
 "Conta vencida": "Conta vencida",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Copie a chave de imediato (só aparece uma vez). Começa por \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Copie a chave de imediato (só aparece uma vez). Começa por \"sk-ant-\".",
 "Cristal": "Cristal",
 "Daqui a 1 hora": "Daqui a 1 hora",
 "Daqui a 1 semana": "Daqui a 1 semana",
 "Daqui a 3 dias": "Daqui a 3 dias",
 "Depois de 5 min fora": "Depois de 5 min fora",
 "Depois de 5 minutos fora": "Depois de 5 minutos fora",
 "Desligar a senha desta aba": "Desligar a palavra-passe deste separador",
 "Detalhes técnicos": "Detalhes técnicos",
 "Dia {n} de {t}": "Dia {n} de {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Dica: a chave é como uma palavra-passe. Não a envie por mensagem nem a publique. Se for divulgada, apague-a no site e crie outra.",
 "Documento vencido": "Documento vencido",
 "Ela abre em {d}.": "Abre em {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Abre em {d}. Vai receber avisos: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Abre em {d}. Vai receber um aviso: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê-lhe um nome, por exemplo \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "Em \"Billing\" (Faturação), adicione um cartão e alguns dólares de crédito. A subscrição ChatGPT Plus não conta aqui.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "Em \"Billing\" (Faturação), compre créditos. A subscrição Claude Pro não conta aqui.",
 "Em breve": "Em breve",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Inicie sessão com a mesma conta do ChatGPT ou crie uma.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Inicie sessão com a sua conta Google (a mesma do Gmail serve).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Inicie sessão ou crie uma conta (pode ser o mesmo e-mail do Claude).",
 "Enviados para o My Planner": "Enviados para o My Planner",
 "Enviar agora": "Enviar agora",
 "Escolha hoje ou uma data futura.": "Escolha hoje ou uma data futura.",
 "Escolhas lembradas": "Escolhas memorizadas",
 "Escolher a data": "Escolher a data",
 "Escolher células": "Escolher células",
 "Escolher quando": "Escolher quando",
 "Espessura": "Espessura",
 "Esquecer": "Esquecer",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Esta chave é de outro serviço ({servico}). Aqui só funcionam chaves do Claude, do ChatGPT ou do Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "Esta chave é do {ia}, não do {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Esta conta vê a app como uma conta nova, sem nenhum separador desbloqueado, para verificar os cadeados, o teste gratuito e a compra. As outras contas não mudam.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Esta ferramenta precisa de ver as páginas do PDF, o que chega com a nova app (versão 0.50). Use o navegador ou atualize o My Planner pela loja.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Isto não parece uma chave do {ia}. As chaves do {ia} começam por {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Este aviso está em \"Desligado\": nada vai tocar.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Este telemóvel ainda não recebe avisos com a app fechada. Atualize o My Planner pela loja (versão {v} ou mais recente). Com a app aberta, os avisos já funcionam.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Este tipo de aviso está desligado nas definições de notificações do telemóvel.",
 "Estudado": "Estudado",
 "Estudado: {dur}": "Estudado: {dur}",
 "Faltou: {dur}": "Faltou: {dur}",
 "Fazer os testes terminarem agora": "Terminar os testes agora",
 "Fechar a barra do editor": "Fechar a barra do editor",
 "Fichário": "Dossier",
 "Figurinhas e emojis": "Autocolantes e emojis",
 "Garantia terminou": "Garantia terminou",
 "Gerando…": "A gerar…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Guarda documentos, exames e histórico de saúde com uma palavra-passe só sua. Nem o suporte consegue ler. Se se esquecer da palavra-passe, não há forma de a recuperar.",
 "Harpa": "Harpa",
 "Horas por dia": "Horas por dia",
 "Identificação": "Identificação",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Isto parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Isto só aparece no My Planner se o enviar. Quer enviar agora?",
 "Já dá para confirmar {titulo}?": "Já pode confirmar {titulo}?",
 "Lembrar minha escolha nesta aba": "Lembrar a minha escolha neste separador",
 "Lembrete para confirmar: {data}": "Lembrete para confirmar: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Marque pelo menos um dia da semana no plano.",
 "Me lembre de confirmar": "Lembre-me de confirmar",
 "Me lembre depois": "Lembre-me mais tarde",
 "Menos": "Menos",
 "Meta somada": "Meta somada",
 "Meta somada: {dur}": "Meta somada: {dur}",
 "Meus dados - My Planner {data}": "Os meus dados - My Planner {data}",
 "Meus dados do My Planner": "Os meus dados do My Planner",
 "Mostrar a barra": "Mostrar a barra",
 "Mudar senha do diário": "Alterar a palavra-passe do diário",
 "Na primeira vez, aceite os termos de uso.": "Na primeira vez, aceite os termos de utilização.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "Na versão das lojas, a compra será feita pela loja de apps do telemóvel. Por enquanto, a chave simula a subscrição para testes.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Nada de outros separadores vai automaticamente para o My Planner. Estes itens têm data e ainda não foram enviados.",
 "Nenhum estudo registrado neste mês.": "Nenhum estudo registado neste mês.",
 "Nenhum item aguardando envio.": "Nenhum item a aguardar envio.",
 "Nenhum teste começado": "Nenhum teste iniciado",
 "Nesta tela não há nada para adicionar.": "Neste ecrã não há nada para adicionar.",
 "No dia": "No dia",
 "Nova nota rápida": "Nova nota rápida",
 "Nova página do dia": "Nova página do dia",
 "Não deu certo": "Não resultou",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Não incluídos: o conteúdo do Diário e os campos do cofre (ficam protegidos pela palavra-passe), fotos e ficheiros anexados. Para restaurar os dados na app, use o ficheiro técnico.",
 "Não foi possível gerar o PDF.": "Não foi possível gerar o PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Não foi possível testar agora. Tente novamente dentro de alguns segundos.",
 "Não lembrar": "Não lembrar",
 "Não, obrigada": "Não, obrigada",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "O Diário está protegido pela sua palavra-passe e não entra neste ficheiro.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "A app abre \"Guardar em Ficheiros\" para escolher a pasta (pode ser o iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "A app guarda apenas o atalho do ficheiro escolhido: ele continua onde está (Drive, OneDrive, Transferências) e abre na app do telemóvel. Nada é copiado. Esta opção aplica-se às fotos tiradas com a câmara.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "A app instalada neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais recente). As mensagens já funcionam.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "O aviso vai chegar em silêncio, diretamente na lista de notificações: ative os alertas do My Planner nas definições do telemóvel.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas definições do telemóvel.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "O aviso vai chegar, mas o som das notificações do My Planner está desligado no telemóvel.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "O convite leva o link para transferir a app. Quem entra pelo link vai diretamente para o escritório.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "O ditado chega com a nova versão da app. Atualize o My Planner pela loja para usar o microfone.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "O mesmo desbloqueio da app: palavra-passe, biometria ou PIN. Pede uma vez ao entrar; dentro do separador não volta a pedir. Abrir a galeria, a câmara ou os ficheiros não conta como sair. Itens grandes continuam a pedir a palavra-passe para eliminar.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "O modo silencioso do telemóvel pode impedir o alarme. Deixe o telemóvel no modo normal.",
 "O plano fica só em Estudos (não vai para o My Planner).": "O plano fica apenas em Estudos (não vai para o My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Opcional: prazo, horas por dia e dias da semana.",
 "Os avisos do celular funcionam no app instalado.": "Os avisos do telemóvel funcionam na app instalada.",
 "Os avisos no celular funcionam no app instalado.": "Os avisos no telemóvel funcionam na app instalada.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Os testes iniciados terminaram. Abra o separador para ver \"O teste gratuito terminou\".",
 "Outros dados": "Outros dados",
 "Ouvir": "Ouvir",
 "Pacote em uso": "Pacote em uso",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Para subscrever, atualize o My Planner pela loja de apps do telemóvel.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Para ler (PDF): organizado por separador, com títulos e datas. Abre em qualquer dispositivo ou computador.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Para o alarme do medicamento tocar com o \"Não incomodar\" ativo, o telemóvel tem de permitir o acesso ao \"Não incomodar\" para o My Planner. Toque em \"Abrir definições\", procure o My Planner na lista e ative a permissão.",
 "Passo a passo para criar a chave": "Passo a passo para criar a chave",
 "Pedir de novo": "Pedir novamente",
 "Pedir senha ao abrir esta aba": "Pedir palavra-passe ao abrir este separador",
 "Plano com período": "Plano com período",
 "Plano começa em {d}": "O plano começa em {d}",
 "Por matéria": "Por disciplina",
 "Prolongar": "Prolongar",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, verifique se o telemóvel está em silêncio.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Pronto: o aviso chega em até 5 segundos, só a vibrar.",
 "Publicado em": "Publicado em",
 "Pulso": "Pulso",
 "Quando o app bloquear": "Quando a app bloquear",
 "Quer proteger esta aba com senha?": "Quer proteger este separador com palavra-passe?",
 "Recolher ou arrastar a barra": "Recolher ou arrastar a barra",
 "Recomeçar os testes grátis": "Reiniciar os testes gratuitos",
 "Recomeçar os testes grátis?": "Reiniciar os testes gratuitos?",
 "Rolar a folha para os lados": "Deslocar a folha para os lados",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Se ligar o relógio: totais diários de passos, distância, calorias, exercício, batimentos cardíacos e sono, lidos do Health Connect ou da app Saúde do telemóvel. A app só lê e nunca altera estes dados.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Sem internet ou a ligação caiu. Verifique o Wi-Fi ou os dados móveis e tente novamente.",
 "Senha desta aba": "Palavra-passe deste separador",
 "Seu plano terminou": "O seu plano terminou",
 "Sino": "Sino",
 "Som do alarme": "Som do alarme",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Soma a garantia legal e a do fabricante. Confirme no certificado de garantia.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "São dois ficheiros com os seus dados do My Planner (portabilidade, LGPD):",
 "Só quando o app bloquear": "Só quando a app bloquear",
 "Tamanho da borracha": "Tamanho da borracha",
 "Tamanho da letra": "Tamanho da letra",
 "Tempo": "Tempo",
 "Termina em": "Termina em",
 "Testar": "Testar",
 "Texto de exemplo": "Texto de exemplo",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do telemóvel.",
 "Toda vez que sair": "Sempre que sair",
 "Toda vez que sair da aba": "Sempre que sair do separador",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Todos os separadores voltam a \"{n} dias grátis para testar\", como numa conta nova. As subscrições simuladas são desligadas.",
 "Todos os fichários": "Todos os dossiers",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Toque em \"Criar a minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Toque em \"Criar a minha chave de API\" acima. Abre a Consola da Anthropic (não é o site do Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Toque em \"Criar a minha chave de API\" acima. Abre o Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Toque em Ligar e, no ecrã da app Saúde, ative os itens que o My Planner pode ler.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Toque no ícone de copiar ao lado da chave. Começa por \"AIza\" ou \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Toque numa célula da tabela (ou em \"Escolher células\") para alterar o tamanho da letra dela.",
 "Transparência": "Transparência",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Técnico (para restaurar): cópia completa que só o My Planner lê. Para a usar, vá a Definições › Nuvem e cópias de segurança › Importar ficheiro.",
 "Uma carta da {nome} abre em {n} dias 💌": "Uma carta de {nome} abre daqui a {n} dias 💌",
 "Usa a senha do app": "Usa a palavra-passe da app",
 "Usar no {ia}": "Usar no {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Use a app no telemóvel para transferir o ficheiro técnico.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Valor final definido pela loja de apps, já na moeda do seu país.",
 "Você ainda não enviou {titulo} para o My Planner.": "Ainda não enviou {titulo} para o My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Volte aqui, cole no campo abaixo e toque em \"Guardar e testar\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Volte a \"API keys\" e toque em \"Create new secret key\" (Criar chave).",
 "atualização automática": "atualização automática",
 "erro desconhecido": "erro desconhecido",
 "estudados no mês": "estudados no mês",
 "faltou {dur}": "faltou {dur}",
 "hoje {feito} de {meta}": "hoje {feito} de {meta}",
 "hoje é folga": "hoje é folga",
 "login do Google (não é chave de API)": "início de sessão do Google (não é chave de API)",
 "meta cumprida": "meta cumprida",
 "o que veio com a instalação": "o que veio com a instalação",
 "outro": "outro",
 "provisório": "provisório",
 "superou {dur}": "superou {dur}",
 "token de login (não é chave de API)": "token de início de sessão (não é chave de API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} demorou demasiado a responder. Tente novamente daqui a instantes.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} está em baixo ou sobrecarregado neste momento. Não é um problema da sua chave: tente novamente mais tarde.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nos separadores.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} recusou-se a ler este conteúdo (filtro de segurança da empresa).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: chave inválida. Verifique se copiou a chave inteira ou crie uma nova.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: limite de utilização atingido. Aguarde alguns minutos (ou até amanhã, no plano gratuito) e tente novamente.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: a sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.",
 "{item}: a garantia termina hoje ({data}).": "{item}: a garantia termina hoje ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: a garantia terminou em {data}.",
 "{item}: venceu em {data}.": "{item}: venceu em {data}.",
 "{mes} de {ano}": "{mes} de {ano}",
 "{nome} protegida com senha": "{nome} protegido com palavra-passe",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: terminar o plano ou prolongar com uma nova data final? Nada é apagado.",
 "{n} dias antes": "{n} dias antes",
 "{n} dias de estudo no plano · {dur} por dia": "{n} dias de estudo no plano · {dur} por dia",
 "{n} dias de plano": "{n} dias de plano",
 "{n} dias depois": "{n} dias depois",
 "{n} item(ns) aguardando envio ao My Planner": "{n} item(ns) a aguardar envio para o My Planner",
 "{n} itens aguardando envio": "{n} itens a aguardar envio",
 "{quando} às {hora}": "{quando} às {hora}",
 "ÚLTIMOS 6 MESES": "ÚLTIMOS 6 MESES",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Abra a app My Planner Anne e inicie sessão com o seu CPF ou e-mail e a sua palavra-passe.",
 "Anexo": "Anexo",
 "Assédio ou ameaça": "Assédio ou ameaça",
 "Bloquear {nome}": "Bloquear {nome}",
 "Conte mais (opcional)": "Conte-nos mais (opcional)",
 "Conteúdo impróprio": "Conteúdo impróprio",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Conteúdo ofensivo e utilizadores abusivos não são tolerados. As denúncias são analisadas pela nossa equipa no prazo de 24 horas.",
 "Denunciar": "Denunciar",
 "Denunciar contato": "Denunciar contacto",
 "Denunciar grupo": "Denunciar grupo",
 "Denunciar mensagem": "Denunciar mensagem",
 "Denúncia enviada": "Denúncia enviada",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Denúncias que faz nas Mensagens: o motivo, quem foi denunciado e o excerto da mensagem denunciada. Só a equipa do My Planner as lê, para analisar o caso.",
 "Enviar denúncia": "Enviar denúncia",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Envie um e-mail a pedir a eliminação, com o CPF ou o e-mail da conta. Respondemos no prazo de 15 dias.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem utilizadores abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contacto ou um grupo (mantenha a mensagem premida ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipa no prazo de 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Obrigado. A nossa equipa vai analisar no prazo de 24 horas.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Para contas que iniciam sessão com CPF, a nova palavra-passe é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} indicando o seu CPF ou o e-mail registado.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Porque está a denunciar? A pessoa denunciada não fica a saber quem a denunciou.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} já não pode conversar consigo.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nVálido até {d}. Fica encriptado no seu cofre, só neste dispositivo e na sua cópia na nuvem.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. No computador, abra {url} e escolha Entrar com código QR.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Aqui, toque em Ligar navegador e aponte a câmara para o código QR do computador.",
 "Abandonados": "Abandonados",
 "Bloquear o computador": "Bloquear o computador",
 "Cheguei na página...": "Cheguei à página...",
 "Computador conectado": "Computador ligado",
 "Computador desconectado": "Computador desligado",
 "Conectado em {d}": "Ligado em {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crie o grupo e envie a ligação: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode libertar isso para quem também usa o separador. Só quem administra põe ou tira pessoas.",
 "Depois de {n} minutos parado": "Após {n} minutos parado",
 "Desconectar o computador?": "Desligar o computador?",
 "Difícil demais": "Difícil demais",
 "Editar livro": "Editar livro",
 "Entrar com o QR Code": "Entrar com o código QR",
 "Escreva (ex.: filosofia)": "Escreva (ex.: filosofia)",
 "Este computador": "Este computador",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Este computador foi desligado (pelo telemóvel ou porque outro computador entrou). Para usar de novo, entre com o código QR.",
 "Já existe um computador conectado": "Já existe um computador ligado",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Já existe um computador ligado. Trocar para este? O outro será desligado.",
 "Navegador": "Navegador",
 "Nenhum computador conectado": "Nenhum computador ligado",
 "Novo livro": "Novo livro",
 "Não gostei": "Não gostei",
 "Não, abandonei": "Não, abandonei",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "O My Planner fecha no computador. Para usar de novo, basta ligar pelo código QR.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "O código QR muda a cada 3 minutos e só vale uma vez. Em computador partilhado, use Definições › Sair deste computador ao terminar.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Os seus dados continuam guardados na nuvem e no telemóvel. Para entrar de novo, use o código QR.",
 "Parei em": "Parei em",
 "Perdi o interesse": "Perdi o interesse",
 "Por que parei": "Porque parei",
 "Páginas e meta": "Páginas e meta",
 "Quero voltar a ler?": "Quero voltar a ler?",
 "Sair deste computador": "Sair deste computador",
 "Sair deste computador?": "Sair deste computador?",
 "Se quiser, escreva com as suas palavras": "Se quiser, escreva com as suas palavras",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Sem mexer no rato ou no teclado durante esse tempo, o My Planner bloqueia. Para voltar, escreva a palavra-passe da conta (ou entre de novo com o código QR).",
 "Sem tempo": "Sem tempo",
 "Sim, depois": "Sim, depois",
 "Só um computador pode ficar conectado por vez.": "Só um computador pode ficar ligado de cada vez.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "A foto ou o PDF do certificado vai em \"Fotos, ficheiros e ligações\": marque como Certificado.",
 "ABNT copiada": "ABNT copiada",
 "APA copiada": "APA copiada",
 "Ano inválido": "Ano inválido",
 "Ano ou data de publicação": "Ano ou data de publicação",
 "Assisti em": "Vi em",
 "Buscando os dados...": "A procurar os dados...",
 "Calculado pelos módulos": "Calculado pelos módulos",
 "Carga horária (horas)": "Carga horária (horas)",
 "Certificado": "Certificado",
 "Certificado emitido em": "Certificado emitido em",
 "Cheguei na aula": "Cheguei à aula",
 "Cheguei na aula...": "Cheguei à aula...",
 "Cheguei na temporada": "Estou na temporada",
 "Cheguei no episódio": "Estou no episódio",
 "Citação copiada": "Citação copiada",
 "Colocar em pasta": "Colocar numa pasta",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Coloque livros, filmes ou cursos nesta pasta para montar a lista.",
 "Comentário": "Comentário",
 "Copiar ABNT": "Copiar ABNT",
 "Copiar APA": "Copiar APA",
 "Copiar citação (ABNT)": "Copiar citação (ABNT)",
 "Copiar citação (APA)": "Copiar citação (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Crie cartões com checklist, lista, texto livre ou desenho para esta disciplina. Arraste para a direita para eliminar e para a esquerda para Arquivar ou Duplicar.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crie o grupo e envie a ligação: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode libertar isso para quem também usa o separador. Só quem administra põe ou tira pessoas.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crie o grupo e envie a ligação: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode libertar isso para quem também usa o separador. Só quem administra põe ou tira pessoas.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Crie primeiro uma pasta, na parte 📁 Pastas deste separador.",
 "DOI (artigos)": "DOI (artigos)",
 "Data de acesso": "Data de acesso",
 "Deixar avulsas": "Deixar soltas",
 "Descrição (objetivo)": "Descrição (objetivo)",
 "Digite o ano com 4 números (ex.: {a}).": "Escreva o ano com 4 algarismos (ex.: {a}).",
 "Direção": "Realização",
 "Editar pasta": "Editar pasta",
 "Editora": "Editora",
 "Edição": "Edição",
 "Em 1 mês": "Daqui a 1 mês",
 "Em {n} meses": "Daqui a {n} meses",
 "Episódios por temporada (opcional)": "Episódios por temporada (opcional)",
 "Escreva o trecho na anotação para copiar a citação.": "Escreva o excerto na anotação para copiar a citação.",
 "Este item já está em todas as pastas.": "Este item já está em todas as pastas.",
 "Ex.: 10.1590/...": "Ex.: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Ex.: Tese — Ética e Direito",
 "Ex.: {a}": "Ex.: {a}",
 "Fazendo": "A fazer",
 "Grupo de filmes e séries": "Grupo de filmes e séries",
 "Grupo de leitura": "Grupo de leitura",
 "Grupo do curso": "Grupo do curso",
 "ISBN": "ISBN",
 "Ideia minha": "Ideia minha",
 "Instrutor": "Formador",
 "Itens da pasta": "Itens da pasta",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Junte livros, filmes e cursos numa pasta (ex.: \"Tese\", \"Só romances\"). O mesmo item pode estar em várias pastas.",
 "Link (material online)": "Ligação (material online)",
 "Lista copiada": "Lista copiada",
 "Lista de referências": "Lista de referências",
 "Mais de um autor: separe com ponto e vírgula (;).": "Mais de um autor: separe com ponto e vírgula (;).",
 "Módulo": "Módulo",
 "Nada novo": "Nada de novo",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "No ⋮ de um livro, filme ou curso, toque em \"Colocar numa pasta\".",
 "Nome da pasta": "Nome da pasta",
 "Não achei dados novos para completar a ficha.": "Não encontrei dados novos para completar a ficha.",
 "Não foi possível preencher": "Não foi possível preencher",
 "O módulo não tem cards de anotações.": "O módulo não tem cartões de anotações.",
 "Organizador": "Organizador",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Os dados vêm da ficha do livro (Editar › Referência).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Os livros, filmes e cursos da pasta NÃO são eliminados: continuam no separador.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "Os {n} cartão(ões) de anotações deste módulo também vão para o lixo.",
 "Pasta vazia": "Pasta vazia",
 "Preencha o título (e o que mais tiver) na ficha.": "Preencha o título (e o que mais tiver) na ficha.",
 "Preencher pelo DOI": "Preencher pelo DOI",
 "Preencher pelo link": "Preencher pela ligação",
 "Produtora ou país": "Produtora ou país",
 "Quero fazer": "Quero fazer",
 "Quero voltar?": "Quero voltar?",
 "Referência vazia": "Referência vazia",
 "Referências": "Referências",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Se as deixar soltas, continuam a contar no total do curso.",
 "Subtítulo": "Subtítulo",
 "Tirar da pasta": "Tirar da pasta",
 "Total de episódios (opcional)": "Total de episódios (opcional)",
 "Total de temporadas (opcional)": "Total de temporadas (opcional)",
 "Tradutor": "Tradutor",
 "Trecho (citação)": "Excerto (citação)",
 "Trecho vazio": "Excerto vazio",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Já assistiu a {n} aula(s). Colocar em que módulo?",
 "Volume": "Volume",
 "{n} item(ns)": "{n} item(ns)",
 "{n} referência(s) em ordem alfabética.": "{n} referência(s) por ordem alfabética.",
 "Ícone": "Ícone",
 "ASSISTIDOS POR DIA": "VISTOS POR DIA",
 "ASSISTIDOS POR MÊS": "VISTOS POR MÊS",
 "AULAS POR DIA": "AULAS POR DIA",
 "AULAS POR MÊS": "AULAS POR MÊS",
 "Apagar a meta": "Apagar a meta",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Vi {a} · A ver {b} · Parei {c} · Quero ver {d}",
 "Aulas": "Aulas",
 "CURSOS": "CURSOS",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Concluí {a} · A fazer {b} · Parei {c}",
 "Datas": "Datas",
 "Datas escolhidas": "Datas escolhidas",
 "Datas à escolha": "Datas à escolha",
 "Definir meta de {ano}": "Definir meta de {ano}",
 "Definir meta do ano": "Definir meta do ano",
 "FILMES E SÉRIES": "FILMES E SÉRIES",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Faltam {f} curso(s): dá cerca de {m} por mês",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Faltam {f} livro(s): dá cerca de {m} por mês",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Faltam {f} título(s): dá cerca de {m} por mês",
 "Gênero": "Género",
 "Incluir lista de referências no PDF": "Incluir lista de referências no PDF",
 "LIVROS": "LIVROS",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Li {a} livro(s) · Parei {b} · A ler {c}",
 "Meta de {ano}": "Meta de {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Meta de {ano}: usar a de {antes} ({n})?",
 "Meta do ano cumprida": "Meta do ano cumprida",
 "Mudar": "Mudar",
 "Nada neste período.": "Nada neste período.",
 "Nota": "Nota",
 "O PDF não leva as suas anotações, resumos e comentários.": "O PDF não inclui as suas anotações, resumos e comentários.",
 "POR ITEM": "POR ITEM",
 "Plataforma": "Plataforma",
 "PÁGINAS POR DIA": "PÁGINAS POR DIA",
 "PÁGINAS POR MÊS": "PÁGINAS POR MÊS",
 "Quantos no ano?": "Quantos no ano?",
 "Quero ler {a} · Abandonei {b}": "Quero ler {a} · Abandonei {b}",
 "Relatório de leitura e mídia": "Relatório de leitura e média",
 "concluídos no período": "concluídos no período",
 "cursos concluídos no período": "cursos concluídos no período",
 "livros lidos no período": "livros lidos no período",
 "pág. {a} de {n}": "pág. {a} de {n}",
 "títulos assistidos no período": "títulos vistos no período",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos",
 "{a} de {n} aulas ({p}%)": "{a} de {n} aulas ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} de {n} curso(s) concluído(s) em {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} de {n} livro(s) em {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} de {n} título(s) visto(s) em {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} item(ns) sem data de mudança de situação: usei a data de criação.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)",
 "{p}% lido · falta {f}%": "{p}% lido · falta {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Este separador pede palavra-passe. Desbloqueie-o primeiro e o guia continua daqui.",
 "Abrir esta aba": "Abrir este separador",
 "Mostrar na tela": "Mostrar no ecrã",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Não encontrei este ponto no ecrã agora. Confirme se o ecrã certo está aberto e tente de novo.",
 "Primeiros passos": "Primeiros passos",
 "Buscar no guia": "Procurar no guia",
 "Entendi": "Percebi",
 "{n} de {total} passos feitos": "{n} de {total} passos feitos",
 "Já fiz": "Já fiz",
 "Guia em construção": "Guia em construção",
 "Limpar marcações": "Limpar marcações",
 "Este ponto ainda não está marcado no app.": "Este ponto ainda não está marcado na app.",
 "Dicas e atalhos": "Dicas e atalhos",
 "Gestos do app": "Gestos da app",
 "Procurando na tela…": "A procurar no ecrã…",
 "Guia das abas": "Guia dos separadores",
 "Voltar ao guia": "Voltar ao guia",
 "Para que serve": "Para que serve",
 "Disponível no app do celular.": "Disponível na app do telemóvel.",
 "Nada encontrado no guia.": "Nada encontrado no guia.",
 "Recursos que valem para todas as abas": "Recursos que valem para todos os separadores",
 "Perguntas comuns": "Perguntas frequentes",
 "Ligar e desligar partes": "Ligar e desligar partes",
 "Entrada cancelada. Este computador não foi conectado.": "Entrada cancelada. Este computador não foi ligado.",
 "Alterações ainda não enviadas": "Alterações ainda não enviadas",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, perdem-se. Sair mesmo assim?",
 "Sair mesmo assim": "Sair mesmo assim",
 "O seu papel no grupo não permite mudar aqui.": "O seu papel no grupo não permite alterar aqui.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Não foi possível consultar o DOI agora (sem internet?). Tente novamente.",
 "DOI inválido.": "DOI inválido.",
 "DOI não encontrado.": "DOI não encontrado.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pela app no telemóvel, use o DOI ou escreva os campos.",
 "Atualizando...": "A atualizar...",
 "Banco de dados (Supabase, plano grátis)": "Base de dados (Supabase, plano gratuito)",
 "Cadeado (HTTPS) até": "Cadeado (HTTPS) até",
 "Dados das abas: {d}": "Dados dos separadores: {d}",
 "Disco": "Disco",
 "Esta conta não tem acesso a estas informações.": "Esta conta não tem acesso a estas informações.",
 "Ligado há": "Ligado há",
 "Livre: {l} · site: {s}": "Livre: {l} · site: {s}",
 "Maiores tabelas": "Maiores tabelas",
 "Memória em uso": "Memória em uso",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "O servidor ainda não enviou o relatório. Envia a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "O servidor ainda não tem esta função. Execute o 53-SERVIDOR-0.78.bat no computador.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "O sistema do servidor pede reinício (atualização de segurança instalada).",
 "Processador": "Processador",
 "Relatório do servidor: {q}": "Relatório do servidor: {q}",
 "Servidor": "Servidor",
 "Servidor do site (Locaweb)": "Servidor do site (Locaweb)",
 "Sistema": "Sistema",
 "Só você vê este quadro.": "Só você vê este quadro.",
 "Versão do site no ar": "Versão do site no ar",
 "atrasado: confira se o servidor está ligado": "atrasado: confirme se o servidor está ligado",
 "sem cadeado": "sem cadeado",
 "{a} ({n} guardadas)": "{a} ({n} guardadas)",
 "{d} dia(s) e {h} h": "{d} dia(s) e {h} h",
 "{n} núcleo(s) · carga {c}": "{n} núcleo(s) · carga {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias",
 "{u} de {t} ({p}%)": "{u} de {t} ({p}%)",
 "Fechar teclado": "Fechar teclado",
 "Mostrar as ferramentas": "Mostrar as ferramentas",
 "Últimas cores usadas": "Últimas cores usadas",
 "Voltar ao topo": "Voltar ao topo",
 "Topo": "Topo",
 "1 atividade do roteiro por fazer": "1 atividade do roteiro por fazer",
 "1 dia": "1 dia",
 "1 item por pôr na mala": "1 item por pôr na mala",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item a item, pelo ⋮ de cada item.",
 "1 lugar não visitado": "1 lugar não visitado",
 "1 reserva por confirmar": "1 reserva por confirmar",
 "Abrir o bloco": "Abrir o bloco",
 "Adicionar pessoa": "Adicionar pessoa",
 "Ainda pode gastar {v}": "Ainda pode gastar {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Ao ativar, o valor entra em Gastos como pago.",
 "Até (dd/mm/aaaa)": "Até (dd/mm/aaaa)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Coloque as pessoas em \"Quem vai\" (edite a viagem).",
 "Como foi?": "Como foi?",
 "Concluído em {d}": "Concluído em {d}",
 "Confirmada em {d}": "Confirmada em {d}",
 "Confirmadas": "Confirmadas",
 "Dia anterior": "Dia anterior",
 "Dias": "Dias",
 "Dias × valor por dia": "Dias × valor por dia",
 "Documentos (só o tipo e a validade)": "Documentos (só o tipo e a validade)",
 "EXIGÊNCIAS DO DESTINO": "EXIGÊNCIAS DO DESTINO",
 "Em mãos": "Em mãos",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Escreva o que o destino exige (ex.: 2 páginas em branco no passaporte, certificado de vacinação). Confirme no site oficial do país.",
 "Ex.: Lisboa (LIS)": "Ex.: Lisboa (LIS)",
 "Ex.: São Paulo (GRU)": "Ex.: São Paulo (GRU)",
 "Falta confirmar": "Por confirmar",
 "Falta pôr": "Por pôr",
 "Faltou ({n}): {l}": "Faltou ({n}): {l}",
 "Foi ({n}): {l}": "Foi ({n}): {l}",
 "Fotos (lista das legendas)": "Fotos (lista das legendas)",
 "Gasto de {nome} em {d}": "Gasto de {nome} em {d}",
 "Gastos do dia": "Gastos do dia",
 "Gastos em outras moedas (não convertidos): {v}": "Gastos em outras moedas (não convertidos): {v}",
 "Gastos por dia": "Gastos por dia",
 "Horário de chegada": "Hora de chegada",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Lugares (visitados, em falta, imperdíveis e a nota)",
 "Mala (o que foi e o que faltou)": "Mala (o que foi e o que faltou)",
 "Marcar como acertado": "Marcar como acertado",
 "Marcar como acertado?": "Marcar como acertado?",
 "Na mala": "Na mala",
 "Nenhuma parada ainda": "Ainda sem paragens",
 "Nova exigência": "Nova exigência",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.",
 "O QUE AINDA FALTA": "O QUE AINDA FALTA",
 "O QUE INCLUIR": "O QUE INCLUIR",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Opcional. A app avisa se o passaporte caducar antes disso, a contar do regresso. Confirme a exigência do país.",
 "Orçamento previsto × gasto por categoria": "Orçamento previsto × gasto por categoria",
 "Passou do previsto em {v}": "Ultrapassou o previsto em {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Indique a validade de cada documento: a app avisa antes de caducar. As fotos dos documentos ficam protegidas no cofre.",
 "Próximo dia": "Dia seguinte",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Quem está no grupo da viagem entra automaticamente. Use \"+ Adicionar pessoa\" para quem não tem a app.",
 "Recolher o bloco": "Recolher o bloco",
 "Relatório da viagem": "Relatório da viagem",
 "Reserva confirmada": "Reserva confirmada",
 "Resumo da viagem": "Resumo da viagem",
 "Resumo da viagem (datas, destino, pessoas)": "Resumo da viagem (datas, destino, pessoas)",
 "Roteiro por dia (feito e falta)": "Roteiro por dia (feito e por fazer)",
 "Sem data": "Sem data",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "O seu passaporte pode não ser aceite. Confirme a exigência do país",
 "Subir": "Subir",
 "Total do dia: {v}": "Total do dia: {v}",
 "Uma frase (opcional)": "Uma frase (opcional)",
 "Validade mínima exigida (meses)": "Validade mínima exigida (meses)",
 "Validade: {d}": "Validade: {d}",
 "Valor por dia": "Valor por dia",
 "Viagens no My Planner": "Viagens no My Planner",
 "Visitado": "Visitado",
 "Visitado em {d}": "Visitado em {d}",
 "Voltaria: {r}": "Voltaria: {r}",
 "Voltaria?": "Voltaria?",
 "confirmada": "confirmada",
 "em mãos": "em mãos",
 "gasto na viagem {d}": "gasto na viagem {d}",
 "meses": "meses",
 "outro gasto": "outro gasto",
 "vence em {d}": "caduca em {d}",
 "{a} de {b} confirmadas": "{a} de {b} confirmadas",
 "{a} de {b} em mãos": "{a} de {b} em mãos",
 "{a} de {b} feitos": "{a} de {b} feitos",
 "{a} de {b} na mala": "{a} de {b} na mala",
 "{a} de {b} pagos": "{a} de {b} pagos",
 "{a} de {b} visitados": "{a} de {b} visitados",
 "{de} deve {v} a {para}": "{de} deve {v} a {para}",
 "{g} de {p}": "{g} de {p}",
 "{n} atividades do roteiro por fazer": "{n} atividades do roteiro por fazer",
 "{n} item(ns) enviado(s).": "{n} item(ns) enviado(s).",
 "{n} itens por pôr na mala": "{n} itens por pôr na mala",
 "{n} já estava(m) no My Planner.": "{n} já estava(m) no My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item a item, pelo ⋮ de cada item.",
 "{n} lugares não visitados": "{n} lugares não visitados",
 "{n} reservas por confirmar": "{n} reservas por confirmar",
 "{n} sem data (não foi).": "{n} sem data (não foi enviado).",
 "ARTIGOS E SITES": "ARTIGOS E SITES",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Agora o envio é item a item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):",
 "Artigo científico": "Artigo científico",
 "Artigo de site ou blog": "Artigo de site ou blogue",
 "Artigo ou site": "Artigo ou site",
 "Artigos e sites": "Artigos e sites",
 "Autor(es)": "Autor(es)",
 "Cadastrar pela foto ou PDF": "Registar pela foto ou PDF",
 "Capítulo de livro": "Capítulo de livro",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crie o grupo e envie a ligação: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode libertar isso para quem também usa o separador. Só quem administra põe ou tira pessoas.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Data ou ano de publicação",
 "Editar artigo ou site": "Editar artigo ou site",
 "Enviar para o My Planner (lembrete de renovação)": "Enviar para o My Planner (lembrete de renovação)",
 "Envio para o My Planner": "Envio para o My Planner",
 "Ex.: 2024 ou 12/03/2024": "Ex.: 2024 ou 12/03/2024",
 "Ex.: 45-60": "Ex.: 45-60",
 "Grupo de artigos": "Grupo de artigos",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pela ligação.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Li {a} · A ler {b} · Parei {c} · Quero ler {d}",
 "Minhas anotações do artigo": "As minhas anotações do artigo",
 "Notícia": "Notícia",
 "Novo artigo ou site": "Novo artigo ou site",
 "Os dados vêm da ficha do artigo (Editar).": "Os dados vêm da ficha do artigo (Editar).",
 "Páginas (opcional)": "Páginas (opcional)",
 "Revista, site ou veículo": "Revista, site ou meio",
 "artigos e sites lidos no período": "artigos e sites lidos no período",
 "1 confirmado": "1 confirmado",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pela app, ele passa automaticamente para \"Convidado, sem resposta\".",
 "1 extra": "1 extra",
 "1 talvez": "1 talvez",
 "A convidar": "Por convidar",
 "Agendar na igreja": "Marcar na igreja",
 "Agora": "Agora",
 "Agradeci": "Agradeci",
 "Agradeci em {d}": "Agradeci em {d}",
 "Agradecidos": "Agradecidos",
 "Alianças": "Alianças",
 "Aluguéis (mesas, cadeiras, louças)": "Alugueres (mesas, cadeiras, loiça)",
 "Avisar a data (save the date)": "Avisar a data (save the date)",
 "Bebidas": "Bebidas",
 "Beca e cerimônia": "Beca e cerimónia",
 "Bolo": "Bolo",
 "Brincadeiras": "Brincadeiras",
 "Brincadeiras e amigo secreto": "Brincadeiras e amigo secreto",
 "Brindes": "Brindes",
 "Buffet": "Buffet",
 "Calculado sozinho: valor menos o sinal.": "Calculado automaticamente: valor menos o sinal.",
 "Calcular quantidades": "Calcular quantidades",
 "Categoria do orçamento": "Categoria do orçamento",
 "Celebrante": "Celebrante",
 "Cerimônia": "Cerimónia",
 "Cerveja (adultos)": "Cerveja (adultos)",
 "Checklist de preparação": "Checklist de preparação",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Indique a data do evento (edite o evento) para ver até quando fazer cada item.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Adicione as pessoas em \"Pessoas do evento\" (edite o evento).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Indique quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram automaticamente na categoria escolhida.",
 "Combinado: {v}": "Combinado: {v}",
 "Comprado": "Comprado",
 "Comprados": "Comprados",
 "Comprar a decoração e as lembrancinhas": "Comprar a decoração e as lembranças",
 "Comprar as alianças": "Comprar as alianças",
 "Comprar as lembrancinhas": "Comprar as lembranças",
 "Comprar bebidas e gelo": "Comprar bebidas e gelo",
 "Comprar comida e bebidas": "Comprar comida e bebidas",
 "Comprar o que falta": "Comprar o que falta",
 "Comprar ou alugar a roupa": "Comprar ou alugar a roupa",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Confirmados com os acompanhantes. Muda automaticamente quando alguém confirma ou cancela.",
 "Confirmar a presença dos convidados": "Confirmar a presença dos convidados",
 "Confirmar os fornecedores": "Confirmar os fornecedores",
 "Confirmar os fornecedores e os convidados": "Confirmar os fornecedores e os convidados",
 "Contratar a comida": "Contratar a comida",
 "Contratar a comida e o bolo": "Contratar a comida e o bolo",
 "Contratar a decoração": "Contratar a decoração",
 "Contratar comida e bebidas": "Contratar comida e bebidas",
 "Contratar foto e vídeo": "Contratar fotografia e vídeo",
 "Contratar o buffet": "Contratar o buffet",
 "Convidado, sem resposta": "Convidado, sem resposta",
 "Convidados (por situação, com acompanhantes)": "Convidados (por situação, com acompanhantes)",
 "Convidados que contam no ⊕": "Convidados que contam no ⊕",
 "Convites": "Convites",
 "Cronograma do dia (com responsáveis e situação)": "Cronograma do dia (com responsáveis e situação)",
 "Data do restante": "Data do restante",
 "Data do sinal": "Data do sinal",
 "Decoração": "Decoração",
 "Definir a data e o orçamento": "Definir a data e o orçamento",
 "Definir a lista de convidados": "Definir a lista de convidados",
 "Doces": "Doces",
 "Dá para mudar, tirar e incluir itens depois.": "Pode alterar, retirar e incluir itens depois.",
 "Enviar os convites": "Enviar os convites",
 "Equipamentos (projetor, som)": "Equipamentos (projetor, som)",
 "Equipe (garçons, limpeza)": "Equipa (empregados de mesa, limpeza)",
 "Escolha \"Outro\" para escrever o nome.": "Escolha \"Outro\" para escrever o nome.",
 "Escolher a roupa": "Escolher a roupa",
 "Escolher a roupa dos noivos": "Escolher a roupa dos noivos",
 "Escolher os padrinhos": "Escolher os padrinhos",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Estimativa para {n} convidados. Altere o que quiser antes de levar.",
 "Eu faço": "Eu faço",
 "Ex.: 200 un.": "Ex.: 200 un.",
 "Ex.: Copos descartáveis": "Ex.: Copos descartáveis",
 "Ex.: Jogo de panelas": "Ex.: Trem de cozinha",
 "Ex.: Reservar o local": "Ex.: Reservar o local",
 "Ex.: em negociação": "Ex.: em negociação",
 "Extras de margem (quem aparece sem avisar)": "Extras de margem (quem aparece sem avisar)",
 "Falta 1 dia": "Falta 1 dia",
 "Falta agradecer": "Falta agradecer",
 "Falta comprar": "Falta comprar",
 "Falta pagar": "Falta pagar",
 "Fazer a lista de presentes": "Fazer a lista de presentes",
 "Fazer o curso de batismo": "Fazer o curso de batismo",
 "Fornecedores (contratado, pago, falta)": "Fornecedores (contratado, pago, falta)",
 "Foto e vídeo": "Fotografia e vídeo",
 "Fraldas": "Fraldas",
 "Frase curta (opcional)": "Frase curta (opcional)",
 "Hoje é o dia do evento!": "Hoje é o dia do evento!",
 "Igreja e celebrante": "Igreja e celebrante",
 "Incluir os Talvez": "Incluir os Talvez",
 "Incluir telefones": "Incluir telefones",
 "Item da lista de compras": "Item da lista de compras",
 "Item da preparação": "Item da preparação",
 "Já deram: {d} · Falta: {f}": "Já deram: {d} · Falta: {f}",
 "Já deu": "Já deu",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Registe aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram automaticamente.",
 "Lançar o gasto": "Registar o gasto",
 "Lembrancinhas": "Lembranças",
 "Levar para os itens": "Levar para os itens",
 "Local / espaço": "Local / espaço",
 "Mais um extra": "Mais um extra",
 "Menos um extra": "Menos um extra",
 "Música / som / DJ": "Música / som / DJ",
 "No dia do evento": "No dia do evento",
 "O que comprar": "O que comprar",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "O total muda automaticamente quando alguém confirma ou cancela.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "O valor do contrato entra automaticamente como previsto nesta categoria, e o que for pago entra nos gastos.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "O valor entra nos gastos do evento, na categoria do item. Se preferir, salte.",
 "Onde comprar": "Onde comprar",
 "Orçamento do evento": "Orçamento do evento",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Os telefones dos convidados só aparecem no PDF se marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.",
 "Pago em {d}": "Pago em {d}",
 "Parte da vaquinha": "Parte da vaquinha",
 "Pessoas do evento": "Pessoas do evento",
 "Pessoas do evento: {p}": "Pessoas do evento: {p}",
 "Preparar as brincadeiras": "Preparar as brincadeiras",
 "Preparação": "Preparação",
 "Presente recebido": "Presente recebido",
 "Presentes": "Presentes",
 "Prova final da roupa": "Prova final da roupa",
 "Pular": "Saltar",
 "Quantidade por convidado": "Quantidade por convidado",
 "Quantidade por convidado × valor unitário": "Quantidade por convidado × valor unitário",
 "Quanto custou?": "Quanto custou?",
 "Quanto já deu": "Quanto já deu",
 "Quanto vai contribuir": "Quanto vai contribuir",
 "Quantos dias antes do evento": "Quantos dias antes do evento",
 "Quem deu": "Quem deu",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Quem está no grupo do evento entra automaticamente. Use \"+ Adicionar pessoa\" para quem não tem a app. Esta lista é usada no cronograma, nos gastos e na vaquinha.",
 "Recreação e brinquedos": "Animação e insufláveis",
 "Refrigerante": "Refrigerante",
 "Relatório do evento": "Relatório do evento",
 "Relatório do evento (PDF)": "Relatório do evento (PDF)",
 "Reservar o local": "Reservar o local",
 "Reservar o local da cerimônia e da festa": "Reservar o local da cerimónia e da festa",
 "Reservar o local ou a mesa da festa": "Reservar o local ou a mesa da festa",
 "Restante": "Restante",
 "Restante pago": "Restante pago",
 "Resumo do evento": "Resumo do evento",
 "Roupa e beleza": "Roupa e beleza",
 "Salgados": "Salgados",
 "Separar a roupa e o que levar": "Separar a roupa e o que levar",
 "Separar os documentos e as alianças": "Separar os documentos e as alianças",
 "Separar os documentos e os ingressos": "Separar os documentos e os bilhetes",
 "Sinal": "Sinal",
 "Sinal pago": "Sinal pago",
 "Sinal {v} pago": "Sinal {v} pago",
 "Usar a lista pronta para {tipo}": "Usar a lista pronta para {tipo}",
 "Vai contribuir": "Vai contribuir",
 "Valor unitário": "Valor unitário",
 "Vaquinha": "Vaquinha",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Acompanha tudo o que foi partilhado, sempre atualizado. Para incluir, editar e assumir tarefas, subscreva o separador.",
 "agradeci": "agradeci",
 "atrasado": "atrasado",
 "completo": "completo",
 "deu {d} de {v}": "deu {d} de {v}",
 "em {l}": "em {l}",
 "falta o valor": "falta o valor",
 "falta {v} até {d}": "falta {v} até {d}",
 "gasto em {e}": "gasto em {e}",
 "kg": "kg",
 "o evento": "o evento",
 "restante": "restante",
 "sinal": "sinal",
 "total": "total",
 "un.": "un.",
 "{n} confirmados": "{n} confirmados",
 "{n} convidados contam no ⊕ por convidado.": "{n} convidados contam no ⊕ por convidado.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} convidados que estavam em \"Pendente\" passaram para \"Por convidar\". Ao enviar o convite pela app, passam automaticamente para \"Convidado, sem resposta\".",
 "{n} extras": "{n} extras",
 "{n} talvez": "{n} talvez",
 "{q} por convidado": "{q} por convidado",
 "{v} por convidado": "{v} por convidado",
 "Item completo": "Item completo",
 "Nota rápida": "Nota rápida",
 "📝 Nota rápida": "📝 Nota rápida",
 "Conteúdo da nota": "Conteúdo da nota",
 "{c} confirmado(s) de {n} convidado(s)": "{c} confirmado(s) de {n} convidado(s)",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua nas Mensagens.",
 "Confirme para apagar o escritório": "Confirme para apagar o escritório",
 "Escreva o assunto da reunião para poder marcar.": "Escreva o assunto da reunião para poder marcar.",
 "{n} min (marcada para {m} min)": "{n} min (marcada para {m} min)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Não foi possível descarregar o ficheiro agora. Verifique a internet e tente de novo.",
 "Meus clientes": "Os meus clientes",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Uma única lista de clientes, usada por todos os separadores de trabalho: contacto, morada, etiquetas, notas e ficheiros.",
 "Copiar para Meus clientes": "Copiar para Os meus clientes",
 "Ver ou mudar": "Ver ou alterar",
 "Ver o documento completo": "Ver o documento completo",
 "CEP incompleto": "CEP incompleto",
 "O CEP tem 8 números.": "O CEP tem 8 dígitos.",
 "CEP não encontrado": "CEP não encontrado",
 "Confira os números ou preencha o endereço à mão.": "Verifique os números ou preencha a morada à mão.",
 "Não foi possível buscar o CEP": "Não foi possível procurar o CEP",
 "Confira a internet ou preencha o endereço à mão.": "Verifique a ligação à internet ou preencha a morada à mão.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Parece que falta algo neste e-mail (ex.: nome@site.com).",
 "opcional": "opcional",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Os seus clientes estão agora numa única lista, usada por todos os separadores de trabalho.",
 "Portal do Cliente: {n} cliente(s).": "Portal do Cliente: {n} cliente(s).",
 "Freelancer & Projetos: {n} cliente(s).": "Freelancer & Projetos: {n} cliente(s).",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} eram o mesmo cliente em mais de um separador e passaram a uma única ficha.",
 "Nenhum cliente repetido.": "Nenhum cliente repetido.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.",
 "Já está em Meus clientes": "Já está em Os meus clientes",
 "{nome} já está na lista.": "{nome} já está na lista.",
 "Copiado para Meus clientes": "Copiado para Os meus clientes",
 "Só o nome e o contato foram copiados.": "Só o nome e o contacto foram copiados.",
 "Aniversário hoje!": "Aniversário hoje!",
 "Fechar tudo": "Fechar tudo",
 "Abrir tudo": "Abrir tudo",
 "Quem é": "Quem é",
 "Razão social": "Denominação social",
 "Nome fantasia": "Nome comercial",
 "Data de abertura": "Data de constituição",
 "Inscrição estadual / municipal": "Inscrição estadual / municipal",
 "Outras pessoas de contato": "Outras pessoas de contacto",
 "Como chamar": "Como tratar",
 "Cliente desde": "Cliente desde",
 "Outro telefone": "Outro telefone",
 "Site": "Site",
 "Melhor jeito de falar": "Melhor forma de contacto",
 "Autorizou receber mensagens": "Autorizou receber mensagens",
 "Outros endereços": "Outras moradas",
 "Relacionamento": "Relacionamento",
 "Como me conheceu": "Como me conheceu",
 "Etiquetas": "Etiquetas",
 "Nada anotado ainda.": "Ainda não há notas.",
 "Bloco da aba {aba}": "Bloco do separador {aba}",
 "Abrir na aba {aba}": "Abrir no separador {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Uma única lista, usada por todos os separadores de trabalho.",
 "Escreva o nome do cliente.": "Escreva o nome do cliente.",
 "Telefone / WhatsApp": "Telefone / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Só o nome é obrigatório. Abra as partes que quiser preencher.",
 "Como chamar (apelido)": "Como tratar (alcunha)",
 "Inscrição estadual / municipal (opcional)": "Inscrição estadual / municipal (opcional)",
 "Cargo": "Cargo",
 "Telefone da pessoa de contato": "Telefone da pessoa de contacto",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Outras pessoas de contacto (uma por linha: nome, cargo, telefone)",
 "O telefone principal é WhatsApp": "O telefone principal é WhatsApp",
 "O outro telefone é WhatsApp": "O outro telefone é WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Ex.: @nome",
 "Ex.: WhatsApp, à tarde": "Ex.: WhatsApp, à tarde",
 "Estado (UF)": "Estado (UF)",
 "Endereço (como estava escrito)": "Morada (como estava escrita)",
 "Outros endereços (trabalho, entrega...)": "Outras moradas (trabalho, entrega...)",
 "Google": "Google",
 "Passou na frente": "Passou à porta",
 "Indicado por": "Recomendado por",
 "Criar etiqueta": "Criar etiqueta",
 "Ex.: VIP, Mensal, Atacado": "Ex.: VIP, Mensal, Grossista",
 "Ativo": "Ativo",
 "Inativo": "Inativo",
 "Em negociação": "Em negociação",
 "O cliente autorizou receber mensagens?": "O cliente autorizou receber mensagens?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Sem autorização, nada de mensagens de aniversário, cobranças automáticas ou promoções para este cliente.",
 "aniversário hoje": "aniversário hoje",
 "contato: {n}": "contacto: {n}",
 "com esse telefone": "com este telefone",
 "com esse e-mail": "com este e-mail",
 "com esse documento": "com este documento",
 "com esse nome": "com este nome",
 "Cliente parecido": "Cliente semelhante",
 "Já existe {nome} {por}. Abrir?": "Já existe {nome} {por}. Abrir?",
 "Cadastrar mesmo assim": "Registar mesmo assim",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Serão apagados: a ficha, as notas e os ficheiros deste cliente.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Também nos separadores: {abas} (com os documentos, pedidos, cartões e horas de lá).",
 "Juntar com outra ficha": "Juntar com outra ficha",
 "Juntar fichas": "Juntar fichas",
 "Não há outra ficha para juntar.": "Não há outra ficha para juntar.",
 "Juntar \"{nome}\" com:": "Juntar \"{nome}\" com:",
 "Juntar as duas fichas?": "Juntar as duas fichas?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" fica com tudo de \"{b}\" (dados, notas, ficheiros e as ligações aos separadores). A ficha \"{b}\" deixa de existir.",
 "Juntar": "Juntar",
 "Confirme para juntar as fichas": "Confirme para juntar as fichas",
 "Aniversariantes do mês": "Aniversariantes do mês",
 "Ativos": "Ativos",
 "Inativos": "Inativos",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Registe cada cliente uma vez: ele aparece em todos os separadores de trabalho que usa.",
 "Novo cliente": "Novo cliente",
 "Editar cliente": "Editar cliente",
 "Linha do tempo": "Cronologia",
 "{n} registro(s)": "{n} registo(s)",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Ainda nada. Vendas, pagamentos, documentos e horas aparecem aqui.",
 "Me deve": "Deve-me",
 "Total pago": "Total pago",
 "Última compra ou atendimento": "Última compra ou atendimento",
 "Próximo compromisso": "Próximo compromisso",
 "na entrega": "na entrega",
 "Passou do limite de fiado ({v}).": "Ultrapassou o limite de crédito ({v}).",
 "Recebeu {v} ({p})": "Recebeu {v} ({p})",
 "Hoje é aniversário de {n}.": "Hoje é o aniversário de {n}.",
 "Mandar parabéns": "Dar os parabéns",
 "{n}: parcela de {v} atrasada.": "{n}: prestação de {v} em atraso.",
 "Cobrar": "Cobrar",
 "{n} não compra há {d} dias.": "{n} não compra há {d} dias.",
 "Chamar de volta": "Voltar a contactar",
 "🟢 em dia · 🟡 sumido": "🟢 em dia · 🟡 ausente",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 em dia · 🟡 algo a vencer ou cliente ausente · 🔴 em atraso",
 "Limite de fiado (opcional)": "Limite de crédito (opcional)",
 "Avisa quando o que ele deve passar deste valor.": "Avisa quando o que o cliente deve ultrapassar este valor.",
 "A prazo": "A prazo",
 "parcela atrasada": "prestação em atraso",
 "falta na entrega": "falta na entrega",
 "Sumidos": "Ausentes",
 "Sinal pago, falta o resto": "Sinal pago, falta o resto",
 "Pagou {a} de {b}": "Pagou {a} de {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Esta prestação vem de Os meus clientes. Marque-a aqui como recebida ou abra o cliente para cobrar e gerar o recibo.",
 "Sinal + restante": "Sinal + restante",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Cartão de crédito a pronto",
 "Cartão de crédito parcelado": "Cartão de crédito em prestações",
 "Fiado / a prazo": "Fiado / a prazo",
 "Parcela única": "Prestação única",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Olá, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Olá, {nome}! Há quanto tempo não falamos! Posso ajudar em alguma coisa? Será um prazer voltar a atendê-lo(a)!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Olá, {nome}! Só para lembrar a prestação de {v} que venceu no dia {d}. Qualquer coisa, diga-me. Obrigada!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Olá, {nome}! Só para lembrar a prestação de {v}{d}. Qualquer coisa, diga-me. Obrigada!",
 "que vence dia {d}": "que vence no dia {d}",
 "Quanto recebeu?": "Quanto recebeu?",
 "Falta {v}. Pode ser só uma parte.": "Faltam {v}. Pode ser só uma parte.",
 "(seu nome ou sua marca, em Como você recebe?)": "(o seu nome ou a sua marca, em Como recebe?)",
 "Recibo {c}": "Recibo {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Recebi de {c} a quantia de {v}, referente a {o}.",
 "{v} no {f} → recebe {l}": "{v} no {f} → recebe {l}",
 "Pagou {a} de {b}, faltam {c}": "Pagou {a} de {b}, faltam {c}",
 "Recebido em {d}": "Recebido em {d}",
 "Cobrar pelo WhatsApp": "Cobrar pelo WhatsApp",
 "Sem autorização": "Sem autorização",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).",
 "Sem telefone": "Sem telefone",
 "Coloque o telefone na ficha do cliente.": "Adicione o telefone na ficha do cliente.",
 "Gerar recibo": "Gerar recibo",
 "Como você recebe?": "Como recebe?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Só \"À vista\": o ecrã fica limpo, sem a prazo, prestações nem vermelho.",
 "Taxa da maquininha (%)": "Taxa do terminal de pagamento (%)",
 "Taxa {k}": "Taxa {k}",
 "Cliente sumido depois de (dias sem comprar)": "Cliente ausente após (dias sem comprar)",
 "Dias para considerar sumido": "Dias para considerar ausente",
 "Lembretes de cobrança por parcela atrasada": "Lembretes de cobrança por prestação em atraso",
 "Nome ou marca no recibo": "Nome ou marca no recibo",
 "Ex.: Ana Beatriz Doces": "Ex.: Ana Beatriz Doces",
 "Venda ou serviço": "Venda ou serviço",
 "O que foi vendido ou feito": "O que foi vendido ou feito",
 "Ex.: Bolo de aniversário": "Ex.: Bolo de aniversário",
 "Como paga": "Como paga",
 "Sinal (%)": "Sinal (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Ou escreva o valor do sinal logo abaixo.",
 "Sinal (valor)": "Sinal (valor)",
 "Restante na entrega": "Restante na entrega",
 "Próximo vencimento": "Próximo vencimento",
 "Sinal a receber": "Sinal a receber",
 "falta {v}{q}": "falta {v}{q}",
 "quitado": "liquidado",
 "Parcelas mantidas": "Prestações mantidas",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Já existe um pagamento registado: as prestações não foram refeitas. Para alterar, anule primeiro os pagamentos.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Registe o que o cliente comprou ou o serviço que fez, e como ele paga.",
 "Débito": "Débito",
 "Crédito à vista": "Crédito a pronto",
 "Crédito 2x": "Crédito 2x",
 "Crédito 3x": "Crédito 3x",
 "Crédito 4x": "Crédito 4x",
 "Crédito 5x": "Crédito 5x",
 "Crédito 6x": "Crédito 6x",
 "Crédito 7x": "Crédito 7x",
 "Crédito 8x": "Crédito 8x",
 "Crédito 9x": "Crédito 9x",
 "Crédito 10x": "Crédito 10x",
 "Crédito 11x": "Crédito 11x",
 "Crédito 12x": "Crédito 12x",
 "ATRASADOS": "EM ATRASO",
 "Atrasado (hoje): {v}": "Em atraso (hoje): {v}",
 "Buscar um cliente": "Procurar um cliente",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ completo, morada completa e data de nascimento. Pede a palavra-passe da app.",
 "Cliente cadastrado": "Cliente registado",
 "Com documentos: guarde o arquivo em lugar seguro.": "Com documentos: guarde o ficheiro num local seguro.",
 "Como pagou": "Como pagou",
 "Esse contato não tem nome.": "Este contacto não tem nome.",
 "Exportar planilha": "Exportar folha de cálculo",
 "Falta receber": "Falta receber",
 "Falta receber (hoje): {v}": "Falta receber (hoje): {v}",
 "Importar dos contatos": "Importar dos contactos",
 "Importar dos contatos do celular": "Importar dos contactos do telemóvel",
 "Incluir documentos": "Incluir documentos",
 "Incluir documentos no relatório": "Incluir documentos no relatório",
 "MELHORES CLIENTES": "MELHORES CLIENTES",
 "Melhores clientes": "Melhores clientes",
 "Não foi possível gerar a planilha.": "Não foi possível gerar a folha de cálculo.",
 "O que foi": "O que foi",
 "Pago em": "Pago em",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Para trazer clientes dos contactos do telemóvel, atualize o My Planner na loja de aplicações.",
 "RECEBIDO POR DIA": "RECEBIDO POR DIA",
 "RECEBIDO POR MÊS": "RECEBIDO POR MÊS",
 "Recebeu": "Recebeu",
 "Recebeu no período": "Recebeu no período",
 "Recebeu no período: {v}": "Recebeu no período: {v}",
 "Recebido no período": "Recebido no período",
 "Relatório de clientes": "Relatório de clientes",
 "Relatório deste cliente": "Relatório deste cliente",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Sem a permissão de contactos não é possível escolher um contacto. Pode autorizá-la nas definições do telemóvel.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Sem documentos: o CPF/CNPJ aparece só com os 2 últimos números. As notas nunca aparecem.",
 "Todos os clientes": "Todos os clientes",
 "Trabalha em: {e}": "Trabalha em: {e}",
 "Trazer outro": "Trazer outro",
 "VENDAS E ATENDIMENTOS": "VENDAS E ATENDIMENTOS",
 "Vence": "Vence",
 "Venceu": "Venceu",
 "Vendas e atendimentos": "Vendas e atendimentos",
 "Vendeu": "Vendeu",
 "Vendeu no período": "Vendeu no período",
 "Vendeu no período: {v}": "Vendeu no período: {v}",
 "venceu {d}": "venceu a {d}",
 "vendido no período": "vendido no período",
 "{nome} comprou no período": "{nome} comprou no período",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} foi adicionado a Os meus clientes. Verifique a ficha e indique se autorizou receber mensagens.",
 "{n} compra(s)": "{n} compra(s)",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Arraste uma caixa para a esquerda para arquivar ou para a direita para eliminar. Mantenha premida uma parte livre da caixa e arraste para mudar a ordem.",
 "Bloco": "Bloco",
 "Confirme para apagar o grupo": "Confirme para apagar o grupo",
 "Descer": "Descer",
 "Opções do bloco": "Opções do bloco",
 "Exigências do destino": "Exigências do destino",
 "{n} para acertar": "{n} por acertar",
 "{n} parada(s)": "{n} paragem(ns)",
 "Cor do item selecionado": "Cor do item selecionado",
 "Abrir o grupo": "Abrir o grupo",
 "Recolher o grupo": "Recolher o grupo",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Arraste uma caixa para a direita para eliminar ou para a esquerda para arquivar. Mantenha premido e arraste para mudar a ordem.",
 "Editar subtítulo": "Editar subtítulo",
 "Início da caixa": "Início da caixa",
 "Mover para…": "Mover para…",
 "Mover {n} item(ns) para": "Mover {n} item(ns) para",
 "Opções do item": "Opções do item",
 "Transformar em subtítulo": "Transformar em subtítulo",
 "Transformar em texto": "Transformar em texto",
 "esta caixa": "esta caixa",
 "{a} de {n} feitos": "{a} de {n} feitos",
 "1 documento pedido atrasado": "1 documento pedido em atraso",
 "1 pedido vence logo": "1 pedido vence em breve",
 "A lista vem de \"Meus clientes\".": "A lista vem de \"Os meus clientes\".",
 "Abrir Meus clientes": "Abrir Os meus clientes",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Os separadores Escritório e Portal do Cliente agora são um só.",
 "Clientes com pendência": "Clientes com pendências",
 "Com pendência ({n})": "Com pendências ({n})",
 "Conversa da equipe": "Conversa da equipa",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Crie o escritório e chame a equipa (amigos da app ou convite por link): conversa, reuniões por vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.",
 "Documentos internos": "Documentos internos",
 "Entrar com um código de convite": "Entrar com um código de convite",
 "Escritório & Clientes": "Escritório & Clientes",
 "Escritórios: {n}": "Escritórios: {n}",
 "Esta parte é para quem trabalha com equipe": "Esta parte é para quem trabalha com equipa",
 "Guias vencendo": "Guias a vencer",
 "Minhas tarefas": "As minhas tarefas",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Nada foi apagado: a equipa, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Ainda sem clientes. Registe em \"Os meus clientes\": aparece aqui de imediato.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Para quem trabalha com clientes, sozinho ou com equipa: a pasta de cada cliente (documentos, pedidos, guias), equipa, conversa, reuniões e documentos internos.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)",
 "Pessoa física": "Pessoa singular",
 "Procurar por nome, CNPJ ou CPF": "Procurar por nome, CNPJ ou CPF",
 "Reuniões hoje": "Reuniões hoje",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Sem escritório (equipa). Toque para criar ou entrar com um código.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Só a equipa vê. Os clientes nunca veem esta parte.",
 "Tudo em dia": "Tudo em dia",
 "Vencendo ({n})": "A vencer ({n})",
 "chega na próxima versão": "chega na próxima versão",
 "nos próximos 7 dias": "nos próximos 7 dias",
 "vence amanhã": "vence amanhã",
 "vence hoje": "vence hoje",
 "{doc} venceu em {d}": "{doc} venceu em {d}",
 "{n} documentos pedidos atrasados": "{n} documentos pedidos em atraso",
 "{n} pedidos vencem logo": "{n} pedidos vencem em breve",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 em dia · 🟡 algo vence em breve · 🔴 pedido em atraso ou guia vencida",
 "Acesso ao gov.br": "Acesso ao gov.br",
 "Alvará": "Alvará",
 "Até o dia (do mês)": "Até ao dia (do mês)",
 "CCMEI (certificado do MEI)": "CCMEI (certificado do MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Registe o telefone do cliente para lembrar pelo WhatsApp.",
 "Cartão CNPJ": "Cartão CNPJ",
 "Checklist criado": "Checklist criada",
 "Checklist de cliente novo": "Checklist de cliente novo",
 "Cliente viu {doc}": "O cliente viu {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Cole na app do banco, em Pix copia e cola.",
 "Cole no app do banco.": "Cole na app do banco.",
 "Comprovante de endereço": "Comprovativo de morada",
 "Contrato social e alterações": "Contrato de sociedade e alterações",
 "Copiado": "Copiado",
 "Copiar Pix": "Copiar Pix",
 "Copiar código de barras": "Copiar código de barras",
 "Código de barras (linha digitável)": "Código de barras (linha digitável)",
 "Dados bancários": "Dados bancários",
 "Escreva o recado.": "Escreva a mensagem.",
 "Escritório enviou {doc}": "O escritório enviou {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Este cliente não autorizou receber mensagens (ficha em Os meus clientes).",
 "Extratos bancários": "Extratos bancários",
 "Ficha completa": "Ficha completa",
 "Guia": "Guia",
 "Guias a pagar": "Guias a pagar",
 "Honorário": "Honorários",
 "Honorário por": "Honorários por",
 "Informes de rendimentos": "Declarações de rendimentos",
 "Lembrar pelo WhatsApp": "Lembrar pelo WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Ler a guia ou o boleto com a minha IA",
 "Lucro presumido": "Lucro presumido",
 "Lucro real": "Lucro real",
 "Nada ainda.": "Ainda nada.",
 "Nenhum pedido em aberto.": "Nenhum pedido em aberto.",
 "Notas fiscais emitidas": "Faturas emitidas",
 "O cliente": "O cliente",
 "O pedido entrou em Pedidos de documentos.": "O pedido entrou em Pedidos de documentos.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Olá, {nome}! Falta: {itens}. Pode enviar por aqui?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Olá, {nome}! Faltam: {itens}. Pode enviar por aqui?",
 "Oi, {nome}! Tudo certo por aí?": "Olá, {nome}! Está tudo bem por aí?",
 "Pedido criado": "Pedido criado",
 "Pedido feito: {o}": "Pedido feito: {o}",
 "Pedido recebido: {o}": "Pedido recebido: {o}",
 "Pedidos pendentes": "Pedidos pendentes",
 "Pedir de novo todo mês": "Pedir de novo todos os meses",
 "Pedir nova ({c})": "Pedir nova ({c})",
 "Pendentes": "Pendentes",
 "Que tipo de cliente?": "Que tipo de cliente?",
 "RG e CPF": "RG e CPF",
 "RG e CPF do titular": "RG e CPF do titular",
 "RG e CPF dos sócios": "RG e CPF dos sócios",
 "Recados": "Mensagens",
 "Recados entre você e o cliente, presos à pasta dele.": "Mensagens entre si e o cliente, guardadas na pasta dele.",
 "Responde ao pedido": "Responde ao pedido",
 "Tipo / regime": "Tipo / regime",
 "Visto pelo cliente em {d}": "Visto pelo cliente em {d}",
 "Válido até": "Válido até",
 "ano": "ano",
 "código Pix copia e cola, se houver": "código Pix copia e cola, se existir",
 "data de vencimento": "data de vencimento",
 "documento": "documento",
 "linha digitável do boleto ou da guia, só números": "linha digitável do boleto ou da guia, só números",
 "mês": "mês",
 "novo": "novo",
 "todo mês, até o dia {n}": "todos os meses, até ao dia {n}",
 "valor a pagar": "valor a pagar",
 "válido até {d}": "válido até {d}",
 "{c} nova": "{c} nova",
 "{doc} pago": "{doc} pago",
 "{n} a pagar": "{n} a pagar",
 "{n} enviou {doc}": "{n} enviou {doc}",
 "{n} novo(s)": "{n} novo(s)",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} pedido(s) de documentos criado(s), com prazo de 7 dias.",
 "{n} vencida(s)": "{n} vencida(s)",
 "Última declaração do Imposto de Renda": "Última declaração de IRS",
 "Últimas guias pagas": "Últimas guias pagas",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Esta parte do Escritório ainda não foi ligada ao servidor. No computador, execute o 56-SERVIDOR-0.96.bat (apenas uma vez).",
 "Só vê": "Só vê",
 "Nova versão": "Nova versão",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Já havia um ficheiro com este nome: o anterior fica guardado como versão {n}.",
 "Visto por e comentários": "Visto por e comentários",
 "Arquivar (só neste aparelho)": "Arquivar (só neste aparelho)",
 "Tirar do topo": "Tirar do topo",
 "Fixar no topo (para todos)": "Fixar no topo (para todos)",
 "Mover para a pasta…": "Mover para a pasta…",
 "versão {n}": "versão {n}",
 "visto por {n}": "visto por {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Até 50 MB por ficheiro. Enviar um ficheiro com o mesmo nome guarda o anterior como versão.",
 "Procurar documento ou pasta": "Procurar documento ou pasta",
 "Fixados": "Fixados",
 "Abrir o documento": "Abrir o documento",
 "enviado por {nome}": "enviado por {nome}",
 "Versões ({n})": "Versões ({n})",
 "Versão {n} (atual)": "Versão {n} (atual)",
 "Versão {n}": "Versão {n}",
 "Visto por ({n})": "Visto por ({n})",
 "Ninguém da equipe abriu ainda.": "Ninguém da equipa abriu ainda.",
 "{nome} em {d}": "{nome} em {d}",
 "Comentários ({n})": "Comentários ({n})",
 "Escreva um comentário": "Escreva um comentário",
 "Contratos": "Contratos",
 "Financeiro do escritório": "Financeiro do escritório",
 "RH": "RH",
 "Mover para a pasta": "Mover para a pasta",
 "Ou escreva o nome de uma pasta nova": "Ou escreva o nome de uma pasta nova",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Repete-se todas as semanas: ao cancelar, sai de todas as semanas, da lista e dos Recebidos da equipa.",
 "a equipe toda": "a equipa toda",
 "Com {quem}": "Com {quem}",
 "toda semana": "todas as semanas",
 "Vão: {n}": "Vão: {n}",
 "Não vão: {n}": "Não vão: {n}",
 "Vou": "Vou",
 "Não vou": "Não vou",
 "Pauta": "Pauta",
 "Ata": "Ata",
 "Escrever a ata": "Escrever a ata",
 "Abrir o link": "Abrir a ligação",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Cada pessoa convidada recebe a reunião em Recebidos e coloca-a no Planner com um toque, com o alerta.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Escreva primeiro as anotações da reunião (o que foi dito e decidido); a IA organiza-as em ata.",
 "Ata: {nome}": "Ata: {nome}",
 "Gerando...": "A gerar...",
 "Gerar ata com a minha IA": "Gerar ata com a minha IA",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "A IA organiza a pauta e as suas anotações em ata. Confira antes de guardar.",
 "Ainda sem ata.": "Ainda sem ata.",
 "Tarefas da reunião ({n})": "Tarefas da reunião ({n})",
 "Tarefa da reunião": "Tarefa da reunião",
 "Salvar a ata": "Guardar a ata",
 "Repetir toda semana ({dia})": "Repetir todas as semanas ({dia})",
 "Quem participa": "Quem participa",
 "A equipe toda": "A equipa toda",
 "Link externo (opcional: Meet, Zoom, Teams)": "Ligação externa (opcional: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "A ligação tem de começar por https://",
 "Marcar e avisar quem participa": "Marcar e avisar quem participa",
 "Cargo e papel": "Cargo e papel",
 "Passar o Admin": "Passar o Admin",
 "Passar o Admin para {nome}?": "Passar o Admin para {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipa como administrador (quem recebe pode alterar isso depois).",
 "Passar": "Passar",
 "{nome} agora cuida do escritório.": "{nome} agora cuida do escritório.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "O seu papel aqui é \"Só vê\": acompanha avisos, tarefas, reuniões e documentos.",
 "Edita": "Edita",
 "Incluir": "Incluir",
 "Novo aviso no mural": "Novo aviso no mural",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para si. Peça a quem administra para alterar, se precisar.",
 "Quem viu": "Quem viu",
 "Apagar aviso": "Apagar aviso",
 "Mural de avisos": "Mural de avisos",
 "Novo aviso": "Novo aviso",
 "Ex.: Feriado na sexta: escritório fechado": "Ex.: Feriado na sexta: escritório fechado",
 "Fixar no mural": "Fixar no mural",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipa.",
 "visto por {n} de {m}": "visto por {n} de {m}",
 "sem responsável": "sem responsável",
 "atrasada desde {d}": "em atraso desde {d}",
 "prazo {d}": "prazo {d}",
 "Comecei": "Comecei",
 "Terminei": "Terminei",
 "Reabrir": "Reabrir",
 "Tarefas da equipe": "Tarefas da equipa",
 "1 aberta": "1 aberta",
 "{n} abertas": "{n} abertas",
 "Minhas tarefas ({n})": "As minhas tarefas ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Nenhuma tarefa sua em aberto. Toque em \"Eu faço\" numa tarefa da equipa.",
 "Nenhuma tarefa aberta.": "Nenhuma tarefa em aberto.",
 "Feitas ({n})": "Concluídas ({n})",
 "Apagar a tarefa?": "Apagar a tarefa?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "O que é preciso fazer? (ex.: Apurar o DAS de março)",
 "Cliente (opcional)": "Cliente (opcional)",
 "Prazo (opcional)": "Prazo (opcional)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Responsável (opcional; se não, alguém toca em \"Eu faço\")",
 "Escreva a tarefa para poder salvar.": "Escreva a tarefa para poder guardar.",
 "Membro": "Membro",
 "Cargo (livre)": "Cargo (livre)",
 "Ex.: Advogada, Assistente, Estagiário": "Ex.: Advogada, Assistente, Estagiário",
 "Papel": "Papel",
 "Admin: pode tudo no escritório.": "Admin: pode tudo no escritório.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Edita: inclui tarefas, avisos, documentos e reuniões",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Só vê: acompanha tudo, sem incluir nem alterar",
 "Proposta": "Proposta",
 "Documento sensível (pede a senha do app para abrir)": "Documento sensível (pede o código da app para abrir)",
 "Li e concordo: {d}": "Li e concordo: {d}",
 "Li e concordo": "Li e concordo",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Ao tocar em Concordo, a app guarda a data e a hora em que leu e concordou com \"{doc}\". É uma aceitação simples: não substitui uma assinatura digital oficial.",
 "Concordo": "Concordo",
 "Fotos (escolha quais entram)": "Fotografias (escolha quais entram)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 fotografia não pôde ser lida neste dispositivo e ficou de fora.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} fotografias não puderam ser lidas neste dispositivo e ficaram de fora.",
 "Nenhuma foto no álbum desta viagem.": "Nenhuma fotografia no álbum desta viagem.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Toque nas fotografias para marcar ou desmarcar. Entram reduzidas, para o PDF ficar leve.",
 "Sugerir até 12": "Sugerir até 12",
 "1 foto marcada": "1 fotografia marcada",
 "{n} fotos marcadas": "{n} fotografias marcadas",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Com mais de 12 fotografias o PDF fica mais pesado.",
 "Confirme para abrir este documento": "Confirme para abrir este documento",
 "Como usar esta aba": "Como usar este separador",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 cliente estava em mais de um separador e passou a ser uma ficha só.",
 "Juntar {n} fotos num PDF?": "Juntar {n} fotos num PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "As fotos passam a ser as páginas de um único PDF, pela ordem da lista. As fotos soltas saem desta ficha.",
 "Não foi possível ler as fotos neste dispositivo.": "Não foi possível ler as fotos neste dispositivo.",
 "PDF criado": "PDF criado",
 "Montando o PDF...": "A montar o PDF...",
 "Juntar as {n} fotos num PDF": "Juntar as {n} fotos num PDF",
 "Baixar o mês": "Descarregar o mês",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "Os ficheiros deste mês estão noutro dispositivo e não puderam ser lidos aqui.",
 "Os documentos deste mês não têm arquivos.": "Os documentos deste mês não têm ficheiros.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 ficheiro está noutro dispositivo e ficou de fora.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} ficheiros estão noutro dispositivo e ficaram de fora.",
 "Conversa sobre este documento": "Conversa sobre este documento",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.",
 "Escreva a mensagem": "Escreva a mensagem",
 "Usar um modelo de pedido ({n})": "Usar um modelo de pedido ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Lembrar {nome} pelo WhatsApp: {o}",
 "Sem honorário": "Sem honorário",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Registe o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Os meus clientes.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.",
 "Recibo honorário {m} {c}": "Recibo honorário {m} {c}",
 "Recibo do honorário {m}": "Recibo do honorário {m}",
 "Recibo criado": "Recibo criado",
 "O recibo entrou em Documentos, na competência {m}.": "O recibo entrou em Documentos, na competência {m}.",
 "Vendo como o cliente": "A ver como o cliente",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipa. Nada pode ser alterado neste modo.",
 "Voltar a ver como escritório": "Voltar a ver como escritório",
 "Ver como o cliente": "Ver como o cliente",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Anotações internas (o cliente nunca vê)",
 "Recibo do honorário…": "Recibo do honorário…",
 "Competência do recibo": "Competência do recibo",
 "⬇️ Baixar o mês": "⬇️ Descarregar o mês",
 "Me avisar para lembrar o cliente": "Avisar-me para lembrar o cliente",
 "Guardar como modelo": "Guardar como modelo",
 "Modelo guardado": "Modelo guardado",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".",
 "Relatório do mês": "Relatório do mês",
 "Notas rápidas": "Notas rápidas",
 "Item completo: {o}": "Item completo: {o}",
 "Reuniões do mês": "Reuniões do mês",
 "Tarefas feitas e pendentes": "Tarefas feitas e pendentes",
 "Documentos internos enviados": "Documentos internos enviados",
 "Documentos enviados e recebidos dos clientes": "Documentos enviados e recebidos dos clientes",
 "Documentos da competência": "Documentos da competência",
 "Guias pagas e vencidas": "Guias pagas e vencidas",
 "Honorários": "Honorários",
 "Relatório do mês · {m}": "Relatório do mês · {m}",
 "Reuniões ({n})": "Reuniões ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Tarefas: {f} feitas no mês · {p} pendentes",
 "Quem fez": "Quem fez",
 "Feita em": "Feita em",
 "Documentos internos enviados ({n})": "Documentos internos enviados ({n})",
 "Documentos trocados com os clientes": "Documentos trocados com os clientes",
 "Enviados pelo escritório": "Enviados pelo escritório",
 "Recebidos do cliente": "Recebidos do cliente",
 "Nenhum documento trocado neste mês.": "Nenhum documento trocado neste mês.",
 "Clientes com pendência ({n})": "Clientes com pendência ({n})",
 "Pendência": "Pendência",
 "Nenhum cliente com pendência.": "Nenhum cliente com pendência.",
 "Documentos da competência {m} ({n})": "Documentos da competência {m} ({n})",
 "Pedidos de documentos ({n})": "Pedidos de documentos ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Guias do mês: {p} pagas · {v} vencidas",
 "Vencida": "Vencida",
 "Recebido no mês": "Recebido no mês",
 "Relatório {m} {q}": "Relatório {m} {q}",
 "MÊS": "MÊS",
 "DE QUEM": "DE QUEM",
 "O escritório": "O escritório",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Reuniões, tarefas e documentos internos entram quando há um escritório (equipa).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.",
 "Anotações recebidas": "Anotações recebidas",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Os valores a receber desta lista aparecem no My Planner, incluindo os novos.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Envia só os valores a receber desta lista (as consultas já vão sozinhas), incluindo os novos.",
 "Acrescentar": "Acrescentar",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "As {n} caixas estão em {aba}, em \"Anotações recebidas\".",
 "Enviadas": "Enviadas",
 "Enviar para": "Enviar para",
 "Excluir 1 item?": "Eliminar 1 item?",
 "Excluir {n} itens?": "Eliminar {n} itens?",
 "Inserir abaixo": "Inserir abaixo",
 "Mover para": "Mover para",
 "Mover {n} selecionados para": "Mover {n} selecionados para",
 "adicionar aqui": "adicionar aqui",
 "continue segurando para selecionar": "continue a segurar para selecionar"
}
